/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * * `miles` - Miles
 * * `kilometers` - Kilometers
 * * `hours` - Hours
 */
export enum UsageEnum {
  Miles = "miles",
  Kilometers = "kilometers",
  Hours = "hours",
}

/**
 * UnifiedOrganizationType
 * Types of organizations we support across providers
 */
export enum UnifiedOrganizationType {
  Carrier = "carrier",
  Shipper = "shipper",
  Broker = "broker",
  Other = "other",
}

/**
 * * `document` - Document
 * * `photo` - Photo
 */
export enum TypeEnum {
  Document = "document",
  Photo = "photo",
}

/**
 * * `Days` - Days
 * * `Weeks` - Weeks
 * * `Months` - Months
 * * `Years` - Years
 */
export enum TimeIntervalUnitEnum {
  Days = "Days",
  Weeks = "Weeks",
  Months = "Months",
  Years = "Years",
}

/**
 * * `12-hour` - 12-hour clock
 * * `24-hour` - 24-hour clock
 */
export enum TimeFormatEnum {
  Value12Hour = "12-hour",
  Value24Hour = "24-hour",
}

/**
 * * `Days` - Days
 * * `Weeks` - Weeks
 * * `Months` - Months
 * * `Years` - Years
 */
export enum TimeDueSoonThresholdUnitEnum {
  Days = "Days",
  Weeks = "Weeks",
  Months = "Months",
  Years = "Years",
}

/**
 * * `contacts` - Contacts
 * * `contact_renewals` - Contact Renewals
 * * `fuel_history` - Fuel History
 * * `issues` - Issues
 * * `service_reminders` - Service Reminders
 * * `service_task` - Service Task
 * * `vehicle_list` - Vehicle List
 * * `vendors` - Vendors
 * * `internal_vendors` - Internal Vendors
 * * `work_order` - Work Order
 * * `purchase_orders` - Purchase Orders
 * * `inspection_history` - Inspection History
 * * `meter_history` - Meter History
 * * `faults` - Faults
 * * `parts` - Parts
 * * `vehicle_renewals` - Vehicle Renewals
 * * `service_history` - Service History
 * * `expenses` - Expenses
 */
export enum TemplateTypeEnum {
  Contacts = "contacts",
  ContactRenewals = "contact_renewals",
  FuelHistory = "fuel_history",
  Issues = "issues",
  ServiceReminders = "service_reminders",
  ServiceTask = "service_task",
  VehicleList = "vehicle_list",
  Vendors = "vendors",
  InternalVendors = "internal_vendors",
  WorkOrder = "work_order",
  PurchaseOrders = "purchase_orders",
  InspectionHistory = "inspection_history",
  MeterHistory = "meter_history",
  Faults = "faults",
  Parts = "parts",
  VehicleRenewals = "vehicle_renewals",
  ServiceHistory = "service_history",
  Expenses = "expenses",
}

/**
 * * `all_users` - All Users
 * * `owners` - Owners
 * * `admins` - Admins
 */
export enum TargetAudienceEnum {
  AllUsers = "all_users",
  Owners = "owners",
  Admins = "admins",
}

/**
 * * `imperial` - Imperial
 * * `metric` - Metric
 */
export enum SystemOfMeasurementEnum {
  Imperial = "imperial",
  Metric = "metric",
}

/** StatusType */
export enum StatusType {
  Active = "active",
  Inactive = "inactive",
  InShop = "in_shop",
  OutOfService = "out_of_service",
  Reserved = "reserved",
  Sold = "sold",
  Downtime = "downtime",
}

/**
 * * `active` - Active
 * * `inactive` - Inactive
 * * `in_shop` - In Shop
 * * `out_of_service` - Out of Service
 * * `sold` - Sold
 * * `yes` - Yes
 * * `downtime` - Downtime
 */
export enum StatusToEnum {
  Active = "active",
  Inactive = "inactive",
  InShop = "in_shop",
  OutOfService = "out_of_service",
  Sold = "sold",
  Yes = "yes",
  Downtime = "downtime",
}

/**
 * * `draft` - Draft
 * * `pending_approval` - Pending Approval
 * * `rejected` - Rejected
 * * `approved` - Approved
 * * `purchased` - Purchased
 * * `partially_received` - Partially Received
 * * `received_in_full` - Received in Full
 * * `closed` - Closed
 */
export enum StatusE93Enum {
  Draft = "draft",
  PendingApproval = "pending_approval",
  Rejected = "rejected",
  Approved = "approved",
  Purchased = "purchased",
  PartiallyReceived = "partially_received",
  ReceivedInFull = "received_in_full",
  Closed = "closed",
}

/**
 * * `pending` - Pending
 * * `active` - Active
 * * `failed` - Failed
 * * `disabled` - Disabled
 */
export enum StatusDfcEnum {
  Pending = "pending",
  Active = "active",
  Failed = "failed",
  Disabled = "disabled",
}

/**
 * * `Upcoming` - Upcoming
 * * `DueSoon` - Due Soon
 * * `Overdue` - Overdue
 * * `Snoozed` - Snoozed
 * * `Completed` - Completed
 */
export enum StatusCb4Enum {
  Upcoming = "Upcoming",
  DueSoon = "DueSoon",
  Overdue = "Overdue",
  Snoozed = "Snoozed",
  Completed = "Completed",
}

/**
 * * `in_service` - In Service
 * * `available` - Available
 * * `out_of_service` - Out Of service
 * * `disposed` - Disposed
 * * `missing` - Missing
 * * `rented` - Rented
 */
export enum StatusC30Enum {
  InService = "in_service",
  Available = "available",
  OutOfService = "out_of_service",
  Disposed = "disposed",
  Missing = "missing",
  Rented = "rented",
}

/**
 * * `open` - Open
 * * `pending` - Pending
 * * `under_review` - Under review
 * * `completed` - Completed
 */
export enum Status6AbEnum {
  Open = "open",
  Pending = "pending",
  UnderReview = "under_review",
  Completed = "completed",
}

/**
 * * `upcoming` - Upcoming
 * * `due_soon` - Due Soon
 * * `overdue` - Overdue
 */
export enum Status5D2Enum {
  Upcoming = "upcoming",
  DueSoon = "due_soon",
  Overdue = "overdue",
}

/**
 * * `NEEDS_ACTION` - Needs Action
 * * `OPEN_ISSUE` - Open Issue
 * * `ACKNOWLEDGED` - Acknowledged
 * * `RESOLVED` - Resolved
 */
export enum Status474Enum {
  NEEDS_ACTION = "NEEDS_ACTION",
  OPEN_ISSUE = "OPEN_ISSUE",
  ACKNOWLEDGED = "ACKNOWLEDGED",
  RESOLVED = "RESOLVED",
}

/**
 * * `active` - active
 * * `inactive` - inactive
 * * `suspended` - suspended
 * * `deleted` - deleted
 * * `invited` - invited
 * * `need_invite` - need_invite
 * * `archived` - archived
 */
export enum Status3FcEnum {
  Active = "active",
  Inactive = "inactive",
  Suspended = "suspended",
  Deleted = "deleted",
  Invited = "invited",
  NeedInvite = "need_invite",
  Archived = "archived",
}

/**
 * * `active` - Active
 * * `in_service` - In Service
 * * `completed` - Completed
 */
export enum Status0C4Enum {
  Active = "active",
  InService = "in_service",
  Completed = "completed",
}

/**
 * * `Active` - Active
 * * `Expired` - Expired
 */
export enum Status081Enum {
  Active = "Active",
  Expired = "Expired",
}

/**
 * * `open` - Open
 * * `resolved` - Resolved
 * * `pending` - Pending
 * * `ignored` - Ignored
 */
export enum Status05DEnum {
  Open = "open",
  Resolved = "resolved",
  Pending = "pending",
  Ignored = "ignored",
}

/**
 * * `monday` - Monday
 * * `tuesday` - Tuesday
 * * `wednesday` - Wednesday
 * * `thursday` - Thursday
 * * `friday` - Friday
 * * `saturday` - Saturday
 * * `sunday` - Sunday
 */
export enum SpecificDayEnum {
  Monday = "monday",
  Tuesday = "tuesday",
  Wednesday = "wednesday",
  Thursday = "thursday",
  Friday = "friday",
  Saturday = "saturday",
  Sunday = "sunday",
}

/**
 * * `web` - Web
 * * `mobile` - Mobile
 */
export enum SourceEnum {
  Web = "web",
  Mobile = "mobile",
}

/**
 * * `all_companies` - All Companies
 * * `specific_companies` - Specific Companies
 */
export enum ScopeEnum {
  AllCompanies = "all_companies",
  SpecificCompanies = "specific_companies",
}

/**
 * * `all` - All Vehicles
 * * `by_type` - By Vehicle Type
 * * `by_group` - By Vehicle Group
 */
export enum RuleTypeEnum {
  All = "all",
  ByType = "by_type",
  ByGroup = "by_group",
}

/**
 * * `section` - Section
 * * `pass_fail` - Pass/Fail
 * * `meter_entry` - Meter Entry
 * * `date_time` - Date and Time
 * * `number` - Number
 * * `dropdown` - Dropdown
 * * `photo` - Photo
 * * `video` - Video
 * * `signature` - Signature
 * * `free_text` - Free Text
 */
export enum ResultTypeEnum {
  Section = "section",
  PassFail = "pass_fail",
  MeterEntry = "meter_entry",
  DateTime = "date_time",
  Number = "number",
  Dropdown = "dropdown",
  Photo = "photo",
  Video = "video",
  Signature = "signature",
  FreeText = "free_text",
}

/**
 * * `scheduled` - Scheduled
 * * `non_scheduled` - Non scheduled
 * * `emergency` - Emergency
 */
export enum RepairPriorityClassEnum {
  Scheduled = "scheduled",
  NonScheduled = "non_scheduled",
  Emergency = "emergency",
}

/**
 * * `vehicle` - Vehicle
 * * `inspection` - Inspection
 */
export enum ReferenceTypeEnum {
  Vehicle = "vehicle",
  Inspection = "inspection",
}

/**
 * * `YOUTUBE` - YouTube
 * * `VIMEO` - Vimeo
 */
export enum ProviderEnum {
  YOUTUBE = "YOUTUBE",
  VIMEO = "VIMEO",
}

/**
 * * `off` - Off
 * * `ignore` - Ignore
 * * `critical` - Critical
 */
export enum PriorityStatusEnum {
  Off = "off",
  Ignore = "ignore",
  Critical = "critical",
}

/**
 * * `off` - Off
 * * `ignore` - Ignore
 * * `critical` - Critical
 */
export enum PriorityEc4Enum {
  Off = "off",
  Ignore = "ignore",
  Critical = "critical",
}

/**
 * * `critical` - Critical
 * * `high` - High
 * * `medium` - Medium
 * * `low` - Low
 * * `no_priority` - No Priority
 */
export enum Priority3DfEnum {
  Critical = "critical",
  High = "high",
  Medium = "medium",
  Low = "low",
  NoPriority = "no_priority",
}

/**
 * * `days` - Days
 * * `weeks` - Weeks
 * * `months` - Months
 * * `years` - Years
 */
export enum PrimaryMeterDueSoonThresholdEnum {
  Days = "days",
  Weeks = "weeks",
  Months = "months",
  Years = "years",
}

/**
 * * `pending` - Pending
 * * `paid` - Paid
 * * `unpaid` - Unpaid
 */
export enum PaymentStatusEnum {
  Pending = "pending",
  Paid = "paid",
  Unpaid = "unpaid",
}

/**
 * * `basic` - Basic
 * * `standard` - Standard
 * * `premium` - Premium
 */
export enum PartnershipTierEnum {
  Basic = "basic",
  Standard = "standard",
  Premium = "premium",
}

/**
 * * `company` - Company
 * * `partial` - Partial
 * * `driver` - Driver
 */
export enum PaidByEnum {
  Company = "company",
  Partial = "partial",
  Driver = "driver",
}

/**
 * * `owned` - Owned
 * * `leased` - Leased
 * * `rented` - Rented
 * * `customer` - Customer
 * * `vehicle` - Vehicle
 */
export enum OwnershipEnum {
  Owned = "owned",
  Leased = "leased",
  Rented = "rented",
  Customer = "customer",
  Vehicle = "vehicle",
}

/**
 * * `vehicle` - VEHICLE
 * * `issue` - ISSUE
 * * `service_reminder` - SERVICE_REMINDER
 * * `work_order` - WORK_ORDER
 * * `contact` - CONTACT
 * * `vendor` - VENDOR
 * * `part` - PART
 * * `fuel_entry` - FUEL_ENTRY
 */
export enum ObjectTypeEnum {
  Vehicle = "vehicle",
  Issue = "issue",
  ServiceReminder = "service_reminder",
  WorkOrder = "work_order",
  Contact = "contact",
  Vendor = "vendor",
  Part = "part",
  FuelEntry = "fuel_entry",
}

export type NullEnum = null;

/**
 * * `scheduled` - Scheduled
 * * `pending` - Pending
 * * `processing` - Processing
 * * `delivered` - Delivered
 * * `failed` - Failed
 * * `partially_delivered` - Partially Delivered
 * * `cancelled` - Cancelled
 */
export enum NotificationStatusEnum {
  Scheduled = "scheduled",
  Pending = "pending",
  Processing = "processing",
  Delivered = "delivered",
  Failed = "failed",
  PartiallyDelivered = "partially_delivered",
  Cancelled = "cancelled",
}

/**
 * * `urgent` - Urgent
 * * `high` - High
 * * `medium` - Medium
 * * `low` - Low
 */
export enum NotificationPriorityEnum {
  Urgent = "urgent",
  High = "high",
  Medium = "medium",
  Low = "low",
}

/**
 * * `push` - Push
 * * `email` - Email
 * * `sms` - SMS
 * * `telegram` - Telegram
 */
export enum NotificationChannelsEnum {
  Push = "push",
  Email = "email",
  Sms = "sms",
  Telegram = "telegram",
}

/**
 * * `system_update` - System Update
 * * `feature` - Feature
 * * `maintenance` - Maintenance
 * * `security` - Security
 * * `status` - Status
 * * `action` - Action
 * * `alert` - Alert
 * * `create` - Create
 * * `update` - Update
 * * `delete` - Delete
 * * `approval` - Approval
 * * `assignment` - Assignment
 * * `general` - General
 */
export enum NotificationCategoryEnum {
  SystemUpdate = "system_update",
  Feature = "feature",
  Maintenance = "maintenance",
  Security = "security",
  Status = "status",
  Action = "action",
  Alert = "alert",
  Create = "create",
  Update = "update",
  Delete = "delete",
  Approval = "approval",
  Assignment = "assignment",
  General = "general",
}

/** MetricPeriod */
export enum MetricPeriod {
  Value24Hr = "24hr",
  Value1Week = "1 week",
  Value1Month = "1 month",
}

/**
 * * `miles` - Miles
 * * `gallons` - Gallons
 * * `liters` - Liters
 * * `kilometers` - Kilometers
 */
export enum MeterUnitEnum {
  Miles = "miles",
  Gallons = "gallons",
  Liters = "liters",
  Kilometers = "kilometers",
}

/**
 * * `kilo` - Kilometers
 * * `m` - Miles
 */
export enum MeterIntervalUnitEnum {
  Kilo = "kilo",
  M = "m",
}

/**
 * * `web` - Web
 * * `mobile` - Mobile
 */
export enum LoginLocationEnum {
  Web = "web",
  Mobile = "mobile",
}

/**
 * * `vehicles` - Vehicles
 * * `companies` - Companies
 * * `contacts` - Contacts
 * * `issues` - Issues
 * * `parts` - Parts
 * * `purchase_order` - Purchase Order
 * * `service_entry` - Service Entry
 * * `vendors` - Vendors
 * * `inspection` - Inspection
 * * `reminders` - Reminders
 * * `fuel` - Fuel
 * * `reports` - Reports
 * * `inventory` - Inventory
 * * `billing` - Billing
 * * `work_orders` - Work Orders
 */
export enum LocationEnum {
  Vehicles = "vehicles",
  Companies = "companies",
  Contacts = "contacts",
  Issues = "issues",
  Parts = "parts",
  PurchaseOrder = "purchase_order",
  ServiceEntry = "service_entry",
  Vendors = "vendors",
  Inspection = "inspection",
  Reminders = "reminders",
  Fuel = "fuel",
  Reports = "reports",
  Inventory = "inventory",
  Billing = "billing",
  WorkOrders = "work_orders",
}

/**
 * * `section` - Section
 * * `pass_fail` - Pass/Fail
 * * `meter_entry` - Meter Entry
 * * `date_time` - Date and Time
 * * `number` - Number
 * * `dropdown` - Dropdown
 * * `photo` - Photo
 * * `video` - Video
 * * `signature` - Signature
 * * `free_text` - Free Text
 */
export enum ItemTypeEnum {
  Section = "section",
  PassFail = "pass_fail",
  MeterEntry = "meter_entry",
  DateTime = "date_time",
  Number = "number",
  Dropdown = "dropdown",
  Photo = "photo",
  Video = "video",
  Signature = "signature",
  FreeText = "free_text",
}

/** IssueStatus */
export enum IssueStatus {
  Open = "open",
  Resolved = "resolved",
  Closed = "closed",
  Done = "done",
}

/** IssuePriority */
export enum IssuePriority {
  Critical = "critical",
  High = "high",
  Medium = "medium",
  Low = "low",
  NoPriority = "no_priority",
}

/**
 * * `open` - Open
 * * `resolved` - Resolved
 * * `closed` - Closed
 * * `done` - Done
 */
export enum IssueMiniReadStatusEnum {
  Open = "open",
  Resolved = "resolved",
  Closed = "closed",
  Done = "done",
}

/**
 * * `draft` - Draft
 * * `issued` - Issued
 * * `paid` - Paid
 * * `overdue` - Overdue
 * * `cancelled` - Cancelled
 */
export enum InvoiceStatusEnum {
  Draft = "draft",
  Issued = "issued",
  Paid = "paid",
  Overdue = "overdue",
  Cancelled = "cancelled",
}

/**
 * * `online` - Online
 * * `offline` - Offline
 */
export enum IntegrationsStatusEnum {
  Online = "online",
  Offline = "offline",
}

/**
 * * `PENDING` - Pending
 * * `PROCESSING` - Processing
 * * `COMPLETED` - Completed
 * * `FAILED` - Failed
 */
export enum ImportJobStatusEnum {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/**
 * * `dashboard` - Dashboard
 * * `units` - Units
 * * `users` - Users
 * * `contact` - Contact
 * * `samsara_devices` - Samsara Devices
 * * `assignment` - Assignment
 * * `meter_history` - Meter History
 * * `fuel_history` - Fuel History
 * * `report` - Report
 * * `expense` - Expense
 * * `training_videos` - Training Videos
 * * `papers` - Papers
 * * `settings` - Settings
 * * `warranty` - Warranty
 * * `inspections_history` - Inspections History
 * * `inspections_forms` - Inspections Forms
 * * `inspection_item_failures` - Inspection Item Failures
 * * `issue` - Issue
 * * `faults` - Faults
 * * `service_history` - Service History
 * * `service_tasks` - Service Tasks
 * * `contact_renewal` - Contact Renewal
 * * `vehicle_renewal` - Vehicle Renewal
 * * `service_reminders` - Service Reminders
 * * `equipment` - Equipment
 * * `vendors` - Vendors
 * * `parts` - Parts
 * * `purchase_orders` - Purchase Orders
 * * `work_orders` - Work Orders
 */
export enum HintSectionEnum {
  Dashboard = "dashboard",
  Units = "units",
  Users = "users",
  Contact = "contact",
  SamsaraDevices = "samsara_devices",
  Assignment = "assignment",
  MeterHistory = "meter_history",
  FuelHistory = "fuel_history",
  Report = "report",
  Expense = "expense",
  TrainingVideos = "training_videos",
  Papers = "papers",
  Settings = "settings",
  Warranty = "warranty",
  InspectionsHistory = "inspections_history",
  InspectionsForms = "inspections_forms",
  InspectionItemFailures = "inspection_item_failures",
  Issue = "issue",
  Faults = "faults",
  ServiceHistory = "service_history",
  ServiceTasks = "service_tasks",
  ContactRenewal = "contact_renewal",
  VehicleRenewal = "vehicle_renewal",
  ServiceReminders = "service_reminders",
  Equipment = "equipment",
  Vendors = "vendors",
  Parts = "parts",
  PurchaseOrders = "purchase_orders",
  WorkOrders = "work_orders",
}

/** HeightClass */
export enum HeightClass {
  Xs = "xs",
  Sm = "sm",
  Md = "md",
  Lg = "lg",
  Xl = "xl",
}

/**
 * * `gallons_us` - Gallons (US)
 * * `gallons_uk` - Gallons (UK)
 * * `liters` - Liters
 */
export enum FuelVolumeEnum {
  GallonsUs = "gallons_us",
  GallonsUk = "gallons_uk",
  Liters = "liters",
}

/**
 * * `daily` - Daily
 * * `weekly` - Weekly
 * * `monthly` - Monthly
 * * `yearly` - Yearly
 */
export enum FrequencyD02Enum {
  Daily = "daily",
  Weekly = "weekly",
  Monthly = "monthly",
  Yearly = "yearly",
}

/**
 * * `ONE_TIME` - One-time
 * * `MONTHLY` - Monthly
 * * `YEARLY` - Yearly
 */
export enum Frequency80AEnum {
  ONE_TIME = "ONE_TIME",
  MONTHLY = "MONTHLY",
  YEARLY = "YEARLY",
}

/**
 * * `csv` - csv
 * * `xlsx` - xlsx
 */
export enum FormatTypeEnum {
  Csv = "csv",
  Xlsx = "xlsx",
}

/**
 * * `personal_use` - Personal Use
 * * `partial_fuel_up` - Partial Fuel-Up
 * * `reset_usage` - Reset Usage
 */
export enum FlagEnum {
  PersonalUse = "personal_use",
  PartialFuelUp = "partial_fuel_up",
  ResetUsage = "reset_usage",
}

/**
 * * `csv` - csv
 * * `xlsx` - xlsx
 */
export enum FileTypeB48Enum {
  Csv = "csv",
  Xlsx = "xlsx",
}

/**
 * * `photo` - Photo
 * * `document` - Document
 * * `video` - Video
 * * `audio` - Audio
 * * `text` - Text
 * * `html` - HTML
 * * `microsoft_word` - Microsoft Word
 * * `microsoft_excel` - Microsoft Excel
 * * `microsoft_powerpoint` - Microsoft PowerPoint
 * * `csv` - CSV
 */
export enum FileType173Enum {
  Photo = "photo",
  Document = "document",
  Video = "video",
  Audio = "audio",
  Text = "text",
  Html = "html",
  MicrosoftWord = "microsoft_word",
  MicrosoftExcel = "microsoft_excel",
  MicrosoftPowerpoint = "microsoft_powerpoint",
  Csv = "csv",
}

/**
 * * `basic` - BASIC
 * * `detailed` - DETAILED
 */
export enum ExportScopeEnum {
  Basic = "basic",
  Detailed = "detailed",
}

/**
 * * `telematics` - Telematics
 * * `fuel` - Fuel
 * * `maintenance` - Maintenance
 * * `accounting` - Accounting
 */
export enum DomainEnum {
  Telematics = "telematics",
  Fuel = "fuel",
  Maintenance = "maintenance",
  Accounting = "accounting",
}

/**
 * * `SV` - Samsara Vehicle
 * * `ST` - Samsara Tracker
 * * `TR` - Trailer
 */
export enum DeviceTypeEnum {
  SV = "SV",
  ST = "ST",
  TR = "TR",
}

/**
 * * `percentage` - Percentage
 * * `fixed` - Fixed
 */
export enum DefaultTaxTypeEnum {
  Percentage = "percentage",
  Fixed = "fixed",
}

/**
 * * `MON` - Monday
 * * `TUE` - Tuesday
 * * `WED` - Wednesday
 * * `THU` - Thursday
 * * `FRI` - Friday
 * * `SAT` - Saturday
 * * `SUN` - Sunday
 */
export enum DaysEnum {
  MON = "MON",
  TUE = "TUE",
  WED = "WED",
  THU = "THU",
  FRI = "FRI",
  SAT = "SAT",
  SUN = "SUN",
}

/**
 * * `Standard` - Standard Warranty
 * * `Extended` - Extended Warranty
 */
export enum CoverageTypeEnum {
  Standard = "Standard",
  Extended = "Extended",
}

/**
 * * `months` - Months
 * * `years` - Years
 */
export enum CoverageDurationUnitEnum {
  Months = "months",
  Years = "years",
}

/**
 * * `on_time` - On time
 * * `up_coming` - Upcoming
 * * `late` - Late
 */
export enum ComplianceStatusEnum {
  OnTime = "on_time",
  UpComing = "up_coming",
  Late = "late",
}

/**
 * * `fuel` - Fuel
 * * `parts` - Parts
 * * `services_app` - Service
 * * `vehicle` - Vehicle
 */
export enum ClassificationEnum {
  Fuel = "fuel",
  Parts = "parts",
  ServicesApp = "services_app",
  Vehicle = "vehicle",
}

/** ChartType */
export enum ChartType {
  Line = "line",
  Bar = "bar",
  Pie = "pie",
  Doughnut = "doughnut",
  Radar = "radar",
  PolarArea = "polarArea",
  Bubble = "bubble",
  Scatter = "scatter",
}

/**
 * * `group` - Group
 * * `channel` - Channel
 * * `private` - Private
 */
export enum ChannelTypeEnum {
  Group = "group",
  Channel = "channel",
  Private = "private",
}

/**
 * * `NEW` - New
 * * `IMPROVED` - Improved
 * * `UPDATE` - Update
 * * `MAINTENANCE` - Maintenance
 * * `DEPRECATED` - Deprecated
 */
export enum Category964Enum {
  NEW = "NEW",
  IMPROVED = "IMPROVED",
  UPDATE = "UPDATE",
  MAINTENANCE = "MAINTENANCE",
  DEPRECATED = "DEPRECATED",
}

/**
 * * `contacts` - Contacts
 * * `contact_renewals` - Contact Renewals
 * * `fuel_history` - Fuel History
 * * `issues` - Issues
 * * `service_reminders` - Service Reminders
 * * `service_task` - Service Task
 * * `vehicle_list` - Vehicle List
 * * `vendors` - Vendors
 * * `work_order` - Work Order
 * * `purchase_orders` - Purchase Orders
 * * `inspection_history` - Inspection History
 * * `meter_history` - Meter History
 * * `faults` - Faults
 * * `parts` - Parts
 * * `vehicle_renewals` - Vehicle Renewals
 * * `service_history` - Service History
 */
export enum BulkDataImportSectionEnum {
  Contacts = "contacts",
  ContactRenewals = "contact_renewals",
  FuelHistory = "fuel_history",
  Issues = "issues",
  ServiceReminders = "service_reminders",
  ServiceTask = "service_task",
  VehicleList = "vehicle_list",
  Vendors = "vendors",
  WorkOrder = "work_order",
  PurchaseOrders = "purchase_orders",
  InspectionHistory = "inspection_history",
  MeterHistory = "meter_history",
  Faults = "faults",
  Parts = "parts",
  VehicleRenewals = "vehicle_renewals",
  ServiceHistory = "service_history",
}

export enum BlankEnum {
  Value = "",
}

/**
 * * `token` - Token
 * * `oauth2` - OAuth2
 * * `basic_auth` - Basic Auth
 * * `api_key` - API Key
 */
export enum AuthTypeEnum {
  Token = "token",
  Oauth2 = "oauth2",
  BasicAuth = "basic_auth",
  ApiKey = "api_key",
}

/**
 * * `vehicles` - Vehicles
 * * `companies` - Companies
 * * `contacts` - Contacts
 * * `issues` - Issues
 * * `parts` - Parts
 * * `purchase_order` - Purchase Order
 * * `service_entry` - Service Entry
 * * `vendors` - Vendors
 * * `inspection` - Inspection
 * * `reminders` - Reminders
 * * `fuel` - Fuel
 * * `reports` - Reports
 * * `inventory` - Inventory
 * * `billing` - Billing
 * * `work_orders` - Work Orders
 */
export enum AppNameEnum {
  Vehicles = "vehicles",
  Companies = "companies",
  Contacts = "contacts",
  Issues = "issues",
  Parts = "parts",
  PurchaseOrder = "purchase_order",
  ServiceEntry = "service_entry",
  Vendors = "vendors",
  Inspection = "inspection",
  Reminders = "reminders",
  Fuel = "fuel",
  Reports = "reports",
  Inventory = "inventory",
  Billing = "billing",
  WorkOrders = "work_orders",
}

/**
 * * `man` - Manual
 * * `init` - Initial
 * * `wo` - Work Order
 * * `po` - Purchase Order
 * * `bu` - Bulk Update
 * * `tr` - Transfer
 */
export enum AdjustmentTypeEnum {
  Man = "man",
  Init = "init",
  Wo = "wo",
  Po = "po",
  Bu = "bu",
  Tr = "tr",
}

/**
 * * `rule` - Added by Rule
 * * `manual` - Manually Added
 */
export enum AddViaEnum {
  Rule = "rule",
  Manual = "manual",
}

export interface AdjustmentCreate {
  /** @format uuid */
  part: string;
  /** @format uuid */
  part_location: string;
  /** @format uuid */
  adjustment_reason?: string | null;
  comment?: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  adjustment_qty?: number;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  new_qty: number;
}

export interface AdjustmentCreateRequest {
  /** @format uuid */
  part: string;
  /** @format uuid */
  part_location: string;
  /** @format uuid */
  adjustment_reason?: string | null;
  comment?: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  adjustment_qty?: number;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  new_qty: number;
}

export interface AdjustmentList {
  /** @format uuid */
  id: string;
  /** @format uuid */
  part: string;
  /** @format uuid */
  adjusted_by: string;
  /** @format uuid */
  adjustment_reason?: string | null;
  /**
   * * `man` - Manual
   * * `init` - Initial
   * * `wo` - Work Order
   * * `po` - Purchase Order
   * * `bu` - Bulk Update
   * * `tr` - Transfer
   */
  adjustment_type: AdjustmentTypeEnum;
  comment?: string;
  /** @format date-time */
  date: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  adjustment_qty?: number;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  new_qty: number;
  /** @format uuid */
  part_location: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  previous_qty: number;
  /** @format uuid */
  vendor?: string | null;
}

export interface AdjustmentReasonList {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
}

export interface AnnouncementCreate {
  /**
   * Announcement title that will be used in notifications
   * @maxLength 255
   */
  title: string;
  /** Main content of the announcement */
  description: string;
  /**
   * * `NEW` - New
   * * `IMPROVED` - Improved
   * * `UPDATE` - Update
   * * `MAINTENANCE` - Maintenance
   * * `DEPRECATED` - Deprecated
   */
  category?: Category964Enum;
  /** Images to be attached to this announcement */
  photos?: string[];
  /** Documents to be attached to this announcement */
  documents?: string[];
  /**
   * When this announcement should be sent
   * @format date-time
   */
  scheduled_for?: string | null;
  /** Company Scope */
  scope?: ScopeEnum;
  /** Specific companies to receive this announcement */
  target_companies?: string[];
  /**
   * A target audience types
   *
   * * `all_users` - All Users
   * * `owners` - Owners
   * * `admins` - Admins
   */
  target_audience: TargetAudienceEnum;
  /** Channels to be used when creating notifications. Can be overridden per notification. */
  notification_channels?: NotificationChannelsEnum[];
  /** Specific Telegram channels to send this announcement to */
  telegram_channels?: string[];
}

export interface AnnouncementCreateRequest {
  /**
   * Announcement title that will be used in notifications
   * @minLength 1
   * @maxLength 255
   */
  title: string;
  /**
   * Main content of the announcement
   * @minLength 1
   */
  description: string;
  /**
   * * `NEW` - New
   * * `IMPROVED` - Improved
   * * `UPDATE` - Update
   * * `MAINTENANCE` - Maintenance
   * * `DEPRECATED` - Deprecated
   */
  category?: Category964Enum;
  /** Images to be attached to this announcement */
  photos?: string[];
  /** Documents to be attached to this announcement */
  documents?: string[];
  /**
   * When this announcement should be sent
   * @format date-time
   */
  scheduled_for?: string | null;
  /** Company Scope */
  scope?: ScopeEnum;
  /** Specific companies to receive this announcement */
  target_companies?: string[];
  /**
   * A target audience types
   *
   * * `all_users` - All Users
   * * `owners` - Owners
   * * `admins` - Admins
   */
  target_audience: TargetAudienceEnum;
  /** Channels to be used when creating notifications. Can be overridden per notification. */
  notification_channels?: NotificationChannelsEnum[];
  /** Specific Telegram channels to send this announcement to */
  telegram_channels?: string[];
}

export interface AnnouncementList {
  /** @format uuid */
  id: string;
  /**
   * Announcement title that will be used in notifications
   * @maxLength 255
   */
  title: string;
  /** Main content of the announcement */
  description: string;
  /**
   * * `NEW` - New
   * * `IMPROVED` - Improved
   * * `UPDATE` - Update
   * * `MAINTENANCE` - Maintenance
   * * `DEPRECATED` - Deprecated
   */
  category?: Category964Enum;
  photos: File[];
  documents: File[];
  /** @format date-time */
  date: string;
  is_read: boolean;
}

export interface AppUploadDocumentsRequest {
  documents: string[];
}

export interface AssemblyCodeCreate {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  /**
   * @min 0
   * @max 32767
   */
  assembly_code: number;
  /**
   * Assembly Name
   * @maxLength 255
   */
  name: string;
  /** @format uuid */
  system_code: string;
}

export interface AssemblyCodeCreateRequest {
  is_active?: boolean;
  /**
   * @min 0
   * @max 32767
   */
  assembly_code: number;
  /**
   * Assembly Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** @format uuid */
  system_code: string;
}

export interface AssemblyCodeReadOnly {
  /** @format uuid */
  id: string;
  /**
   * @min 0
   * @max 32767
   */
  assembly_code: number;
  /**
   * Assembly Name
   * @maxLength 255
   */
  name: string;
  system_code: SystemCodeReadOnly;
}

export interface AssemblyCodeReadOnlyRequest {
  /**
   * @min 0
   * @max 32767
   */
  assembly_code: number;
  /**
   * Assembly Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  system_code: SystemCodeReadOnlyRequest;
}

export interface AssignEquipment {
  /** @format uuid */
  linked_vehicle: string;
  /** @format uuid */
  assigned_user?: string | null;
}

export interface AssignEquipmentRequest {
  /** @format uuid */
  linked_vehicle: string;
  /** @format uuid */
  assigned_user?: string | null;
}

export interface AssignTelematicsDeviceRequest {
  /** @format uuid */
  vehicle: string;
}

export interface AssignedUser {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  full_name: string;
}

export interface AssignmentDetail {
  /** @format uuid */
  id: string;
  operator: Contact;
  vehicle: Vehicle;
  /** @format date-time */
  start_datetime?: string | null;
  /** @format date-time */
  end_datetime?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  end_odometer?: number | null;
}

export interface AssignmentHistoryList {
  /** @format uuid */
  id: string;
  /** @format uuid */
  equipment: string;
  assigned_user: AssignedUser;
  started_by: AssignedUser;
  ended_by: AssignedUser;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * Duration in days
   * @min -2147483648
   * @max 2147483647
   */
  duration?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  per_month: number;
  total_price: string;
  comment?: string | null;
  linked_vehicle: LinkedVehicle;
}

export interface AssignmentList {
  /** @format uuid */
  id: string;
  operator: Contact;
  vehicle: Vehicle;
  /** @format date-time */
  start_datetime?: string | null;
  /** @format date-time */
  end_datetime?: string | null;
}

export interface BulkAddAttachmentExpense {
  files: string[];
}

export interface BulkAddAttachmentExpenseRequest {
  files: string[];
}

export interface BulkContactId {
  ids: string[];
}

export interface BulkContactIdRequest {
  ids: string[];
}

export interface BulkDataImportRequest {
  /**
   * Target section for data import (e.g., vehicles, maintenance, fuel)
   *
   * * `contacts` - Contacts
   * * `contact_renewals` - Contact Renewals
   * * `fuel_history` - Fuel History
   * * `issues` - Issues
   * * `service_reminders` - Service Reminders
   * * `service_task` - Service Task
   * * `vehicle_list` - Vehicle List
   * * `vendors` - Vendors
   * * `work_order` - Work Order
   * * `purchase_orders` - Purchase Orders
   * * `inspection_history` - Inspection History
   * * `meter_history` - Meter History
   * * `faults` - Faults
   * * `parts` - Parts
   * * `vehicle_renewals` - Vehicle Renewals
   * * `service_history` - Service History
   */
  section: BulkDataImportSectionEnum;
  /**
   * CSV file containing the data to import
   * @format binary
   */
  csv_file: File;
}

export interface BulkFuelEntry {
  ids: string[];
}

export interface BulkFuelEntryRequest {
  ids: string[];
}

export interface BulkRemoveAttachmentExpense {
  files: string[];
}

export interface BulkRemoveAttachmentExpenseRequest {
  files: string[];
}

export interface BulkServiceReminder {
  ids: string[];
}

export interface BulkServiceReminderRequest {
  ids: string[];
}

/**
 * CalendarIssue
 * Individual issue entry in the calendar.
 */
export interface CalendarIssue {
  /** Detailed information about an issue. */
  issue: IssueDetail;
  /** Status */
  status: string;
}

/** Serializer class for creating catalogues reports */
export interface CatalogueCreate {
  /** @format uuid */
  id: string;
  /**
   * Logo of the category
   * @format uuid
   */
  logo?: string | null;
  /**
   * Name of the category
   * @maxLength 255
   */
  name: string;
  /**
   * Code name of the category
   * @maxLength 255
   */
  code_name: string;
}

/** Serializer class for creating catalogues reports */
export interface CatalogueCreateRequest {
  /**
   * Logo of the category
   * @format uuid
   */
  logo?: string | null;
  /**
   * Name of the category
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Code name of the category
   * @minLength 1
   * @maxLength 255
   */
  code_name: string;
  reports: NestedCatalogueReportCreateRequest[];
}

/** Read serializer to include CatalogueReport data as detail of Catalogue data */
export interface CatalogueReportRead {
  /** @format uuid */
  id: string;
  catalogue: NestedCatalogueRead;
  /**
   * Name of the report
   * @maxLength 255
   */
  name: string;
  /**
   * Code name of the report
   * @maxLength 255
   */
  code_name: string;
  /** Description of the report */
  description?: string | null;
  link: string;
}

/** Serializer class for reading catalogues of reports */
export interface CatalogueWithCountRead {
  /** @format uuid */
  id: string;
  logo: File;
  /**
   * Name of the category
   * @maxLength 255
   */
  name: string;
  /**
   * Code name of the category
   * @maxLength 255
   */
  code_name: string;
  reports_count: string;
}

export interface ChangePasswordRequest {
  /**
   * @minLength 1
   * @maxLength 128
   */
  old_password: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  new_password: string;
}

/** ChartDefinition */
export interface ChartDefinition {
  /** Id */
  id: string;
  /** Title */
  title: string;
  type: ChartType;
  /**
   * Width
   * Width of the chart in Bootstrap grid columns
   * @min 0
   * @max 12
   * @default 6
   */
  width?: number;
  /**
   * Height class (xs, sm, md, lg, xl)
   * @default "md"
   */
  height?: HeightClass;
  /** Labels */
  labels: string[];
  /** Datasets */
  datasets: DatasetOptions[];
  /** @default null */
  options?: ChartOptions | null;
  /**
   * Icon
   * @default null
   */
  icon?: string | null;
  /**
   * Description
   * @default null
   */
  description?: string | null;
  [key: string]: any;
}

/** ChartOptions */
export interface ChartOptions {
  /**
   * Responsive
   * @default true
   */
  responsive?: boolean;
  /**
   * Maintainaspectratio
   * @default true
   */
  maintainAspectRatio?: boolean;
  /**
   * Scales
   * @default null
   */
  scales?: object | null;
  /**
   * Plugins
   * @default null
   */
  plugins?: object | null;
  [key: string]: any;
}

export interface Comment {
  /** @format uuid */
  id: string;
  comment: string;
  /** @format uuid */
  contact: string;
}

export interface CommentReadOnly {
  /** @format uuid */
  id: string;
  comment: string;
  /** @format date-time */
  created: string;
  created_by: string;
}

export interface CommentRequest {
  /** @minLength 1 */
  comment: string;
  /** @format uuid */
  contact: string;
}

export interface Company {
  /** @maxLength 255 */
  account_name?: string;
  /** @maxLength 255 */
  address?: string | null;
  /** @maxLength 255 */
  address_line_2?: string | null;
  /** @maxLength 255 */
  city?: string | null;
  /** @format uuid */
  logo?: string | null;
  /** @maxLength 255 */
  state_province_region?: string | null;
  /** @maxLength 10 */
  zip_postal_code?: string | null;
  /** @maxLength 255 */
  country?: string | null;
  /** @maxLength 20 */
  phone_number?: string | null;
  /** @maxLength 255 */
  industry?: string | null;
  /** @maxLength 5 */
  currency?: string;
  /** @maxLength 10 */
  short_date_format?: string;
  /** @maxLength 50 */
  time_zone?: string | null;
  time_format?: TimeFormatEnum | BlankEnum | NullEnum | null;
  /**
   * * `miles` - Miles
   * * `kilometers` - Kilometers
   * * `hours` - Hours
   */
  usage?: UsageEnum;
  /**
   * * `gallons_us` - Gallons (US)
   * * `gallons_uk` - Gallons (UK)
   * * `liters` - Liters
   */
  fuel_volume?: FuelVolumeEnum;
  /**
   * * `imperial` - Imperial
   * * `metric` - Metric
   */
  system_of_measurement?: SystemOfMeasurementEnum;
  tax_free_labor?: boolean;
  secondary_tax?: boolean;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  default_tax_1?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  default_tax_2?: number;
  /**
   * * `percentage` - Percentage
   * * `fixed` - Fixed
   */
  default_tax_type?: DefaultTaxTypeEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  fleet_size?: number;
}

export interface CompanyListMini {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  account_name?: string;
  /** @format uuid */
  logo?: string | null;
  /** @maxLength 20 */
  phone_number?: string | null;
}

export interface CompanyOnBoarding {
  /** @maxLength 255 */
  account_name?: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  fleet_size?: number;
  /** @maxLength 20 */
  phone_number?: string | null;
  /** @maxLength 255 */
  industry?: string | null;
  /** @maxLength 50 */
  time_zone?: string | null;
  time_format?: TimeFormatEnum | BlankEnum | NullEnum | null;
  /** @maxLength 5 */
  currency?: string;
  /** @maxLength 10 */
  short_date_format?: string;
  /**
   * Company' Owner first name
   * @maxLength 255
   */
  first_name: string;
}

export interface CompanyOnBoardingRequest {
  /** @maxLength 255 */
  account_name?: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  fleet_size?: number;
  /** @maxLength 20 */
  phone_number?: string | null;
  /** @maxLength 255 */
  industry?: string | null;
  /** @maxLength 50 */
  time_zone?: string | null;
  time_format?: TimeFormatEnum | BlankEnum | NullEnum | null;
  /**
   * @minLength 1
   * @maxLength 5
   */
  currency?: string;
  /**
   * @minLength 1
   * @maxLength 10
   */
  short_date_format?: string;
  /**
   * Company' Owner first name
   * @minLength 1
   * @maxLength 255
   */
  first_name: string;
}

export interface CompanyPackage {
  package: Package;
  /**
   * Optional custom price per unit
   * @format double
   * @min 0.01
   * @max 100000000
   * @exclusiveMax true
   */
  custom_price?: number | null;
  effective_price: string;
}

export interface ConfirmResetPasswordRequest {
  /**
   * @minLength 1
   * @maxLength 128
   */
  password: string;
  /**
   * @minLength 1
   * @maxLength 512
   */
  token: string;
}

export interface Consultation {
  /** @format uuid */
  id: string;
  /** @maxLength 100 */
  name: string;
  /** @maxLength 15 */
  phone_number: string;
  /**
   * @format email
   * @maxLength 254
   */
  email: string;
  /** @maxLength 100 */
  company_name?: string | null;
  message: string;
}

export interface ConsultationRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 15
   */
  phone_number: string;
  /**
   * @format email
   * @minLength 1
   * @maxLength 254
   */
  email: string;
  /** @maxLength 100 */
  company_name?: string | null;
  /** @minLength 1 */
  message: string;
}

export interface Contact {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  enable_fleetio_access?: boolean;
  /** @maxLength 64 */
  mobile_phone?: string | null;
  /** @maxLength 64 */
  home_phone?: string | null;
  /** @maxLength 64 */
  work_phone?: string | null;
  /** @maxLength 64 */
  other_phone?: string | null;
  address?: string | null;
  /** @maxLength 255 */
  address_line_2?: string | null;
  /** @maxLength 255 */
  city?: string | null;
  /**
   * State/province/region
   * @maxLength 255
   */
  state_province_region?: string | null;
  /**
   * Zip/postal code
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /** @maxLength 255 */
  country?: string | null;
  /** @maxLength 100 */
  job_title?: string | null;
  /** @format date */
  date_of_birth?: string | null;
  /** @maxLength 64 */
  employee_number?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  leave_date?: string | null;
  /** @maxLength 64 */
  license_number?: string | null;
  /** @maxLength 64 */
  license_class?: string | null;
  /** @maxLength 64 */
  license_state?: string | null;
  /**
   * License state/province/region
   * @maxLength 255
   */
  license_state_province_region?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  hourly_labor_rate?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  login_count?: number;
  /** @maxLength 255 */
  saml_id?: string | null;
  /** @maxLength 255 */
  id_number?: string | null;
  /** @format date */
  hire_date?: string | null;
  /** @maxLength 255 */
  cdl_endorsements?: string | null;
  /**
   * Regular user
   * Designates whether the user can log into this admin site.
   */
  is_regular_user?: boolean;
  /**
   * Administrator
   * Designates whether the user has all permissions without explicitly assigning them. But the user has certain limitations.
   */
  is_administrator?: boolean;
  /** @format uuid */
  profile_picture?: string | null;
  /** @format uuid */
  group?: string | null;
  /** @format uuid */
  role?: string | null;
}

export interface ContactCommentRead {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  profile_picture: File;
}

export interface ContactCommentReadRequest {
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
}

export interface ContactFileBulkRequest {
  files?: string[];
  /**
   * * `document` - Document
   * * `photo` - Photo
   */
  type?: TypeEnum;
}

export interface ContactForStatusChanges {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  /** @maxLength 64 */
  mobile_phone?: string | null;
  /** @maxLength 64 */
  employee_number?: string | null;
}

export interface ContactList {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  /** @maxLength 64 */
  mobile_phone?: string | null;
  /** @maxLength 64 */
  home_phone?: string | null;
  /** @maxLength 64 */
  work_phone?: string | null;
  /** @maxLength 64 */
  other_phone?: string | null;
  address?: string | null;
  /** @maxLength 255 */
  address_line_2?: string | null;
  /** @maxLength 255 */
  city?: string | null;
  /**
   * State/province/region
   * @maxLength 255
   */
  state_province_region?: string | null;
  /**
   * Zip/postal code
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /** @maxLength 255 */
  country?: string | null;
  /** @maxLength 100 */
  job_title?: string | null;
  /** @format date */
  date_of_birth?: string | null;
  /** @maxLength 64 */
  employee_number?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  leave_date?: string | null;
  /** @maxLength 64 */
  license_number?: string | null;
  /** @maxLength 64 */
  license_class?: string | null;
  /** @maxLength 64 */
  license_state?: string | null;
  /**
   * License state/province/region
   * @maxLength 255
   */
  license_state_province_region?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  hourly_labor_rate?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  login_count?: number;
  /** @maxLength 255 */
  saml_id?: string | null;
  /** @maxLength 255 */
  id_number?: string | null;
  /** @format date */
  hire_date?: string | null;
  /** @maxLength 255 */
  cdl_endorsements?: string | null;
  /**
   * Regular user
   * Designates whether the user can log into this admin site.
   */
  is_regular_user?: boolean;
  /**
   * Administrator
   * Designates whether the user has all permissions without explicitly assigning them. But the user has certain limitations.
   */
  is_administrator?: boolean;
  profile_picture: File;
  group: GroupRead;
  role: RoleContact;
  /**
   * * `active` - active
   * * `inactive` - inactive
   * * `suspended` - suspended
   * * `deleted` - deleted
   * * `invited` - invited
   * * `need_invite` - need_invite
   * * `archived` - archived
   */
  status?: Status3FcEnum;
  comments: CommentReadOnly[];
  is_archived: string;
  assigned_vehicle: string;
}

export interface ContactReadOnly {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
}

export interface ContactRenewalCreate {
  /** @format uuid */
  id: string;
  /** @format uuid */
  contact: string;
  /**
   * Date on which the contact will be renewed
   * @format date
   */
  due_date: string;
  /** @format uuid */
  renewal_type: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold: PrimaryMeterDueSoonThresholdEnum;
  enable_notification?: boolean;
  /** @format uuid */
  recipient?: string | null;
  description?: string | null;
}

export interface ContactRenewalCreateRequest {
  /** @format uuid */
  contact: string;
  /**
   * Date on which the contact will be renewed
   * @format date
   */
  due_date: string;
  /** @format uuid */
  renewal_type: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold: PrimaryMeterDueSoonThresholdEnum;
  enable_notification?: boolean;
  /** @format uuid */
  recipient?: string | null;
  description?: string | null;
}

export interface ContactRenewalList {
  /** @format uuid */
  id: string;
  contact: ContactRenewalRead;
  /**
   * Date on which the contact will be renewed
   * @format date
   */
  due_date: string;
  renewal_type: ContactRenewalType;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold: PrimaryMeterDueSoonThresholdEnum;
  enable_notification?: boolean;
  /** @format uuid */
  recipient?: string | null;
  description?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  /**
   * * `upcoming` - Upcoming
   * * `due_soon` - Due Soon
   * * `overdue` - Overdue
   */
  status?: Status5D2Enum;
  /** @format date-time */
  created: string;
}

export interface ContactRenewalRead {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  /** @maxLength 64 */
  mobile_phone?: string | null;
  /** @maxLength 64 */
  home_phone?: string | null;
  /** @maxLength 64 */
  work_phone?: string | null;
  /** @maxLength 64 */
  other_phone?: string | null;
  address?: string | null;
  /** @maxLength 255 */
  address_line_2?: string | null;
  /** @maxLength 255 */
  city?: string | null;
  /** @maxLength 255 */
  country?: string | null;
  /** @maxLength 100 */
  job_title?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  leave_date?: string | null;
  /** @maxLength 64 */
  license_number?: string | null;
  /** @maxLength 64 */
  license_class?: string | null;
  /** @maxLength 64 */
  license_state?: string | null;
  /**
   * License state/province/region
   * @maxLength 255
   */
  license_state_province_region?: string | null;
  profile_picture: File;
  /** @format uuid */
  group?: string | null;
  role: RoleContact;
  /**
   * * `active` - active
   * * `inactive` - inactive
   * * `suspended` - suspended
   * * `deleted` - deleted
   * * `invited` - invited
   * * `need_invite` - need_invite
   * * `archived` - archived
   */
  status?: Status3FcEnum;
}

export interface ContactRenewalRetrieve {
  /** @format uuid */
  id: string;
  contact: ContactRenewalRead;
  /**
   * Date on which the contact will be renewed
   * @format date
   */
  due_date: string;
  renewal_type: ContactRenewalType;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold: PrimaryMeterDueSoonThresholdEnum;
  enable_notification?: boolean;
  recipient: ContactCommentRead;
  description?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  /**
   * * `upcoming` - Upcoming
   * * `due_soon` - Due Soon
   * * `overdue` - Overdue
   */
  status?: Status5D2Enum;
}

export interface ContactRenewalType {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface ContactRenewalTypeCreate {
  /** @maxLength 255 */
  name: string;
}

export interface ContactRenewalTypeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface ContactRenewalTypeList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface ContactRenewalUpdate {
  /** @format uuid */
  contact: string;
  /**
   * Date on which the contact will be renewed
   * @format date
   */
  due_date: string;
  /** @format uuid */
  renewal_type: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold: PrimaryMeterDueSoonThresholdEnum;
  description?: string | null;
  enable_notification?: boolean;
  /** @format uuid */
  recipient?: string | null;
}

export interface ContactRenewalUpdateRequest {
  /** @format uuid */
  contact: string;
  /**
   * Date on which the contact will be renewed
   * @format date
   */
  due_date: string;
  /** @format uuid */
  renewal_type: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold: PrimaryMeterDueSoonThresholdEnum;
  description?: string | null;
  enable_notification?: boolean;
  /** @format uuid */
  recipient?: string | null;
}

export interface ContactRequest {
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  enable_fleetio_access?: boolean;
  /** @maxLength 64 */
  mobile_phone?: string | null;
  /** @maxLength 64 */
  home_phone?: string | null;
  /** @maxLength 64 */
  work_phone?: string | null;
  /** @maxLength 64 */
  other_phone?: string | null;
  address?: string | null;
  /** @maxLength 255 */
  address_line_2?: string | null;
  /** @maxLength 255 */
  city?: string | null;
  /**
   * State/province/region
   * @maxLength 255
   */
  state_province_region?: string | null;
  /**
   * Zip/postal code
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /** @maxLength 255 */
  country?: string | null;
  /** @maxLength 100 */
  job_title?: string | null;
  /** @format date */
  date_of_birth?: string | null;
  /** @maxLength 64 */
  employee_number?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  leave_date?: string | null;
  /** @maxLength 64 */
  license_number?: string | null;
  /** @maxLength 64 */
  license_class?: string | null;
  /** @maxLength 64 */
  license_state?: string | null;
  /**
   * License state/province/region
   * @maxLength 255
   */
  license_state_province_region?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  hourly_labor_rate?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  login_count?: number;
  /** @maxLength 255 */
  saml_id?: string | null;
  /** @maxLength 255 */
  id_number?: string | null;
  /** @format date */
  hire_date?: string | null;
  /** @maxLength 255 */
  cdl_endorsements?: string | null;
  /**
   * Regular user
   * Designates whether the user can log into this admin site.
   */
  is_regular_user?: boolean;
  /**
   * Administrator
   * Designates whether the user has all permissions without explicitly assigning them. But the user has certain limitations.
   */
  is_administrator?: boolean;
  /** @format uuid */
  profile_picture?: string | null;
  /** @format uuid */
  group?: string | null;
  /** @format uuid */
  role?: string | null;
}

export interface CreateAssignment {
  /** @format uuid */
  vehicle?: string | null;
  /** @format uuid */
  operator?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  end_odometer?: number | null;
  /** @format date-time */
  start_datetime?: string | null;
  /** @format date-time */
  end_datetime?: string | null;
  comment?: string | null;
}

export interface CreateAssignmentRequest {
  /** @format uuid */
  vehicle?: string | null;
  /** @format uuid */
  operator?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  end_odometer?: number | null;
  /** @format date-time */
  start_datetime?: string | null;
  /** @format date-time */
  end_datetime?: string | null;
  comment?: string | null;
}

export interface CreateFileRequest {
  /** @format binary */
  file: File;
  location?: LocationEnum | BlankEnum | NullEnum | null;
  /** @format uuid */
  object_id?: string | null;
  /** @format uuid */
  vehicle?: string | null;
}

/** Serializer for creating new integration accounts */
export interface CreateIntegrationAccountRequest {
  /** @minLength 1 */
  provider_code: string;
  /** Serializer for handling different types of credentials */
  credentials: IntegrationCredentialsRequest;
  /** @default {} */
  config?: any;
}

export interface CreateMeterEntryRequest {
  /** @format uuid */
  vehicle: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_value: number;
  /**
   * * `miles` - Miles
   * * `gallons` - Gallons
   * * `liters` - Liters
   * * `kilometers` - Kilometers
   */
  meter_unit?: MeterUnitEnum;
  void?: boolean;
  /** @format date */
  meter_date: string;
}

export interface CreateService {
  /** @format uuid */
  id: string;
  /** @format uuid */
  vehicle: string;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  void?: boolean;
  /** @format date-time */
  completion_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format uuid */
  vendor?: string | null;
  general_notes?: string | null;
  /**
   * Labor
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_labor: number;
  /**
   * Parts
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_parts: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  tax?: number;
  notes?: string | null;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  sub_total: number;
  /**
   * Total
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  total_cost: number;
  issues?: string[];
  service_task_items?: CreateServiceTaskItem[];
  labels?: string[];
  documents?: string[];
  /** @maxLength 155 */
  reference?: string | null;
  /** @format uuid */
  assigned_to?: string | null;
  /** @format uuid */
  driver?: string | null;
  /** @format uuid */
  vehicle_vendor?: string | null;
  warranties?: string[];
  /** @format uuid */
  payment_type?: string;
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface CreateServiceRequest {
  /** @format uuid */
  vehicle: string;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  void?: boolean;
  /** @format date-time */
  completion_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format uuid */
  vendor?: string | null;
  general_notes?: string | null;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  tax?: number;
  notes?: string | null;
  issues?: string[];
  service_task_items?: CreateServiceTaskItemRequest[];
  labels?: string[];
  documents?: string[];
  /** @maxLength 155 */
  reference?: string | null;
  /** @format uuid */
  assigned_to?: string | null;
  /** @format uuid */
  driver?: string | null;
  /** @format uuid */
  vehicle_vendor?: string | null;
  warranties?: string[];
  /** @format uuid */
  payment_type?: string;
  faults?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface CreateServiceTask {
  /** @maxLength 255 */
  name: string;
  description?: string;
  /** @format uuid */
  maintenance_category?: string | null;
  /** @format uuid */
  system_code?: string | null;
  /** @format uuid */
  assembly_code?: string | null;
  /** @format uuid */
  reason_for_repair_code?: string | null;
}

export interface CreateServiceTaskItem {
  /** @format uuid */
  service_task: string;
  /** @format uuid */
  reason_for_repair_code?: string | null;
  /** @format uuid */
  category?: string | null;
  /** @format uuid */
  system?: string | null;
  /** @format uuid */
  assembly?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  parts?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  subtotal?: number;
}

export interface CreateServiceTaskItemRequest {
  /** @format uuid */
  service_task: string;
  /** @format uuid */
  reason_for_repair_code?: string | null;
  /** @format uuid */
  category?: string | null;
  /** @format uuid */
  system?: string | null;
  /** @format uuid */
  assembly?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  parts?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  subtotal?: number;
}

export interface CreateServiceTaskRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: string;
  /** @format uuid */
  maintenance_category?: string | null;
  /** @format uuid */
  system_code?: string | null;
  /** @format uuid */
  assembly_code?: string | null;
  /** @format uuid */
  reason_for_repair_code?: string | null;
}

export interface CreateVendor {
  /** @format uuid */
  id: string;
  schedules?: VendorScheduleCreate[];
  services?: VendorServiceCreate[];
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /**
   * Longitude coordinate of the vendor's location
   * @format double
   */
  longitude?: number | null;
  /**
   * Latitude coordinate of the vendor's location
   * @format double
   */
  latitude?: number | null;
  /** Geographic point representing the vendor's location (automatically set from latitude/longitude) */
  location?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  attributes?: any;
  /**
   * Logo or brand image of the vendor
   * @format uuid
   */
  logo?: string | null;
  /** Tags or categories to help organize and filter vendors */
  labels?: string[];
  /** Related documents such as contracts, certificates, or agreements */
  documents?: string[];
}

export interface CreateVendorRequest {
  schedules?: VendorScheduleCreateRequest[];
  services?: VendorServiceCreateRequest[];
  /**
   * The official business name of the vendor
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /**
   * Longitude coordinate of the vendor's location
   * @format double
   */
  longitude?: number | null;
  /**
   * Latitude coordinate of the vendor's location
   * @format double
   */
  latitude?: number | null;
  /** Geographic point representing the vendor's location (automatically set from latitude/longitude) */
  location?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  attributes?: any;
  /**
   * Logo or brand image of the vendor
   * @format uuid
   */
  logo?: string | null;
  /** Tags or categories to help organize and filter vendors */
  labels?: string[];
  /** Related documents such as contracts, certificates, or agreements */
  documents?: string[];
}

export interface Currency {
  /** @maxLength 255 */
  name: string;
  /** @maxLength 3 */
  code: string;
}

export interface DamageLocations {
  /** Name of the component */
  component_name: string;
  /** Location of the damage */
  location: string;
}

/** DashboardDefinition */
export interface DashboardDefinition {
  /**
   * Title
   * @default "Admin Dashboard"
   */
  title?: string;
  /** Charts */
  charts: ChartDefinition[];
}

/** DashboardMetrics */
export interface DashboardMetrics {
  invoiced_hours: MetricData;
  new_vehicles: MetricData;
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
}

/** DashboardResponse */
export interface DashboardResponse {
  status_distribution: VehicleStatusDistribution;
  new_vehicles: NewVehiclesMetric;
  /**
   * Downtime Count
   * @min 0
   */
  downtime_count: number;
}

export interface DataImportResult {
  success: boolean;
  message: string;
  stats?: Record<string, number>;
  warnings?: string[];
  errors?: string[];
}

/** DatasetOptions */
export interface DatasetOptions {
  /** Label */
  label: string;
  /** Data */
  data: (number | object)[];
  /**
   * Backgroundcolor
   * @default null
   */
  backgroundColor?: string | string[] | null;
  /**
   * Bordercolor
   * @default null
   */
  borderColor?: string | string[] | null;
  /**
   * Borderwidth
   * @default 1
   */
  borderWidth?: number | null;
  /**
   * Fill
   * @default null
   */
  fill?: boolean | null;
  /**
   * Tension
   * @default null
   */
  tension?: number | null;
  [key: string]: any;
}

/**
 * DayIssue
 * Issue information for a specific day.
 */
export interface DayIssue {
  /** Day */
  day: number;
  /** Issue Id */
  issue_id: string | null;
  /** Status */
  status: string;
  /**
   * Has Multi Issues
   * @default false
   */
  has_multi_issues?: boolean;
  /**
   * Issues
   * @default []
   */
  issues?: CalendarIssue[];
  /**
   * Total Critical
   * @default 0
   */
  total_critical?: number;
  /**
   * Total Open
   * @default 0
   */
  total_open?: number;
  /**
   * Total Resolved
   * @default 0
   */
  total_resolved?: number;
}

export interface DeleteMultipleObjects {
  ids: string[];
}

export interface DeleteMultipleObjectsRequest {
  ids: string[];
}

/** Serializer for deletion flags */
export interface DeletionAccountRequest {
  /**
   * Integration account ID
   * @format uuid
   */
  account_id: string;
  /**
   * Provider-specific deletion options
   * @default {}
   */
  deletion_options?: any;
}

export interface DetailVendor {
  /** @format uuid */
  id: string;
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
  partner: VendorPartner;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  /** @format double */
  longitude: number | null;
  /** @format double */
  latitude: number | null;
  labels: Label[];
  documents: File[];
  comments: string;
  services: string;
  schedules: string;
  active_service_count: string;
  current_status: string;
  is_active?: boolean;
  /** Determines if the vendor should be featured in listings and searches */
  is_featured?: boolean;
  /** Indicates if the vendor is available across all companies */
  is_global?: boolean;
}

export interface DetailVendorRequest {
  /**
   * The official business name of the vendor
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  /** @format double */
  longitude: number | null;
  /** @format double */
  latitude: number | null;
  labels: LabelRequest[];
  documents: FileRequest[];
  is_active?: boolean;
  /** Determines if the vendor should be featured in listings and searches */
  is_featured?: boolean;
  /** Indicates if the vendor is available across all companies */
  is_global?: boolean;
}

/** Serializer for all travel time estimates with metadata. */
export interface DetailedTravelTimes {
  /** Detailed serializer for travel time estimates. */
  walking: TravelTime;
  /** Detailed serializer for travel time estimates. */
  cycling: TravelTime;
  /** Serializer for different driving scenarios. */
  driving: DrivingTime;
}

export interface DeviceToken {
  /** @maxLength 255 */
  device_id: string;
  /** @maxLength 255 */
  token: string;
}

export interface DeviceTokenRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  device_id: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  token: string;
}

export interface Dimensions {
  /** @format uuid */
  id: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  width?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  height?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  length?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  interior_volume?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  passenger_volume?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cargo_volume?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  ground_clearance?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  bed_length?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  weight?: number | null;
  /** @format uuid */
  vehicle: string;
}

export interface DimensionsRequest {
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  width?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  height?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  length?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  interior_volume?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  passenger_volume?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cargo_volume?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  ground_clearance?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  bed_length?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  weight?: number | null;
}

export interface DriverForWOListReport {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
}

/** Serializer for different driving scenarios. */
export interface DrivingTime {
  /** Detailed serializer for travel time estimates. */
  city: TravelTime;
  /** Detailed serializer for travel time estimates. */
  suburban: TravelTime;
  /** Detailed serializer for travel time estimates. */
  highway: TravelTime;
}

export interface DynamicInspectionItemRequest {
  items: InspectionItemCreateRequest[];
}

export interface EmailCodeConfirmation {
  code: string;
}

export interface EmailCodeConfirmationRequest {
  /** @minLength 1 */
  code: string;
}

export interface EngineAspirationCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface EngineAspirationList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface EngineBlockTypeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface EngineBlockTypeList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface EngineCamTypeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface EngineCamTypeList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface EngineFuelInductionCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface EngineFuelInductionList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface EngineWrite {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  engine_summary?: string | null;
  /** @maxLength 255 */
  engine_brand?: string | null;
  /** @format uuid */
  aspiration?: string | null;
  /** @format uuid */
  block_type?: string | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  bore?: number | null;
  /** @format uuid */
  cam_type?: string | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  compression?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  cylinders?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  displacement?: number | null;
  /** @format uuid */
  fuel_induction?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  max_hp?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  max_torque?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  redline_rpm?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  stroke?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  valves?: number | null;
}

export interface EngineWriteRequest {
  /** @maxLength 255 */
  engine_summary?: string | null;
  /** @maxLength 255 */
  engine_brand?: string | null;
  /** @format uuid */
  aspiration?: string | null;
  /** @format uuid */
  block_type?: string | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  bore?: number | null;
  /** @format uuid */
  cam_type?: string | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  compression?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  cylinders?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  displacement?: number | null;
  /** @format uuid */
  fuel_induction?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  max_hp?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  max_torque?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  redline_rpm?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  stroke?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  valves?: number | null;
}

export interface EquipmentAddPhoto {
  /** @format uuid */
  photo?: string | null;
}

export interface EquipmentComment {
  /** @format uuid */
  id: string;
  comment: string;
  /** @format uuid */
  fuel_entry: string;
}

export interface EquipmentCommentRequest {
  /** @minLength 1 */
  comment: string;
  /** @format uuid */
  fuel_entry: string;
}

export interface EquipmentCreate {
  /** @format uuid */
  id: string;
  /**
   * * `in_service` - In Service
   * * `available` - Available
   * * `out_of_service` - Out Of service
   * * `disposed` - Disposed
   * * `missing` - Missing
   * * `rented` - Rented
   */
  status?: StatusC30Enum;
  /** @maxLength 255 */
  name: string;
  description?: string | null;
  /** @format uuid */
  type?: string | null;
  /** @maxLength 255 */
  brand?: string | null;
  /** @maxLength 255 */
  model?: string | null;
  /** @maxLength 255 */
  serial_number: string;
  /** @format uuid */
  photo?: string | null;
  /** @format uuid */
  linked_vehicle?: string | null;
  /** @format uuid */
  assigned_user?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /** @format uuid */
  purchase_vendor?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  purchase_price?: number | null;
  /** @format date */
  purchase_date?: string | null;
  /** @format date */
  warranty_expiration_date?: string | null;
  /**
   * @min 0
   * @max 32767
   */
  estimated_service_life?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  estimated_resale_value?: number | null;
  /** @format date */
  in_service_date?: string | null;
  /** @format date */
  out_of_service_date?: string | null;
}

export interface EquipmentCreateRequest {
  /**
   * * `in_service` - In Service
   * * `available` - Available
   * * `out_of_service` - Out Of service
   * * `disposed` - Disposed
   * * `missing` - Missing
   * * `rented` - Rented
   */
  status?: StatusC30Enum;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: string | null;
  /** @format uuid */
  type?: string | null;
  /** @maxLength 255 */
  brand?: string | null;
  /** @maxLength 255 */
  model?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  serial_number: string;
  /** @format uuid */
  photo?: string | null;
  /** @format uuid */
  linked_vehicle?: string | null;
  /** @format uuid */
  assigned_user?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /** @format uuid */
  purchase_vendor?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  purchase_price?: number | null;
  /** @format date */
  purchase_date?: string | null;
  /** @format date */
  warranty_expiration_date?: string | null;
  /**
   * @min 0
   * @max 32767
   */
  estimated_service_life?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  estimated_resale_value?: number | null;
  /** @format date */
  in_service_date?: string | null;
  /** @format date */
  out_of_service_date?: string | null;
}

export interface EquipmentForRentHistory {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  /** @maxLength 255 */
  brand?: string | null;
  /** @maxLength 255 */
  model?: string | null;
  /** @maxLength 255 */
  serial_number: string;
}

export interface EquipmentHistoryUpdate {
  /** @format uuid */
  equipment: string;
  /** @format uuid */
  linked_vehicle: string;
  /** @format uuid */
  assigned_user?: string | null;
  /** @format uuid */
  started_by?: string | null;
  /** @format uuid */
  ended_by: string;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * Duration in days
   * @min -2147483648
   * @max 2147483647
   */
  duration?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  per_month: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_price: number;
  comment?: string | null;
}

export interface EquipmentHistoryUpdateRequest {
  /** @format uuid */
  equipment: string;
  /** @format uuid */
  linked_vehicle: string;
  /** @format uuid */
  assigned_user?: string | null;
  /** @format uuid */
  started_by?: string | null;
  /** @format uuid */
  ended_by: string;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * Duration in days
   * @min -2147483648
   * @max 2147483647
   */
  duration?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  per_month: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_price: number;
  comment?: string | null;
}

export interface EquipmentImportFileRequest {
  /** @format binary */
  file: File;
  /** @default "csv" */
  format_type?: FormatTypeEnum;
}

export interface EquipmentList {
  /** @format uuid */
  id: string;
  /**
   * * `in_service` - In Service
   * * `available` - Available
   * * `out_of_service` - Out Of service
   * * `disposed` - Disposed
   * * `missing` - Missing
   * * `rented` - Rented
   */
  status?: StatusC30Enum;
  /** @maxLength 255 */
  name: string;
  type: EquipmentTypeRetrieve;
  /** @maxLength 255 */
  brand?: string | null;
  /** @maxLength 255 */
  serial_number: string;
  assigned_user: AssignedUser;
  linked_vehicle: LinkedVehicle;
  /** @format date */
  start_date?: string | null;
  is_assigned?: boolean;
  image: File;
  documents: File[];
}

export interface EquipmentPurchaseVendor {
  /** @format uuid */
  id: string;
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
}

export interface EquipmentRemovePhoto {
  /** @format uuid */
  photo?: string | null;
}

export interface EquipmentRetrieve {
  /** @format uuid */
  id: string;
  /**
   * * `in_service` - In Service
   * * `available` - Available
   * * `out_of_service` - Out Of service
   * * `disposed` - Disposed
   * * `missing` - Missing
   * * `rented` - Rented
   */
  status?: StatusC30Enum;
  /** @maxLength 255 */
  name: string;
  description?: string | null;
  linked_vehicle: LinkedVehicle;
  /** @maxLength 255 */
  brand?: string | null;
  /** @maxLength 255 */
  model?: string | null;
  /** @maxLength 255 */
  serial_number: string;
  type: EquipmentTypeRetrieve;
  purchase_vendor: EquipmentPurchaseVendor;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  purchase_price?: number | null;
  /** @format date */
  purchase_date?: string | null;
  /** @format date */
  warranty_expiration_date?: string | null;
  /** @format date */
  in_service_date?: string | null;
  /**
   * @min 0
   * @max 32767
   */
  estimated_service_life?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  estimated_resale_value?: number | null;
  /** @format date */
  out_of_service_date?: string | null;
  assigned_user: AssignedUser;
  image: File;
  documents: File[];
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  photo: File;
  geo_position: string;
  rent_history: string;
  linked_vehicle_history: string;
  assignment_history: string;
  is_assigned?: boolean;
}

export interface EquipmentTypeCreate {
  /** @maxLength 255 */
  name: string;
}

export interface EquipmentTypeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface EquipmentTypeList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface EquipmentTypeRetrieve {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface EquipmentTypeUpdate {
  /** @maxLength 255 */
  name: string;
}

export interface EquipmentTypeUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface EquipmentUnAssign {
  /** @format uuid */
  linked_vehicle: string;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * Duration in days
   * @min -2147483648
   * @max 2147483647
   */
  duration?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  per_month: number;
  comment?: string | null;
}

export interface EquipmentUnAssignRequest {
  /** @format uuid */
  linked_vehicle: string;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * Duration in days
   * @min -2147483648
   * @max 2147483647
   */
  duration?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  per_month: number;
  comment?: string | null;
}

export interface EquipmentUpdate {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description?: string | null;
  /**
   * * `in_service` - In Service
   * * `available` - Available
   * * `out_of_service` - Out Of service
   * * `disposed` - Disposed
   * * `missing` - Missing
   * * `rented` - Rented
   */
  status?: StatusC30Enum;
  /** @format uuid */
  type?: string | null;
  /** @maxLength 255 */
  brand?: string | null;
  /** @maxLength 255 */
  model?: string | null;
  /** @maxLength 255 */
  serial_number: string;
  /** @format uuid */
  photo?: string | null;
  /** @format uuid */
  linked_vehicle?: string | null;
  /** @format uuid */
  assigned_user?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /** @format uuid */
  purchase_vendor?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  purchase_price?: number | null;
  /** @format date */
  purchase_date?: string | null;
  /** @format date */
  warranty_expiration_date?: string | null;
  /**
   * @min 0
   * @max 32767
   */
  estimated_service_life?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  estimated_resale_value?: number | null;
  /** @format date */
  in_service_date?: string | null;
  /** @format date */
  out_of_service_date?: string | null;
}

export interface EquipmentUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: string | null;
  /**
   * * `in_service` - In Service
   * * `available` - Available
   * * `out_of_service` - Out Of service
   * * `disposed` - Disposed
   * * `missing` - Missing
   * * `rented` - Rented
   */
  status?: StatusC30Enum;
  /** @format uuid */
  type?: string | null;
  /** @maxLength 255 */
  brand?: string | null;
  /** @maxLength 255 */
  model?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  serial_number: string;
  /** @format uuid */
  photo?: string | null;
  /** @format uuid */
  linked_vehicle?: string | null;
  /** @format uuid */
  assigned_user?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /** @format uuid */
  purchase_vendor?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  purchase_price?: number | null;
  /** @format date */
  purchase_date?: string | null;
  /** @format date */
  warranty_expiration_date?: string | null;
  /**
   * @min 0
   * @max 32767
   */
  estimated_service_life?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  estimated_resale_value?: number | null;
  /** @format date */
  in_service_date?: string | null;
  /** @format date */
  out_of_service_date?: string | null;
}

export interface EquipmentVehicles {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
}

export interface ExpenseComment {
  /** @format uuid */
  id: string;
  comment: string;
  /** @format uuid */
  expense: string;
}

export interface ExpenseCommentRequest {
  /** @minLength 1 */
  comment: string;
  /** @format uuid */
  expense: string;
}

export interface ExpenseCreate {
  /** @format uuid */
  vendor?: string | null;
  /** @format uuid */
  expense_type: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  amount?: number;
  /** @format date */
  payment_date?: string | null;
  /**
   * * `ONE_TIME` - One-time
   * * `MONTHLY` - Monthly
   * * `YEARLY` - Yearly
   */
  frequency?: Frequency80AEnum;
  /**
   * Start Date for Recurring
   * @format date
   */
  start_date?: string | null;
  /**
   * End Date for Recurring
   * @format date
   */
  end_date?: string | null;
  notes?: string | null;
  attachments?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface ExpenseCreateRequest {
  vehicles: string[];
  /** @format uuid */
  vendor?: string | null;
  /** @format uuid */
  expense_type: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  amount?: number;
  /** @format date */
  payment_date?: string | null;
  /**
   * * `ONE_TIME` - One-time
   * * `MONTHLY` - Monthly
   * * `YEARLY` - Yearly
   */
  frequency?: Frequency80AEnum;
  /**
   * Start Date for Recurring
   * @format date
   */
  start_date?: string | null;
  /**
   * End Date for Recurring
   * @format date
   */
  end_date?: string | null;
  notes?: string | null;
  attachments?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface ExpenseList {
  /** @format uuid */
  id: string;
  vehicle: VehicleRetrieveMini;
  vendor: VendorReport;
  expense_type: ExpenseType;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  amount?: number;
  /** @format date */
  payment_date?: string | null;
  is_single_expense?: boolean;
  is_recurring_expense?: boolean;
  /**
   * * `ONE_TIME` - One-time
   * * `MONTHLY` - Monthly
   * * `YEARLY` - Yearly
   */
  frequency?: Frequency80AEnum;
  /**
   * Start Date for Recurring
   * @format date
   */
  start_date?: string | null;
  /**
   * End Date for Recurring
   * @format date
   */
  end_date?: string | null;
  notes?: string | null;
  attachments: File[];
  comments: ExpenseComment[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface ExpenseType {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
  /** Custom Type */
  is_custom?: boolean;
}

export interface ExpenseTypeRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
  /** Custom Type */
  is_custom?: boolean;
}

export interface ExpenseUpdate {
  /** @format uuid */
  id: string;
  /** @format uuid */
  vendor?: string | null;
  /** @format uuid */
  expense_type: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  amount?: number;
  /** @format date */
  payment_date?: string | null;
  /**
   * * `ONE_TIME` - One-time
   * * `MONTHLY` - Monthly
   * * `YEARLY` - Yearly
   */
  frequency?: Frequency80AEnum;
  /**
   * Start Date for Recurring
   * @format date
   */
  start_date?: string | null;
  /**
   * End Date for Recurring
   * @format date
   */
  end_date?: string | null;
  notes?: string | null;
  attachments?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface ExpenseUpdateRequest {
  /** @format uuid */
  vendor?: string | null;
  /** @format uuid */
  expense_type: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  amount?: number;
  /** @format date */
  payment_date?: string | null;
  /**
   * * `ONE_TIME` - One-time
   * * `MONTHLY` - Monthly
   * * `YEARLY` - Yearly
   */
  frequency?: Frequency80AEnum;
  /**
   * Start Date for Recurring
   * @format date
   */
  start_date?: string | null;
  /**
   * End Date for Recurring
   * @format date
   */
  end_date?: string | null;
  notes?: string | null;
  attachments?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface ExpenseVehicle {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  expense_count: number;
}

export interface ExportData {
  /**
   * ID of the template to use for importing data
   * @format uuid
   */
  template_id: string;
  /** @default "xlsx" */
  file_type?: FileTypeB48Enum;
  /** @default "basic" */
  export_scope?: ExportScopeEnum;
}

export interface ExportDataRequest {
  /**
   * ID of the template to use for importing data
   * @format uuid
   */
  template_id: string;
  /** @default "xlsx" */
  file_type?: FileTypeB48Enum;
  /** @default "basic" */
  export_scope?: ExportScopeEnum;
}

export interface FaultCodeList {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format uuid */
  company?: string | null;
  device: TelematicsDeviceList;
  /** @maxLength 255 */
  code: string;
  /**
   * Code Description
   * @maxLength 200
   */
  name?: string | null;
  /** Code Description */
  description?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  occurrence_count?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  fmi_id?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  mil_status?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  tx_id?: number | null;
  /** @maxLength 100 */
  source_address_name?: string | null;
  /**
   * * `open` - Open
   * * `resolved` - Resolved
   * * `pending` - Pending
   * * `ignored` - Ignored
   */
  status?: Status05DEnum;
  /**
   * * `off` - Off
   * * `ignore` - Ignore
   * * `critical` - Critical
   */
  priority?: PriorityEc4Enum;
  issue: string;
}

export interface FaultCodeListRequest {
  /** @format uuid */
  company?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  code: string;
  /**
   * Code Description
   * @maxLength 200
   */
  name?: string | null;
  /** Code Description */
  description?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  occurrence_count?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  fmi_id?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  mil_status?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  tx_id?: number | null;
  /** @maxLength 100 */
  source_address_name?: string | null;
  /**
   * * `open` - Open
   * * `resolved` - Resolved
   * * `pending` - Pending
   * * `ignored` - Ignored
   */
  status?: Status05DEnum;
  /**
   * * `off` - Off
   * * `ignore` - Ignore
   * * `critical` - Critical
   */
  priority?: PriorityEc4Enum;
}

export interface FaultRuleCreate {
  /** @maxLength 255 */
  code: string;
  /** @maxLength 255 */
  name?: string | null;
  description?: string;
  /**
   * * `off` - Off
   * * `ignore` - Ignore
   * * `critical` - Critical
   */
  priority_status?: PriorityStatusEnum;
}

export interface FaultRuleCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  code: string;
  /** @maxLength 255 */
  name?: string | null;
  description?: string;
  /**
   * * `off` - Off
   * * `ignore` - Ignore
   * * `critical` - Critical
   */
  priority_status?: PriorityStatusEnum;
}

export interface FaultRuleList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  code: string;
  /** @maxLength 255 */
  name?: string | null;
  description?: string;
  /**
   * * `off` - Off
   * * `ignore` - Ignore
   * * `critical` - Critical
   */
  priority_status?: PriorityStatusEnum;
}

export interface FaultRuleRetrieve {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  code: string;
  /** @maxLength 255 */
  name?: string | null;
  description?: string;
  /**
   * * `off` - Off
   * * `ignore` - Ignore
   * * `critical` - Critical
   */
  priority_status?: PriorityStatusEnum;
}

export interface FaultRuleUpdate {
  /** @maxLength 255 */
  code: string;
  /** @maxLength 255 */
  name?: string | null;
  description?: string;
  /**
   * * `off` - Off
   * * `ignore` - Ignore
   * * `critical` - Critical
   */
  priority_status?: PriorityStatusEnum;
}

export interface FaultRuleUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  code: string;
  /** @maxLength 255 */
  name?: string | null;
  description?: string;
  /**
   * * `off` - Off
   * * `ignore` - Ignore
   * * `critical` - Critical
   */
  priority_status?: PriorityStatusEnum;
}

/** Serializer for fault sync request parameters. */
export interface FaultSyncRequest {
  /** Optional specific vehicle external ID to sync. If not provided, syncs all vehicles. */
  vehicle_external_id?: string;
  /**
   * Whether to run the sync asynchronously using Celery (default: false)
   * @default false
   */
  async_sync?: boolean;
}

export interface FaultsSummaryReport {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  code: string;
  /**
   * Code Description
   * @maxLength 200
   */
  name?: string | null;
  /** Code Description */
  description?: string | null;
  critical: string;
  vehicle_count: number;
  open_count: number;
  pending_count: number;
  ignored_count: number;
  resolved_count: number;
  /** @format date-time */
  last_occurred_date: string;
  /**
   * * `open` - Open
   * * `resolved` - Resolved
   * * `pending` - Pending
   * * `ignored` - Ignored
   */
  status?: Status05DEnum;
  /**
   * * `off` - Off
   * * `ignore` - Ignore
   * * `critical` - Critical
   */
  priority?: PriorityEc4Enum;
}

/** Serializer for featured vendors. */
export interface FeaturedVendor {
  /** @format uuid */
  id: string;
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
  /**
   * Latitude coordinate of the vendor's location
   * @format double
   */
  latitude?: number | null;
  /**
   * Longitude coordinate of the vendor's location
   * @format double
   */
  longitude?: number | null;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  partner: VendorPartner;
  /** Determines if the vendor should be featured in listings and searches */
  is_featured?: boolean;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  promotions: string;
  scoring: string;
  services: string;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  schedules: string;
  /**
   * Logo or brand image of the vendor
   * @format uuid
   */
  logo?: string | null;
}

export interface File {
  /** @format uuid */
  id: string;
  /** @format uri */
  file?: string | null;
  original_file_name: string;
  /** @maxLength 255 */
  file_name: string;
  /**
   * * `photo` - Photo
   * * `document` - Document
   * * `video` - Video
   * * `audio` - Audio
   * * `text` - Text
   * * `html` - HTML
   * * `microsoft_word` - Microsoft Word
   * * `microsoft_excel` - Microsoft Excel
   * * `microsoft_powerpoint` - Microsoft PowerPoint
   * * `csv` - CSV
   */
  file_type: FileType173Enum;
  /**
   * @min 0
   * @max 2147483647
   */
  file_size?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  original_file_size?: number | null;
  location?: LocationEnum | BlankEnum | NullEnum | null;
}

export interface FileMinimal {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  file_name: string;
  url: string;
}

export interface FileRequest {
  /** @format binary */
  file?: File | null;
  /** @minLength 1 */
  original_file_name: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  file_name: string;
  /**
   * * `photo` - Photo
   * * `document` - Document
   * * `video` - Video
   * * `audio` - Audio
   * * `text` - Text
   * * `html` - HTML
   * * `microsoft_word` - Microsoft Word
   * * `microsoft_excel` - Microsoft Excel
   * * `microsoft_powerpoint` - Microsoft PowerPoint
   * * `csv` - CSV
   */
  file_type: FileType173Enum;
  /**
   * @min 0
   * @max 2147483647
   */
  file_size?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  original_file_size?: number | null;
  location?: LocationEnum | BlankEnum | NullEnum | null;
}

export interface FileVehicleListRequest {
  files: string[];
}

export interface FileVendorRead {
  documents: File[];
}

export interface FilesEquipmentRequest {
  files: string[];
}

export interface FilesFuelEntryRequest {
  files: string[];
}

export interface FilesIssueRequest {
  files: string[];
}

export interface FilesVendor {
  /** Related documents such as contracts, certificates, or agreements */
  documents?: string[];
}

export interface FilesVendorRequest {
  /** Related documents such as contracts, certificates, or agreements */
  documents?: string[];
}

export interface FinancialDetailWrite {
  /** @format date */
  purchase_date?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  purchase_price?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  notes?: string | null;
  /** @format date */
  warranty_expiration_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  max_meter_value?: number | null;
  /** @format uuid */
  vendor?: string | null;
}

export interface FinancialDetailWriteRequest {
  /** @format date */
  purchase_date?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  purchase_price?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  notes?: string | null;
  /** @format date */
  warranty_expiration_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  max_meter_value?: number | null;
  /** @format uuid */
  vendor?: string | null;
}

export interface FleetSize {
  /** @maxLength 255 */
  name: string;
  /**
   * @min 0
   * @max 2147483647
   */
  min_range?: number;
  /**
   * @min 0
   * @max 2147483647
   */
  max_range?: number;
}

export interface Fuel {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  fuel_quality?: string | null;
  /**
   * Fuel Tank 1 Capacity
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  fuel_tank_capacity_1?: number | null;
  /**
   * Fuel Tank 2 Capacity
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  fuel_tank_capacity_2?: number | null;
  /** @format uuid */
  vehicle: string;
}

export interface FuelCardTransaction {
  /** @maxLength 255 */
  transaction_card_number: string;
  /** @maxLength 255 */
  transaction_driver_id: string;
  /** @maxLength 255 */
  transaction_driver_name: string;
  /** @maxLength 255 */
  transaction_vehicle_id: string;
  transaction_raw_data?: string | null;
}

export interface FuelEntriesByVehicle {
  /** @format uuid */
  id: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  vehicle: VehicleForFuelEntries;
  /** @format date-time */
  date: string;
  /** @maxLength 255 */
  fuel_type: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  volume: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  fuel_price: number;
  /** @format double */
  total_price: number;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  /** @format double */
  fuel_efficiency: number;
  /** @maxLength 255 */
  last_known_location?: string | null;
  vendor: VendorForFuelEntries;
}

export interface FuelEntryCreate {
  /** @format uuid */
  vehicle?: string | null;
  /** @format date-time */
  date: string;
  /** @format uuid */
  vendor?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  is_void?: boolean;
  /** @maxLength 255 */
  fuel_type: string;
  /** @maxLength 255 */
  reference?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  volume: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  fuel_price: number;
  description?: string | null;
  flag?: FlagEnum | BlankEnum | NullEnum | null;
  documents?: string[];
}

export interface FuelEntryCreateRequest {
  /** @format uuid */
  vehicle?: string | null;
  /** @format date-time */
  date: string;
  /** @format uuid */
  vendor?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  is_void?: boolean;
  /**
   * @minLength 1
   * @maxLength 255
   */
  fuel_type: string;
  /** @maxLength 255 */
  reference?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  volume: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  fuel_price: number;
  description?: string | null;
  flag?: FlagEnum | BlankEnum | NullEnum | null;
  documents?: string[];
}

export interface FuelEntryListMod {
  /** @format uuid */
  id: string;
  vehicle: LinkedVehicle;
  /** @format date-time */
  date: string;
  vendor: VendorRead;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  /** @maxLength 255 */
  fuel_type: string;
  /** @maxLength 255 */
  reference?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  volume: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  fuel_price: number;
  /** @maxLength 255 */
  last_known_location?: string | null;
  description?: string | null;
  documents: File[];
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  usage: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  total_cost: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  fuel_economy: number;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  cost_per_meter: number;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
}

export interface FuelEntryRetrieve {
  /** @format uuid */
  id: string;
  vehicle: LinkedVehicle;
  /** @format date-time */
  date: string;
  vendor: VendorRead;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  /** @maxLength 255 */
  fuel_type: string;
  /** @maxLength 255 */
  reference?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  volume: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  fuel_price: number;
  /** @maxLength 255 */
  last_known_location?: string | null;
  description?: string | null;
  transactions: FuelCardTransaction[];
  documents: File[];
  comments: string;
  flag?: FlagEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_cost: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  fuel_economy: number;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  cost_per_meter: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  usage: number;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
}

export interface FuelEntryUpdate {
  /** @format uuid */
  vehicle?: string | null;
  /** @format date-time */
  date: string;
  /** @format uuid */
  vendor?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  is_void?: boolean;
  /** @maxLength 255 */
  fuel_type: string;
  /** @maxLength 255 */
  reference?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  volume: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  fuel_price: number;
  description?: string | null;
  flag?: FlagEnum | BlankEnum | NullEnum | null;
  documents?: string[];
}

export interface FuelEntryUpdateRequest {
  /** @format uuid */
  vehicle?: string | null;
  /** @format date-time */
  date: string;
  /** @format uuid */
  vendor?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  is_void?: boolean;
  /**
   * @minLength 1
   * @maxLength 255
   */
  fuel_type: string;
  /** @maxLength 255 */
  reference?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  volume: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  fuel_price: number;
  description?: string | null;
  flag?: FlagEnum | BlankEnum | NullEnum | null;
  documents?: string[];
}

export interface FuelRequest {
  /** @maxLength 255 */
  fuel_quality?: string | null;
  /**
   * Fuel Tank 1 Capacity
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  fuel_tank_capacity_1?: number | null;
  /**
   * Fuel Tank 2 Capacity
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  fuel_tank_capacity_2?: number | null;
}

export interface FuelSummary {
  /** @format uuid */
  id: string;
  vehicle: VehicleFuelSummary;
  /** @format date-time */
  date: string;
  usage: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  volume: number;
  economy: string;
  total_cost: string;
  cost_per_gallon: string;
}

export interface FuelSummaryByLocation {
  /** @format uuid */
  vendor: string;
  vendor_name: string;
  transactions: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_gallons: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_cost: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  average_cost_per_gallon: number;
}

export interface Group {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  /** Default group */
  is_default_group?: boolean;
  /** @format uuid */
  parent_group?: string | null;
  child_groups: string[];
}

export interface GroupRead {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface GroupRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** Default group */
  is_default_group?: boolean;
  /** @format uuid */
  parent_group?: string | null;
}

export interface Hint {
  /** @format uuid */
  id: string;
  /**
   * Short, descriptive title for this hint
   * @maxLength 200
   */
  title: string;
  /** Main hint content. Markdown formatting is supported including **bold**, *italic*, lists, [links](https://example.com), and `code`. Use ## for headings. */
  content: string;
  /**
   * Application section where this hint will be displayed
   *
   * * `dashboard` - Dashboard
   * * `units` - Units
   * * `users` - Users
   * * `contact` - Contact
   * * `samsara_devices` - Samsara Devices
   * * `assignment` - Assignment
   * * `meter_history` - Meter History
   * * `fuel_history` - Fuel History
   * * `report` - Report
   * * `expense` - Expense
   * * `training_videos` - Training Videos
   * * `papers` - Papers
   * * `settings` - Settings
   * * `warranty` - Warranty
   * * `inspections_history` - Inspections History
   * * `inspections_forms` - Inspections Forms
   * * `inspection_item_failures` - Inspection Item Failures
   * * `issue` - Issue
   * * `faults` - Faults
   * * `service_history` - Service History
   * * `service_tasks` - Service Tasks
   * * `contact_renewal` - Contact Renewal
   * * `vehicle_renewal` - Vehicle Renewal
   * * `service_reminders` - Service Reminders
   * * `equipment` - Equipment
   * * `vendors` - Vendors
   * * `parts` - Parts
   * * `purchase_orders` - Purchase Orders
   * * `work_orders` - Work Orders
   */
  section: HintSectionEnum;
  /**
   * Active
   * Whether this hint is currently displayed to users
   */
  is_active?: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
}

export interface HistoryList {
  /** @format uuid */
  id: string;
  /** @format uuid */
  equipment: string;
  assigned_user: AssignedUser;
  linked_vehicle: LinkedVehicle;
  started_by: AssignedUser;
  ended_by: AssignedUser;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * Duration in days
   * @min -2147483648
   * @max 2147483647
   */
  duration?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  per_month: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_price: number;
  comment?: string | null;
}

export interface IdsRequest {
  ids: string[];
}

export interface ImportData {
  /**
   * ID of the template to use for importing data
   * @format uuid
   */
  template_id: string;
  /**
   * File containing the data to import (any supported format)
   * @format uri
   */
  file: string;
}

export interface ImportDataAsync {
  /**
   * ID of the template to use for importing data
   * @format uuid
   */
  template_id: string;
  /**
   * File ID
   * @format uuid
   */
  file: string;
}

export interface ImportDataAsyncRequest {
  /**
   * ID of the template to use for importing data
   * @format uuid
   */
  template_id: string;
  /**
   * File ID
   * @format uuid
   */
  file: string;
}

export interface ImportDataRequest {
  /**
   * ID of the template to use for importing data
   * @format uuid
   */
  template_id: string;
  /**
   * File containing the data to import (any supported format)
   * @format binary
   */
  file: File;
}

export interface ImportFile {
  /** @format uri */
  file: string;
}

export interface ImportFileRequest {
  /** @format binary */
  file: File;
}

export interface ImportJob {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  /** @maxLength 255 */
  celery_task_id: string;
  /**
   * * `PENDING` - Pending
   * * `PROCESSING` - Processing
   * * `COMPLETED` - Completed
   * * `FAILED` - Failed
   */
  status?: ImportJobStatusEnum;
  /**
   * @min 0
   * @max 32767
   */
  progress?: number;
  /**
   * @min 0
   * @max 2147483647
   */
  total_records?: number;
  /**
   * @min 0
   * @max 2147483647
   */
  imported_count?: number;
  /**
   * @min 0
   * @max 2147483647
   */
  skipped_count?: number;
  /**
   * @min 0
   * @max 2147483647
   */
  error_count?: number;
  /**
   * @min 0
   * @max 2147483647
   */
  warning_count?: number;
  results?: any;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  completed_at?: string | null;
  /** @format uuid */
  template: string;
  /** @format uuid */
  company: string;
  /** @format uuid */
  file?: string | null;
}

export interface ImportSectionWithCount {
  /** @format uuid */
  id: string;
  /**
   * Name of the import section
   * @maxLength 255
   */
  name: string;
  /**
   * Code name of the import section
   * @maxLength 255
   */
  code_name: string;
  /** Description of the import section */
  description?: string | null;
  /** Whether this section is active */
  is_active?: boolean;
  templates_count: string;
  templates: ImportTemplate[];
}

export interface ImportTemplate {
  /** @format uuid */
  id: string;
  /**
   * Name of the template
   * @maxLength 255
   */
  name: string;
  /**
   * Code name of the template
   * @maxLength 255
   */
  code_name: string;
  /**
   * Type of the import template
   *
   * * `contacts` - Contacts
   * * `contact_renewals` - Contact Renewals
   * * `fuel_history` - Fuel History
   * * `issues` - Issues
   * * `service_reminders` - Service Reminders
   * * `service_task` - Service Task
   * * `vehicle_list` - Vehicle List
   * * `vendors` - Vendors
   * * `internal_vendors` - Internal Vendors
   * * `work_order` - Work Order
   * * `purchase_orders` - Purchase Orders
   * * `inspection_history` - Inspection History
   * * `meter_history` - Meter History
   * * `faults` - Faults
   * * `parts` - Parts
   * * `vehicle_renewals` - Vehicle Renewals
   * * `service_history` - Service History
   * * `expenses` - Expenses
   */
  template_type: TemplateTypeEnum;
  empty_file: File;
  prefilled_file: File;
}

export interface Industry {
  /** @maxLength 255 */
  name: string;
}

export interface InputDirectFinishRequest {
  /** @minLength 1 */
  file_id: string;
}

export interface InputRequest {
  /** @minLength 1 */
  file_name: string;
  /** @minLength 1 */
  file_type: string;
}

export interface InspectionError {
  /** Component or area with issue */
  field: string;
  /** Brief error description */
  error: string;
  /** Detailed explanation of the issue */
  detail: string;
  /**
   * Priority level (1-5, where 5 is highest)
   * @format double
   * @min 1
   * @max 5
   */
  priority: number;
  /**
   * Estimated repair cost in USD
   * @format double
   * @min 0
   */
  estimated_cost: number;
  /**
   * Estimated repair time in hours
   * @format double
   * @min 0
   */
  estimated_time: number;
}

export interface InspectionFailedList {
  /** @format uuid */
  id: string;
  submission: string;
  item_name: string;
  form: string;
  vehicle: string;
  /** @format date-time */
  inspection_date: string;
  inspector: string;
  comment?: string | null;
  /**
   * * `NEEDS_ACTION` - Needs Action
   * * `OPEN_ISSUE` - Open Issue
   * * `ACKNOWLEDGED` - Acknowledged
   * * `RESOLVED` - Resolved
   */
  status?: Status474Enum;
  /**
   * Stage of the inspection item
   * @maxLength 20
   */
  stage?: string | null;
}

export interface InspectionFailedResultList {
  /** @format uuid */
  id: string;
  submission: InspectionReadOnly;
  item: InspectionItemCreate;
  chosen_option: InspectionItemChoice;
  photo: File | null;
  video: File | null;
  issue: Issue;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  failed: boolean;
  /**
   * * `section` - Section
   * * `pass_fail` - Pass/Fail
   * * `meter_entry` - Meter Entry
   * * `date_time` - Date and Time
   * * `number` - Number
   * * `dropdown` - Dropdown
   * * `photo` - Photo
   * * `video` - Video
   * * `signature` - Signature
   * * `free_text` - Free Text
   */
  result_type: ResultTypeEnum;
  comment?: string | null;
  /** @format date-time */
  date_time_result?: string | null;
  text_value?: string | null;
  /**
   * @format double
   * @min -1e+23
   * @exclusiveMin true
   * @max 1e+23
   * @exclusiveMax true
   */
  meter_entry_value?: number | null;
  /**
   * @format double
   * @min -1e+23
   * @exclusiveMin true
   * @max 1e+23
   * @exclusiveMax true
   */
  numeric_value?: number | null;
  pass_fail_value?: boolean | null;
  pass_fail_na_option?: boolean | null;
  /**
   * * `NEEDS_ACTION` - Needs Action
   * * `OPEN_ISSUE` - Open Issue
   * * `ACKNOWLEDGED` - Acknowledged
   * * `RESOLVED` - Resolved
   */
  status?: Status474Enum;
  /**
   * Stage of the inspection item
   * @maxLength 20
   */
  stage?: string | null;
  acknowledged_comment?: string | null;
}

export interface InspectionFormDetailsRead {
  /** @format uuid */
  id: string;
  items: InspectionItemCreate[];
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  /** @maxLength 255 */
  title: string;
  description?: string | null;
  /**
   * Hex color code for the form
   * @maxLength 7
   */
  color?: string;
  /** Enable Location Exception Tracking */
  enable_location_exception_tracking?: boolean;
  /** Prevent Use of Stored Photos, forcing users to take photos using the device's camera */
  prevent_use_of_stored_photos?: boolean;
}

export interface InspectionFormLinkedVehiclesList {
  /** @format uuid */
  id: string;
  vehicle: VehicleSerializerForInspection;
  inspection_form: InspectionFormSimpleList;
  /** Whether the inspection form is currently enabled for this vehicle. */
  is_enabled?: boolean;
  /**
   * Indicates whether this was added by rule or manually.
   *
   * * `rule` - Added by Rule
   * * `manual` - Manually Added
   */
  add_via?: AddViaEnum;
  current_status: string;
  human_readable_frequency: string;
  /**
   * Calculated date for the next inspection.
   * @format date-time
   */
  next_due_date?: string | null;
}

export interface InspectionFormLinkedVehiclesListByForm {
  /** @format uuid */
  id: string;
  vehicle: VehicleSerializerForInspection;
  /** Whether the inspection form is currently enabled for this vehicle. */
  is_enabled?: boolean;
  /**
   * Indicates whether this was added by rule or manually.
   *
   * * `rule` - Added by Rule
   * * `manual` - Manually Added
   */
  add_via?: AddViaEnum;
  human_readable_frequency: string;
  /**
   * Calculated date for the next inspection.
   * @format date-time
   */
  next_due_date?: string | null;
  current_status: string;
}

export interface InspectionFormRead {
  /** @format uuid */
  id: string;
  items_count: number;
  submissions_count: number;
  is_archived: boolean;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  /** @maxLength 255 */
  title: string;
  description?: string | null;
  /**
   * Hex color code for the form
   * @maxLength 7
   */
  color?: string;
  /** Enable Location Exception Tracking */
  enable_location_exception_tracking?: boolean;
  /** Prevent Use of Stored Photos, forcing users to take photos using the device's camera */
  prevent_use_of_stored_photos?: boolean;
}

export interface InspectionFormReadRequest {
  is_active?: boolean;
  /**
   * @minLength 1
   * @maxLength 255
   */
  title: string;
  description?: string | null;
  /**
   * Hex color code for the form
   * @minLength 1
   * @maxLength 7
   */
  color?: string;
  /** Enable Location Exception Tracking */
  enable_location_exception_tracking?: boolean;
  /** Prevent Use of Stored Photos, forcing users to take photos using the device's camera */
  prevent_use_of_stored_photos?: boolean;
}

/**
 * Serializer for creating inspection form rules.
 * This serializer is used to create new inspection form rules.
 */
export interface InspectionFormRuleCreate {
  /**
   * The inspection form this rule applies to.
   * @format uuid
   */
  inspection_form: string;
  /**
   * Determines how vehicles are selected for this rule.
   *
   * * `all` - All Vehicles
   * * `by_type` - By Vehicle Type
   * * `by_group` - By Vehicle Group
   */
  rule_type?: RuleTypeEnum;
  /** Vehicle types to which this rule should apply. */
  vehicle_types?: string[];
  /** Vehicle groups to which this rule should apply. */
  vehicle_groups?: string[];
  /** Contacts to which notifications should be sent. */
  recipients?: string[];
  /**
   * Priority of this rule when multiple rules could apply.
   * @min 0
   * @max 2147483647
   */
  priority_order?: number;
  specific_vehicles?: string[];
  /** Whether this rule defines a recurring inspection schedule. */
  set_schedule?: boolean;
  /**
   * Frequency of the scheduled inspection (if enabled).
   *
   * * `daily` - Daily
   * * `weekly` - Weekly
   * * `monthly` - Monthly
   * * `yearly` - Yearly
   */
  frequency?: FrequencyD02Enum | BlankEnum | NullEnum | null;
  /**
   * Repeat interval based on the selected frequency (e.g., every 2 weeks).
   * @min 0
   * @max 2147483647
   */
  interval_value?: number | null;
  /**
   * Day of the week to run the inspection (e.g., 'Monday').
   *
   * * `monday` - Monday
   * * `tuesday` - Tuesday
   * * `wednesday` - Wednesday
   * * `thursday` - Thursday
   * * `friday` - Friday
   * * `saturday` - Saturday
   * * `sunday` - Sunday
   */
  specific_day?: SpecificDayEnum | BlankEnum | NullEnum | null;
  /** If true, reminder notifications will be sent for due inspections. */
  send_reminder_notification?: boolean;
}

/**
 * Serializer for creating inspection form rules.
 * This serializer is used to create new inspection form rules.
 */
export interface InspectionFormRuleCreateRequest {
  /**
   * The inspection form this rule applies to.
   * @format uuid
   */
  inspection_form: string;
  /**
   * Determines how vehicles are selected for this rule.
   *
   * * `all` - All Vehicles
   * * `by_type` - By Vehicle Type
   * * `by_group` - By Vehicle Group
   */
  rule_type?: RuleTypeEnum;
  /** Vehicle types to which this rule should apply. */
  vehicle_types?: string[];
  /** Vehicle groups to which this rule should apply. */
  vehicle_groups?: string[];
  /** Contacts to which notifications should be sent. */
  recipients?: string[];
  /**
   * Priority of this rule when multiple rules could apply.
   * @min 0
   * @max 2147483647
   */
  priority_order?: number;
  specific_vehicles?: string[];
  /** Whether this rule defines a recurring inspection schedule. */
  set_schedule?: boolean;
  /**
   * Frequency of the scheduled inspection (if enabled).
   *
   * * `daily` - Daily
   * * `weekly` - Weekly
   * * `monthly` - Monthly
   * * `yearly` - Yearly
   */
  frequency?: FrequencyD02Enum | BlankEnum | NullEnum | null;
  /**
   * Repeat interval based on the selected frequency (e.g., every 2 weeks).
   * @min 0
   * @max 2147483647
   */
  interval_value?: number | null;
  /**
   * Day of the week to run the inspection (e.g., 'Monday').
   *
   * * `monday` - Monday
   * * `tuesday` - Tuesday
   * * `wednesday` - Wednesday
   * * `thursday` - Thursday
   * * `friday` - Friday
   * * `saturday` - Saturday
   * * `sunday` - Sunday
   */
  specific_day?: SpecificDayEnum | BlankEnum | NullEnum | null;
  /** If true, reminder notifications will be sent for due inspections. */
  send_reminder_notification?: boolean;
}

export interface InspectionFormRuleList {
  /** @format uuid */
  id: string;
  /**
   * Determines how vehicles are selected for this rule.
   *
   * * `all` - All Vehicles
   * * `by_type` - By Vehicle Type
   * * `by_group` - By Vehicle Group
   */
  rule_type?: RuleTypeEnum;
  vehicles_count: number;
  vehicle_types: VehicleType[] | null;
  vehicle_groups: GroupRead[] | null;
  /**
   * Frequency of the scheduled inspection (if enabled).
   *
   * * `daily` - Daily
   * * `weekly` - Weekly
   * * `monthly` - Monthly
   * * `yearly` - Yearly
   */
  frequency?: FrequencyD02Enum | BlankEnum | NullEnum | null;
}

export interface InspectionFormSimpleList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  title: string;
  is_active?: boolean;
}

export interface InspectionFormWrite {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active: boolean;
  /** @maxLength 255 */
  title: string;
  description?: string | null;
  /**
   * Hex color code for the form
   * @maxLength 7
   */
  color?: string;
  /** Enable Location Exception Tracking */
  enable_location_exception_tracking?: boolean;
  /** Prevent Use of Stored Photos, forcing users to take photos using the device's camera */
  prevent_use_of_stored_photos?: boolean;
}

export interface InspectionFormWriteRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  title: string;
  description?: string | null;
  /**
   * Hex color code for the form
   * @minLength 1
   * @maxLength 7
   */
  color?: string;
  /** Enable Location Exception Tracking */
  enable_location_exception_tracking?: boolean;
  /** Prevent Use of Stored Photos, forcing users to take photos using the device's camera */
  prevent_use_of_stored_photos?: boolean;
}

export interface InspectionItemChoice {
  id?: number;
  /** @maxLength 255 */
  text: string;
  fail_if_chosen?: boolean;
}

export interface InspectionItemChoiceRead {
  id: number;
  /** @maxLength 255 */
  text: string;
  fail_if_chosen?: boolean;
}

export interface InspectionItemChoiceRequest {
  id?: number;
  /**
   * @minLength 1
   * @maxLength 255
   */
  text: string;
  fail_if_chosen?: boolean;
}

export interface InspectionItemCreate {
  /** @format uuid */
  id?: string;
  /** @maxLength 255 */
  name: string;
  description?: string | null;
  instructions?: string | null;
  is_required?: boolean;
  item_type?: ItemTypeEnum | BlankEnum | NullEnum | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  order?: number | null;
  enable_na_option?: boolean;
  require_photo_or_comment_for_pass?: boolean | null;
  require_photo_or_comment_for_fail?: boolean | null;
  /** @maxLength 100 */
  pass_label?: string;
  /** @maxLength 100 */
  fail_label?: string;
  /** @maxLength 100 */
  na_label?: string | null;
  require_secondary_meter?: boolean;
  require_photo_verification?: boolean;
  date_only?: boolean;
  date_and_time?: boolean;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  minimum?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  maximum?: number | null;
  allow_multiple_selections?: boolean;
  choices?: InspectionItemChoice[];
}

export interface InspectionItemCreateRequest {
  /** @format uuid */
  id?: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: string | null;
  instructions?: string | null;
  is_required?: boolean;
  item_type?: ItemTypeEnum | BlankEnum | NullEnum | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  order?: number | null;
  enable_na_option?: boolean;
  require_photo_or_comment_for_pass?: boolean | null;
  require_photo_or_comment_for_fail?: boolean | null;
  /**
   * @minLength 1
   * @maxLength 100
   */
  pass_label?: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  fail_label?: string;
  /** @maxLength 100 */
  na_label?: string | null;
  require_secondary_meter?: boolean;
  require_photo_verification?: boolean;
  date_only?: boolean;
  date_and_time?: boolean;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  minimum?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  maximum?: number | null;
  allow_multiple_selections?: boolean;
  choices?: InspectionItemChoiceRequest[];
}

export interface InspectionMetadata {
  file_name: string;
  file_size: number;
  /** @format date-time */
  upload_date: string;
  model: string;
  /** @format uuid */
  company_id: string;
  /** @format uuid */
  uploaded_by?: string;
}

export interface InspectionReadItem {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  /** @format uuid */
  form: string;
  /** @format uuid */
  parent?: string | null;
  /** @maxLength 255 */
  name: string;
  description?: string | null;
  instructions?: string | null;
  is_required?: boolean;
  item_type?: ItemTypeEnum | BlankEnum | NullEnum | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  order?: number | null;
  enable_na_option?: boolean;
  /** @maxLength 100 */
  pass_label?: string;
  /** @maxLength 100 */
  fail_label?: string;
  /** @maxLength 100 */
  na_label?: string | null;
  require_secondary_meter?: boolean;
  require_photo_verification?: boolean;
  date_only?: boolean;
  date_and_time?: boolean;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  minimum?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  maximum?: number | null;
  allow_multiple_selections?: boolean;
  require_photo_or_comment_for_pass?: boolean | null;
  require_photo_or_comment_for_fail?: boolean | null;
  choices: InspectionItemChoiceRead[];
}

export interface InspectionReadOnly {
  /** @format uuid */
  id: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  reference_code?: number | null;
  form: InspectionFormRead;
  vehicle: LinkedVehicle;
  /** @format date-time */
  submitted_at: string;
  /** @maxLength 20 */
  latitude?: string | null;
  /** @maxLength 20 */
  longitude?: string | null;
  /**
   * * `web` - Web
   * * `mobile` - Mobile
   */
  source?: SourceEnum;
  duration: string;
  /** @format date-time */
  started_at: string;
  submitted_by: ContactCommentRead;
}

export interface InspectionRequestRequest {
  /**
   * ID of the uploaded image file
   * @format uuid
   */
  file_id: string;
  /**
   * Include additional metadata in response
   * @default false
   */
  include_metadata?: boolean;
}

export interface InspectionResponse {
  /** @format uuid */
  file_id: string;
  /** General description of the issue */
  general_description: string;
  damage_locations: DamageLocations[];
  errors: InspectionError[];
  summary: Summary;
  metadata?: InspectionMetadata;
}

/** Serializer for inspection results. */
export interface InspectionResult {
  /** @format uuid */
  id: string;
  /** @format uuid */
  submission: string;
  /** @format uuid */
  item: string;
  failed: boolean;
  result_type: ResultTypeEnum;
  comment?: string | null;
  /** @format uuid */
  photo?: string | null;
  /** @format uuid */
  video?: string | null;
  /** @format date-time */
  date_time_result?: string | null;
  chosen_option?: number | null;
  text_value?: string | null;
  /**
   * @format double
   * @min -1e+23
   * @exclusiveMin true
   * @max 1e+23
   * @exclusiveMax true
   */
  meter_entry_value?: number | null;
  /**
   * @format double
   * @min -1e+23
   * @exclusiveMin true
   * @max 1e+23
   * @exclusiveMax true
   */
  numeric_value?: number | null;
  pass_fail_value?: boolean | null;
  pass_fail_na_option?: boolean | null;
}

export interface InspectionResultAcknowledge {
  acknowledged_comment?: string;
}

export interface InspectionResultAcknowledgeRequest {
  acknowledged_comment?: string;
}

/** Serializer for inspection results. */
export interface InspectionResultRequest {
  /** @format uuid */
  item: string;
  comment?: string | null;
  /** @format uuid */
  photo?: string | null;
  /** @format uuid */
  video?: string | null;
  /** @format date-time */
  date_time_result?: string | null;
  chosen_option?: number | null;
  text_value?: string | null;
  /**
   * @format double
   * @min -1e+23
   * @exclusiveMin true
   * @max 1e+23
   * @exclusiveMax true
   */
  meter_entry_value?: number | null;
  /**
   * @format double
   * @min -1e+23
   * @exclusiveMin true
   * @max 1e+23
   * @exclusiveMax true
   */
  numeric_value?: number | null;
  pass_fail_value?: boolean | null;
  pass_fail_na_option?: boolean | null;
}

export interface InspectionSubmission {
  /** @format uuid */
  id: string;
  reference_code: number | null;
  /** @format uuid */
  form: string;
  /** @format uuid */
  vehicle: string;
  /**
   * * `web` - Web
   * * `mobile` - Mobile
   */
  source?: SourceEnum;
  duration: string;
  /** @format date-time */
  started_at: string;
  /** @format date-time */
  submitted_at: string;
  /** @maxLength 20 */
  latitude?: string | null;
  /** @maxLength 20 */
  longitude?: string | null;
}

/** Serializer for listing the main information of inspection submissions. */
export interface InspectionSubmissionDetailItems {
  /** @format uuid */
  id: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  reference_code?: number | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  form: InspectionFormRead;
  vehicle: LinkedVehicle;
  /**
   * * `web` - Web
   * * `mobile` - Mobile
   */
  source?: SourceEnum;
  duration: string;
  /** @format date-time */
  started_at: string;
  /** @format date-time */
  submitted_at: string;
  /** @maxLength 20 */
  latitude?: string | null;
  /** @maxLength 20 */
  longitude?: string | null;
  submitted_by: ContactCommentRead;
  failed_items_count: number;
  results: InspectionFailedResultList[];
  faults: FaultCodeList[];
}

/** Serializer for listing the main information of inspection submissions. */
export interface InspectionSubmissionList {
  /** @format uuid */
  id: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  reference_code?: number | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  form: InspectionFormRead;
  vehicle: LinkedVehicle;
  /**
   * * `web` - Web
   * * `mobile` - Mobile
   */
  source?: SourceEnum;
  duration: string;
  /** @format date-time */
  started_at: string;
  /** @format date-time */
  submitted_at: string;
  /** @maxLength 20 */
  latitude?: string | null;
  /** @maxLength 20 */
  longitude?: string | null;
  submitted_by: ContactCommentRead;
  failed_items: string;
  failed_items_count: number;
  is_archived: boolean;
}

export interface InspectionSubmissionRequest {
  /** @format uuid */
  form: string;
  /** @format uuid */
  vehicle: string;
  /**
   * * `web` - Web
   * * `mobile` - Mobile
   */
  source?: SourceEnum;
  duration: string;
  /** @format date-time */
  started_at: string;
  /** @maxLength 20 */
  latitude?: string | null;
  /** @maxLength 20 */
  longitude?: string | null;
  inspection_results: InspectionResultRequest[];
}

export interface InspectionSubmissionSummary {
  vehicle_name: string;
  submissions_count: number;
  forms_count: number;
  average_duration: string;
}

export interface IntFaultCode {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  code: string;
}

/** Serializer for handling different types of credentials */
export interface IntegrationCredentialsRequest {
  /** @minLength 1 */
  token?: string | null;
  /** @minLength 1 */
  access_token?: string | null;
  /** @minLength 1 */
  refresh_token?: string | null;
  /** @format date-time */
  expires_at?: string | null;
  /** @minLength 1 */
  username?: string | null;
  /** @minLength 1 */
  password?: string | null;
  /** @minLength 1 */
  api_key?: string | null;
  /** @minLength 1 */
  api_secret?: string | null;
}

export interface Integrations {
  id: number;
  /**
   * Samsara Name
   * @maxLength 255
   */
  samsara_account_name?: string | null;
  /**
   * Samsara ID
   * @maxLength 255
   */
  samsara_account_id?: string | null;
  /**
   * * `online` - Online
   * * `offline` - Offline
   */
  status?: IntegrationsStatusEnum;
  device_count: string;
}

export interface Invoice {
  /** @format uuid */
  id: string;
  /**
   * Unique invoice number
   * @maxLength 50
   */
  number: string;
  /** @format date */
  period_start: string;
  /** @format date */
  period_end: string;
  /** @format date */
  due_date: string;
  /**
   * Total units in fleet
   * @min 0
   * @max 2147483647
   */
  total_units: number;
  /**
   * Units exceeding 20% usage threshold
   * @min 0
   * @max 2147483647
   */
  active_units: number;
  /**
   * @format double
   * @min 0.01
   * @max 100000000
   * @exclusiveMax true
   */
  unit_price: number;
  /**
   * @format double
   * @min 0.01
   * @max 100000000
   * @exclusiveMax true
   */
  total_amount: number;
  /**
   * * `draft` - Draft
   * * `issued` - Issued
   * * `paid` - Paid
   * * `overdue` - Overdue
   * * `cancelled` - Cancelled
   */
  status?: InvoiceStatusEnum;
  status_display: string;
  pdf_url: string;
  /** @format date-time */
  issued_at?: string | null;
  /** @format date-time */
  paid_at?: string | null;
}

export interface InvoiceRequestRequest {
  /**
   * ID of the uploaded image file
   * @format uuid
   */
  file_id: string;
  /**
   * 'service' or 'work_order'
   * @minLength 1
   */
  schema_type: string;
}

export interface Issue {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  summary: string;
  description: string;
  /**
   * * `critical` - Critical
   * * `high` - High
   * * `medium` - Medium
   * * `low` - Low
   * * `no_priority` - No Priority
   */
  priority?: Priority3DfEnum;
  major_functionality_impaired?: boolean;
  /** @format uuid */
  vehicle: string;
  /** @format date-time */
  reported_date: string;
  /** @format uuid */
  reported_by: string;
  /** @format date-time */
  due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_odometer?: number | null;
  assigned_to?: string[];
  /** @format time */
  time?: string | null;
  labels?: string[];
  /** @format uuid */
  failed_item?: string | null;
  reference_type?: ReferenceTypeEnum | BlankEnum;
  /** @format uuid */
  reference_id?: string | null;
  /** @format uuid */
  fault?: string | null;
}

export interface IssueComment {
  /** @format uuid */
  id: string;
  comment: string;
  /** @format uuid */
  issue: string;
}

export interface IssueCommentRequest {
  /** @minLength 1 */
  comment: string;
  /** @format uuid */
  issue: string;
}

export interface IssueContact {
  /** @format uuid */
  id: string;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /** @maxLength 64 */
  mobile_phone?: string | null;
  /** @maxLength 64 */
  home_phone?: string | null;
  /** @maxLength 64 */
  work_phone?: string | null;
  /** @maxLength 64 */
  other_phone?: string | null;
  address?: string | null;
  /** @maxLength 255 */
  address_line_2?: string | null;
  /** @maxLength 255 */
  city?: string | null;
  /**
   * State/province/region
   * @maxLength 255
   */
  state_province_region?: string | null;
  /**
   * Zip/postal code
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /** @maxLength 255 */
  country?: string | null;
  /** @maxLength 100 */
  job_title?: string | null;
  /** @format date */
  date_of_birth?: string | null;
  /** @maxLength 64 */
  employee_number?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  leave_date?: string | null;
  /** @maxLength 64 */
  license_number?: string | null;
  /** @maxLength 64 */
  license_class?: string | null;
  /** @maxLength 64 */
  license_state?: string | null;
  /**
   * License state/province/region
   * @maxLength 255
   */
  license_state_province_region?: string | null;
  /** @maxLength 255 */
  saml_id?: string | null;
  /** @maxLength 255 */
  id_number?: string | null;
  /** @format date */
  hire_date?: string | null;
  /** @maxLength 255 */
  cdl_endorsements?: string | null;
  /** @format uuid */
  profile_picture?: string | null;
}

/**
 * IssueDashboardResponse
 * Main response schema for the issue dashboard API endpoint.
 * This is what the frontend will receive when calling GET /api/v1/issue-dashboard/
 */
export interface IssueDashboardResponse {
  /**
   * Total Issues
   * Total number of issues
   */
  total_issues: number;
  /** Issues created in the last period */
  issues_created: TimeMetricValue;
  /** Issues resolved in the last period */
  issues_resolved: TimeMetricValue;
  /** Percentage of issues resolved */
  resolution_rate: TimeMetricValue;
  status_percentages: StatusPercentages;
  priority_distribution: PriorityDistribution;
  time_metrics: TimeMetrics;
  /**
   * By Vehicle Distribution
   * Top 10 vehicles with most issues
   */
  by_vehicle_distribution: VehicleIssueCount[];
  /**
   * Trending Labels
   * Top 5 trending issue labels
   */
  trending_labels: TrendingLabel[];
  /**
   * Last Updated
   * Timestamp of when the data was last updated
   * @format date-time
   */
  last_updated: string;
}

/**
 * IssueDetail
 * Detailed information about an issue.
 */
export interface IssueDetail {
  /**
   * Id
   * @format uuid4
   */
  id: string;
  /** Summary */
  summary: string;
  /** Description */
  description: string | null;
  /** Priority */
  priority: string;
  /** Status */
  status: string;
  /**
   * Reported Date
   * @format date-time
   */
  reported_date: string;
  /** Due Date */
  due_date: string | null;
  /** Major Functionality Impaired */
  major_functionality_impaired: boolean;
  /** Resolved Date */
  resolved_date: string | null;
  /** Reference Code */
  reference_code: number | null;
  /** Odometer */
  odometer: number | null;
}

export interface IssueMiniRead {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  summary: string;
  description: string;
  /**
   * * `open` - Open
   * * `resolved` - Resolved
   * * `closed` - Closed
   * * `done` - Done
   */
  status?: IssueMiniReadStatusEnum;
  /**
   * * `critical` - Critical
   * * `high` - High
   * * `medium` - Medium
   * * `low` - Low
   * * `no_priority` - No Priority
   */
  priority?: Priority3DfEnum;
  /** @format date-time */
  reported_date: string;
  /** @format time */
  time?: string | null;
  is_overdue: string;
  reference_type?: ReferenceTypeEnum | BlankEnum;
  /** @format uuid */
  reference_id?: string | null;
}

export interface IssueNote {
  note?: string | null;
}

export interface IssueNoteRequest {
  note?: string | null;
}

export interface IssueRead {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  summary: string;
  description: string;
  status: string;
  /**
   * * `critical` - Critical
   * * `high` - High
   * * `medium` - Medium
   * * `low` - Low
   * * `no_priority` - No Priority
   */
  priority?: Priority3DfEnum;
  major_functionality_impaired?: boolean;
  vehicle: VehicleIssue;
  /** @format date-time */
  reported_date: string;
  reported_by: IssueContact;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  /** @maxLength 255 */
  source?: string | null;
  /** @format date-time */
  due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_odometer?: number | null;
  assigned_to: IssueContact[];
  /** @format time */
  time?: string | null;
  labels: Label[];
  resolved_by: IssueContact;
  resolution_details: string;
  is_overdue: boolean;
  comments: string;
  reference_type?: ReferenceTypeEnum | BlankEnum;
  /** @format uuid */
  reference_id?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  reference_code?: number | null;
  /** @format uuid */
  fault?: string | null;
}

export interface IssueRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  summary: string;
  /** @minLength 1 */
  description: string;
  /**
   * * `critical` - Critical
   * * `high` - High
   * * `medium` - Medium
   * * `low` - Low
   * * `no_priority` - No Priority
   */
  priority?: Priority3DfEnum;
  major_functionality_impaired?: boolean;
  /** @format uuid */
  vehicle: string;
  /** @format date-time */
  reported_date: string;
  /** @format uuid */
  reported_by: string;
  /** @format date-time */
  due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_odometer?: number | null;
  assigned_to?: string[];
  /** @format time */
  time?: string | null;
  labels?: string[];
  /** @format uuid */
  failed_item?: string | null;
  reference_type?: ReferenceTypeEnum | BlankEnum;
  /** @format uuid */
  reference_id?: string | null;
  /** @format uuid */
  fault?: string | null;
}

export interface IssueTimeline {
  action: string;
  /** @format date-time */
  timestamp: string;
  /** @format uuid */
  taken_by: string;
}

export interface IssueUpdate {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  summary: string;
  description: string;
  /**
   * * `critical` - Critical
   * * `high` - High
   * * `medium` - Medium
   * * `low` - Low
   * * `no_priority` - No Priority
   */
  priority?: Priority3DfEnum;
  major_functionality_impaired?: boolean;
  /** @format uuid */
  vehicle: string;
  /** @format date-time */
  reported_date: string;
  /** @format uuid */
  reported_by: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  /** @maxLength 255 */
  source?: string | null;
  /** @format date-time */
  due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_odometer?: number | null;
  assigned_to?: string[];
  /** @format time */
  time?: string | null;
  labels?: string[];
}

export interface IssueUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  summary: string;
  /** @minLength 1 */
  description: string;
  /**
   * * `critical` - Critical
   * * `high` - High
   * * `medium` - Medium
   * * `low` - Low
   * * `no_priority` - No Priority
   */
  priority?: Priority3DfEnum;
  major_functionality_impaired?: boolean;
  /** @format uuid */
  vehicle: string;
  /** @format date-time */
  reported_date: string;
  /** @format uuid */
  reported_by: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  /** @maxLength 255 */
  source?: string | null;
  /** @format date-time */
  due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_odometer?: number | null;
  assigned_to?: string[];
  /** @format time */
  time?: string | null;
  labels?: string[];
}

/**
 * IssuesCalendarResponse
 * Complete calendar response.
 */
export interface IssuesCalendarResponse {
  /**
   * Start Date
   * @format date
   */
  start_date: string;
  /**
   * End Date
   * @format date
   */
  end_date: string;
  /** Vehicles */
  vehicles: VehicleCalendarIssues[];
  /**
   * Total Vehicles With Issues
   * @default 0
   */
  total_vehicles_with_issues?: number;
}

export interface Label {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface LabelRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface LaborTimeEntriesListReport {
  /** @format uuid */
  id: string;
  technician: TechnicianForLaborTimeEntriesListReport;
  vehicle: string;
  service_task: string;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  completed_at?: string | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  labor_hours?: number;
  /** @maxLength 16 */
  labor_time?: string | null;
  note?: string | null;
}

export interface LinkedVehicle {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  image: LinkedVehicleImage;
}

export interface LinkedVehicleHistoryList {
  /** @format uuid */
  id: string;
  /** @format uuid */
  equipment: string;
  linked_vehicle: LinkedVehicle;
  started_by: AssignedUser;
  ended_by: AssignedUser;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * Duration in days
   * @min -2147483648
   * @max 2147483647
   */
  duration?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  per_month: number;
  total_price: string;
  comment?: string | null;
}

export interface LinkedVehicleImage {
  /** @format uuid */
  id: string;
  /** @format uri */
  file?: string | null;
}

export interface LinkedVehicleRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  type: VehicleTypeListRequest;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
}

export interface ListFile {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format uri */
  file?: string | null;
  original_file_name: string;
  /** @maxLength 255 */
  file_name: string;
  /**
   * * `photo` - Photo
   * * `document` - Document
   * * `video` - Video
   * * `audio` - Audio
   * * `text` - Text
   * * `html` - HTML
   * * `microsoft_word` - Microsoft Word
   * * `microsoft_excel` - Microsoft Excel
   * * `microsoft_powerpoint` - Microsoft PowerPoint
   * * `csv` - CSV
   */
  file_type: FileType173Enum;
  /**
   * @min 0
   * @max 2147483647
   */
  file_size?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  original_file_size?: number | null;
  /** @format uuid */
  uploaded_by?: string | null;
  /** @format date-time */
  upload_finished_at?: string | null;
  vehicle: VehicleReadFile;
  labels: Label[];
  location?: LocationEnum | BlankEnum | NullEnum | null;
  /** @format uuid */
  object_id?: string | null;
}

export interface ListServiceTask {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description?: string;
  maintenance_category: MaintenanceCategoryReadOnly;
  system_code: SystemCodeReadOnly;
  assembly_code: AssemblyCodeReadOnly;
  reason_for_repair_code: ReasonForRepairCodeReadOnly;
  service_entries_count: string;
  work_order_count: string;
  is_general?: boolean;
  is_archived: string;
}

export interface ListUsersReport {
  /** @format uuid */
  id: string;
  full_name: string;
  /** @format uuid */
  group?: string | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  /** @maxLength 64 */
  employee_number?: string | null;
  /** @maxLength 100 */
  job_title?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  leave_date?: string | null;
  /** @maxLength 64 */
  license_number?: string | null;
  /** @maxLength 64 */
  license_state?: string | null;
  /** @maxLength 64 */
  license_class?: string | null;
}

export interface ListVendor {
  /** @format uuid */
  id: string;
  partner: VendorPartner | null;
  logo: File | null;
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  /** @format double */
  longitude: number | null;
  /** @format double */
  latitude: number | null;
  labels: Label[];
  is_active?: boolean;
  full_address: string;
  /** Indicates if the vendor is available across all companies */
  is_global?: boolean;
  /** Determines if the vendor should be featured in listings and searches */
  is_featured?: boolean;
  active_service_count: number;
  current_status: string;
  schedules: string;
}

/** Serializer for vendor location with distance information. */
export interface Location {
  address: string | null;
  city: string | null;
  state_province_region: string | null;
  country: string | null;
  /** @format double */
  latitude: number;
  /** @format double */
  longitude: number;
  distance: LocationDistance;
}

/** Enhanced serializer for distance information including detailed travel times. */
export interface LocationDistance {
  /** @format double */
  km: number;
  /** @format double */
  miles: number;
  travel_times: DetailedTravelTimes;
}

export interface LocationForHistory {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description?: string;
}

export interface LocationRetrieve {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description?: string;
}

export interface LocationRetrieveRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: string;
}

export interface Login {
  /** @default "web" */
  login_location?: LoginLocationEnum;
}

export interface LoginRequest {
  /**
   * @format email
   * @minLength 1
   * @maxLength 254
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  password: string;
  /** @default "web" */
  login_location?: LoginLocationEnum;
  /**
   * @minLength 1
   * @maxLength 255
   */
  device_id?: string;
  /**
   * @minLength 1
   * @maxLength 1024
   */
  token?: string;
}

export interface LogoutRequest {
  /**
   * Refresh token to be blacklisted
   * @minLength 1
   * @maxLength 1024
   */
  refresh: string;
}

export interface MaintenanceCategoryCreate {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  /**
   * @min 0
   * @max 32767
   */
  category_code: number;
  /**
   * Category Name
   * @maxLength 255
   */
  name: string;
}

export interface MaintenanceCategoryCreateRequest {
  is_active?: boolean;
  /**
   * @min 0
   * @max 32767
   */
  category_code: number;
  /**
   * Category Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface MaintenanceCategoryReadOnly {
  /** @format uuid */
  id: string;
  /**
   * @min 0
   * @max 32767
   */
  category_code: number;
  /**
   * Category Name
   * @maxLength 255
   */
  name: string;
}

export interface MaintenanceCategoryReadOnlyRequest {
  /**
   * @min 0
   * @max 32767
   */
  category_code: number;
  /**
   * Category Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface ManufacturerRetrieve {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface MeasurementUnit {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface MeasurementUnitRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface MeasurementUnitRetrieve {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface MeterEntry {
  /** @format uuid */
  id: string;
  source: string;
  vehicle: VehicleRetrieveMini;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_value: number;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  original_meter_value?: number | null;
  /**
   * * `miles` - Miles
   * * `gallons` - Gallons
   * * `liters` - Liters
   * * `kilometers` - Kilometers
   */
  meter_unit?: MeterUnitEnum;
  void?: boolean;
  /** @format date */
  meter_date: string;
  /** @format uuid */
  company?: string | null;
  /** @format uuid */
  integration_account?: string | null;
}

/** MetricData */
export interface MetricData {
  /** Value */
  value: number | string;
  /** Percentage Change */
  percentage_change: number | string;
  period: MetricPeriod;
  /** Label */
  label: string;
}

/** Serializer for system modules with nested permissions */
export interface Module {
  /** @format uuid */
  id: string;
  name: string;
  code_name: string;
  description: string;
  permissions: Permission[];
}

/** Serializer for nearby vendors with enhanced distance calculations. */
export interface NearbyVendor {
  /** @format uuid */
  id: string;
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  partner: VendorPartner | null;
  /** Determines if the vendor should be featured in listings and searches */
  is_featured?: boolean;
  has_active_promos: boolean;
  location: Location;
  contact: VendorContact;
  services_count: number;
}

export interface NearestVendor {
  /** @format uuid */
  id: string;
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  is_distance_available: boolean;
  distance: string;
  current_status: string;
  /** Indicates if the vendor is available across all companies */
  is_global?: boolean;
  services: string;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  working_hour: string;
}

export interface NestedCatalogueRead {
  /** @format uuid */
  id: string;
  /**
   * Logo of the category
   * @format uuid
   */
  logo?: string | null;
  /**
   * Name of the category
   * @maxLength 255
   */
  name: string;
  /**
   * Code name of the category
   * @maxLength 255
   */
  code_name: string;
}

/** Write serializer to include CatalogueReport data inside Catalogue data */
export interface NestedCatalogueReportCreate {
  /** @format uuid */
  id: string;
  /**
   * Name of the report
   * @maxLength 255
   */
  name: string;
  /**
   * Code name of the report
   * @maxLength 255
   */
  code_name: string;
  /** Description of the report */
  description?: string | null;
}

/** Write serializer to include CatalogueReport data inside Catalogue data */
export interface NestedCatalogueReportCreateRequest {
  /**
   * Name of the report
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Code name of the report
   * @minLength 1
   * @maxLength 255
   */
  code_name: string;
  /** Description of the report */
  description?: string | null;
}

export interface NestedServiceReminderComment {
  /** @format uuid */
  id: string;
  comment: string;
  created_by: Contact;
}

export interface NestedServiceReminderCommentRequest {
  /** @minLength 1 */
  comment: string;
}

/** NewVehiclesMetric */
export interface NewVehiclesMetric {
  /**
   * Count
   * @min 0
   */
  count: number;
  /** Change Percentage */
  change_percentage: number | string;
  /**
   * Period Days
   * @default 7
   */
  period_days?: number;
}

export interface Notification {
  /** @format uuid */
  id: string;
  /**
   * The type of notification (e.g., update, alert, status).
   *
   * * `system_update` - System Update
   * * `feature` - Feature
   * * `maintenance` - Maintenance
   * * `security` - Security
   * * `status` - Status
   * * `action` - Action
   * * `alert` - Alert
   * * `create` - Create
   * * `update` - Update
   * * `delete` - Delete
   * * `approval` - Approval
   * * `assignment` - Assignment
   * * `general` - General
   */
  category?: NotificationCategoryEnum;
  /**
   * Application Module
   * The specific module/application this notification relates to.
   *
   * * `vehicles` - Vehicles
   * * `companies` - Companies
   * * `contacts` - Contacts
   * * `issues` - Issues
   * * `parts` - Parts
   * * `purchase_order` - Purchase Order
   * * `service_entry` - Service Entry
   * * `vendors` - Vendors
   * * `inspection` - Inspection
   * * `reminders` - Reminders
   * * `fuel` - Fuel
   * * `reports` - Reports
   * * `inventory` - Inventory
   * * `billing` - Billing
   * * `work_orders` - Work Orders
   */
  app_name?: AppNameEnum | BlankEnum | NullEnum | null;
  /**
   * Brief headline of the notification.
   * @maxLength 255
   */
  title: string;
  /** Main content of the notification. */
  message: string;
  /**
   * Importance level of the notification affecting delivery speed and UI display.
   *
   * * `urgent` - Urgent
   * * `high` - High
   * * `medium` - Medium
   * * `low` - Low
   */
  priority?: NotificationPriorityEnum;
  /**
   * Current state of the notification in its delivery lifecycle.
   *
   * * `scheduled` - Scheduled
   * * `pending` - Pending
   * * `processing` - Processing
   * * `delivered` - Delivered
   * * `failed` - Failed
   * * `partially_delivered` - Partially Delivered
   * * `cancelled` - Cancelled
   */
  status?: NotificationStatusEnum;
  /** Indicates whether the notification has been read by the recipient. */
  is_read?: boolean;
  /** @format date-time */
  created: string;
  /**
   * Timestamp when the recipient read the notification.
   * @format date-time
   */
  read_at: string | null;
  /** URL for any action associated with this notification. */
  action_url?: string | null;
  /**
   * Additional Data
   * Additional context data in JSON format for dynamic content or metadata.
   */
  data?: any;
}

export interface OTPRequestRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface OTPVerifyRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 6
   */
  otp: string;
}

export interface OdometerImportRequest {
  /** Optional specific vehicle number to import. If not provided, imports all vehicles. */
  vehicle_number?: string;
  /**
   * Whether to run the import asynchronously using Celery (default: false)
   * @default false
   */
  async_import?: boolean;
}

export interface Oil {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  oil_type?: string | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  oil_capacity?: number | null;
  /** @format uuid */
  vehicle: string;
}

export interface OilRequest {
  /** @maxLength 255 */
  oil_type?: string | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  oil_capacity?: number | null;
}

export interface OperatorForAssignmentLog {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  /** @maxLength 64 */
  mobile_phone?: string | null;
  /** @maxLength 64 */
  work_phone?: string | null;
  /** @maxLength 64 */
  employee_number?: string | null;
}

export interface Output {
  message: string;
  stats: Record<string, Record<string, number>>;
}

export interface Package {
  /** @format uuid */
  id: string;
  /**
   * Package name display to customers
   * @maxLength 255
   */
  name: string;
  /** Detailed package description */
  description?: string;
  /**
   * Base price per unit
   * @format double
   * @min 0.01
   * @max 100000000
   * @exclusiveMax true
   */
  price_per_unit: number;
  /** Whether this package is available for new customers */
  is_active?: boolean;
}

export interface PaginatedAdjustmentListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: AdjustmentList[];
}

export interface PaginatedAdjustmentReasonListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: AdjustmentReasonList[];
}

export interface PaginatedAnnouncementListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: AnnouncementList[];
}

export interface PaginatedAssemblyCodeReadOnlyList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: AssemblyCodeReadOnly[];
}

export interface PaginatedAssignedUserList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: AssignedUser[];
}

export interface PaginatedAssignmentHistoryListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: AssignmentHistoryList[];
}

export interface PaginatedAssignmentListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: AssignmentList[];
}

export interface PaginatedCatalogueReportReadList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: CatalogueReportRead[];
}

export interface PaginatedCatalogueWithCountReadList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: CatalogueWithCountRead[];
}

export interface PaginatedCompanyListMiniList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: CompanyListMini[];
}

export interface PaginatedContactListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ContactList[];
}

export interface PaginatedContactRenewalListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ContactRenewalList[];
}

export interface PaginatedContactRenewalTypeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ContactRenewalTypeList[];
}

export interface PaginatedCurrencyList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: Currency[];
}

export interface PaginatedEngineAspirationListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: EngineAspirationList[];
}

export interface PaginatedEngineBlockTypeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: EngineBlockTypeList[];
}

export interface PaginatedEngineCamTypeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: EngineCamTypeList[];
}

export interface PaginatedEngineFuelInductionListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: EngineFuelInductionList[];
}

export interface PaginatedEquipmentListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: EquipmentList[];
}

export interface PaginatedEquipmentTypeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: EquipmentTypeList[];
}

export interface PaginatedEquipmentVehiclesList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: EquipmentVehicles[];
}

export interface PaginatedExpenseListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ExpenseList[];
}

export interface PaginatedExpenseTypeList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ExpenseType[];
}

export interface PaginatedExpenseVehicleList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ExpenseVehicle[];
}

export interface PaginatedFaultCodeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: FaultCodeList[];
}

export interface PaginatedFaultRuleListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: FaultRuleList[];
}

export interface PaginatedFaultsSummaryReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: FaultsSummaryReport[];
}

export interface PaginatedFeaturedVendorList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: FeaturedVendor[];
}

export interface PaginatedFileList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: File[];
}

export interface PaginatedFileVendorReadList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: FileVendorRead[];
}

export interface PaginatedFleetSizeList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: FleetSize[];
}

export interface PaginatedFuelEntriesByVehicleList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: FuelEntriesByVehicle[];
}

export interface PaginatedFuelEntryListModList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: FuelEntryListMod[];
}

export interface PaginatedFuelSummaryByLocationList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: FuelSummaryByLocation[];
}

export interface PaginatedFuelSummaryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: FuelSummary[];
}

export interface PaginatedGroupList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: Group[];
}

export interface PaginatedHistoryListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: HistoryList[];
}

export interface PaginatedImportSectionWithCountList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ImportSectionWithCount[];
}

export interface PaginatedImportTemplateList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ImportTemplate[];
}

export interface PaginatedIndustryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: Industry[];
}

export interface PaginatedInspectionFailedListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: InspectionFailedList[];
}

export interface PaginatedInspectionFailedResultListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: InspectionFailedResultList[];
}

export interface PaginatedInspectionFormLinkedVehiclesListByFormList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: InspectionFormLinkedVehiclesListByForm[];
}

export interface PaginatedInspectionFormLinkedVehiclesListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: InspectionFormLinkedVehiclesList[];
}

export interface PaginatedInspectionFormReadList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: InspectionFormRead[];
}

export interface PaginatedInspectionFormRuleListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: InspectionFormRuleList[];
}

export interface PaginatedInspectionReadItemList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: InspectionReadItem[];
}

export interface PaginatedInspectionSubmissionListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: InspectionSubmissionList[];
}

export interface PaginatedInspectionSubmissionSummaryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: InspectionSubmissionSummary[];
}

export interface PaginatedIntFaultCodeList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: IntFaultCode[];
}

export interface PaginatedIntegrationsList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: Integrations[];
}

export interface PaginatedInvoiceList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: Invoice[];
}

export interface PaginatedIssueList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: Issue[];
}

export interface PaginatedIssueReadList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: IssueRead[];
}

export interface PaginatedLabelList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: Label[];
}

export interface PaginatedLaborTimeEntriesListReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: LaborTimeEntriesListReport[];
}

export interface PaginatedLinkedVehicleHistoryListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: LinkedVehicleHistoryList[];
}

export interface PaginatedListFileList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ListFile[];
}

export interface PaginatedListServiceTaskList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ListServiceTask[];
}

export interface PaginatedListUsersReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ListUsersReport[];
}

export interface PaginatedListVendorList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ListVendor[];
}

export interface PaginatedLocationRetrieveList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: LocationRetrieve[];
}

export interface PaginatedMaintenanceCategoryReadOnlyList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: MaintenanceCategoryReadOnly[];
}

export interface PaginatedMeasurementUnitList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: MeasurementUnit[];
}

export interface PaginatedMeterEntryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: MeterEntry[];
}

export interface PaginatedNearbyVendorList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: NearbyVendor[];
}

export interface PaginatedNearestVendorList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: NearestVendor[];
}

export interface PaginatedNotificationList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: Notification[];
}

export interface PaginatedPartCategoryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: PartCategory[];
}

export interface PaginatedPartListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: PartList[];
}

export interface PaginatedPartManufacturerList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: PartManufacturer[];
}

export interface PaginatedPartPurchaseHistoryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: PartPurchaseHistory[];
}

export interface PaginatedPartsActivityReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: PartsActivityReport[];
}

export interface PaginatedPartsByLocationReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: PartsByLocationReport[];
}

export interface PaginatedPartsByVehicleReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: PartsByVehicleReport[];
}

export interface PaginatedPaymentTypeList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: PaymentType[];
}

export interface PaginatedPurchaseOrderListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: PurchaseOrderList[];
}

export interface PaginatedPurchaseOrderTimeLineList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: PurchaseOrderTimeLine[];
}

export interface PaginatedReadAccountsGroupedByProviderList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ReadAccountsGroupedByProvider[];
}

export interface PaginatedReadAssignmentList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ReadAssignment[];
}

export interface PaginatedReadIntegrationAccountList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ReadIntegrationAccount[];
}

export interface PaginatedReadIntegrationProviderList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ReadIntegrationProvider[];
}

export interface PaginatedReadRoleList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ReadRole[];
}

export interface PaginatedReasonForRepairCodeReadOnlyList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ReasonForRepairCodeReadOnly[];
}

export interface PaginatedRecentCommentDashboardList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: RecentCommentDashboard[];
}

export interface PaginatedReminderDashboardList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ReminderDashboard[];
}

export interface PaginatedRentHistoryListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: RentHistoryList[];
}

export interface PaginatedRetrieveServiceList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: RetrieveService[];
}

export interface PaginatedSearchVendorList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: SearchVendor[];
}

export interface PaginatedSectionCategoryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: SectionCategory[];
}

export interface PaginatedServiceHistoryByVehicleReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ServiceHistoryByVehicleReport[];
}

export interface PaginatedServiceHistorySummaryReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ServiceHistorySummaryReport[];
}

export interface PaginatedServiceReminderComplianceReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ServiceReminderComplianceReport[];
}

export interface PaginatedServiceReminderReadList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ServiceReminderRead[];
}

export interface PaginatedServiceReminderReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: ServiceReminderReport[];
}

export interface PaginatedSystemCodeReadOnlyList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: SystemCodeReadOnly[];
}

export interface PaginatedSystemModuleList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: SystemModule[];
}

export interface PaginatedTelegramChannelList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: TelegramChannel[];
}

export interface PaginatedTelematicsDeviceListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: TelematicsDeviceList[];
}

export interface PaginatedTrainingVideoList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: TrainingVideo[];
}

export interface PaginatedTransmissionTypeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: TransmissionTypeList[];
}

export interface PaginatedUserRenewalRemindersList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: UserRenewalReminders[];
}

export interface PaginatedVehicleAssignmentLogList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleAssignmentLog[];
}

export interface PaginatedVehicleAssignmentsSummaryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleAssignmentsSummary[];
}

export interface PaginatedVehicleBodySubTypeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleBodySubTypeList[];
}

export interface PaginatedVehicleBodyTypeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleBodyTypeList[];
}

export interface PaginatedVehicleCostComparisonReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleCostComparisonReport[];
}

export interface PaginatedVehicleFaultList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleFault[];
}

export interface PaginatedVehicleFuelTypeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleFuelTypeList[];
}

export interface PaginatedVehicleIssueList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleIssue[];
}

export interface PaginatedVehicleListForSelectOptionsList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleListForSelectOptions[];
}

export interface PaginatedVehicleListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleList[];
}

export interface PaginatedVehicleListMiniList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleListMini[];
}

export interface PaginatedVehicleMakeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleMakeList[];
}

export interface PaginatedVehicleMeterEntryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleMeterEntry[];
}

export interface PaginatedVehicleModelListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleModelList[];
}

export interface PaginatedVehicleOperatingCostsSummaryReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleOperatingCostsSummaryReport[];
}

export interface PaginatedVehicleReadList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleRead[];
}

export interface PaginatedVehicleRenewalListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleRenewalList[];
}

export interface PaginatedVehicleRenewalRemindersList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleRenewalReminders[];
}

export interface PaginatedVehicleRenewalTypeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleRenewalTypeList[];
}

export interface PaginatedVehicleReportListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleReportList[];
}

export interface PaginatedVehicleServiceList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleService[];
}

export interface PaginatedVehicleStatusChangesList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleStatusChanges[];
}

export interface PaginatedVehicleStatusSummaryList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleStatusSummary[];
}

export interface PaginatedVehicleTypeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehicleTypeList[];
}

export interface PaginatedVehiclesWithoutServiceReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VehiclesWithoutServiceReport[];
}

export interface PaginatedVideoSectionList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: VideoSection[];
}

export interface PaginatedWarrantyListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: WarrantyList[];
}

export interface PaginatedWheelsTiresBrakeSystemListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: WheelsTiresBrakeSystemList[];
}

export interface PaginatedWheelsTiresDriveTypeListList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: WheelsTiresDriveTypeList[];
}

export interface PaginatedWorkOrderActivityByPartList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: WorkOrderActivityByPart[];
}

export interface PaginatedWorkOrderByVehicleReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: WorkOrderByVehicleReport[];
}

export interface PaginatedWorkOrderCostLimitList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: WorkOrderCostLimit[];
}

export interface PaginatedWorkOrderListReportList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: WorkOrderListReport[];
}

export interface PaginatedWorkOrderRetrieveList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: WorkOrderRetrieve[];
}

export interface PaginatedWorkOrderServiceTaskList {
  /** @example 123 */
  count: number;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=400&limit=100"
   */
  next?: string | null;
  /**
   * @format uri
   * @example "http://api.example.org/accounts/?offset=200&limit=100"
   */
  previous?: string | null;
  results: WorkOrderServiceTask[];
}

export interface PaidHistory {
  /** @format uuid */
  rent_history: string;
}

export interface PaidHistoryRequest {
  /** @format uuid */
  rent_history: string;
}

export interface PartAddPurchaseHistory {
  /** @format uuid */
  vendor?: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  price: number;
}

export interface PartAddPurchaseHistoryRequest {
  /** @format uuid */
  vendor?: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  price: number;
}

export interface PartCategory {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface PartCategoryRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface PartCategoryRetrieve {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface PartCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  part_number: string;
  description?: string;
  /** @format uuid */
  photo?: string | null;
  /** @format uuid */
  manufacturer?: string | null;
  /** @maxLength 255 */
  manufacturer_part_number?: string | null;
  /** @maxLength 255 */
  upc?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number | null;
  /** @format uuid */
  measurement_unit?: string | null;
  /** @format uuid */
  category?: string | null;
  locations?: PartLocationCreateRequest[];
  purchase_history?: PurchaseHistoryPartCreateRequest[];
}

export interface PartList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  part_number: string;
  description?: string;
  photo: File | null;
  document: File | null;
  manufacturer: ManufacturerRetrieve;
  /** @maxLength 255 */
  manufacturer_part_number?: string | null;
  /** @maxLength 255 */
  upc?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number | null;
  measurement_unit: MeasurementUnitRetrieve;
  category: PartCategoryRetrieve;
  locations: PartLocation[];
  is_archived?: boolean;
}

export interface PartLocation {
  location: LocationRetrieve;
  /** @maxLength 255 */
  aisle?: string | null;
  /** @maxLength 255 */
  row?: string | null;
  /** @maxLength 255 */
  bin?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  current_quantity?: number;
  track_inventory?: boolean;
  /**
   * @min 0
   * @max 2147483647
   */
  reorder_point?: number | null;
}

export interface PartLocationAdjust {
  adjust_quantity: number;
  new_quantity?: number;
  /** @format uuid */
  reason: string;
  comment?: string;
}

export interface PartLocationAdjustRequest {
  adjust_quantity: number;
  new_quantity?: number;
  /** @format uuid */
  reason: string;
  /** @minLength 1 */
  comment?: string;
}

export interface PartLocationCreateRequest {
  /** @format uuid */
  location: string;
  /** @maxLength 255 */
  aisle?: string | null;
  /** @maxLength 255 */
  row?: string | null;
  /** @maxLength 255 */
  bin?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  current_quantity?: number;
  track_inventory?: boolean;
  /**
   * @min 0
   * @max 2147483647
   */
  reorder_point?: number | null;
}

export interface PartLocationInventoryEditRequest {
  /** @maxLength 255 */
  aisle?: string | null;
  /** @maxLength 255 */
  row?: string | null;
  /** @maxLength 255 */
  bin?: string | null;
  track_inventory?: boolean;
  /**
   * @min 0
   * @max 2147483647
   */
  reorder_point?: number | null;
}

export interface PartLocationRetrieve {
  /** @format uuid */
  id: string;
  location: LocationRetrieve;
  /** @maxLength 255 */
  aisle?: string | null;
  /** @maxLength 255 */
  row?: string | null;
  /** @maxLength 255 */
  bin?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  current_quantity?: number;
  track_inventory?: boolean;
  /**
   * @min 0
   * @max 2147483647
   */
  reorder_point?: number | null;
  pending_po_quantity: string;
}

export interface PartLocationUpdateRequest {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  location: string;
  /** @maxLength 255 */
  aisle?: string | null;
  /** @maxLength 255 */
  row?: string | null;
  /** @maxLength 255 */
  bin?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  current_quantity?: number;
  track_inventory?: boolean;
  /**
   * @min 0
   * @max 2147483647
   */
  reorder_point?: number | null;
}

export interface PartManufacturer {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface PartManufacturerRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface PartPurchaseHistory {
  /** @format uuid */
  id: string;
  vendor: VendorRead;
  /** @format date */
  date_ordered: string;
  purchase_order: PurchaseOrderForHistory;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  price: number;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  qty_ordered?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  qty_received?: number | null;
  location: LocationForHistory;
}

export interface PartReadOnly {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  part_number: string;
  description?: string;
  photo: File | null;
}

export interface PartRetrieve {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  part_number: string;
  description?: string;
  photo: File;
  documents: File[];
  manufacturer: ManufacturerRetrieve;
  /** @maxLength 255 */
  manufacturer_part_number?: string | null;
  /** @maxLength 255 */
  upc?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number | null;
  measurement_unit: MeasurementUnitRetrieve;
  category: PartCategoryRetrieve;
  locations: string;
  purchase_history: string;
  comments: string;
}

export interface PartUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  part_number: string;
  description?: string;
  /** @format uuid */
  photo?: string | null;
  documents?: string[];
  /** @format uuid */
  manufacturer?: string | null;
  /** @maxLength 255 */
  manufacturer_part_number?: string | null;
  /** @maxLength 255 */
  upc?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number | null;
  /** @format uuid */
  measurement_unit?: string | null;
  /** @format uuid */
  category?: string | null;
  locations?: PartLocationUpdateRequest[];
  purchase_history?: PurchaseHistoryUpdateRequest[];
}

export interface PartsActivityReport {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created_at: string;
  part: string;
  part_description: string;
  adjustment_qty: number;
  new_qty: number;
  /**
   * * `man` - Manual
   * * `init` - Initial
   * * `wo` - Work Order
   * * `po` - Purchase Order
   * * `bu` - Bulk Update
   * * `tr` - Transfer
   */
  adjustment_type: AdjustmentTypeEnum;
  part_location: string;
  adjustment_reason: string | null;
  contact: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  previous_qty: number;
  inventory_adjustment: string;
}

export interface PartsByLocationReport {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description?: string;
  total_part_cost: string;
  parts: string;
}

export interface PartsByVehicleReport {
  /** @format uuid */
  id: string;
  vehicle_name: string;
  group_name: string | null;
  year: number;
  make: string;
  model: string;
  /** @format uuid */
  part_id: string;
  part_name: string;
  part_description: string | null;
  part_category: string | null;
  manufacturer_name: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  quantity?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number;
  total_cost: string;
  work_order_number: string;
  work_order_status: string;
  /** @format date-time */
  completion_date: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor_cost: number;
  current_odometer: number | null;
}

export interface PartsMetaData {
  total_quantity: number;
  /** @default 0 */
  out_of_stock?: number;
  /** @default 0 */
  low_stock?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_inventory_value: number;
}

export interface PasswordReset {
  new_password: string;
}

export interface PasswordResetRequest {
  /** @minLength 1 */
  new_password: string;
}

export interface PatchedCompanyRequest {
  /** @maxLength 255 */
  account_name?: string;
  /** @maxLength 255 */
  address?: string | null;
  /** @maxLength 255 */
  address_line_2?: string | null;
  /** @maxLength 255 */
  city?: string | null;
  /** @format uuid */
  logo?: string | null;
  /** @maxLength 255 */
  state_province_region?: string | null;
  /** @maxLength 10 */
  zip_postal_code?: string | null;
  /** @maxLength 255 */
  country?: string | null;
  /** @maxLength 20 */
  phone_number?: string | null;
  /** @maxLength 255 */
  industry?: string | null;
  /**
   * @minLength 1
   * @maxLength 5
   */
  currency?: string;
  /**
   * @minLength 1
   * @maxLength 10
   */
  short_date_format?: string;
  /** @maxLength 50 */
  time_zone?: string | null;
  time_format?: TimeFormatEnum | BlankEnum | NullEnum | null;
  /**
   * * `miles` - Miles
   * * `kilometers` - Kilometers
   * * `hours` - Hours
   */
  usage?: UsageEnum;
  /**
   * * `gallons_us` - Gallons (US)
   * * `gallons_uk` - Gallons (UK)
   * * `liters` - Liters
   */
  fuel_volume?: FuelVolumeEnum;
  /**
   * * `imperial` - Imperial
   * * `metric` - Metric
   */
  system_of_measurement?: SystemOfMeasurementEnum;
  tax_free_labor?: boolean;
  secondary_tax?: boolean;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  default_tax_1?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  default_tax_2?: number;
  /**
   * * `percentage` - Percentage
   * * `fixed` - Fixed
   */
  default_tax_type?: DefaultTaxTypeEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  fleet_size?: number;
}

export interface PatchedContactRenewalUpdateRequest {
  /** @format uuid */
  contact?: string;
  /**
   * Date on which the contact will be renewed
   * @format date
   */
  due_date?: string;
  /** @format uuid */
  renewal_type?: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold?: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold?: PrimaryMeterDueSoonThresholdEnum;
  description?: string | null;
  enable_notification?: boolean;
  /** @format uuid */
  recipient?: string | null;
}

export interface PatchedContactRequest {
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  enable_fleetio_access?: boolean;
  /** @maxLength 64 */
  mobile_phone?: string | null;
  /** @maxLength 64 */
  home_phone?: string | null;
  /** @maxLength 64 */
  work_phone?: string | null;
  /** @maxLength 64 */
  other_phone?: string | null;
  address?: string | null;
  /** @maxLength 255 */
  address_line_2?: string | null;
  /** @maxLength 255 */
  city?: string | null;
  /**
   * State/province/region
   * @maxLength 255
   */
  state_province_region?: string | null;
  /**
   * Zip/postal code
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /** @maxLength 255 */
  country?: string | null;
  /** @maxLength 100 */
  job_title?: string | null;
  /** @format date */
  date_of_birth?: string | null;
  /** @maxLength 64 */
  employee_number?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  leave_date?: string | null;
  /** @maxLength 64 */
  license_number?: string | null;
  /** @maxLength 64 */
  license_class?: string | null;
  /** @maxLength 64 */
  license_state?: string | null;
  /**
   * License state/province/region
   * @maxLength 255
   */
  license_state_province_region?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  hourly_labor_rate?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  login_count?: number;
  /** @maxLength 255 */
  saml_id?: string | null;
  /** @maxLength 255 */
  id_number?: string | null;
  /** @format date */
  hire_date?: string | null;
  /** @maxLength 255 */
  cdl_endorsements?: string | null;
  /**
   * Regular user
   * Designates whether the user can log into this admin site.
   */
  is_regular_user?: boolean;
  /**
   * Administrator
   * Designates whether the user has all permissions without explicitly assigning them. But the user has certain limitations.
   */
  is_administrator?: boolean;
  /** @format uuid */
  profile_picture?: string | null;
  /** @format uuid */
  group?: string | null;
  /** @format uuid */
  role?: string | null;
}

export interface PatchedCreateAssignmentRequest {
  /** @format uuid */
  vehicle?: string | null;
  /** @format uuid */
  operator?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  end_odometer?: number | null;
  /** @format date-time */
  start_datetime?: string | null;
  /** @format date-time */
  end_datetime?: string | null;
  comment?: string | null;
}

export interface PatchedDetailVendorRequest {
  /**
   * The official business name of the vendor
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  /** @format double */
  longitude?: number | null;
  /** @format double */
  latitude?: number | null;
  labels?: LabelRequest[];
  documents?: FileRequest[];
  is_active?: boolean;
  /** Determines if the vendor should be featured in listings and searches */
  is_featured?: boolean;
  /** Indicates if the vendor is available across all companies */
  is_global?: boolean;
}

export interface PatchedDynamicInspectionItemRequest {
  items?: InspectionItemCreateRequest[];
}

export interface PatchedEquipmentAddPhotoRequest {
  /** @format uuid */
  photo?: string | null;
}

export interface PatchedEquipmentHistoryUpdateRequest {
  /** @format uuid */
  equipment?: string;
  /** @format uuid */
  linked_vehicle?: string;
  /** @format uuid */
  assigned_user?: string | null;
  /** @format uuid */
  started_by?: string | null;
  /** @format uuid */
  ended_by?: string;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /**
   * Duration in days
   * @min -2147483648
   * @max 2147483647
   */
  duration?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  per_month?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_price?: number;
  comment?: string | null;
}

export interface PatchedEquipmentRemovePhotoRequest {
  /** @format uuid */
  photo?: string | null;
}

export interface PatchedEquipmentTypeUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
}

export interface PatchedEquipmentUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  description?: string | null;
  /**
   * * `in_service` - In Service
   * * `available` - Available
   * * `out_of_service` - Out Of service
   * * `disposed` - Disposed
   * * `missing` - Missing
   * * `rented` - Rented
   */
  status?: StatusC30Enum;
  /** @format uuid */
  type?: string | null;
  /** @maxLength 255 */
  brand?: string | null;
  /** @maxLength 255 */
  model?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  serial_number?: string;
  /** @format uuid */
  photo?: string | null;
  /** @format uuid */
  linked_vehicle?: string | null;
  /** @format uuid */
  assigned_user?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  end_date?: string | null;
  /** @format uuid */
  purchase_vendor?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  purchase_price?: number | null;
  /** @format date */
  purchase_date?: string | null;
  /** @format date */
  warranty_expiration_date?: string | null;
  /**
   * @min 0
   * @max 32767
   */
  estimated_service_life?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  estimated_resale_value?: number | null;
  /** @format date */
  in_service_date?: string | null;
  /** @format date */
  out_of_service_date?: string | null;
}

export interface PatchedExpenseTypeRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name?: string;
  /** @maxLength 512 */
  description?: string | null;
  /** Custom Type */
  is_custom?: boolean;
}

export interface PatchedExpenseUpdateRequest {
  /** @format uuid */
  vendor?: string | null;
  /** @format uuid */
  expense_type?: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  amount?: number;
  /** @format date */
  payment_date?: string | null;
  /**
   * * `ONE_TIME` - One-time
   * * `MONTHLY` - Monthly
   * * `YEARLY` - Yearly
   */
  frequency?: Frequency80AEnum;
  /**
   * Start Date for Recurring
   * @format date
   */
  start_date?: string | null;
  /**
   * End Date for Recurring
   * @format date
   */
  end_date?: string | null;
  notes?: string | null;
  attachments?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface PatchedFaultCodeListRequest {
  /** @format uuid */
  company?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  code?: string;
  /**
   * Code Description
   * @maxLength 200
   */
  name?: string | null;
  /** Code Description */
  description?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  occurrence_count?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  fmi_id?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  mil_status?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  tx_id?: number | null;
  /** @maxLength 100 */
  source_address_name?: string | null;
  /**
   * * `open` - Open
   * * `resolved` - Resolved
   * * `pending` - Pending
   * * `ignored` - Ignored
   */
  status?: Status05DEnum;
  /**
   * * `off` - Off
   * * `ignore` - Ignore
   * * `critical` - Critical
   */
  priority?: PriorityEc4Enum;
}

export interface PatchedFaultRuleUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  code?: string;
  /** @maxLength 255 */
  name?: string | null;
  description?: string;
  /**
   * * `off` - Off
   * * `ignore` - Ignore
   * * `critical` - Critical
   */
  priority_status?: PriorityStatusEnum;
}

export interface PatchedFuelEntryUpdateRequest {
  /** @format uuid */
  vehicle?: string | null;
  /** @format date-time */
  date?: string;
  /** @format uuid */
  vendor?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  is_void?: boolean;
  /**
   * @minLength 1
   * @maxLength 255
   */
  fuel_type?: string;
  /** @maxLength 255 */
  reference?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  volume?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  fuel_price?: number;
  description?: string | null;
  flag?: FlagEnum | BlankEnum | NullEnum | null;
  documents?: string[];
}

export interface PatchedGroupRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  /** Default group */
  is_default_group?: boolean;
  /** @format uuid */
  parent_group?: string | null;
}

export interface PatchedInspectionFormReadRequest {
  is_active?: boolean;
  /**
   * @minLength 1
   * @maxLength 255
   */
  title?: string;
  description?: string | null;
  /**
   * Hex color code for the form
   * @minLength 1
   * @maxLength 7
   */
  color?: string;
  /** Enable Location Exception Tracking */
  enable_location_exception_tracking?: boolean;
  /** Prevent Use of Stored Photos, forcing users to take photos using the device's camera */
  prevent_use_of_stored_photos?: boolean;
}

export interface PatchedInspectionFormWriteRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  title?: string;
  description?: string | null;
  /**
   * Hex color code for the form
   * @minLength 1
   * @maxLength 7
   */
  color?: string;
  /** Enable Location Exception Tracking */
  enable_location_exception_tracking?: boolean;
  /** Prevent Use of Stored Photos, forcing users to take photos using the device's camera */
  prevent_use_of_stored_photos?: boolean;
}

export interface PatchedIssueUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  summary?: string;
  /** @minLength 1 */
  description?: string;
  /**
   * * `critical` - Critical
   * * `high` - High
   * * `medium` - Medium
   * * `low` - Low
   * * `no_priority` - No Priority
   */
  priority?: Priority3DfEnum;
  major_functionality_impaired?: boolean;
  /** @format uuid */
  vehicle?: string;
  /** @format date-time */
  reported_date?: string;
  /** @format uuid */
  reported_by?: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  /** @maxLength 255 */
  source?: string | null;
  /** @format date-time */
  due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_odometer?: number | null;
  assigned_to?: string[];
  /** @format time */
  time?: string | null;
  labels?: string[];
}

export interface PatchedLabelRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
}

export interface PatchedLocationRetrieveRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  description?: string;
}

export interface PatchedMeasurementUnitRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
}

export interface PatchedPartCategoryRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
}

export interface PatchedPartLocationInventoryEditRequest {
  /** @maxLength 255 */
  aisle?: string | null;
  /** @maxLength 255 */
  row?: string | null;
  /** @maxLength 255 */
  bin?: string | null;
  track_inventory?: boolean;
  /**
   * @min 0
   * @max 2147483647
   */
  reorder_point?: number | null;
}

export interface PatchedPartManufacturerRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
}

export interface PatchedPartUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  part_number?: string;
  description?: string;
  /** @format uuid */
  photo?: string | null;
  documents?: string[];
  /** @format uuid */
  manufacturer?: string | null;
  /** @maxLength 255 */
  manufacturer_part_number?: string | null;
  /** @maxLength 255 */
  upc?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number | null;
  /** @format uuid */
  measurement_unit?: string | null;
  /** @format uuid */
  category?: string | null;
  locations?: PartLocationUpdateRequest[];
  purchase_history?: PurchaseHistoryUpdateRequest[];
}

export interface PatchedPaymentTypeRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  description?: string | null;
  is_default?: boolean;
}

export interface PatchedPurchaseOrderUpdateRequest {
  description?: string;
  labels?: string[];
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  shipping?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
  line_items?: PurchaseOrderLineItemUpdateRequest[];
  /**
   * @min -2147483648
   * @max 2147483647
   */
  po_number?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  sub_total?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total?: number;
  /** @format uuid */
  vendor?: string;
  /** @format uuid */
  location?: string | null;
}

export interface PatchedRentHistoryUpdateRequest {
  /**
   * * `pending` - Pending
   * * `paid` - Paid
   * * `unpaid` - Unpaid
   */
  payment_status?: PaymentStatusEnum;
  /** @format uuid */
  equipment?: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  rented_company?: string;
  /** @maxLength 255 */
  rented_by?: string | null;
  /**
   * Contact Phone
   * @maxLength 255
   */
  phone?: string | null;
  /** @format date */
  start_date?: string;
  /** @format date */
  end_date?: string | null;
  duration?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  rent_per_month?: number;
  /**
   * Total Cost
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost?: number | null;
  comment?: string | null;
}

export interface PatchedRoleUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  description?: string;
}

export interface PatchedServiceReminderCommentRequest {
  /** @format uuid */
  service_reminder?: string;
  /** @minLength 1 */
  comment?: string;
}

export interface PatchedServiceReminderReadRequest {
  /**
   * * `Upcoming` - Upcoming
   * * `DueSoon` - Due Soon
   * * `Overdue` - Overdue
   * * `Snoozed` - Snoozed
   * * `Completed` - Completed
   */
  status?: StatusCb4Enum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_interval?: number | null;
  /** Time Interval */
  time_interval_unit?: TimeIntervalUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_due_soon_threshold?: number | null;
  /** Time Due Soon Threshold */
  time_due_soon_threshold_unit?: TimeDueSoonThresholdUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  meter_interval?: number | null;
  manual_next_due?: boolean;
  /** @format date */
  next_due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  next_due_meter?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_due_soon_threshold?: number | null;
  notification_active?: boolean;
  /** @format date-time */
  snoozed_until?: string | null;
  /** @format date-time */
  archived_at?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
}

export interface PatchedUpdateFileRequest {
  /** @minLength 1 */
  original_file_name?: string;
  labels?: string[];
}

export interface PatchedUpdateMeterEntryRequest {
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_value?: number;
  /**
   * * `miles` - Miles
   * * `gallons` - Gallons
   * * `liters` - Liters
   * * `kilometers` - Kilometers
   */
  meter_unit?: MeterUnitEnum;
  void?: boolean;
  /** @format date */
  meter_date?: string;
}

export interface PatchedUpdateRolePermissionsRequest {
  permissions?: string[];
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  description?: string;
}

export interface PatchedUpdateServiceReminderRequest {
  /** @format uuid */
  vehicle?: string;
  /** @format uuid */
  work_order?: string | null;
  /** @format uuid */
  service_task?: string;
  /**
   * * `Upcoming` - Upcoming
   * * `DueSoon` - Due Soon
   * * `Overdue` - Overdue
   * * `Snoozed` - Snoozed
   * * `Completed` - Completed
   */
  status?: StatusCb4Enum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_interval?: number | null;
  /** Time Interval */
  time_interval_unit?: TimeIntervalUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_due_soon_threshold?: number | null;
  /** Time Due Soon Threshold */
  time_due_soon_threshold_unit?: TimeDueSoonThresholdUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  meter_interval?: number | null;
  manual_next_due?: boolean;
  /** @format date */
  next_due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  next_due_meter?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_due_soon_threshold?: number | null;
  notification_active?: boolean;
  /** Recipient */
  recipients?: string[];
  /** @format uuid */
  recipient_group?: string | null;
  documents?: string[];
}

export interface PatchedUpdateServiceRequest {
  /** @format uuid */
  vehicle?: string;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class?: RepairPriorityClassEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  void?: boolean;
  /** @format date-time */
  completion_date?: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format uuid */
  vendor?: string | null;
  general_notes?: string | null;
  /**
   * Labor
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_labor?: number;
  /**
   * Parts
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_parts?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  tax?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  sub_total?: number;
  /**
   * Total
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  total_cost?: number;
  notes?: string | null;
  service_task_items?: PatchedUpdateServiceTaskItemRequest[];
  labels?: string[];
  /** @maxLength 155 */
  reference?: string | null;
  /** @format uuid */
  assigned_to?: string | null;
  faults?: string[];
  issues?: string[];
  warranties?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface PatchedUpdateServiceTaskItemRequest {
  /** @format uuid */
  st_id?: string;
  /** @format uuid */
  service_task?: string;
  /** @format uuid */
  reason_for_repair_code?: string | null;
  /** @format uuid */
  category?: string | null;
  /** @format uuid */
  system?: string | null;
  /** @format uuid */
  assembly?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  parts?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  subtotal?: number;
}

export interface PatchedUpdateServiceTaskRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  description?: string;
  /** @format uuid */
  maintenance_category?: string | null;
  /** @format uuid */
  system_code?: string | null;
  /** @format uuid */
  assembly_code?: string | null;
  /** @format uuid */
  reason_for_repair_code?: string | null;
}

export interface PatchedUpdateUserContactRequest {
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /** @maxLength 64 */
  mobile_phone?: string | null;
  /** @maxLength 64 */
  home_phone?: string | null;
  /** @maxLength 64 */
  work_phone?: string | null;
  /** @maxLength 64 */
  other_phone?: string | null;
  address?: string | null;
  /** @maxLength 255 */
  address_line_2?: string | null;
  /** @maxLength 255 */
  city?: string | null;
  /**
   * State/province/region
   * @maxLength 255
   */
  state_province_region?: string | null;
  /**
   * Zip/postal code
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /** @maxLength 255 */
  country?: string | null;
  /** @maxLength 100 */
  job_title?: string | null;
  /** @format date */
  date_of_birth?: string | null;
  /** @maxLength 64 */
  employee_number?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  leave_date?: string | null;
  /** @maxLength 64 */
  license_number?: string | null;
  /** @maxLength 64 */
  license_class?: string | null;
  /** @maxLength 64 */
  license_state?: string | null;
  /**
   * License state/province/region
   * @maxLength 255
   */
  license_state_province_region?: string | null;
  /** @maxLength 255 */
  saml_id?: string | null;
  /** @maxLength 255 */
  id_number?: string | null;
  /** @format date */
  hire_date?: string | null;
  /** @maxLength 255 */
  cdl_endorsements?: string | null;
  /** @format uuid */
  profile_picture?: string | null;
}

export interface PatchedUpdateVendorRequest {
  schedules?: VendorScheduleUpdateRequest[];
  services?: VendorServiceUpdateRequest[];
  is_active?: boolean;
  /**
   * The official business name of the vendor
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /**
   * Longitude coordinate of the vendor's location
   * @format double
   */
  longitude?: number | null;
  /**
   * Latitude coordinate of the vendor's location
   * @format double
   */
  latitude?: number | null;
  /** Geographic point representing the vendor's location (automatically set from latitude/longitude) */
  location?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  /** Indicates if the vendor is available across all companies */
  is_global?: boolean;
  /** Controls whether the vendor is visible in public listings */
  public_visibility?: boolean;
  /** Determines if the vendor should be featured in listings and searches */
  is_featured?: boolean;
  attributes?: any;
  /**
   * Logo or brand image of the vendor
   * @format uuid
   */
  logo?: string | null;
  /**
   * Associated partner organization or program
   * @format uuid
   */
  partner?: string | null;
  /** Tags or categories to help organize and filter vendors */
  labels?: string[];
  /** Related documents such as contracts, certificates, or agreements */
  documents?: string[];
}

export interface PatchedVehicleLinkRequest {
  /** @format uuid */
  linked_vehicle_id?: string;
}

export interface PatchedVehicleRenewalUpdateRequest {
  /** @format uuid */
  vehicle?: string;
  /** @format date */
  due_date?: string;
  /** @format uuid */
  renewal_type?: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold?: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold?: PrimaryMeterDueSoonThresholdEnum;
  description?: string | null;
  enable_notification?: boolean;
  /** @format uuid */
  recipient?: string | null;
}

export interface PatchedVehicleUnlinkRequest {
  /** @format uuid */
  linked_vehicle_id?: string;
}

export interface PatchedVehicleWriteRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name?: string;
  /** @format uuid */
  type?: string | null;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  /**
   * Meter (mi)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  meter?: number | null;
  /** @format uuid */
  fuel_type?: string | null;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  /** @maxLength 32 */
  license_plate?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number | null;
  /** @format uuid */
  make?: string | null;
  /** @format uuid */
  model?: string | null;
  /** @maxLength 255 */
  trim?: string | null;
  /**
   * Registration State/Province
   * @maxLength 255
   */
  registration_state_province?: string | null;
  /** @maxLength 255 */
  color?: string | null;
  ownership?: OwnershipEnum | BlankEnum | NullEnum | null;
  /**
   * MSRP ($)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  msrp?: number | null;
  /** @format uuid */
  body_type?: string | null;
  /** @format uuid */
  body_subtype?: string | null;
  /** @format uuid */
  group?: string | null;
  /** @format uuid */
  operator?: string | null;
  /** @format uuid */
  image?: string | null;
  financial_detail?: FinancialDetailWriteRequest;
  lifecycle?: VehicleLifeCycleCreateRequest;
  specifications?: SpecificationWriteRequest;
  linked_vehicles?: string[];
}

export interface PatchedWarrantyCreateRequest {
  /**
   * The vehicle this warranty is associated with.
   * @format uuid
   */
  vehicle?: string;
  /**
   * Warranty Name
   * The name of the warranty.
   * @minLength 1
   * @maxLength 255
   */
  name?: string;
  /** A description of the warranty. */
  description?: string | null;
  /**
   * The manufacturer of the vehicle or part covered by the warranty.
   * @maxLength 255
   */
  manufacturer?: string | null;
  /**
   * The vendor providing the warranty.
   * @format uuid
   */
  vendor?: string | null;
  /**
   * The contract ID associated with the warranty.
   * @maxLength 100
   */
  contract_id?: string | null;
  /**
   * URL to the vendor’s website
   * @format uri
   * @maxLength 200
   */
  vendor_link?: string | null;
  /**
   * Type of warranty coverage.Standard Warranty or Extended Warranty
   *
   * * `Standard` - Standard Warranty
   * * `Extended` - Extended Warranty
   */
  coverage_type?: CoverageTypeEnum;
  /**
   * The date the warranty starts.
   * @format date
   */
  start_date?: string | null;
  /**
   * The date the warranty ends.
   * @format date
   */
  end_date?: string | null;
  /**
   * The meter reading at the start of the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  start_meter?: number;
  /**
   * The meter reading at the end of the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  end_meter?: number | null;
  /**
   * The distance covered by the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  coverage_distance?: number | null;
  /**
   * The value of the coverage duration.(used with unit)
   * @min 0
   * @max 2147483647
   */
  coverage_duration_value?: number | null;
  /**
   * The unit of the coverage duration.(used with value)
   *
   * * `months` - Months
   * * `years` - Years
   */
  coverage_duration_unit?:
    | CoverageDurationUnitEnum
    | BlankEnum
    | NullEnum
    | null;
  /**
   * The status of the warranty.
   *
   * * `Active` - Active
   * * `Expired` - Expired
   */
  status?: Status081Enum;
  /** If checked, the End Meter is ignored and considered unlimited. */
  is_unlimited?: boolean;
  /** Files attached to this notification. */
  attachments?: string[];
}

export interface PatchedWorkOrderCostLimitRequest {
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost_limit?: number;
  is_active?: boolean;
}

export interface PatchedWorkOrderLaborCompleteRequest {
  /** @maxLength 16 */
  labor_time?: string | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  labor_hours?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  hourly_rate?: number;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  completed_at?: string | null;
  note?: string | null;
}

export interface PatchedWorkOrderUpdateRequest {
  /**
   * * `open` - Open
   * * `pending` - Pending
   * * `under_review` - Under review
   * * `completed` - Completed
   */
  status?: Status6AbEnum;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class?: RepairPriorityClassEnum;
  /** @format date-time */
  issue_date?: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format date-time */
  completion_date?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  completion_odometer?: number | null;
  void?: boolean;
  /** @maxLength 50 */
  invoice_number?: string | null;
  /** @maxLength 50 */
  po_number?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
  /** @format uuid */
  vehicle?: string;
  /** @format uuid */
  vendor?: string | null;
  /** @format uuid */
  assigned_to?: string | null;
  /** @format uuid */
  driver?: string | null;
  /** @format uuid */
  issued_by?: string | null;
  description?: string | null;
  labels?: string[];
  issues?: string[];
  service_task_items?: WorkOrderServiceUpdateTaskRequest[];
  non_related_labors?: WorkOrderLaborUpdateRequest[];
  non_related_parts?: WorkOrderPartsUpdateRequest[];
  warranties?: string[];
  /** @format uuid */
  payment_type?: string;
  faults?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
  /** @format uuid */
  approved_by?: string | null;
  cost_limit_approved?: boolean;
  need_cost_limit_approval?: boolean;
}

export interface PaymentType {
  /** @format uuid */
  id: string;
  /** @maxLength 100 */
  name: string;
  description?: string | null;
  is_default?: boolean;
}

export interface PaymentTypeRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  description?: string | null;
  is_default?: boolean;
}

export interface Performance {
  /** @format uuid */
  id: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  towing_capacity?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  max_payload?: number | null;
  /**
   * EPA City
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  fuel_economy_city?: number | null;
  /**
   * EPA Highway
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  fuel_economy_highway?: number | null;
  /**
   * EPA Combined
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  fuel_economy_combined?: number | null;
  /** @format uuid */
  vehicle: string;
}

export interface PerformanceRequest {
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  towing_capacity?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  max_payload?: number | null;
  /**
   * EPA City
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  fuel_economy_city?: number | null;
  /**
   * EPA Highway
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  fuel_economy_highway?: number | null;
  /**
   * EPA Combined
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  fuel_economy_combined?: number | null;
}

/** Serializer for permissions with nested sub-permissions */
export interface Permission {
  /** @format uuid */
  id: string;
  name: string;
  codename: string;
  description: string;
  /** @default false */
  is_child_permission?: boolean;
  parent_permission: string | null;
  sub_permissions?: SubPermission[];
}

/**
 * Read-only serializer for the PlatformMetadata model.
 * Provides a comprehensive view of all platform information.
 */
export interface PlatformMetadataRead {
  /** @format uuid */
  id: string;
  /**
   * Company Name
   * Name of the company/organization
   */
  name: string;
  support_phone: string;
  /** @format email */
  support_email: string;
  /**
   * Support Hours
   * e.g., 'Mon-Fri: 9AM-5PM EST'
   */
  contact_hours: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  /** State/Province */
  state_province: string;
  /** Postal/ZIP Code */
  postal_code: string;
  country: string;
  full_address: string;
  /** Social Media Links */
  socials: any;
  privacy_policy: string;
  terms_of_service: string;
}

export interface PreviewProviderDataRequest {
  /** @minLength 1 */
  provider_code: string;
  /** Serializer for handling different types of credentials */
  credentials: IntegrationCredentialsRequest;
}

/** PriorityDistribution */
export interface PriorityDistribution {
  /**
   * Critical
   * Count of critical issues
   */
  critical: number;
  /**
   * High
   * Count of high priority issues
   */
  high: number;
  /**
   * Medium
   * Count of medium priority issues
   */
  medium: number;
  /**
   * Low
   * Count of low priority issues
   */
  low: number;
  /**
   * No Priority
   * Count of issues with no priority
   */
  no_priority: number;
}

export interface PurchaseHistoryPartCreateRequest {
  /** @format uuid */
  vendor?: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  price: number;
  /** @format date */
  date_ordered: string;
}

export interface PurchaseHistoryUpdateRequest {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  vendor?: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  price: number;
  /** @format date */
  date_ordered: string;
}

export interface PurchaseOrderCreate {
  /** @format uuid */
  id: string;
  /** @format uuid */
  vendor: string;
  /** @format uuid */
  location?: string | null;
  /**
   * * `draft` - Draft
   * * `pending_approval` - Pending Approval
   * * `rejected` - Rejected
   * * `approved` - Approved
   * * `purchased` - Purchased
   * * `partially_received` - Partially Received
   * * `received_in_full` - Received in Full
   * * `closed` - Closed
   */
  status?: StatusE93Enum;
  description?: string;
  labels?: string[];
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  sub_total?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  shipping?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total?: number;
  line_items?: PurchaseOrderLineItemCreate[];
  /**
   * @min -2147483648
   * @max 2147483647
   */
  po_number?: number | null;
}

export interface PurchaseOrderCreateRequest {
  /** @format uuid */
  vendor: string;
  /** @format uuid */
  location?: string | null;
  /**
   * * `draft` - Draft
   * * `pending_approval` - Pending Approval
   * * `rejected` - Rejected
   * * `approved` - Approved
   * * `purchased` - Purchased
   * * `partially_received` - Partially Received
   * * `received_in_full` - Received in Full
   * * `closed` - Closed
   */
  status?: StatusE93Enum;
  description?: string;
  labels?: string[];
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  sub_total?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  shipping?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total?: number;
  line_items?: PurchaseOrderLineItemCreateRequest[];
  /**
   * @min -2147483648
   * @max 2147483647
   */
  po_number?: number | null;
}

export interface PurchaseOrderForHistory {
  /** @format uuid */
  id: string;
  /**
   * * `draft` - Draft
   * * `pending_approval` - Pending Approval
   * * `rejected` - Rejected
   * * `approved` - Approved
   * * `purchased` - Purchased
   * * `partially_received` - Partially Received
   * * `received_in_full` - Received in Full
   * * `closed` - Closed
   */
  status?: StatusE93Enum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  po_number?: number | null;
  description?: string;
}

export interface PurchaseOrderLineItemCreate {
  /** @format uuid */
  part?: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  quantity?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number;
}

export interface PurchaseOrderLineItemCreateRequest {
  /** @format uuid */
  part?: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  quantity?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number;
}

export interface PurchaseOrderLineItemUpdate {
  /** @format uuid */
  id?: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  quantity?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number;
  /** @format uuid */
  part: string;
}

export interface PurchaseOrderLineItemUpdateRequest {
  /** @format uuid */
  id?: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  quantity?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number;
  /** @format uuid */
  part: string;
}

export interface PurchaseOrderList {
  /** @format uuid */
  id: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  po_number?: number | null;
  vendor: VendorRead;
  location: LocationRetrieve;
  /**
   * * `draft` - Draft
   * * `pending_approval` - Pending Approval
   * * `rejected` - Rejected
   * * `approved` - Approved
   * * `purchased` - Purchased
   * * `partially_received` - Partially Received
   * * `received_in_full` - Received in Full
   * * `closed` - Closed
   */
  status?: StatusE93Enum;
  created_by: Contact;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  labels: Label[];
  description?: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total?: number;
  inline_items: string;
}

export interface PurchaseOrderRetrieve {
  /** @format uuid */
  id: string;
  vendor: VendorRead;
  location: LocationRetrieve;
  /**
   * * `draft` - Draft
   * * `pending_approval` - Pending Approval
   * * `rejected` - Rejected
   * * `approved` - Approved
   * * `purchased` - Purchased
   * * `partially_received` - Partially Received
   * * `received_in_full` - Received in Full
   * * `closed` - Closed
   */
  status?: StatusE93Enum;
  created_by: Contact;
  partially_received_by: Contact;
  purchased_by: Contact;
  received_in_full_by: Contact;
  rejected_by: Contact;
  /** @format uuid */
  closed_by?: string | null;
  approved_by: Contact;
  description?: string;
  labels: Label[];
  /**
   * @min -2147483648
   * @max 2147483647
   */
  po_number?: number | null;
  /** @format date-time */
  approved_on?: string | null;
  /** @format date-time */
  partially_received_on?: string | null;
  /** @format date-time */
  purchased_on?: string | null;
  /** @format date-time */
  received_in_full_on?: string | null;
  /** @format date-time */
  rejected_on?: string | null;
  /** @format date-time */
  closed_on?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  sub_total?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  shipping?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total?: number;
  line_items: string;
  documents?: string[];
}

export interface PurchaseOrderTimeLine {
  /** @format uuid */
  id: string;
  /** @format uuid */
  purchase_order: string;
  action: string;
  /** @format uuid */
  taken_by: string;
  /** @format date-time */
  timestamp: string;
}

export interface PurchaseOrderUpdate {
  description?: string;
  labels?: string[];
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  shipping?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
  line_items: PurchaseOrderLineItemUpdate[];
  /**
   * @min -2147483648
   * @max 2147483647
   */
  po_number?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  sub_total?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total?: number;
  /** @format uuid */
  vendor: string;
  /** @format uuid */
  location?: string | null;
}

export interface PurchaseOrderUpdateRequest {
  description?: string;
  labels?: string[];
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  shipping?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
  line_items: PurchaseOrderLineItemUpdateRequest[];
  /**
   * @min -2147483648
   * @max 2147483647
   */
  po_number?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  sub_total?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total?: number;
  /** @format uuid */
  vendor: string;
  /** @format uuid */
  location?: string | null;
}

export interface ReadAccountsGroupedByProvider {
  /** @format uuid */
  id: string;
  /**
   * Display name of the integration provider
   * @maxLength 255
   */
  name: string;
  /**
   * Unique code identifier for the provider (e.g., 'samsara', 'efs')
   * @maxLength 50
   * @pattern ^[a-z0-9_-]+$
   */
  code: string;
  /**
   * Business domain this integration operates in
   *
   * * `telematics` - Telematics
   * * `fuel` - Fuel
   * * `maintenance` - Maintenance
   * * `accounting` - Accounting
   */
  domain?: DomainEnum;
  /**
   * Public website URL for the provider's service
   * @format uri
   * @maxLength 200
   */
  website_url?: string | null;
  /** @default 0 */
  active_accounts_count?: number;
  accounts: ReadMiniIntegrationAccount[];
}

export interface ReadAssignment {
  /** @format uuid */
  id: string;
  vehicle: VehicleRetrieve;
  operator: Contact;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  end_odometer?: number | null;
  /** @format date-time */
  start_datetime?: string | null;
  /** @format date-time */
  end_datetime?: string | null;
  comment?: string | null;
}

export interface ReadDetailedIntegrationAccount {
  /** @format uuid */
  id: string;
  /**
   * Display name for this integration account
   * @maxLength 255
   */
  name?: string | null;
  provider: ReadMiniIntegrationProvider;
  /**
   * Unique identifier or reference in the provider's system
   * @maxLength 255
   */
  external_id: string | null;
  /**
   * Current status of the integration account
   *
   * * `pending` - Pending
   * * `active` - Active
   * * `failed` - Failed
   * * `disabled` - Disabled
   */
  status?: StatusDfcEnum;
  /**
   * Configuration
   * Account-specific settings, feature flags, and configurations
   */
  config?: any;
  /** @format date-time */
  created: string;
}

export interface ReadIntegrationAccount {
  /** @format uuid */
  id: string;
  /**
   * Display name for this integration account
   * @maxLength 255
   */
  name?: string | null;
  provider: ReadMiniIntegrationProvider;
  /**
   * Unique identifier or reference in the provider's system
   * @maxLength 255
   */
  external_id: string | null;
  /**
   * Current status of the integration account
   *
   * * `pending` - Pending
   * * `active` - Active
   * * `failed` - Failed
   * * `disabled` - Disabled
   */
  status?: StatusDfcEnum;
  /** @format date-time */
  created: string;
}

export interface ReadIntegrationProvider {
  /** @format uuid */
  id: string;
  /**
   * Display name of the integration provider
   * @maxLength 255
   */
  name: string;
  /** Description of the integration provider */
  description?: string | null;
  /**
   * Unique code identifier for the provider (e.g., 'samsara', 'efs')
   * @maxLength 50
   * @pattern ^[a-z0-9_-]+$
   */
  code: string;
  /**
   * Business domain this integration operates in
   *
   * * `telematics` - Telematics
   * * `fuel` - Fuel
   * * `maintenance` - Maintenance
   * * `accounting` - Accounting
   */
  domain?: DomainEnum;
  /**
   * Authentication method required by the provider
   *
   * * `token` - Token
   * * `oauth2` - OAuth2
   * * `basic_auth` - Basic Auth
   * * `api_key` - API Key
   */
  auth_type?: AuthTypeEnum;
  /**
   * Base URL for the provider's API endpoints
   * @format uri
   * @maxLength 200
   */
  api_url?: string | null;
  /**
   * Public website URL for the provider's service
   * @format uri
   * @maxLength 200
   */
  website_url?: string | null;
  /** @default false */
  connected?: boolean;
}

export interface ReadMiniIntegrationAccount {
  /** @format uuid */
  id: string;
  /**
   * Display name for this integration account
   * @maxLength 255
   */
  name?: string | null;
  /**
   * Unique identifier or reference in the provider's system
   * @maxLength 255
   */
  external_id?: string | null;
  /**
   * Current status of the integration account
   *
   * * `pending` - Pending
   * * `active` - Active
   * * `failed` - Failed
   * * `disabled` - Disabled
   */
  status?: StatusDfcEnum;
  /** @format date-time */
  created: string;
}

export interface ReadMiniIntegrationProvider {
  /** @format uuid */
  id: string;
  /**
   * Display name of the integration provider
   * @maxLength 255
   */
  name: string;
  /**
   * Unique code identifier for the provider (e.g., 'samsara', 'efs')
   * @maxLength 50
   * @pattern ^[a-z0-9_-]+$
   */
  code: string;
  /**
   * Business domain this integration operates in
   *
   * * `telematics` - Telematics
   * * `fuel` - Fuel
   * * `maintenance` - Maintenance
   * * `accounting` - Accounting
   */
  domain?: DomainEnum;
  /**
   * Public website URL for the provider's service
   * @format uri
   * @maxLength 200
   */
  website_url?: string | null;
}

export interface ReadRole {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description?: string;
  permissions: Permission[];
}

export interface ReadUserContact {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /** @maxLength 64 */
  mobile_phone?: string | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  /** @maxLength 64 */
  home_phone?: string | null;
  /** @maxLength 64 */
  work_phone?: string | null;
  /** @maxLength 64 */
  other_phone?: string | null;
  address?: string | null;
  /** @maxLength 255 */
  address_line_2?: string | null;
  /** @maxLength 255 */
  city?: string | null;
  /**
   * State/province/region
   * @maxLength 255
   */
  state_province_region?: string | null;
  /**
   * Zip/postal code
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /** @maxLength 255 */
  country?: string | null;
  /** @maxLength 100 */
  job_title?: string | null;
  /** @format date */
  date_of_birth?: string | null;
  /** @maxLength 64 */
  employee_number?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  leave_date?: string | null;
  /** @maxLength 64 */
  license_number?: string | null;
  /** @maxLength 64 */
  license_class?: string | null;
  /** @maxLength 64 */
  license_state?: string | null;
  /**
   * License state/province/region
   * @maxLength 255
   */
  license_state_province_region?: string | null;
  /** @maxLength 255 */
  saml_id?: string | null;
  /** @maxLength 255 */
  id_number?: string | null;
  /** @format date */
  hire_date?: string | null;
  /** @maxLength 255 */
  cdl_endorsements?: string | null;
  profile_picture: File;
}

export interface ReasonForRepairCodeCreate {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  /**
   * @min 0
   * @max 32767
   */
  code_key: number;
  /**
   * Code Name
   * @maxLength 255
   */
  name: string;
  /** @maxLength 255 */
  description: string;
}

export interface ReasonForRepairCodeCreateRequest {
  is_active?: boolean;
  /**
   * @min 0
   * @max 32767
   */
  code_key: number;
  /**
   * Code Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  description: string;
}

export interface ReasonForRepairCodeReadOnly {
  /** @format uuid */
  id: string;
  /**
   * @min 0
   * @max 32767
   */
  code_key: number;
  /**
   * Code Name
   * @maxLength 255
   */
  name: string;
  /** @maxLength 255 */
  description: string;
}

export interface ReasonForRepairCodeReadOnlyRequest {
  /**
   * @min 0
   * @max 32767
   */
  code_key: number;
  /**
   * Code Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  description: string;
}

export interface ReceiveLineItemPurchaseOrderRequest {
  /** @format uuid */
  id: string;
  received_quantity: number;
}

export interface ReceivePurchaseOrderRequest {
  line_items: ReceiveLineItemPurchaseOrderRequest[];
}

export interface RecentCommentDashboard {
  /** @format uuid */
  id: string;
  /**
   * * `vehicle` - VEHICLE
   * * `issue` - ISSUE
   * * `service_reminder` - SERVICE_REMINDER
   * * `work_order` - WORK_ORDER
   * * `contact` - CONTACT
   * * `vendor` - VENDOR
   * * `part` - PART
   * * `fuel_entry` - FUEL_ENTRY
   */
  object_type: ObjectTypeEnum;
  /** @format uuid */
  object_id: string;
  object_name: string;
  /** @format date-time */
  created: string;
  created_by: Contact;
}

export interface Registration {
  /** @maxLength 128 */
  name?: string;
  /** @maxLength 128 */
  company_name?: string;
  /** @maxLength 128 */
  fleet_size?: string;
}

export interface RegistrationRequest {
  /**
   * @format email
   * @minLength 1
   * @maxLength 128
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  password: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  name?: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  company_name?: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  fleet_size?: string;
}

export interface ReminderDashboard {
  /** @format uuid */
  id: string;
  type: string;
  status: string;
  /** @format date */
  date: string;
  associated_item: string;
  /** @format uuid */
  associated_item_id: string;
  contact_first_name: string;
  contact_last_name: string;
}

export interface RemoveSamsaraIntegrationRequest {
  integration_id: number;
  delete_all_devices: boolean;
}

export interface RentHistoryCreate {
  /** @format uuid */
  equipment: string;
  /** @maxLength 255 */
  rented_company: string;
  /** @maxLength 255 */
  rented_by?: string | null;
  /**
   * Contact Phone
   * @maxLength 255
   */
  phone?: string | null;
  /** @format date */
  start_date: string;
  /** @format date */
  end_date?: string | null;
  duration?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  rent_per_month: number;
  comment?: string | null;
}

export interface RentHistoryCreateRequest {
  /** @format uuid */
  equipment: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  rented_company: string;
  /** @maxLength 255 */
  rented_by?: string | null;
  /**
   * Contact Phone
   * @maxLength 255
   */
  phone?: string | null;
  /** @format date */
  start_date: string;
  /** @format date */
  end_date?: string | null;
  duration?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  rent_per_month: number;
  comment?: string | null;
}

export interface RentHistoryDetail {
  /** @format uuid */
  id: string;
  equipment: EquipmentForRentHistory;
  /**
   * * `pending` - Pending
   * * `paid` - Paid
   * * `unpaid` - Unpaid
   */
  payment_status?: PaymentStatusEnum;
  /** @maxLength 255 */
  rented_company: string;
  /** @maxLength 255 */
  rented_by?: string | null;
  /**
   * Contact Phone
   * @maxLength 255
   */
  phone?: string | null;
  /** @format date */
  start_date: string;
  /** @format date */
  end_date?: string | null;
  duration?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  rent_per_month: number;
  /**
   * Total Cost
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost?: number | null;
  /** Invoice Number */
  invoice_num: string;
  comment?: string | null;
}

export interface RentHistoryList {
  /** @format uuid */
  id: string;
  equipment: EquipmentForRentHistory;
  /**
   * * `pending` - Pending
   * * `paid` - Paid
   * * `unpaid` - Unpaid
   */
  payment_status?: PaymentStatusEnum;
  /** @maxLength 255 */
  rented_company: string;
  /** @maxLength 255 */
  rented_by?: string | null;
  /**
   * Contact Phone
   * @maxLength 255
   */
  phone?: string | null;
  /** @format date */
  start_date: string;
  /** @format date */
  end_date?: string | null;
  duration: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  rent_per_month: number;
  /**
   * Total Cost
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost?: number | null;
  /** Invoice Number */
  invoice_num: string;
  comment?: string | null;
}

export interface RentHistoryUpdate {
  /**
   * * `pending` - Pending
   * * `paid` - Paid
   * * `unpaid` - Unpaid
   */
  payment_status?: PaymentStatusEnum;
  /** @format uuid */
  equipment: string;
  /** @maxLength 255 */
  rented_company: string;
  /** @maxLength 255 */
  rented_by?: string | null;
  /**
   * Contact Phone
   * @maxLength 255
   */
  phone?: string | null;
  /** @format date */
  start_date: string;
  /** @format date */
  end_date?: string | null;
  duration?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  rent_per_month: number;
  /**
   * Total Cost
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost?: number | null;
  comment?: string | null;
}

export interface RentHistoryUpdateRequest {
  /**
   * * `pending` - Pending
   * * `paid` - Paid
   * * `unpaid` - Unpaid
   */
  payment_status?: PaymentStatusEnum;
  /** @format uuid */
  equipment: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  rented_company: string;
  /** @maxLength 255 */
  rented_by?: string | null;
  /**
   * Contact Phone
   * @maxLength 255
   */
  phone?: string | null;
  /** @format date */
  start_date: string;
  /** @format date */
  end_date?: string | null;
  duration?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  rent_per_month: number;
  /**
   * Total Cost
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost?: number | null;
  comment?: string | null;
}

export interface ResendEmailCodeConfirmationRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface ResendPasswordResetLinkRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface ResetPasswordRequest {
  /**
   * @format email
   * @minLength 1
   * @maxLength 128
   */
  email: string;
}

export interface ResolveServiceReminderRequest {
  current_odometer?: number;
  /** @format date */
  completed_date: string;
  /** @format uuid */
  service: string;
}

export interface RetrieveFile {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  /** @format uri */
  file?: string | null;
  original_file_name: string;
  /** @maxLength 255 */
  file_name: string;
  /**
   * * `photo` - Photo
   * * `document` - Document
   * * `video` - Video
   * * `audio` - Audio
   * * `text` - Text
   * * `html` - HTML
   * * `microsoft_word` - Microsoft Word
   * * `microsoft_excel` - Microsoft Excel
   * * `microsoft_powerpoint` - Microsoft PowerPoint
   * * `csv` - CSV
   */
  file_type: FileType173Enum;
  /**
   * @min 0
   * @max 2147483647
   */
  file_size?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  original_file_size?: number | null;
  /** @format uuid */
  uploaded_by?: string | null;
  /** @format date-time */
  upload_finished_at?: string | null;
  vehicle: VehicleReadFile;
  labels: Label[];
  location?: LocationEnum | BlankEnum | NullEnum | null;
  /** @format uuid */
  object_id?: string | null;
  /** @maxLength 255 */
  documentable_name?: string | null;
}

export interface RetrieveFileRequest {
  /** @format binary */
  file?: File | null;
  /** @minLength 1 */
  original_file_name: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  file_name: string;
  /**
   * * `photo` - Photo
   * * `document` - Document
   * * `video` - Video
   * * `audio` - Audio
   * * `text` - Text
   * * `html` - HTML
   * * `microsoft_word` - Microsoft Word
   * * `microsoft_excel` - Microsoft Excel
   * * `microsoft_powerpoint` - Microsoft PowerPoint
   * * `csv` - CSV
   */
  file_type: FileType173Enum;
  /**
   * @min 0
   * @max 2147483647
   */
  file_size?: number | null;
  /**
   * @min 0
   * @max 2147483647
   */
  original_file_size?: number | null;
  /** @format uuid */
  uploaded_by?: string | null;
  /** @format date-time */
  upload_finished_at?: string | null;
  vehicle: VehicleReadFileRequest;
  labels: LabelRequest[];
  location?: LocationEnum | BlankEnum | NullEnum | null;
  /** @format uuid */
  object_id?: string | null;
  /** @maxLength 255 */
  documentable_name?: string | null;
}

export interface RetrieveFilesService {
  documents: RetrieveFile[];
}

export interface RetrieveService {
  /** @format uuid */
  id: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  reference_code?: number | null;
  vehicle: VehicleDeviceRead;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  void?: boolean;
  /** @format date-time */
  completion_date: string;
  /** @format date-time */
  start_date?: string | null;
  vendor: VendorRead;
  general_notes?: string | null;
  /**
   * Labor
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_labor?: number;
  /**
   * Parts
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_parts?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  tax?: number;
  notes?: string | null;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  sub_total?: number;
  /**
   * Total
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  total_cost?: number;
  issues: Issue[];
  service_task_items: RetrieveServiceTaskItem[];
  labels: Label[];
  created_by: ContactCommentRead;
  /** @maxLength 155 */
  reference?: string | null;
  comments: string;
  documents: File[];
  assigned_to: ContactCommentRead;
  driver: ContactCommentRead;
  vehicle_vendor: VendorRead;
  warranties: WarrantyList[];
  payment_type: PaymentType;
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface RetrieveServiceRequest {
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  reference_code?: number | null;
  vehicle: VehicleDeviceReadRequest;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  void?: boolean;
  /** @format date-time */
  completion_date: string;
  /** @format date-time */
  start_date?: string | null;
  vendor: VendorReadRequest;
  general_notes?: string | null;
  /**
   * Labor
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_labor?: number;
  /**
   * Parts
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_parts?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  tax?: number;
  notes?: string | null;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  sub_total?: number;
  /**
   * Total
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  total_cost?: number;
  issues: IssueRequest[];
  service_task_items: RetrieveServiceTaskItemRequest[];
  labels: LabelRequest[];
  created_by: ContactCommentReadRequest;
  /** @maxLength 155 */
  reference?: string | null;
  documents: FileRequest[];
  assigned_to: ContactCommentReadRequest;
  driver: ContactCommentReadRequest;
  vehicle_vendor: VendorReadRequest;
  payment_type: PaymentTypeRequest;
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface RetrieveServiceTask {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description?: string;
  maintenance_category: MaintenanceCategoryReadOnly;
  system_code: SystemCodeReadOnly;
  assembly_code: AssemblyCodeReadOnly;
  reason_for_repair_code: ReasonForRepairCodeReadOnly;
}

export interface RetrieveServiceTaskItem {
  /** @format uuid */
  id: string;
  service_task: RetrieveServiceTaskServiceEntry;
  reason_for_repair_code: ReasonForRepairCodeReadOnly;
  category: MaintenanceCategoryReadOnly;
  system: SystemCodeReadOnly;
  assembly: AssemblyCodeReadOnly;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  parts?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  subtotal?: number;
}

export interface RetrieveServiceTaskItemRequest {
  service_task: RetrieveServiceTaskServiceEntryRequest;
  reason_for_repair_code: ReasonForRepairCodeReadOnlyRequest;
  category: MaintenanceCategoryReadOnlyRequest;
  system: SystemCodeReadOnlyRequest;
  assembly: AssemblyCodeReadOnlyRequest;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  parts?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  subtotal?: number;
}

export interface RetrieveServiceTaskServiceEntry {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description?: string;
}

export interface RetrieveServiceTaskServiceEntryRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: string;
}

/** Serializer for user role information */
export interface Role {
  /** @format uuid */
  id: string;
  name: string;
  description: string;
}

export interface RoleContact {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface RoleRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  permissions: string[];
  description?: string;
}

export interface RoleUpdate {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description?: string;
}

export interface RoleUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: string;
}

export interface SamsaraIntegrationRead {
  id: number;
  /**
   * Samsara Name
   * @maxLength 255
   */
  samsara_account_name?: string | null;
  /**
   * Samsara ID
   * @maxLength 255
   */
  samsara_account_id?: string | null;
}

export interface SamsaraIntegrationReadRequest {
  /**
   * Samsara Name
   * @maxLength 255
   */
  samsara_account_name?: string | null;
  /**
   * Samsara ID
   * @maxLength 255
   */
  samsara_account_id?: string | null;
}

export interface SamsaraSelectDriversRequest {
  driver_ids?: number[];
  integration_id: number;
  /** @default false */
  import_all?: boolean;
}

export interface SamsaraSelectVehiclesRequest {
  vehicle_ids?: number[];
  integration_id: number;
  /** @default false */
  import_all?: boolean;
}

export interface SamsaraTokenRequest {
  /** @minLength 1 */
  token: string;
}

export interface SaveIntegrationAccountDriversRequest {
  /**
   * Integration account ID
   * @format uuid
   */
  account_id: string;
  /** List of driver IDs to import */
  driver_ids?: string[];
  /**
   * If True, imports all available drivers from telematics provider
   * @default false
   */
  import_all?: boolean;
}

export interface SaveIntegrationAccountVehiclesRequest {
  /**
   * Integration account ID
   * @format uuid
   */
  account_id: string;
  /** List of vehicle IDs to import */
  vehicle_ids?: string[];
  /**
   * If True, imports all available vehicles from telematics provider
   * @default false
   */
  import_all?: boolean;
}

export interface SearchVendor {
  /** @format uuid */
  id: string;
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  contact: VendorsContact;
  partner: VendorPartner;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  location: VendorsLocation;
  /** Determines if the vendor should be featured in listings and searches */
  is_featured?: boolean;
  has_active_promos: boolean;
  services_count: number;
}

/** Serializer for SectionCategory model. */
export interface SectionCategory {
  /** @format uuid */
  id: string;
  /**
   * Name of the section.
   * @maxLength 50
   */
  name: string;
}

export interface ServiceEntry {
  /** @format uuid */
  id: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  reference_code?: number | null;
}

export interface ServiceEntryComment {
  /** @format uuid */
  id: string;
  comment: string;
  /** @format uuid */
  service_entry: string;
}

export interface ServiceEntryCommentRequest {
  /** @minLength 1 */
  comment: string;
  /** @format uuid */
  service_entry: string;
}

export interface ServiceHistory {
  /** @format uuid */
  id: string;
  /**
   * Due Date
   * @format date
   */
  date: string;
  /** @format date */
  completed_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  completed_meter: number;
  completed_by: Contact;
  /**
   * * `on_time` - On time
   * * `up_coming` - Upcoming
   * * `late` - Late
   */
  compliance_status?: ComplianceStatusEnum;
  /** Calculate the compliance status based on the service reminder details. */
  calculated_compliance_status: string;
}

export interface ServiceHistoryByVehicleReport {
  /** @format uuid */
  id: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format date-time */
  completion_date: string;
  duration: string;
  vendor: VendorReport;
  service_tasks: string;
  /**
   * Labor
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_labor?: number;
  /**
   * Parts
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_parts?: number;
  /**
   * Total
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  total_cost?: number;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  reference_code?: number | null;
}

export interface ServiceHistoryRequest {
  /**
   * Due Date
   * @format date
   */
  date: string;
  /** @format date */
  completed_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  completed_meter: number;
  /**
   * * `on_time` - On time
   * * `up_coming` - Upcoming
   * * `late` - Late
   */
  compliance_status?: ComplianceStatusEnum;
}

export interface ServiceHistorySummaryReport {
  /** @format uuid */
  id: string;
  vehicle: VehicleServiceReport;
  count_of_service_tasks: string;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  tax?: number;
  /**
   * Total
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  total_cost?: number;
  /**
   * Parts
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_parts?: number;
  duration: string;
  /** @format date-time */
  created: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  reference_code?: number | null;
}

export interface ServiceReminder {
  /** @format uuid */
  id: string;
  /** @format uuid */
  vehicle: string;
  /** @format uuid */
  service_task: string;
  /**
   * * `Upcoming` - Upcoming
   * * `DueSoon` - Due Soon
   * * `Overdue` - Overdue
   * * `Snoozed` - Snoozed
   * * `Completed` - Completed
   */
  status?: StatusCb4Enum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_interval?: number | null;
  /** Time Interval */
  time_interval_unit?: TimeIntervalUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_due_soon_threshold?: number | null;
  /** Time Due Soon Threshold */
  time_due_soon_threshold_unit?: TimeDueSoonThresholdUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  meter_interval?: number | null;
  manual_next_due?: boolean;
  /** @format date */
  next_due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  next_due_meter?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_due_soon_threshold?: number | null;
  notification_active?: boolean;
  /** Recipient */
  recipients?: string[];
  /** @format uuid */
  recipient_group?: string | null;
  documents?: string[];
  comments?: NestedServiceReminderComment[];
}

export interface ServiceReminderBulkCreateRequest {
  vehicles?: string[];
  /** @default false */
  select_all_vehicles?: boolean;
  /** @default false */
  use_latest_odometer?: boolean;
  /** @format uuid */
  service_task: string;
  /**
   * * `Upcoming` - Upcoming
   * * `DueSoon` - Due Soon
   * * `Overdue` - Overdue
   * * `Snoozed` - Snoozed
   * * `Completed` - Completed
   */
  status?: StatusCb4Enum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_interval?: number | null;
  /** Time Interval */
  time_interval_unit?: TimeIntervalUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_due_soon_threshold?: number | null;
  /** Time Due Soon Threshold */
  time_due_soon_threshold_unit?: TimeDueSoonThresholdUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  meter_interval?: number | null;
  manual_next_due?: boolean;
  /** @format date */
  next_due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  next_due_meter?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_due_soon_threshold?: number | null;
  notification_active?: boolean;
  /** Recipient */
  recipients?: string[];
  /** @format uuid */
  recipient_group?: string | null;
  documents?: string[];
  comments?: NestedServiceReminderCommentRequest[];
}

/** ServiceReminderBulkCreateResponse */
export interface ServiceReminderBulkCreateResponse {
  /** Message */
  message: string;
  /** Count */
  count: number;
}

export interface ServiceReminderComment {
  /** @format uuid */
  id: string;
  /** @format uuid */
  service_reminder: string;
  comment: string;
  created_by: Contact;
}

export interface ServiceReminderCommentRequest {
  /** @format uuid */
  service_reminder: string;
  /** @minLength 1 */
  comment: string;
}

export interface ServiceReminderComplianceReport {
  /** @format uuid */
  id: string;
  /** @format date */
  due_at: string;
  /** @format date */
  completed_at: string;
  status: string;
  service_task: RetrieveServiceTaskServiceEntry;
  vehicle: VehicleReport;
  group: Group;
  due_meter_value: number;
  completed_meter_value: number;
}

export interface ServiceReminderDetail {
  /** @format uuid */
  id: string;
  vehicle: LinkedVehicle;
  operator: Contact;
  /**
   * * `Upcoming` - Upcoming
   * * `DueSoon` - Due Soon
   * * `Overdue` - Overdue
   * * `Snoozed` - Snoozed
   * * `Completed` - Completed
   */
  status?: StatusCb4Enum;
  service_task: RetrieveServiceTaskServiceEntry;
  /** @format date */
  next_due_date: string;
  next_due_meter: number;
  last_completed: string;
  work_order: WorkOrderForWorkOrder;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_interval?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  meter_interval?: number | null;
  /** Meter Interval */
  meter_interval_unit?: MeterIntervalUnitEnum;
  manual_set_next_due: boolean;
  notification_active?: boolean;
  service_histories: ServiceHistory[];
  documents: File[];
  comments: NestedServiceReminderComment[];
  history_stats: string;
  recipient_group: Group;
  recipients: Contact[];
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_due_soon_threshold?: number | null;
  /** Time Due Soon Threshold */
  time_due_soon_threshold_unit?: TimeDueSoonThresholdUnitEnum;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_due_soon_threshold?: number | null;
  /** Time Interval */
  time_interval_unit?: TimeIntervalUnitEnum;
}

export interface ServiceReminderDocument {
  documents?: string[];
}

export interface ServiceReminderDocumentRequest {
  documents?: string[];
}

export interface ServiceReminderRead {
  /** @format uuid */
  id: string;
  vehicle: VehicleRetrieveMini;
  operator: Contact;
  service_task: RetrieveServiceTaskServiceEntry;
  /**
   * * `Upcoming` - Upcoming
   * * `DueSoon` - Due Soon
   * * `Overdue` - Overdue
   * * `Snoozed` - Snoozed
   * * `Completed` - Completed
   */
  status?: StatusCb4Enum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_interval?: number | null;
  /** Time Interval */
  time_interval_unit?: TimeIntervalUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_due_soon_threshold?: number | null;
  /** Time Due Soon Threshold */
  time_due_soon_threshold_unit?: TimeDueSoonThresholdUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  meter_interval?: number | null;
  manual_next_due?: boolean;
  /** @format date */
  next_due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  next_due_meter?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_due_soon_threshold?: number | null;
  notification_active?: boolean;
  /** @format date-time */
  snoozed_until?: string | null;
  recipients: Contact[];
  recipient_group: Group;
  work_order: WorkOrderRetrieveServiceEntity;
  /** @format date-time */
  archived_at?: string | null;
  service_histories: ServiceHistory[];
  compliance: string;
  last_completed: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  /** @format date-time */
  created: string;
}

export interface ServiceReminderReadRequest {
  /**
   * * `Upcoming` - Upcoming
   * * `DueSoon` - Due Soon
   * * `Overdue` - Overdue
   * * `Snoozed` - Snoozed
   * * `Completed` - Completed
   */
  status?: StatusCb4Enum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_interval?: number | null;
  /** Time Interval */
  time_interval_unit?: TimeIntervalUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_due_soon_threshold?: number | null;
  /** Time Due Soon Threshold */
  time_due_soon_threshold_unit?: TimeDueSoonThresholdUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  meter_interval?: number | null;
  manual_next_due?: boolean;
  /** @format date */
  next_due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  next_due_meter?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_due_soon_threshold?: number | null;
  notification_active?: boolean;
  /** @format date-time */
  snoozed_until?: string | null;
  /** @format date-time */
  archived_at?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
}

export interface ServiceReminderReport {
  /** @format uuid */
  id: string;
  vehicle: VehicleReport;
  /** @format uuid */
  operator?: string | null;
  service_task: RetrieveServiceTaskServiceEntry;
  /**
   * * `Upcoming` - Upcoming
   * * `DueSoon` - Due Soon
   * * `Overdue` - Overdue
   * * `Snoozed` - Snoozed
   * * `Completed` - Completed
   */
  status?: StatusCb4Enum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_interval?: number | null;
  /** Time Interval */
  time_interval_unit?: TimeIntervalUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_due_soon_threshold?: number | null;
  /** Time Due Soon Threshold */
  time_due_soon_threshold_unit?: TimeDueSoonThresholdUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  meter_interval?: number | null;
  manual_next_due?: boolean;
  /** @format date */
  next_due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  next_due_meter?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_due_soon_threshold?: number | null;
  /** @format date-time */
  snoozed_until?: string | null;
  /** @format uuid */
  work_order?: string | null;
  /** @format date-time */
  archived_at?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
}

export interface ServiceReminderRequest {
  /** @format uuid */
  vehicle: string;
  /** @format uuid */
  service_task: string;
  /**
   * * `Upcoming` - Upcoming
   * * `DueSoon` - Due Soon
   * * `Overdue` - Overdue
   * * `Snoozed` - Snoozed
   * * `Completed` - Completed
   */
  status?: StatusCb4Enum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_interval?: number | null;
  /** Time Interval */
  time_interval_unit?: TimeIntervalUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_due_soon_threshold?: number | null;
  /** Time Due Soon Threshold */
  time_due_soon_threshold_unit?: TimeDueSoonThresholdUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  meter_interval?: number | null;
  manual_next_due?: boolean;
  /** @format date */
  next_due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  next_due_meter?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_due_soon_threshold?: number | null;
  notification_active?: boolean;
  /** Recipient */
  recipients?: string[];
  /** @format uuid */
  recipient_group?: string | null;
  documents?: string[];
  comments?: NestedServiceReminderCommentRequest[];
}

export interface ServiceReminderSnooze {
  status: StatusCb4Enum;
  /** @format date-time */
  snoozed_until: string;
  /** @format date-time */
  snoozed_at: string | null;
  /** @format uuid */
  snoozed_by: string | null;
}

export interface ServiceReminderSnoozeRequest {
  /** @format date-time */
  snoozed_until: string;
}

export interface ServiceTaskForWorkOrderActivity {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  is_general?: boolean;
}

export interface SpecificationWrite {
  dimensions?: Dimensions;
  performance?: Performance;
  fuel?: Fuel;
  engine?: EngineWrite;
  transmission?: TransmissionWrite;
  wheels_tires?: WheelsTiresWrite;
  oil?: Oil;
}

export interface SpecificationWriteRequest {
  dimensions?: DimensionsRequest;
  performance?: PerformanceRequest;
  fuel?: FuelRequest;
  engine?: EngineWriteRequest;
  transmission?: TransmissionWriteRequest;
  wheels_tires?: WheelsTiresWriteRequest;
  oil?: OilRequest;
}

/** StatusDistribution */
export interface StatusDistribution {
  /**
   * Total Vehicles
   * @min 0
   */
  total_vehicles: number;
  /** Points */
  points: StatusPoint[];
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
}

/** StatusPercentages */
export interface StatusPercentages {
  /**
   * Open
   * Percentage of open issues
   */
  open: number;
  /**
   * Resolved
   * Percentage of resolved issues
   */
  resolved: number;
  /**
   * Closed
   * Percentage of closed issues
   */
  closed: number;
  /**
   * Done
   * Percentage of done issues
   */
  done: number;
}

/** StatusPoint */
export interface StatusPoint {
  status: StatusType;
  /**
   * Count
   * @min 0
   */
  count: number;
  /** Percentage */
  percentage: number | string;
  /** Label */
  label: string;
}

/** Serializer for StepByStepGuide model. */
export interface StepByStepGuide {
  /** @format uuid */
  id: string;
  /**
   * Title of the step by step guide.
   * @maxLength 200
   */
  title: string;
  /** Description of the step by step guide. */
  description: string;
  /** @format uri */
  file_1?: string | null;
  /** @format uri */
  file_2?: string | null;
  /**
   * Order of the step by step guide in the training video.
   * @min 0
   * @max 2147483647
   */
  order: number;
}

/** Serializer for sub-permissions (child permissions) */
export interface SubPermission {
  /** @format uuid */
  id: string;
  name: string;
  codename: string;
  description: string;
  /** @default true */
  is_child_permission?: boolean;
}

export interface SubdomainCheck {
  /** @maxLength 255 */
  subdomain: string;
}

export interface SubdomainCheckRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  subdomain: string;
}

export interface SubdomainCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  subdomain: string;
}

export interface SubdomainSuggest {
  /** @maxLength 255 */
  base: string;
}

export interface SubdomainSuggestRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  base: string;
}

export interface Summary {
  /**
   * Total repair cost in USD
   * @format double
   */
  total_cost: number;
  /**
   * Total repair time in hours
   * @format double
   */
  total_time: number;
}

/** SystemAnalyticsDashboardsAPIResponseSchema */
export interface SystemAnalyticsDashboardsAPIResponseSchema {
  /**
   * Count
   * Number of charts
   * @default 0
   */
  count?: number;
  /**
   * Charts
   * List of charts
   */
  charts: DashboardDefinition[];
}

export interface SystemCodeCreate {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  /**
   * @min 0
   * @max 32767
   */
  system_code: number;
  /**
   * System Name
   * @maxLength 255
   */
  name: string;
  /** @format uuid */
  maintenance_category: string;
}

export interface SystemCodeCreateRequest {
  is_active?: boolean;
  /**
   * @min 0
   * @max 32767
   */
  system_code: number;
  /**
   * System Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** @format uuid */
  maintenance_category: string;
}

export interface SystemCodeReadOnly {
  /** @format uuid */
  id: string;
  /**
   * @min 0
   * @max 32767
   */
  system_code: number;
  /**
   * System Name
   * @maxLength 255
   */
  name: string;
  maintenance_category: MaintenanceCategoryReadOnly;
}

export interface SystemCodeReadOnlyRequest {
  /**
   * @min 0
   * @max 32767
   */
  system_code: number;
  /**
   * System Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  maintenance_category: MaintenanceCategoryReadOnlyRequest;
}

export interface SystemModule {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  /** @maxLength 255 */
  code_name: string;
  description: string;
  permissions: string[];
}

export interface SystemModuleRolePermission {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description?: string;
  permissions: string[];
}

export interface TechnicianForLaborTimeEntriesListReport {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
}

export interface TelegramBot {
  /** @format uuid */
  id: string;
  /**
   * Bot Name
   * Name of the bot for identification
   * @maxLength 255
   */
  name?: string | null;
  /**
   * Bot Username
   * Telegram bot username
   * @maxLength 255
   */
  username: string;
  /** Description of the bot's purpose */
  description?: string | null;
  /** Whether this bot is currently active */
  is_active?: boolean;
}

export interface TelegramChannel {
  /** @format uuid */
  id: string;
  /**
   * Channel Name
   * @maxLength 255
   */
  name?: string | null;
  bot: TelegramBot;
  /**
   * * `group` - Group
   * * `channel` - Channel
   * * `private` - Private
   */
  channel_type?: ChannelTypeEnum;
  /** Use this channel by default for new announcements */
  default_for_announcements?: boolean;
  /**
   * Number of members in the channel/group
   * @min -2147483648
   * @max 2147483647
   */
  member_count?: number;
  is_active?: boolean;
}

export interface TelematicsDeviceList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  provider?: string | null;
  /** @maxLength 255 */
  device_name?: string | null;
  /** @maxLength 17 */
  vin?: string | null;
  /** @maxLength 255 */
  serial_number?: string | null;
  device_errors?: string | null;
  device_type?: DeviceTypeEnum | BlankEnum | NullEnum | null;
  vehicle: VehicleDeviceRead;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  samsara_asset_id?: number | null;
  integration: SamsaraIntegrationRead;
  /** Active */
  is_active?: boolean;
  is_assigned_device: string;
}

export interface TelematicsDeviceListRequest {
  /** @maxLength 255 */
  provider?: string | null;
  /** @maxLength 255 */
  device_name?: string | null;
  /** @maxLength 17 */
  vin?: string | null;
  /** @maxLength 255 */
  serial_number?: string | null;
  device_errors?: string | null;
  device_type?: DeviceTypeEnum | BlankEnum | NullEnum | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  samsara_asset_id?: number | null;
  /** Active */
  is_active?: boolean;
}

/** TimeMetricValue */
export interface TimeMetricValue {
  /**
   * Value
   * Current value of the metric
   */
  value: number;
  /**
   * Percentage Change
   * Percentage change from previous period
   */
  percentage_change: number;
  /**
   * Period
   * Time period (24hr or 1week)
   */
  period: string;
}

/** TimeMetrics */
export interface TimeMetrics {
  /**
   * Average Resolution Time
   * Average time to resolve issues in hours
   */
  average_resolution_time: number;
  /**
   * Average Response Time
   * Average time to first response in hours
   */
  average_response_time: number;
}

export interface TokenObtainPair {
  access: string;
  refresh: string;
}

export interface TokenObtainPairRequest {
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  password: string;
}

export interface TokenRefresh {
  access: string;
}

export interface TokenRefreshRequest {
  /** @minLength 1 */
  refresh: string;
}

export interface TokenVerifyRequest {
  /** @minLength 1 */
  token: string;
}

/** Serializer for TrainingVideo model. */
export interface TrainingVideo {
  /** @format uuid */
  id: string;
  /**
   * Title of the training video.
   * @maxLength 200
   */
  title: string;
  /** Description of the training video. */
  description: string;
  /**
   * Section where the video is classified.
   * @format uuid
   */
  section?: string | null;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  file: File;
  /**
   * Provider of the video.
   *
   * * `YOUTUBE` - YouTube
   * * `VIMEO` - Vimeo
   */
  provider?: ProviderEnum | BlankEnum | NullEnum | null;
  /**
   * Link to the video on the provider.
   * @maxLength 255
   */
  provider_link?: string | null;
  step_by_step_guides: StepByStepGuide[];
}

export interface TranscriptionRequestRequest {
  /**
   * ID of the file in the system
   * @format uuid
   */
  file_id: string;
  /**
   * Whether to include translations
   * @default false
   */
  include_translations?: boolean;
}

export interface TranscriptionResponse {
  /** Transcribed text */
  text: string;
  /**
   * Original file ID
   * @format uuid
   */
  file_id: string;
  /**
   * Audio duration in seconds
   * @format double
   */
  duration?: number;
}

export interface TransferPartQuantity {
  new_quantity: number;
  /** @format uuid */
  new_location: string;
}

export interface TransferPartQuantityRequest {
  new_quantity: number;
  /** @format uuid */
  new_location: string;
}

export interface TransmissionTypeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface TransmissionTypeList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface TransmissionWrite {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  transmission_description?: string | null;
  /** @maxLength 255 */
  transmission_brand?: string | null;
  /** @format uuid */
  transmission_type?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  transmission_gears?: number | null;
}

export interface TransmissionWriteRequest {
  /** @maxLength 255 */
  transmission_description?: string | null;
  /** @maxLength 255 */
  transmission_brand?: string | null;
  /** @format uuid */
  transmission_type?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  transmission_gears?: number | null;
}

/** Detailed serializer for travel time estimates. */
export interface TravelTime {
  minutes: number;
  /** @format double */
  speed_kmh: number;
  /** @format double */
  speed_mph: number;
  description: string;
}

/** TrendingLabel */
export interface TrendingLabel {
  /** Name */
  name: string;
  /** Count */
  count: number;
  /** Priority Breakdown */
  priority_breakdown: Record<string, number>;
}

/**
 * UnifiedAddress
 * Common address format across providers
 */
export interface UnifiedAddress {
  /** Street */
  street: string;
  /** City */
  city: string;
  /**
   * State
   * @default null
   */
  state?: string | null;
  /** Country */
  country: string;
  /**
   * Postal Code
   * @default null
   */
  postal_code?: string | null;
}

/**
 * UnifiedCarrierInfo
 * Common carrier information across providers
 */
export interface UnifiedCarrierInfo {
  /** Legal Name */
  legal_name: string;
  /**
   * Dot Number
   * @default null
   */
  dot_number?: string | null;
  /**
   * Mc Number
   * @default null
   */
  mc_number?: string | null;
  /** @default null */
  detailed_address?: UnifiedAddress | null;
  /**
   * Short Address
   * @default null
   */
  short_address?: string | null;
}

/**
 * UnifiedOrganizationData
 * Unified organization schema that represents common fields across all providers.
 * This is what our internal systems will work with.
 */
export interface UnifiedOrganizationData {
  /**
   * Name
   * Organization display name
   */
  name: string;
  /**
   * External Id
   * Original ID in the provider's system
   */
  external_id: string;
  /**
   * Provider
   * Integration provider code (e.g., 'samsara')
   */
  provider: string;
  /** Type of organization */
  org_type: UnifiedOrganizationType;
  /** @default null */
  carrier_info?: UnifiedCarrierInfo | null;
  /**
   * Created At
   * @default null
   */
  created_at?: string | null;
  /**
   * Updated At
   * @default null
   */
  updated_at?: string | null;
  /**
   * Timezone
   * @default null
   */
  timezone?: string | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
}

export interface UpdateFileRequest {
  /** @minLength 1 */
  original_file_name: string;
  labels?: string[];
}

export interface UpdateMeterEntryRequest {
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_value: number;
  /**
   * * `miles` - Miles
   * * `gallons` - Gallons
   * * `liters` - Liters
   * * `kilometers` - Kilometers
   */
  meter_unit?: MeterUnitEnum;
  void?: boolean;
  /** @format date */
  meter_date: string;
}

export interface UpdateRolePermissions {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  description?: string;
}

export interface UpdateService {
  /** @format uuid */
  vehicle: string;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  void?: boolean;
  /** @format date-time */
  completion_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format uuid */
  vendor?: string | null;
  general_notes?: string | null;
  /**
   * Labor
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_labor?: number;
  /**
   * Parts
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_parts?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  tax?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  sub_total?: number;
  /**
   * Total
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  total_cost?: number;
  notes?: string | null;
  service_task_items: UpdateServiceTaskItem[];
  labels?: string[];
  /** @maxLength 155 */
  reference?: string | null;
  /** @format uuid */
  assigned_to?: string | null;
  issues?: string[];
  warranties?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface UpdateServiceReminder {
  /** @format uuid */
  id: string;
  /** @format uuid */
  vehicle: string;
  /** @format uuid */
  work_order?: string | null;
  /** @format uuid */
  service_task: string;
  /**
   * * `Upcoming` - Upcoming
   * * `DueSoon` - Due Soon
   * * `Overdue` - Overdue
   * * `Snoozed` - Snoozed
   * * `Completed` - Completed
   */
  status?: StatusCb4Enum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_interval?: number | null;
  /** Time Interval */
  time_interval_unit?: TimeIntervalUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_due_soon_threshold?: number | null;
  /** Time Due Soon Threshold */
  time_due_soon_threshold_unit?: TimeDueSoonThresholdUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  meter_interval?: number | null;
  manual_next_due?: boolean;
  /** @format date */
  next_due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  next_due_meter?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_due_soon_threshold?: number | null;
  notification_active?: boolean;
  /** Recipient */
  recipients?: string[];
  /** @format uuid */
  recipient_group?: string | null;
  documents?: string[];
}

export interface UpdateServiceReminderRequest {
  /** @format uuid */
  vehicle: string;
  /** @format uuid */
  work_order?: string | null;
  /** @format uuid */
  service_task: string;
  /**
   * * `Upcoming` - Upcoming
   * * `DueSoon` - Due Soon
   * * `Overdue` - Overdue
   * * `Snoozed` - Snoozed
   * * `Completed` - Completed
   */
  status?: StatusCb4Enum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_interval?: number | null;
  /** Time Interval */
  time_interval_unit?: TimeIntervalUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_due_soon_threshold?: number | null;
  /** Time Due Soon Threshold */
  time_due_soon_threshold_unit?: TimeDueSoonThresholdUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  meter_interval?: number | null;
  manual_next_due?: boolean;
  /** @format date */
  next_due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  next_due_meter?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_due_soon_threshold?: number | null;
  notification_active?: boolean;
  /** Recipient */
  recipients?: string[];
  /** @format uuid */
  recipient_group?: string | null;
  documents?: string[];
}

export interface UpdateServiceRequest {
  /** @format uuid */
  vehicle: string;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  void?: boolean;
  /** @format date-time */
  completion_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format uuid */
  vendor?: string | null;
  general_notes?: string | null;
  /**
   * Labor
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_labor?: number;
  /**
   * Parts
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_parts?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  tax?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  sub_total?: number;
  /**
   * Total
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  total_cost?: number;
  notes?: string | null;
  service_task_items: PatchedUpdateServiceTaskItemRequest[];
  labels?: string[];
  /** @maxLength 155 */
  reference?: string | null;
  /** @format uuid */
  assigned_to?: string | null;
  faults?: string[];
  issues?: string[];
  warranties?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
}

export interface UpdateServiceTask {
  /** @maxLength 255 */
  name: string;
  description?: string;
  /** @format uuid */
  maintenance_category?: string | null;
  /** @format uuid */
  system_code?: string | null;
  /** @format uuid */
  assembly_code?: string | null;
  /** @format uuid */
  reason_for_repair_code?: string | null;
}

export interface UpdateServiceTaskItem {
  /** @format uuid */
  st_id?: string;
  /** @format uuid */
  service_task: string;
  /** @format uuid */
  reason_for_repair_code?: string | null;
  /** @format uuid */
  category?: string | null;
  /** @format uuid */
  system?: string | null;
  /** @format uuid */
  assembly?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  parts?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  subtotal?: number;
}

export interface UpdateServiceTaskRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  description?: string;
  /** @format uuid */
  maintenance_category?: string | null;
  /** @format uuid */
  system_code?: string | null;
  /** @format uuid */
  assembly_code?: string | null;
  /** @format uuid */
  reason_for_repair_code?: string | null;
}

export interface UpdateUserContact {
  /** @format uuid */
  id: string;
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /** @maxLength 64 */
  mobile_phone?: string | null;
  /** @maxLength 64 */
  home_phone?: string | null;
  /** @maxLength 64 */
  work_phone?: string | null;
  /** @maxLength 64 */
  other_phone?: string | null;
  address?: string | null;
  /** @maxLength 255 */
  address_line_2?: string | null;
  /** @maxLength 255 */
  city?: string | null;
  /**
   * State/province/region
   * @maxLength 255
   */
  state_province_region?: string | null;
  /**
   * Zip/postal code
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /** @maxLength 255 */
  country?: string | null;
  /** @maxLength 100 */
  job_title?: string | null;
  /** @format date */
  date_of_birth?: string | null;
  /** @maxLength 64 */
  employee_number?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  leave_date?: string | null;
  /** @maxLength 64 */
  license_number?: string | null;
  /** @maxLength 64 */
  license_class?: string | null;
  /** @maxLength 64 */
  license_state?: string | null;
  /**
   * License state/province/region
   * @maxLength 255
   */
  license_state_province_region?: string | null;
  /** @maxLength 255 */
  saml_id?: string | null;
  /** @maxLength 255 */
  id_number?: string | null;
  /** @format date */
  hire_date?: string | null;
  /** @maxLength 255 */
  cdl_endorsements?: string | null;
  /** @format uuid */
  profile_picture?: string | null;
}

export interface UpdateUserContactRequest {
  /**
   * Email address
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
  /** @maxLength 64 */
  mobile_phone?: string | null;
  /** @maxLength 64 */
  home_phone?: string | null;
  /** @maxLength 64 */
  work_phone?: string | null;
  /** @maxLength 64 */
  other_phone?: string | null;
  address?: string | null;
  /** @maxLength 255 */
  address_line_2?: string | null;
  /** @maxLength 255 */
  city?: string | null;
  /**
   * State/province/region
   * @maxLength 255
   */
  state_province_region?: string | null;
  /**
   * Zip/postal code
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /** @maxLength 255 */
  country?: string | null;
  /** @maxLength 100 */
  job_title?: string | null;
  /** @format date */
  date_of_birth?: string | null;
  /** @maxLength 64 */
  employee_number?: string | null;
  /** @format date */
  start_date?: string | null;
  /** @format date */
  leave_date?: string | null;
  /** @maxLength 64 */
  license_number?: string | null;
  /** @maxLength 64 */
  license_class?: string | null;
  /** @maxLength 64 */
  license_state?: string | null;
  /**
   * License state/province/region
   * @maxLength 255
   */
  license_state_province_region?: string | null;
  /** @maxLength 255 */
  saml_id?: string | null;
  /** @maxLength 255 */
  id_number?: string | null;
  /** @format date */
  hire_date?: string | null;
  /** @maxLength 255 */
  cdl_endorsements?: string | null;
  /** @format uuid */
  profile_picture?: string | null;
}

export interface UpdateVendor {
  /** @format uuid */
  id: string;
  schedules?: VendorScheduleUpdate[];
  services?: VendorServiceUpdate[];
  is_active?: boolean;
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /**
   * Longitude coordinate of the vendor's location
   * @format double
   */
  longitude?: number | null;
  /**
   * Latitude coordinate of the vendor's location
   * @format double
   */
  latitude?: number | null;
  /** Geographic point representing the vendor's location (automatically set from latitude/longitude) */
  location?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  /** Indicates if the vendor is available across all companies */
  is_global?: boolean;
  /** Controls whether the vendor is visible in public listings */
  public_visibility?: boolean;
  /** Determines if the vendor should be featured in listings and searches */
  is_featured?: boolean;
  attributes?: any;
  /**
   * Logo or brand image of the vendor
   * @format uuid
   */
  logo?: string | null;
  /**
   * Associated partner organization or program
   * @format uuid
   */
  partner?: string | null;
  /** Tags or categories to help organize and filter vendors */
  labels?: string[];
  /** Related documents such as contracts, certificates, or agreements */
  documents?: string[];
}

export interface UpdateVendorRequest {
  schedules?: VendorScheduleUpdateRequest[];
  services?: VendorServiceUpdateRequest[];
  is_active?: boolean;
  /**
   * The official business name of the vendor
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /**
   * Longitude coordinate of the vendor's location
   * @format double
   */
  longitude?: number | null;
  /**
   * Latitude coordinate of the vendor's location
   * @format double
   */
  latitude?: number | null;
  /** Geographic point representing the vendor's location (automatically set from latitude/longitude) */
  location?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  /** Indicates if the vendor is available across all companies */
  is_global?: boolean;
  /** Controls whether the vendor is visible in public listings */
  public_visibility?: boolean;
  /** Determines if the vendor should be featured in listings and searches */
  is_featured?: boolean;
  attributes?: any;
  /**
   * Logo or brand image of the vendor
   * @format uuid
   */
  logo?: string | null;
  /**
   * Associated partner organization or program
   * @format uuid
   */
  partner?: string | null;
  /** Tags or categories to help organize and filter vendors */
  labels?: string[];
  /** Related documents such as contracts, certificates, or agreements */
  documents?: string[];
}

export interface UploadFilesPart {
  documents?: string[];
}

export interface UploadFilesPartRequest {
  documents?: string[];
}

export interface UploadFilesService {
  documents: string[];
}

export interface UploadFilesServiceRequest {
  documents: string[];
}

export interface UploadFilesWorkOrder {
  documents?: string[];
}

export interface UploadFilesWorkOrderRequest {
  documents?: string[];
}

/**
 * Main serializer for user permissions response
 * Includes has_full_access flag, modules with permissions, and role info
 */
export interface UserPermissions {
  has_full_access: boolean;
  modules: Module[];
  role: Role | null;
}

export interface UserRenewalReminders {
  /** @format uuid */
  id: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  /**
   * * `upcoming` - Upcoming
   * * `due_soon` - Due Soon
   * * `overdue` - Overdue
   */
  status?: Status5D2Enum;
  renewal_type: string | null;
  /**
   * Date on which the contact will be renewed
   * @format date
   */
  due_date: string;
  contact: string;
  group: string | null;
}

export interface Vehicle {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
}

export interface VehicleAssignmentLog {
  /** @format uuid */
  id: string;
  vehicle: VehicleForAssignmentLog;
  operator: OperatorForAssignmentLog;
  /** @format date-time */
  start_datetime?: string | null;
  /** @format date-time */
  end_datetime?: string | null;
  duration: string;
  status: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  end_odometer?: number | null;
}

export interface VehicleAssignmentsSummary {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  assignments_count: number;
  operators_count: number;
  assignment_percentage: string;
}

export interface VehicleBodySubTypeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleBodySubTypeList {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleBodyTypeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleBodyTypeList {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

/**
 * VehicleCalendarIssues
 * Calendar issues for a specific vehicle.
 */
export interface VehicleCalendarIssues {
  /**
   * Vehicle Id
   * @format uuid4
   */
  vehicle_id: string;
  /** Vehicle Name */
  vehicle_name: string;
  /** Issues */
  issues: DayIssue[];
  /**
   * Total Issues
   * @default 0
   */
  total_issues?: number;
  /**
   * Total Critical
   * @default 0
   */
  total_critical?: number;
}

export interface VehicleComments {
  /** @format uuid */
  id: string;
  comment: string;
  created_by: string;
}

export interface VehicleCostComparisonReport {
  /** @format uuid */
  id: string;
}

export interface VehicleDetailRetrieve {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  type: string | null;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number | null;
  fuel_type: string | null;
  current_meter: string;
  current_meter_date: string;
  current_secondary_meter: string;
  current_secondary_meter_date: string;
  ownership?: OwnershipEnum | BlankEnum | NullEnum | null;
  body_type: string | null;
  body_subtype: string | null;
  make: string | null;
  model: string | null;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  /** @maxLength 255 */
  color?: string | null;
  /** @maxLength 32 */
  license_plate?: string | null;
  group: string | null;
  /**
   * Registration State/Province
   * @maxLength 255
   */
  registration_state_province?: string | null;
  operator: string;
  /** @maxLength 255 */
  trim?: string | null;
  purchase: string;
  lifecycle: string;
  comments: VehicleComments[];
  service_reminders: VehicleServiceReminders[];
  vehicle_renewal_reminders: VehicleRenewalReminders[];
  specifications: string;
}

export interface VehicleDeviceRead {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  image: RetrieveFile;
}

export interface VehicleDeviceReadRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  image: RetrieveFileRequest;
}

export interface VehicleFault {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  code: string;
  /**
   * Code Description
   * @maxLength 200
   */
  name?: string | null;
  /** Code Description */
  description?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  occurrence_count?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  fmi_id?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  mil_status?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  tx_id?: number | null;
  /** @maxLength 100 */
  source_address_name?: string | null;
  /**
   * * `open` - Open
   * * `resolved` - Resolved
   * * `pending` - Pending
   * * `ignored` - Ignored
   */
  status?: Status05DEnum;
  /**
   * * `off` - Off
   * * `ignore` - Ignore
   * * `critical` - Critical
   */
  priority?: PriorityEc4Enum;
  /** @format uuid */
  issue: string;
}

export interface VehicleForAssignmentLog {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
}

export interface VehicleForFuelEntries {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
}

export interface VehicleForRenewalRead {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  image: RetrieveFile;
  type: VehicleTypeList;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number | null;
}

export interface VehicleForRenewalReport {
  /** @format uuid */
  id: string;
  type: VehicleType;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  group: GroupRead;
  /** @maxLength 512 */
  name: string;
}

export interface VehicleForStatusChanges {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
}

export interface VehicleFuelSummary {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
}

export interface VehicleFuelTypeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleFuelTypeList {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleIssue {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
}

/** VehicleIssueCount */
export interface VehicleIssueCount {
  /** Vehicle Id */
  vehicle_id: string;
  /** Vehicle Name */
  vehicle_name: string;
  /** Count */
  count: number;
  /** Status Breakdown */
  status_breakdown: Record<string, number>;
}

export interface VehicleLifeCycleCreate {
  /** @format date */
  in_service_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  in_service_odometer?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  estimated_service_life_months?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  estimated_service_life_meter?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  estimated_resale_value?: number | null;
  /** @format date */
  out_of_service_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  out_of_service_odometer?: number | null;
}

export interface VehicleLifeCycleCreateRequest {
  /** @format date */
  in_service_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  in_service_odometer?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  estimated_service_life_months?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  estimated_service_life_meter?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  estimated_resale_value?: number | null;
  /** @format date */
  out_of_service_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  out_of_service_odometer?: number | null;
}

export interface VehicleList {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  type: VehicleTypeList;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  /**
   * Meter (mi)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  meter?: number | null;
  fuel_type: VehicleFuelTypeList;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  /** @maxLength 32 */
  license_plate?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number | null;
  make: VehicleMakeList;
  model: VehicleModelList;
  /** @maxLength 255 */
  trim?: string | null;
  /**
   * Registration State/Province
   * @maxLength 255
   */
  registration_state_province?: string | null;
  /** @maxLength 255 */
  color?: string | null;
  ownership?: OwnershipEnum | BlankEnum | NullEnum | null;
  /**
   * MSRP ($)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  msrp?: number | null;
  body_type: VehicleBodyTypeList;
  body_subtype: VehicleBodySubTypeList;
  group: Group;
  operator: Contact;
  image: RetrieveFile;
  financial_detail: string;
  lifecycle: string;
  specifications: string;
  linked_vehicles: LinkedVehicle[];
  is_archived: string;
}

export interface VehicleListDetails {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  type: VehicleTypeList;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  meter: string;
  fuel_type: VehicleFuelTypeList;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  /** @maxLength 32 */
  license_plate?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number | null;
  make: VehicleMakeList;
  model: VehicleModelList;
  /** @maxLength 255 */
  trim?: string | null;
  /**
   * Registration State/Province
   * @maxLength 255
   */
  registration_state_province?: string | null;
  /** @maxLength 255 */
  color?: string | null;
  ownership?: OwnershipEnum | BlankEnum | NullEnum | null;
  /**
   * MSRP ($)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  msrp?: number | null;
  body_type: VehicleBodyTypeList;
  body_subtype: VehicleBodySubTypeList;
  group: Group;
  operator: Contact;
  image: RetrieveFile;
  financial_detail: string;
  lifecycle: string;
  specifications: string;
  linked_vehicles: LinkedVehicle[];
  is_archived: string;
  current_operator: string;
  comments: string;
  has_device: string;
  geo_position: string;
}

export interface VehicleListForSelectOptions {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  /** @maxLength 32 */
  license_plate?: string | null;
  image: FileMinimal;
}

export interface VehicleListMini {
  /** @format uuid */
  id: string;
  current_operator: string;
  /** @maxLength 512 */
  name: string;
  type: VehicleTypeList;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  /**
   * Meter (mi)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  meter?: number | null;
  /** @format uuid */
  fuel_type?: string | null;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  /** @maxLength 32 */
  license_plate?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number | null;
  make: VehicleMakeList;
  model: VehicleModelList;
  /** @maxLength 255 */
  trim?: string | null;
  /**
   * Registration State/Province
   * @maxLength 255
   */
  registration_state_province?: string | null;
  /** @maxLength 255 */
  color?: string | null;
  ownership?: OwnershipEnum | BlankEnum | NullEnum | null;
  /**
   * MSRP ($)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  msrp?: number | null;
  /** @format uuid */
  body_type?: string | null;
  /** @format uuid */
  body_subtype?: string | null;
  group: GroupRead;
  operator: Contact;
  image: RetrieveFile;
  is_archived: string;
}

export interface VehicleMakeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleMakeList {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleMeterEntry {
  /** @format uuid */
  id: string;
  source: string;
  vehicle: VehicleRetrieveMini;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_value: number;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  original_meter_value?: number | null;
  /**
   * * `miles` - Miles
   * * `gallons` - Gallons
   * * `liters` - Liters
   * * `kilometers` - Kilometers
   */
  meter_unit?: MeterUnitEnum;
  void?: boolean;
  /** @format date */
  meter_date: string;
  /** @format uuid */
  company?: string | null;
  /** @format uuid */
  integration_account?: string | null;
}

export interface VehicleModelCreateRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleModelList {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleOperatingCostsSummaryReport {
  /** @format uuid */
  id: string;
}

export interface VehicleOperatorRead {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  first_name?: string | null;
  /** @maxLength 50 */
  middle_name?: string | null;
  /** @maxLength 150 */
  last_name?: string | null;
}

export interface VehicleRead {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /** @format uuid */
  type?: string | null;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  /**
   * Meter (mi)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  meter?: number | null;
  /** @format uuid */
  fuel_type?: string | null;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  /** @maxLength 32 */
  license_plate?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number | null;
  /** @format uuid */
  make?: string | null;
  /** @format uuid */
  model?: string | null;
  /** @maxLength 255 */
  trim?: string | null;
  /**
   * Registration State/Province
   * @maxLength 255
   */
  registration_state_province?: string | null;
  /** @maxLength 255 */
  color?: string | null;
  ownership?: OwnershipEnum | BlankEnum | NullEnum | null;
  /**
   * MSRP ($)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  msrp?: number | null;
  /** @format uuid */
  body_type?: string | null;
  /** @format uuid */
  body_subtype?: string | null;
  /** @format uuid */
  group?: string | null;
  /** @format uuid */
  operator?: string | null;
  /** @format uuid */
  image?: string | null;
  financial_detail: string;
  lifecycle: string;
  specifications: string;
  linked_vehicles: LinkedVehicle[];
}

export interface VehicleReadFile {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /** @format uuid */
  type?: string | null;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
}

export interface VehicleReadFileRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /** @format uuid */
  type?: string | null;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
}

export interface VehicleReadRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /** @format uuid */
  type?: string | null;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  /**
   * Meter (mi)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  meter?: number | null;
  /** @format uuid */
  fuel_type?: string | null;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  /** @maxLength 32 */
  license_plate?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number | null;
  /** @format uuid */
  make?: string | null;
  /** @format uuid */
  model?: string | null;
  /** @maxLength 255 */
  trim?: string | null;
  /**
   * Registration State/Province
   * @maxLength 255
   */
  registration_state_province?: string | null;
  /** @maxLength 255 */
  color?: string | null;
  ownership?: OwnershipEnum | BlankEnum | NullEnum | null;
  /**
   * MSRP ($)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  msrp?: number | null;
  /** @format uuid */
  body_type?: string | null;
  /** @format uuid */
  body_subtype?: string | null;
  /** @format uuid */
  group?: string | null;
  /** @format uuid */
  operator?: string | null;
  /** @format uuid */
  image?: string | null;
}

export interface VehicleRenewalCreate {
  /** @format uuid */
  id: string;
  /** @format uuid */
  vehicle: string;
  /** @format date */
  due_date: string;
  /** @format uuid */
  renewal_type: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold: PrimaryMeterDueSoonThresholdEnum;
  enable_notification?: boolean;
  /** @format uuid */
  recipient?: string | null;
  description?: string | null;
}

export interface VehicleRenewalCreateRequest {
  /** @format uuid */
  vehicle: string;
  /** @format date */
  due_date: string;
  /** @format uuid */
  renewal_type: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold: PrimaryMeterDueSoonThresholdEnum;
  enable_notification?: boolean;
  /** @format uuid */
  recipient?: string | null;
  description?: string | null;
}

export interface VehicleRenewalList {
  /** @format uuid */
  id: string;
  vehicle: VehicleForRenewalRead;
  /** @format date */
  due_date: string;
  renewal_type: VehicleRenewalTypeList;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold: PrimaryMeterDueSoonThresholdEnum;
  enable_notification?: boolean;
  recipient: ContactCommentRead;
  description?: string | null;
  /**
   * * `upcoming` - Upcoming
   * * `due_soon` - Due Soon
   * * `overdue` - Overdue
   */
  status?: Status5D2Enum;
  /** @format date-time */
  created: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
}

export interface VehicleRenewalReminders {
  /**
   * * `upcoming` - Upcoming
   * * `due_soon` - Due Soon
   * * `overdue` - Overdue
   */
  status?: Status5D2Enum;
  renewal_type: string;
  /** @format date */
  due_date: string;
  vehicle: VehicleForRenewalReport;
}

export interface VehicleRenewalRetrieve {
  /** @format uuid */
  id: string;
  /** @format uuid */
  vehicle: string;
  /** @format date */
  due_date: string;
  /** @format uuid */
  renewal_type: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold: PrimaryMeterDueSoonThresholdEnum;
  enable_notification?: boolean;
  /** @format uuid */
  recipient?: string | null;
  description?: string | null;
  /**
   * * `upcoming` - Upcoming
   * * `due_soon` - Due Soon
   * * `overdue` - Overdue
   */
  status?: Status5D2Enum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
}

export interface VehicleRenewalTypeCreate {
  /** @maxLength 255 */
  name: string;
}

export interface VehicleRenewalTypeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface VehicleRenewalTypeList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface VehicleRenewalUpdate {
  /** @format uuid */
  vehicle: string;
  /** @format date */
  due_date: string;
  /** @format uuid */
  renewal_type: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold: PrimaryMeterDueSoonThresholdEnum;
  description?: string | null;
  enable_notification?: boolean;
  /** @format uuid */
  recipient?: string | null;
}

export interface VehicleRenewalUpdateRequest {
  /** @format uuid */
  vehicle: string;
  /** @format date */
  due_date: string;
  /** @format uuid */
  renewal_type: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  due_soon_threshold: number;
  /**
   * * `days` - Days
   * * `weeks` - Weeks
   * * `months` - Months
   * * `years` - Years
   */
  primary_meter_due_soon_threshold: PrimaryMeterDueSoonThresholdEnum;
  description?: string | null;
  enable_notification?: boolean;
  /** @format uuid */
  recipient?: string | null;
}

export interface VehicleReport {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  group: Group;
}

export interface VehicleReportList {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  /** @maxLength 32 */
  license_plate?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number | null;
  make: VehicleMakeList;
  model: VehicleModelList;
  group: Group;
  operator: Contact;
}

export interface VehicleRetrieve {
  /** @format uuid */
  id: string;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
  /** @maxLength 512 */
  name: string;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  /**
   * Meter (mi)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  meter?: number | null;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn: string | null;
  /** @maxLength 32 */
  license_plate?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number | null;
  /** @maxLength 255 */
  trim?: string | null;
  /**
   * Registration State/Province
   * @maxLength 255
   */
  registration_state_province?: string | null;
  /** @maxLength 255 */
  color?: string | null;
  ownership?: OwnershipEnum | BlankEnum | NullEnum | null;
  /**
   * MSRP ($)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  msrp?: number | null;
  /** Designates whether the object has been deleted. */
  is_deleted?: boolean;
  is_samsara_vehicle?: boolean;
  /** @maxLength 255 */
  external_id: string | null;
  /** @format uuid */
  company: string | null;
  /** @format uuid */
  type?: string | null;
  /** @format uuid */
  fuel_type?: string | null;
  /** @format uuid */
  make?: string | null;
  /** @format uuid */
  model?: string | null;
  /** @format uuid */
  body_type?: string | null;
  /** @format uuid */
  body_subtype?: string | null;
  /** @format uuid */
  group?: string | null;
  /** @format uuid */
  operator?: string | null;
  /** @format uuid */
  image?: string | null;
  /** @format uuid */
  integration_account: string | null;
  labels?: string[];
  linked_vehicles?: string[];
}

export interface VehicleRetrieveMini {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
}

export interface VehicleRetrieveMiniRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
}

export interface VehicleSerializerForInspection {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  type: VehicleType;
  group: GroupRead;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
}

export interface VehicleService {
  /** @format uuid */
  id: string;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  reference_code?: number | null;
  vehicle: VehicleRetrieveMini;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  odometer?: number | null;
  void?: boolean;
  /** @format date-time */
  completion_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format uuid */
  vendor?: string | null;
  general_notes?: string | null;
  /**
   * Labor
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_labor?: number;
  /**
   * Parts
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  cost_parts?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  tax?: number;
  notes?: string | null;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  sub_total?: number;
  /**
   * Total
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  total_cost?: number;
  issues: IssueMiniRead[];
  service_task_items?: RetrieveServiceTaskItem[];
  labels?: string[];
  documents?: string[];
  /** @maxLength 155 */
  reference?: string | null;
}

export interface VehicleServiceReminders {
  /** @format uuid */
  id: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  status: string;
  /** @format date */
  next_due_date?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  next_due_meter?: number | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_interval?: number | null;
  /** Time Interval */
  time_interval_unit?: TimeIntervalUnitEnum;
  service_task: ListServiceTask;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  time_due_soon_threshold?: number | null;
  /** Time Due Soon Threshold */
  time_due_soon_threshold_unit?: TimeDueSoonThresholdUnitEnum;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  meter_interval?: number | null;
  /** Meter Interval */
  meter_interval_unit?: MeterIntervalUnitEnum;
  manual_next_due?: boolean;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  meter_due_soon_threshold?: number | null;
  notification_active?: boolean;
}

export interface VehicleServiceReport {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  group: Group;
  type: VehicleTypeList;
}

export interface VehicleStatusChanges {
  /** @format uuid */
  id: string;
  vehicle: VehicleForStatusChanges;
  /** From Status */
  status_from?: StatusToEnum | BlankEnum | NullEnum | null;
  /** To Status */
  status_to: StatusToEnum;
  updated_by: ContactForStatusChanges;
  /** @format date-time */
  created: string;
}

/** VehicleStatusDistribution */
export interface VehicleStatusDistribution {
  /** Points */
  points: StatusPoint[];
  /**
   * Total Vehicles
   * @min 0
   */
  total_vehicles: number;
  /**
   * Last Updated
   * @format date-time
   */
  last_updated: string;
}

export interface VehicleStatusSummary {
  /** @format uuid */
  id?: string;
  name?: string;
  changes_count?: number;
  active_duration: string;
  inactive_duration: string;
  in_shop_duration: string;
  sold_duration: string;
  yes_duration: string;
  out_of_service_duration: string;
  downtime_duration: string;
}

export interface VehicleType {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleTypeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleTypeList {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleTypeListRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /** @maxLength 512 */
  description?: string | null;
}

export interface VehicleWithLinked {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  linked_vehicles: LinkedVehicle[];
}

export interface VehicleWrite {
  /** @maxLength 512 */
  name: string;
  /** @format uuid */
  type?: string | null;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  /**
   * Meter (mi)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  meter?: number | null;
  /** @format uuid */
  fuel_type?: string | null;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  /** @maxLength 32 */
  license_plate?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number | null;
  /** @format uuid */
  make?: string | null;
  /** @format uuid */
  model?: string | null;
  /** @maxLength 255 */
  trim?: string | null;
  /**
   * Registration State/Province
   * @maxLength 255
   */
  registration_state_province?: string | null;
  /** @maxLength 255 */
  color?: string | null;
  ownership?: OwnershipEnum | BlankEnum | NullEnum | null;
  /**
   * MSRP ($)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  msrp?: number | null;
  /** @format uuid */
  body_type?: string | null;
  /** @format uuid */
  body_subtype?: string | null;
  /** @format uuid */
  group?: string | null;
  /** @format uuid */
  operator?: string | null;
  /** @format uuid */
  image?: string | null;
  financial_detail?: FinancialDetailWrite;
  lifecycle?: VehicleLifeCycleCreate;
  specifications?: SpecificationWrite;
  linked_vehicles?: string[];
}

export interface VehicleWriteRequest {
  /**
   * @minLength 1
   * @maxLength 512
   */
  name: string;
  /** @format uuid */
  type?: string | null;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  /**
   * Meter (mi)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  meter?: number | null;
  /** @format uuid */
  fuel_type?: string | null;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
  /** @maxLength 32 */
  license_plate?: string | null;
  /**
   * @min 0
   * @max 2147483647
   */
  year?: number | null;
  /** @format uuid */
  make?: string | null;
  /** @format uuid */
  model?: string | null;
  /** @maxLength 255 */
  trim?: string | null;
  /**
   * Registration State/Province
   * @maxLength 255
   */
  registration_state_province?: string | null;
  /** @maxLength 255 */
  color?: string | null;
  ownership?: OwnershipEnum | BlankEnum | NullEnum | null;
  /**
   * MSRP ($)
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  msrp?: number | null;
  /** @format uuid */
  body_type?: string | null;
  /** @format uuid */
  body_subtype?: string | null;
  /** @format uuid */
  group?: string | null;
  /** @format uuid */
  operator?: string | null;
  /** @format uuid */
  image?: string | null;
  financial_detail?: FinancialDetailWriteRequest;
  lifecycle?: VehicleLifeCycleCreateRequest;
  specifications?: SpecificationWriteRequest;
  linked_vehicles?: string[];
}

export interface VehiclesWithoutServiceReport {
  /** @format uuid */
  id: string;
  /** @maxLength 512 */
  name: string;
  /**
   * * `active` - Active
   * * `inactive` - Inactive
   * * `in_shop` - In Shop
   * * `out_of_service` - Out of Service
   * * `sold` - Sold
   * * `yes` - Yes
   * * `downtime` - Downtime
   */
  status?: StatusToEnum;
  group: Group;
  type: VehicleTypeList;
  operator: VehicleOperatorRead;
  /**
   * VIN/SN
   * @maxLength 32
   */
  vin_sn?: string | null;
}

export interface VendorComment {
  /** @format uuid */
  id: string;
  comment: string;
  /** @format uuid */
  vendor: string;
}

export interface VendorCommentRequest {
  /** @minLength 1 */
  comment: string;
  /** @format uuid */
  vendor: string;
}

/** Serializer for vendor contact information. */
export interface VendorContact {
  phone: string | null;
  /** @format uri */
  website: string | null;
}

export interface VendorForFuelEntries {
  /** @format uuid */
  id: string;
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
}

export interface VendorPartner {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
  partnership_tier?: PartnershipTierEnum | BlankEnum | NullEnum | null;
  /** @format date-time */
  partnership_start_date?: string | null;
}

export interface VendorPartnerRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  partnership_tier?: PartnershipTierEnum | BlankEnum | NullEnum | null;
  /** @format date-time */
  partnership_start_date?: string | null;
}

export interface VendorRead {
  /** @format uuid */
  id: string;
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
}

export interface VendorReadRequest {
  /**
   * The official business name of the vendor
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
}

export interface VendorReport {
  /** @format uuid */
  id: string;
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
}

export interface VendorRetrieve {
  /** @format uuid */
  id: string;
  /**
   * The official business name of the vendor
   * @maxLength 255
   */
  name: string;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  /**
   * Longitude coordinate of the vendor's location
   * @format double
   */
  longitude?: number | null;
  /**
   * Latitude coordinate of the vendor's location
   * @format double
   */
  latitude?: number | null;
  labels: Label[];
}

export interface VendorRetrieveRequest {
  /**
   * The official business name of the vendor
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Main business phone number for the vendor
   * @maxLength 50
   */
  phone?: string | null;
  /**
   * Official website URL of the vendor
   * @format uri
   * @maxLength 255
   */
  website?: string | null;
  /** Primary street address of the vendor */
  address?: string | null;
  /**
   * Additional address information (suite, unit, etc.)
   * @maxLength 255
   */
  address_line_2?: string | null;
  /**
   * City where the vendor is located
   * @maxLength 100
   */
  city?: string | null;
  /**
   * State/Province/Region
   * State, province, or region of the vendor's location
   * @maxLength 100
   */
  state_province_region?: string | null;
  /**
   * ZIP/Postal Code
   * ZIP or postal code of the vendor's location
   * @maxLength 20
   */
  zip_postal_code?: string | null;
  /**
   * Country where the vendor is located
   * @maxLength 100
   */
  country?: string | null;
  /** Additional notes or comments about the vendor */
  notes?: string | null;
  /**
   * Primary contact person's full name
   * @maxLength 255
   */
  contact_person?: string | null;
  /**
   * Alternative contact name if different from contact person
   * @maxLength 100
   */
  contact_name?: string | null;
  /**
   * Direct phone number for the primary contact
   * @maxLength 50
   */
  contact_phone?: string | null;
  /**
   * Email address for the primary contact
   * @format email
   * @maxLength 255
   */
  contact_email?: string | null;
  /**
   * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
   *
   * * `fuel` - Fuel
   * * `parts` - Parts
   * * `services_app` - Service
   * * `vehicle` - Vehicle
   */
  classification?: ClassificationEnum | BlankEnum | NullEnum | null;
  /**
   * Longitude coordinate of the vendor's location
   * @format double
   */
  longitude?: number | null;
  /**
   * Latitude coordinate of the vendor's location
   * @format double
   */
  latitude?: number | null;
  labels: LabelRequest[];
}

export interface VendorScheduleCreate {
  /**
   * Schedule Name
   * Schedule name (e.g. 'Weekdays', 'Weekends')
   * @maxLength 100
   */
  name: string;
  /**
   * Days of the week this schedule applies to
   * @maxItems 7
   */
  days?: DaysEnum[];
  /**
   * Time when vendor opens (e.g. 09:00)
   * @format time
   */
  opening_time?: string | null;
  /**
   * Time when vendor closes (e.g. 17:00)
   * @format time
   */
  closing_time?: string | null;
  /**
   * Active
   * Whether this schedule is currently active
   */
  is_active?: boolean;
  /**
   * 24 Hours
   * Whether this vendor operates 24 hours on these days
   */
  is_24_hours?: boolean;
}

export interface VendorScheduleCreateRequest {
  /**
   * Schedule Name
   * Schedule name (e.g. 'Weekdays', 'Weekends')
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * Days of the week this schedule applies to
   * @maxItems 7
   */
  days?: DaysEnum[];
  /**
   * Time when vendor opens (e.g. 09:00)
   * @format time
   */
  opening_time?: string | null;
  /**
   * Time when vendor closes (e.g. 17:00)
   * @format time
   */
  closing_time?: string | null;
  /**
   * Active
   * Whether this schedule is currently active
   */
  is_active?: boolean;
  /**
   * 24 Hours
   * Whether this vendor operates 24 hours on these days
   */
  is_24_hours?: boolean;
}

export interface VendorScheduleUpdate {
  /** @format uuid */
  id?: string;
  /**
   * Schedule Name
   * Schedule name (e.g. 'Weekdays', 'Weekends')
   * @maxLength 100
   */
  name: string;
  /**
   * Days of the week this schedule applies to
   * @maxItems 7
   */
  days?: DaysEnum[];
  /**
   * Time when vendor opens (e.g. 09:00)
   * @format time
   */
  opening_time?: string | null;
  /**
   * Time when vendor closes (e.g. 17:00)
   * @format time
   */
  closing_time?: string | null;
  /**
   * 24 Hours
   * Whether this vendor operates 24 hours on these days
   */
  is_24_hours?: boolean;
  /**
   * Active
   * Whether this schedule is currently active
   */
  is_active?: boolean;
}

export interface VendorScheduleUpdateRequest {
  /** @format uuid */
  id?: string;
  /**
   * Schedule Name
   * Schedule name (e.g. 'Weekdays', 'Weekends')
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * Days of the week this schedule applies to
   * @maxItems 7
   */
  days?: DaysEnum[];
  /**
   * Time when vendor opens (e.g. 09:00)
   * @format time
   */
  opening_time?: string | null;
  /**
   * Time when vendor closes (e.g. 17:00)
   * @format time
   */
  closing_time?: string | null;
  /**
   * 24 Hours
   * Whether this vendor operates 24 hours on these days
   */
  is_24_hours?: boolean;
  /**
   * Active
   * Whether this schedule is currently active
   */
  is_active?: boolean;
}

export interface VendorServiceCreate {
  /**
   * Base Cost
   * Base cost for this service
   * @format double
   * @min 0
   * @max 10000000000
   * @exclusiveMax true
   */
  cost?: number;
  /**
   * Negotiable
   * Whether the price is negotiable
   */
  is_negotiable?: boolean;
  /** Estimated time to complete the service */
  estimated_duration?: string | null;
  /**
   * Active
   * Whether this service is currently offered
   */
  is_active?: boolean;
  /**
   * Higher number means higher priority in listings
   * @min 0
   * @max 32767
   */
  priority_level?: number;
  /** Additional information about the service */
  notes?: string | null;
  /** @format uuid */
  service_task: string;
}

export interface VendorServiceCreateRequest {
  /**
   * Base Cost
   * Base cost for this service
   * @format double
   * @min 0
   * @max 10000000000
   * @exclusiveMax true
   */
  cost?: number;
  /**
   * Negotiable
   * Whether the price is negotiable
   */
  is_negotiable?: boolean;
  /** Estimated time to complete the service */
  estimated_duration?: string | null;
  /**
   * Active
   * Whether this service is currently offered
   */
  is_active?: boolean;
  /**
   * Higher number means higher priority in listings
   * @min 0
   * @max 32767
   */
  priority_level?: number;
  /** Additional information about the service */
  notes?: string | null;
  /** @format uuid */
  service_task: string;
}

export interface VendorServiceUpdate {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  service_task: string;
  /**
   * Base Cost
   * Base cost for this service
   * @format double
   * @min 0
   * @max 10000000000
   * @exclusiveMax true
   */
  cost?: number;
  /**
   * Negotiable
   * Whether the price is negotiable
   */
  is_negotiable?: boolean;
  /** Estimated time to complete the service */
  estimated_duration?: string | null;
  /**
   * Higher number means higher priority in listings
   * @min 0
   * @max 32767
   */
  priority_level?: number;
  /**
   * Active
   * Whether this service is currently offered
   */
  is_active?: boolean;
  /** Additional information about the service */
  notes?: string | null;
}

export interface VendorServiceUpdateRequest {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  service_task: string;
  /**
   * Base Cost
   * Base cost for this service
   * @format double
   * @min 0
   * @max 10000000000
   * @exclusiveMax true
   */
  cost?: number;
  /**
   * Negotiable
   * Whether the price is negotiable
   */
  is_negotiable?: boolean;
  /** Estimated time to complete the service */
  estimated_duration?: string | null;
  /**
   * Higher number means higher priority in listings
   * @min 0
   * @max 32767
   */
  priority_level?: number;
  /**
   * Active
   * Whether this service is currently offered
   */
  is_active?: boolean;
  /** Additional information about the service */
  notes?: string | null;
}

export interface VendorsContact {
  contact_name: string;
  contact_person: string;
  contact_phone: string;
  /** @format email */
  contact_email: string;
  /** @format uri */
  website: string;
}

export interface VendorsLocation {
  address: string;
  city: string;
  state_province_region: string;
  country: string;
  zip_postal_code: string;
  /** @format double */
  latitude: number;
  /** @format double */
  longitude: number;
}

/** Serializer for VideoSection model. */
export interface VideoSection {
  /** @format uuid */
  id: string;
  /**
   * Name of the section.
   * @maxLength 50
   */
  name: string;
  /**
   * Category where the section is classified.
   * @format uuid
   */
  category?: string | null;
}

export interface WarrantyComponent {
  /** @format uuid */
  id: string;
  /**
   * The name of the component.
   * @maxLength 255
   */
  name: string;
  /** A description of the component. */
  description?: string | null;
}

export interface WarrantyComponentRequest {
  /**
   * The name of the component.
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** A description of the component. */
  description?: string | null;
}

export interface WarrantyCreate {
  /** @format uuid */
  id: string;
  /**
   * The vehicle this warranty is associated with.
   * @format uuid
   */
  vehicle: string;
  /**
   * Warranty Name
   * The name of the warranty.
   * @maxLength 255
   */
  name: string;
  /** A description of the warranty. */
  description?: string | null;
  /**
   * The manufacturer of the vehicle or part covered by the warranty.
   * @maxLength 255
   */
  manufacturer?: string | null;
  /**
   * The vendor providing the warranty.
   * @format uuid
   */
  vendor?: string | null;
  /**
   * The contract ID associated with the warranty.
   * @maxLength 100
   */
  contract_id?: string | null;
  /**
   * URL to the vendor’s website
   * @format uri
   * @maxLength 200
   */
  vendor_link?: string | null;
  /**
   * Type of warranty coverage.Standard Warranty or Extended Warranty
   *
   * * `Standard` - Standard Warranty
   * * `Extended` - Extended Warranty
   */
  coverage_type?: CoverageTypeEnum;
  /**
   * The date the warranty starts.
   * @format date
   */
  start_date?: string | null;
  /**
   * The date the warranty ends.
   * @format date
   */
  end_date?: string | null;
  /**
   * The meter reading at the start of the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  start_meter?: number;
  /**
   * The meter reading at the end of the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  end_meter?: number | null;
  /**
   * The distance covered by the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  coverage_distance?: number | null;
  /**
   * The value of the coverage duration.(used with unit)
   * @min 0
   * @max 2147483647
   */
  coverage_duration_value?: number | null;
  /**
   * The unit of the coverage duration.(used with value)
   *
   * * `months` - Months
   * * `years` - Years
   */
  coverage_duration_unit?:
    | CoverageDurationUnitEnum
    | BlankEnum
    | NullEnum
    | null;
  /**
   * The status of the warranty.
   *
   * * `Active` - Active
   * * `Expired` - Expired
   */
  status?: Status081Enum;
  /** If checked, the End Meter is ignored and considered unlimited. */
  is_unlimited?: boolean;
  components: WarrantyComponent[];
  /** Files attached to this notification. */
  attachments?: string[];
}

export interface WarrantyCreateRequest {
  /**
   * The vehicle this warranty is associated with.
   * @format uuid
   */
  vehicle: string;
  /**
   * Warranty Name
   * The name of the warranty.
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** A description of the warranty. */
  description?: string | null;
  /**
   * The manufacturer of the vehicle or part covered by the warranty.
   * @maxLength 255
   */
  manufacturer?: string | null;
  /**
   * The vendor providing the warranty.
   * @format uuid
   */
  vendor?: string | null;
  /**
   * The contract ID associated with the warranty.
   * @maxLength 100
   */
  contract_id?: string | null;
  /**
   * URL to the vendor’s website
   * @format uri
   * @maxLength 200
   */
  vendor_link?: string | null;
  /**
   * Type of warranty coverage.Standard Warranty or Extended Warranty
   *
   * * `Standard` - Standard Warranty
   * * `Extended` - Extended Warranty
   */
  coverage_type?: CoverageTypeEnum;
  /**
   * The date the warranty starts.
   * @format date
   */
  start_date?: string | null;
  /**
   * The date the warranty ends.
   * @format date
   */
  end_date?: string | null;
  /**
   * The meter reading at the start of the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  start_meter?: number;
  /**
   * The meter reading at the end of the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  end_meter?: number | null;
  /**
   * The distance covered by the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  coverage_distance?: number | null;
  /**
   * The value of the coverage duration.(used with unit)
   * @min 0
   * @max 2147483647
   */
  coverage_duration_value?: number | null;
  /**
   * The unit of the coverage duration.(used with value)
   *
   * * `months` - Months
   * * `years` - Years
   */
  coverage_duration_unit?:
    | CoverageDurationUnitEnum
    | BlankEnum
    | NullEnum
    | null;
  /**
   * The status of the warranty.
   *
   * * `Active` - Active
   * * `Expired` - Expired
   */
  status?: Status081Enum;
  /** If checked, the End Meter is ignored and considered unlimited. */
  is_unlimited?: boolean;
  /** Files attached to this notification. */
  attachments?: string[];
}

export interface WarrantyList {
  /** @format uuid */
  id: string;
  vehicle: VehicleRetrieveMini;
  vin: string;
  components: WarrantyComponent[];
  /**
   * Warranty Name
   * The name of the warranty.
   * @maxLength 255
   */
  name: string;
  /** A description of the warranty. */
  description?: string | null;
  /**
   * The manufacturer of the vehicle or part covered by the warranty.
   * @maxLength 255
   */
  manufacturer?: string | null;
  vendor: VendorRetrieve;
  /**
   * The contract ID associated with the warranty.
   * @maxLength 100
   */
  contract_id?: string | null;
  /**
   * URL to the vendor’s website
   * @format uri
   * @maxLength 200
   */
  vendor_link?: string | null;
  /**
   * Type of warranty coverage.Standard Warranty or Extended Warranty
   *
   * * `Standard` - Standard Warranty
   * * `Extended` - Extended Warranty
   */
  coverage_type?: CoverageTypeEnum;
  /**
   * The date the warranty starts.
   * @format date
   */
  start_date?: string | null;
  /**
   * The date the warranty ends.
   * @format date
   */
  end_date?: string | null;
  /**
   * The meter reading at the start of the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  start_meter?: number;
  /**
   * The meter reading at the end of the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  end_meter?: number | null;
  /**
   * The distance covered by the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  coverage_distance?: number | null;
  /**
   * The status of the warranty.
   *
   * * `Active` - Active
   * * `Expired` - Expired
   */
  status?: Status081Enum;
  /** If checked, the End Meter is ignored and considered unlimited. */
  is_unlimited?: boolean;
  attachments: File[];
}

export interface WarrantyListRequest {
  vehicle: VehicleRetrieveMiniRequest;
  /**
   * Warranty Name
   * The name of the warranty.
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** A description of the warranty. */
  description?: string | null;
  /**
   * The manufacturer of the vehicle or part covered by the warranty.
   * @maxLength 255
   */
  manufacturer?: string | null;
  vendor: VendorRetrieveRequest;
  /**
   * The contract ID associated with the warranty.
   * @maxLength 100
   */
  contract_id?: string | null;
  /**
   * URL to the vendor’s website
   * @format uri
   * @maxLength 200
   */
  vendor_link?: string | null;
  /**
   * Type of warranty coverage.Standard Warranty or Extended Warranty
   *
   * * `Standard` - Standard Warranty
   * * `Extended` - Extended Warranty
   */
  coverage_type?: CoverageTypeEnum;
  /**
   * The date the warranty starts.
   * @format date
   */
  start_date?: string | null;
  /**
   * The date the warranty ends.
   * @format date
   */
  end_date?: string | null;
  /**
   * The meter reading at the start of the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  start_meter?: number;
  /**
   * The meter reading at the end of the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  end_meter?: number | null;
  /**
   * The distance covered by the warranty.
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  coverage_distance?: number | null;
  /**
   * The status of the warranty.
   *
   * * `Active` - Active
   * * `Expired` - Expired
   */
  status?: Status081Enum;
  /** If checked, the End Meter is ignored and considered unlimited. */
  is_unlimited?: boolean;
}

export interface WheelsTiresBrakeSystemCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface WheelsTiresBrakeSystemList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface WheelsTiresDriveTypeCreateRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface WheelsTiresDriveTypeList {
  /** @format uuid */
  id: string;
  /** @maxLength 255 */
  name: string;
}

export interface WheelsTiresWrite {
  /** @format uuid */
  id: string;
  /** @format uuid */
  drive_type?: string | null;
  /** @format uuid */
  brake_system?: string | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  front_track_width?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  rear_track_width?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  wheelbase?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  front_wheel_diameter?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  rear_wheel_diameter?: number | null;
  /** @maxLength 255 */
  rear_axle?: string | null;
  /** @maxLength 255 */
  front_tire_type?: string | null;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  front_tire_psi?: number | null;
  /** @maxLength 255 */
  rear_tire_type?: string | null;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  rear_tire_psi?: number | null;
  /** @format uuid */
  vehicle: string;
}

export interface WheelsTiresWriteRequest {
  /** @format uuid */
  drive_type?: string | null;
  /** @format uuid */
  brake_system?: string | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  front_track_width?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  rear_track_width?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  wheelbase?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  front_wheel_diameter?: number | null;
  /**
   * @format double
   * @min -10000
   * @exclusiveMin true
   * @max 10000
   * @exclusiveMax true
   */
  rear_wheel_diameter?: number | null;
  /** @maxLength 255 */
  rear_axle?: string | null;
  /** @maxLength 255 */
  front_tire_type?: string | null;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  front_tire_psi?: number | null;
  /** @maxLength 255 */
  rear_tire_type?: string | null;
  /**
   * @format double
   * @min -1000
   * @exclusiveMin true
   * @max 1000
   * @exclusiveMax true
   */
  rear_tire_psi?: number | null;
}

export interface WorkOrderActivityByPart {
  /** @format uuid */
  id: string;
  work_order: WorkOrderForWorkOrder;
  part_location: LocationRetrieve;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  quantity?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number;
  note?: string | null;
  service_task: ServiceTaskForWorkOrderActivity;
  /** @format date-time */
  created: string;
}

export interface WorkOrderByVehicleReport {
  /** @format uuid */
  id: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  /**
   * * `open` - Open
   * * `pending` - Pending
   * * `under_review` - Under review
   * * `completed` - Completed
   */
  status?: Status6AbEnum;
  description?: string | null;
  vendor: VendorReport;
  /** @format uuid */
  vehicle: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  assigned_to: ContactReadOnly;
  /** @format date-time */
  issue_date: string;
  issued_by: ContactReadOnly;
  /** @format date-time */
  start_date?: string | null;
  /** @format date-time */
  completion_date?: string | null;
  line_item_count: string;
  service_task_items: string;
  resolved_issues: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor_subtotal?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  parts_subtotal?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_cost?: number;
}

export interface WorkOrderComment {
  /** @format uuid */
  id: string;
  comment: string;
  /** @format uuid */
  work_order: string;
}

export interface WorkOrderCommentRequest {
  /** @minLength 1 */
  comment: string;
  /** @format uuid */
  work_order: string;
}

export interface WorkOrderCostLimit {
  /** @format uuid */
  id: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost_limit: number;
  /** @format date-time */
  created: string;
  /** @format date-time */
  updated: string;
  is_active?: boolean;
}

export interface WorkOrderCostLimitRequest {
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost_limit: number;
  is_active?: boolean;
}

export interface WorkOrderCreate {
  /** @format uuid */
  id: string;
  /**
   * * `open` - Open
   * * `pending` - Pending
   * * `under_review` - Under review
   * * `completed` - Completed
   */
  status?: Status6AbEnum;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /** @format date-time */
  issue_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format date-time */
  completion_date?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  completion_odometer?: number | null;
  void?: boolean;
  /** @maxLength 50 */
  invoice_number?: string | null;
  /** @maxLength 50 */
  po_number?: string | null;
  reference_code: number | null;
  /** @format uuid */
  payment_type?: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost_labor: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost_parts: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_cost: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
  /** @format uuid */
  vehicle: string;
  /** @format uuid */
  vendor?: string | null;
  /** @format uuid */
  assigned_to?: string | null;
  /** @format uuid */
  driver?: string | null;
  /** @format uuid */
  issued_by?: string | null;
  description?: string | null;
  labels?: string[];
  service_task_items?: WorkOrderServiceCreateTask[];
  non_related_labors?: WorkOrderCreateLabor[];
  non_related_parts?: WorkOrderParts[];
  warranties?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
  /** @format uuid */
  approved_by?: string | null;
}

export interface WorkOrderCreateLabor {
  /** @format uuid */
  id: string;
  /** @format uuid */
  technician?: string | null;
  /** @format uuid */
  associated_part?: string | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  labor_hours?: number;
  /** @maxLength 16 */
  labor_time?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  hourly_rate?: number;
  note?: string | null;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  completed_at?: string | null;
}

export interface WorkOrderCreateLaborRequest {
  /** @format uuid */
  technician?: string | null;
  /** @format uuid */
  associated_part?: string | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  labor_hours?: number;
  /** @maxLength 16 */
  labor_time?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  hourly_rate?: number;
  note?: string | null;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  completed_at?: string | null;
}

export interface WorkOrderCreateRequest {
  /**
   * * `open` - Open
   * * `pending` - Pending
   * * `under_review` - Under review
   * * `completed` - Completed
   */
  status?: Status6AbEnum;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /** @format date-time */
  issue_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format date-time */
  completion_date?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  completion_odometer?: number | null;
  void?: boolean;
  /** @maxLength 50 */
  invoice_number?: string | null;
  /** @maxLength 50 */
  po_number?: string | null;
  /** @format uuid */
  payment_type?: string;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
  /** @format uuid */
  vehicle: string;
  /** @format uuid */
  vendor?: string | null;
  /** @format uuid */
  assigned_to?: string | null;
  /** @format uuid */
  driver?: string | null;
  /** @format uuid */
  issued_by?: string | null;
  description?: string | null;
  labels?: string[];
  faults?: string[];
  issues?: string[];
  service_task_items?: WorkOrderServiceCreateTaskRequest[];
  non_related_labors?: WorkOrderCreateLaborRequest[];
  non_related_parts?: WorkOrderPartsRequest[];
  warranties?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
  /** @format uuid */
  approved_by?: string | null;
}

/** WorkOrderEntity */
export interface WorkOrderEntity {
  /**
   * Id
   * @format uuid4
   */
  id: string;
  /**
   * Reference Code
   * @default null
   */
  reference_code?: number | null;
  /** Total Cost */
  total_cost: number;
  /**
   * Issue Date
   * @format date
   */
  issue_date: string;
  /**
   * Vehicle Id
   * @format uuid4
   */
  vehicle_id: string;
  /** Vehicle Name */
  vehicle_name: string;
  /** Driver First Name */
  driver_first_name: string | null;
  /** Driver Last Name */
  driver_last_name: string | null;
  /** Status */
  status: string;
}

export interface WorkOrderForWorkOrder {
  /** @format uuid */
  id: string;
  vehicle: VehicleReadFile;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
}

export interface WorkOrderLaborComplete {
  /** @format uuid */
  id: string;
  /** @maxLength 16 */
  labor_time?: string | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  labor_hours?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  hourly_rate?: number;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  completed_at?: string | null;
  note?: string | null;
}

export interface WorkOrderLaborCompleteRequest {
  /** @maxLength 16 */
  labor_time?: string | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  labor_hours?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  hourly_rate?: number;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  completed_at?: string | null;
  note?: string | null;
}

export interface WorkOrderLaborCreate {
  /** @format uuid */
  service_task: string;
}

export interface WorkOrderLaborCreateRequest {
  /** @format uuid */
  service_task: string;
}

export interface WorkOrderLaborRetrieve {
  /** @format uuid */
  id: string;
  /** @format uuid */
  work_order: string;
  technician: ReadUserContact;
  associated_part: PartReadOnly;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  labor_hours?: number;
  /** @maxLength 16 */
  labor_time?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  hourly_rate?: number;
  service_task: RetrieveServiceTaskServiceEntry;
  note?: string | null;
  wo_service_task: WorkOrderServiceTaskRead;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  completed_at?: string | null;
  /**
   * * `active` - Active
   * * `in_service` - In Service
   * * `completed` - Completed
   */
  status?: Status0C4Enum;
  total_working_hours: string;
  total_price: string;
}

export interface WorkOrderLaborUpdate {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  technician?: string | null;
  /** @format uuid */
  associated_part?: string | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  labor_hours?: number;
  /** @maxLength 16 */
  labor_time?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  hourly_rate?: number;
  /** @format uuid */
  service_task?: string | null;
  note?: string | null;
  /** @format uuid */
  wo_service_task?: string | null;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  completed_at?: string | null;
  /**
   * * `active` - Active
   * * `in_service` - In Service
   * * `completed` - Completed
   */
  status?: Status0C4Enum;
}

export interface WorkOrderLaborUpdateRequest {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  technician?: string | null;
  /** @format uuid */
  associated_part?: string | null;
  /**
   * @format double
   * @min -1000000
   * @exclusiveMin true
   * @max 1000000
   * @exclusiveMax true
   */
  labor_hours?: number;
  /** @maxLength 16 */
  labor_time?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  hourly_rate?: number;
  /** @format uuid */
  service_task?: string | null;
  note?: string | null;
  /** @format uuid */
  wo_service_task?: string | null;
  /** @format date-time */
  started_at?: string | null;
  /** @format date-time */
  completed_at?: string | null;
  /**
   * * `active` - Active
   * * `in_service` - In Service
   * * `completed` - Completed
   */
  status?: Status0C4Enum;
}

export interface WorkOrderListReport {
  /** @format uuid */
  id: string;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  /**
   * * `open` - Open
   * * `pending` - Pending
   * * `under_review` - Under review
   * * `completed` - Completed
   */
  status?: Status6AbEnum;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  issues: string;
  /** @format date-time */
  issue_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format date-time */
  completion_date?: string | null;
  driver: DriverForWOListReport | null;
  total_cost: string;
}

export interface WorkOrderParts {
  /** @format uuid */
  id: string;
  /** @format uuid */
  part?: string;
  /** @format uuid */
  part_location?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  quantity?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number;
  note?: string | null;
  /** @format uuid */
  service_task?: string | null;
}

export interface WorkOrderPartsRead {
  /** @format uuid */
  id: string;
  part: PartReadOnly;
  part_location: LocationRetrieve;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  quantity?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number;
  note?: string | null;
  /** @format uuid */
  service_task?: string | null;
}

export interface WorkOrderPartsRequest {
  /** @format uuid */
  part?: string;
  /** @format uuid */
  part_location?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  quantity?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number;
  note?: string | null;
  /** @format uuid */
  service_task?: string | null;
}

export interface WorkOrderPartsUpdate {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  part: string;
  /** @format uuid */
  part_location?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  quantity?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number;
  note?: string | null;
  /** @format uuid */
  service_task?: string | null;
}

export interface WorkOrderPartsUpdateRequest {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  part: string;
  /** @format uuid */
  part_location?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  quantity?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  unit_cost?: number;
  note?: string | null;
  /** @format uuid */
  service_task?: string | null;
}

export interface WorkOrderRetrieve {
  /** @format uuid */
  id: string;
  /**
   * * `open` - Open
   * * `pending` - Pending
   * * `under_review` - Under review
   * * `completed` - Completed
   */
  status?: Status6AbEnum;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  current_active_labor: string;
  /** @format date-time */
  issue_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format date-time */
  completion_date?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  completion_odometer?: number | null;
  void?: boolean;
  /** @maxLength 50 */
  invoice_number?: string | null;
  /** @maxLength 50 */
  po_number?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  payment_type: PaymentType;
  cost_labor: string;
  cost_parts: string;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_cost?: number;
  subtotal: string;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
  vehicle: VehicleReadFile;
  vendor: VendorRead;
  assigned_to: ReadUserContact;
  driver: ReadUserContact;
  issued_by: ReadUserContact;
  description?: string | null;
  labels: Label[];
  service_task_items: WorkOrderServiceReadTask[];
  issues: Issue[];
  non_related_labors: string;
  non_related_parts: string;
  comments: string;
  photos: File[];
  documents: File[];
  service_entry: ServiceEntry;
  cost_limit_approved?: boolean;
  need_cost_limit_approval?: boolean;
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
  warranties: WarrantyList[];
  approved_by: ReadUserContact;
}

export interface WorkOrderRetrieveServiceEntity {
  /** @format uuid */
  id: string;
  /**
   * * `open` - Open
   * * `pending` - Pending
   * * `under_review` - Under review
   * * `completed` - Completed
   */
  status?: Status6AbEnum;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /** @format date-time */
  issue_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format date-time */
  completion_date?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  completion_odometer?: number | null;
  void?: boolean;
  /** @maxLength 50 */
  invoice_number?: string | null;
  /** @maxLength 50 */
  po_number?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost_labor: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost_parts: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_cost?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
}

export interface WorkOrderRetrieveServiceEntityRequest {
  /**
   * * `open` - Open
   * * `pending` - Pending
   * * `under_review` - Under review
   * * `completed` - Completed
   */
  status?: Status6AbEnum;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /** @format date-time */
  issue_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format date-time */
  completion_date?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  completion_odometer?: number | null;
  void?: boolean;
  /** @maxLength 50 */
  invoice_number?: string | null;
  /** @maxLength 50 */
  po_number?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost_labor: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost_parts: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_cost?: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
}

export interface WorkOrderServiceCreateTask {
  /** @format uuid */
  id: string;
  /** @format uuid */
  service_task?: string;
  notes?: string | null;
  /** @format uuid */
  reason_for_repair_code?: string | null;
  /** @format uuid */
  category?: string | null;
  /** @format uuid */
  system?: string | null;
  /** @format uuid */
  assembly?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor_cost?: number;
  labors?: WorkOrderCreateLabor[];
  parts?: WorkOrderParts[];
}

export interface WorkOrderServiceCreateTaskRequest {
  /** @format uuid */
  service_task?: string;
  notes?: string | null;
  /** @format uuid */
  reason_for_repair_code?: string | null;
  /** @format uuid */
  category?: string | null;
  /** @format uuid */
  system?: string | null;
  /** @format uuid */
  assembly?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor_cost?: number;
  labors?: WorkOrderCreateLaborRequest[];
  parts?: WorkOrderPartsRequest[];
}

export interface WorkOrderServiceReadTask {
  /** @format uuid */
  id: string;
  service_task: RetrieveServiceTaskServiceEntry;
  notes?: string | null;
  reason_for_repair_code: ReasonForRepairCodeReadOnly;
  category: MaintenanceCategoryReadOnly;
  system: SystemCodeReadOnly;
  assembly: AssemblyCodeReadOnly;
  labor_cost: string;
  parts_cost: string;
  subtotal: string;
  labors?: WorkOrderLaborRetrieve[];
  parts?: WorkOrderPartsRead[];
}

export interface WorkOrderServiceTask {
  general_task: RetrieveServiceTask;
  related_service_tasks: ListServiceTask[];
  rest_of_the_tasks: ListServiceTask[];
}

export interface WorkOrderServiceTaskRead {
  /** @format uuid */
  id: string;
  service_task: RetrieveServiceTaskServiceEntry;
  notes?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor_cost?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  parts_cost?: number;
}

export interface WorkOrderServiceUpdateTask {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  service_task: string;
  notes?: string | null;
  /** @format uuid */
  reason_for_repair_code?: string | null;
  /** @format uuid */
  category?: string | null;
  /** @format uuid */
  system?: string | null;
  /** @format uuid */
  assembly?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor_cost?: number;
  labors?: WorkOrderLaborUpdate[];
  parts?: WorkOrderPartsUpdate[];
}

export interface WorkOrderServiceUpdateTaskRequest {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  service_task: string;
  notes?: string | null;
  /** @format uuid */
  reason_for_repair_code?: string | null;
  /** @format uuid */
  category?: string | null;
  /** @format uuid */
  system?: string | null;
  /** @format uuid */
  assembly?: string | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  labor_cost?: number;
  labors?: WorkOrderLaborUpdateRequest[];
  parts?: WorkOrderPartsUpdateRequest[];
}

export interface WorkOrderUpdate {
  /** @format uuid */
  id: string;
  /**
   * * `open` - Open
   * * `pending` - Pending
   * * `under_review` - Under review
   * * `completed` - Completed
   */
  status?: Status6AbEnum;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /** @format date-time */
  issue_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format date-time */
  completion_date?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  completion_odometer?: number | null;
  void?: boolean;
  /** @maxLength 50 */
  invoice_number?: string | null;
  /** @maxLength 50 */
  po_number?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost_labor: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  cost_parts: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  total_cost: number;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
  /** @format uuid */
  vehicle: string;
  /** @format uuid */
  vendor?: string | null;
  /** @format uuid */
  assigned_to?: string | null;
  /** @format uuid */
  driver?: string | null;
  /** @format uuid */
  issued_by?: string | null;
  description?: string | null;
  labels?: string[];
  service_task_items?: WorkOrderServiceUpdateTask[];
  non_related_labors?: WorkOrderLaborUpdate[];
  non_related_parts?: WorkOrderPartsUpdate[];
  warranties?: string[];
  /** @format uuid */
  payment_type: string;
  faults?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
  /** @format uuid */
  approved_by?: string | null;
  cost_limit_approved?: boolean;
  need_cost_limit_approval?: boolean;
}

export interface WorkOrderUpdateRequest {
  /**
   * * `open` - Open
   * * `pending` - Pending
   * * `under_review` - Under review
   * * `completed` - Completed
   */
  status?: Status6AbEnum;
  /**
   * * `scheduled` - Scheduled
   * * `non_scheduled` - Non scheduled
   * * `emergency` - Emergency
   */
  repair_priority_class: RepairPriorityClassEnum;
  /** @format date-time */
  issue_date: string;
  /** @format date-time */
  start_date?: string | null;
  /** @format date-time */
  completion_date?: string | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  start_odometer?: number | null;
  /**
   * @format int64
   * @min 0
   * @max 9223372036854776000
   */
  completion_odometer?: number | null;
  void?: boolean;
  /** @maxLength 50 */
  invoice_number?: string | null;
  /** @maxLength 50 */
  po_number?: string | null;
  /**
   * @min -2147483648
   * @max 2147483647
   */
  reference_code?: number | null;
  /**
   * @format double
   * @min -10000000000
   * @exclusiveMin true
   * @max 10000000000
   * @exclusiveMax true
   */
  covered_by_warranty?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  discount?: number;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  tax?: number;
  /** @format uuid */
  vehicle: string;
  /** @format uuid */
  vendor?: string | null;
  /** @format uuid */
  assigned_to?: string | null;
  /** @format uuid */
  driver?: string | null;
  /** @format uuid */
  issued_by?: string | null;
  description?: string | null;
  labels?: string[];
  issues?: string[];
  service_task_items?: WorkOrderServiceUpdateTaskRequest[];
  non_related_labors?: WorkOrderLaborUpdateRequest[];
  non_related_parts?: WorkOrderPartsUpdateRequest[];
  warranties?: string[];
  /** @format uuid */
  payment_type: string;
  faults?: string[];
  paid_by?: PaidByEnum | BlankEnum | NullEnum | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  deduct_amount?: number | null;
  /**
   * @format double
   * @min -100000000
   * @exclusiveMin true
   * @max 100000000
   * @exclusiveMax true
   */
  refund_amount?: number | null;
  /** @format uuid */
  approved_by?: string | null;
  cost_limit_approved?: boolean;
  need_cost_limit_approval?: boolean;
}

/** WorkOrdersByStatus */
export interface WorkOrdersByStatus {
  /** Status */
  status: string;
  /** Work Orders */
  work_orders: WorkOrderEntity[];
}

/** WorkOrdersByStatusResponse */
export interface WorkOrdersByStatusResponse {
  /** Results */
  results: WorkOrdersByStatus[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title fleet_managment_backned API
 * @version 0.1.0
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Enhanced vehicle inspection endpoint with streaming support. Provides real-time analysis updates during processing. New Features in V1.5: - Streaming response support - Real-time analysis updates - Enhanced error handling - Metadata control Core Features: - Damage detection and analysis - Component identification - Priority assessment (1-5 scale) - Cost estimation (USD) - Repair time estimation (hours) Supported image formats: - JPEG/JPG - PNG - WebP - HEIC - BMP - GIF Size limit: 20MB Rate limit: 60 requests per hour per user
     *
     * @tags Vehicle Inspection V1.5
     * @name V15AiInspectionAnalyzeCreate
     * @summary [V1.5] Analyze vehicle image with streaming support
     * @request POST:/api/v1.5/ai/inspection/analyze/
     * @secure
     */
    v15AiInspectionAnalyzeCreate: (
      data: InspectionRequestRequest,
      query?: {
        /**
         * Enable streaming response for real-time updates
         * @default true
         */
        stream?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        InspectionResponse,
        | {
            /** Error description */
            error?: string;
          }
        | {
            /** File not found error */
            error?: string;
          }
        | {
            /** Rate limit exceeded */
            error?: string;
          }
      >({
        path: `/api/v1.5/ai/inspection/analyze/`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsContactsList
     * @request GET:/api/v1/accounts/contacts/
     * @secure
     */
    v1AccountsContactsList: (
      query?: {
        email?: string;
        email__icontains?: string;
        enable_fleetio_access?: boolean;
        first_name?: string;
        first_name__contains?: string;
        first_name__icontains?: string;
        first_name__iendswith?: string;
        first_name__iregex?: string;
        first_name__istartswith?: string;
        /** @format uuid */
        group?: string;
        /** Has System Access */
        has_system_access?: boolean;
        is_administrator?: boolean;
        /** Archived Contacts */
        is_archived?: boolean;
        is_owner?: boolean;
        is_regular_user?: boolean;
        job_title?: string;
        job_title__icontains?: string;
        last_name?: string;
        last_name__icontains?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** @format uuid */
        role?: string;
        /** A search term. */
        search?: string;
        /**
         * * `active` - active
         * * `inactive` - inactive
         * * `suspended` - suspended
         * * `deleted` - deleted
         * * `invited` - invited
         * * `need_invite` - need_invite
         * * `archived` - archived
         */
        status?:
          | "active"
          | "archived"
          | "deleted"
          | "inactive"
          | "invited"
          | "need_invite"
          | "suspended";
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedContactListList, any>({
        path: `/api/v1/accounts/contacts/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsContactsRetrieve
     * @request GET:/api/v1/accounts/contacts/{id}/
     * @secure
     */
    v1AccountsContactsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<ContactList, any>({
        path: `/api/v1/accounts/contacts/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsContactsArchiveCreate
     * @request POST:/api/v1/accounts/contacts/{id}/archive/
     * @secure
     */
    v1AccountsContactsArchiveCreate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/${id}/archive/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1AccountsContactsCommentsDeleteDestroy
     * @request DELETE:/api/v1/accounts/contacts/{id}/comments/delete/
     * @secure
     */
    v1AccountsContactsCommentsDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/${id}/comments/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsContactsDeleteDestroy
     * @request DELETE:/api/v1/accounts/contacts/{id}/delete/
     * @secure
     */
    v1AccountsContactsDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1AccountsContactsFilesList
     * @request GET:/api/v1/accounts/contacts/{id}/files/
     * @secure
     */
    v1AccountsContactsFilesList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFileList, any>({
        path: `/api/v1/accounts/contacts/${id}/files/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contact-Files
     * @name V1AccountsContactsFilesCreateCreate
     * @request POST:/api/v1/accounts/contacts/{id}/files/create/
     * @secure
     */
    v1AccountsContactsFilesCreateCreate: (
      id: string,
      data: ContactFileBulkRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/${id}/files/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contact-Files
     * @name V1AccountsContactsFilesDeleteCreate
     * @request POST:/api/v1/accounts/contacts/{id}/files/delete/
     * @secure
     */
    v1AccountsContactsFilesDeleteCreate: (
      id: string,
      data: ContactFileBulkRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/${id}/files/delete/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1AccountsContactsFilesDeleteDestroy
     * @request DELETE:/api/v1/accounts/contacts/{id}/files/delete/
     * @secure
     */
    v1AccountsContactsFilesDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/${id}/files/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1AccountsContactsResendInvitationCreate
     * @request POST:/api/v1/accounts/contacts/{id}/resend_invitation/
     * @secure
     */
    v1AccountsContactsResendInvitationCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/${id}/resend_invitation/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsContactsRestoreArchivedCreate
     * @request POST:/api/v1/accounts/contacts/{id}/restore_archived/
     * @secure
     */
    v1AccountsContactsRestoreArchivedCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/${id}/restore_archived/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsContactsRestoreDeletedCreate
     * @request POST:/api/v1/accounts/contacts/{id}/restore_deleted/
     * @secure
     */
    v1AccountsContactsRestoreDeletedCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/${id}/restore_deleted/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsContactsUpdateUpdate
     * @request PUT:/api/v1/accounts/contacts/{id}/update/
     * @secure
     */
    v1AccountsContactsUpdateUpdate: (
      id: string,
      data: ContactRequest,
      params: RequestParams = {},
    ) =>
      this.request<Contact, any>({
        path: `/api/v1/accounts/contacts/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsContactsUpdatePartialUpdate
     * @request PATCH:/api/v1/accounts/contacts/{id}/update/
     * @secure
     */
    v1AccountsContactsUpdatePartialUpdate: (
      id: string,
      data: PatchedContactRequest,
      params: RequestParams = {},
    ) =>
      this.request<Contact, any>({
        path: `/api/v1/accounts/contacts/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint for bulk archiving contacts.
     *
     * @tags Contacts
     * @name V1AccountsContactsBulkArchiveCreate
     * @request POST:/api/v1/accounts/contacts/bulk/archive/
     * @secure
     */
    v1AccountsContactsBulkArchiveCreate: (
      data: BulkContactIdRequest,
      params: RequestParams = {},
    ) =>
      this.request<BulkContactId, any>({
        path: `/api/v1/accounts/contacts/bulk/archive/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Endpoint for bulk deleting contacts.
     *
     * @tags Contacts
     * @name V1AccountsContactsBulkDeleteDestroy
     * @request DELETE:/api/v1/accounts/contacts/bulk/delete/
     * @secure
     */
    v1AccountsContactsBulkDeleteDestroy: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/bulk/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Endpoint for bulk unarchiving contacts.
     *
     * @tags Contacts
     * @name V1AccountsContactsBulkRestoreArchivedCreate
     * @request POST:/api/v1/accounts/contacts/bulk/restore_archived/
     * @secure
     */
    v1AccountsContactsBulkRestoreArchivedCreate: (
      data: BulkContactIdRequest,
      params: RequestParams = {},
    ) =>
      this.request<BulkContactId, any>({
        path: `/api/v1/accounts/contacts/bulk/restore_archived/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1AccountsContactsCommentsCreateCreate
     * @request POST:/api/v1/accounts/contacts/comments/create/
     * @secure
     */
    v1AccountsContactsCommentsCreateCreate: (
      data: CommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<Comment, any>({
        path: `/api/v1/accounts/contacts/comments/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsContactsCreateCreate
     * @request POST:/api/v1/accounts/contacts/create/
     * @secure
     */
    v1AccountsContactsCreateCreate: (
      data: ContactRequest,
      params: RequestParams = {},
    ) =>
      this.request<Contact, any>({
        path: `/api/v1/accounts/contacts/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import Vehicles
     * @name V1AccountsContactsDriversImportCreate
     * @request POST:/api/v1/accounts/contacts/drivers/import/
     * @secure
     */
    v1AccountsContactsDriversImportCreate: (
      data: ImportFileRequest,
      params: RequestParams = {},
    ) =>
      this.request<ImportFile, any>({
        path: `/api/v1/accounts/contacts/drivers/import/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import Examples Sheets
     * @name V1AccountsContactsDriversImportExampleRetrieve
     * @request GET:/api/v1/accounts/contacts/drivers/import/example/
     * @secure
     */
    v1AccountsContactsDriversImportExampleRetrieve: (
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/drivers/import/example/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsContactsProfileImageDeleteDestroy
     * @request DELETE:/api/v1/accounts/contacts/profile_image/{id}/delete/
     * @secure
     */
    v1AccountsContactsProfileImageDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/profile_image/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsContactsProfileImageUpdateUpdate
     * @request PUT:/api/v1/accounts/contacts/profile_image/{id}/update/
     * @secure
     */
    v1AccountsContactsProfileImageUpdateUpdate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/profile_image/${id}/update/`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsContactsProfileImageUpdatePartialUpdate
     * @request PATCH:/api/v1/accounts/contacts/profile_image/{id}/update/
     * @secure
     */
    v1AccountsContactsProfileImageUpdatePartialUpdate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/contacts/profile_image/${id}/update/`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1AccountsContactsUserPartialUpdate
     * @request PATCH:/api/v1/accounts/contacts/user/
     * @secure
     */
    v1AccountsContactsUserPartialUpdate: (
      data: PatchedUpdateUserContactRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserContact, any>({
        path: `/api/v1/accounts/contacts/user/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name V1AccountsEmailCodeCreate
     * @summary Email confirmation
     * @request POST:/api/v1/accounts/email-code/
     */
    v1AccountsEmailCodeCreate: (
      data: EmailCodeConfirmationRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmailCodeConfirmation, any>({
        path: `/api/v1/accounts/email-code/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handles user login by validating credentials and returning authentication tokens.
     *
     * @tags Accounts
     * @name V1AccountsLoginCreate
     * @summary Login
     * @request POST:/api/v1/accounts/login/
     * @secure
     */
    v1AccountsLoginCreate: (data: LoginRequest, params: RequestParams = {}) =>
      this.request<Login, any>({
        path: `/api/v1/accounts/login/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name V1AccountsLogoutCreate
     * @summary Log out
     * @request POST:/api/v1/accounts/logout/
     * @secure
     */
    v1AccountsLogoutCreate: (data: LogoutRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/accounts/logout/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name V1AccountsMeRetrieve
     * @summary Me
     * @request GET:/api/v1/accounts/me/
     * @secure
     */
    v1AccountsMeRetrieve: (params: RequestParams = {}) =>
      this.request<UpdateUserContact, any>({
        path: `/api/v1/accounts/me/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name V1AccountsMeUpdate
     * @summary Update me
     * @request PUT:/api/v1/accounts/me/
     * @secure
     */
    v1AccountsMeUpdate: (
      data: UpdateUserContactRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserContact, any>({
        path: `/api/v1/accounts/me/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name V1AccountsMePartialUpdate
     * @summary Update me
     * @request PATCH:/api/v1/accounts/me/
     * @secure
     */
    v1AccountsMePartialUpdate: (
      data: PatchedUpdateUserContactRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserContact, any>({
        path: `/api/v1/accounts/me/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name V1AccountsPasswordCreate
     * @summary Change password
     * @request POST:/api/v1/accounts/password/
     * @secure
     */
    v1AccountsPasswordCreate: (
      data: ChangePasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/password/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile, Auth
     * @name V1AccountsPasswordResetConfirmCreate
     * @request POST:/api/v1/accounts/password-reset/confirm/
     * @secure
     */
    v1AccountsPasswordResetConfirmCreate: (
      data: PasswordResetRequest,
      params: RequestParams = {},
    ) =>
      this.request<PasswordReset, any>({
        path: `/api/v1/accounts/password-reset/confirm/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile, Auth
     * @name V1AccountsPasswordResetRequestOtpCreate
     * @request POST:/api/v1/accounts/password-reset/request-otp/
     * @secure
     */
    v1AccountsPasswordResetRequestOtpCreate: (
      data: OTPRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/accounts/password-reset/request-otp/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mobile, Auth
     * @name V1AccountsPasswordResetVerifyOtpCreate
     * @request POST:/api/v1/accounts/password-reset/verify-otp/
     * @secure
     */
    v1AccountsPasswordResetVerifyOtpCreate: (
      data: OTPVerifyRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/accounts/password-reset/verify-otp/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name V1AccountsPasswordConfirmCreate
     * @summary Confirm reset password
     * @request POST:/api/v1/accounts/password/confirm/
     * @secure
     */
    v1AccountsPasswordConfirmCreate: (
      data: ConfirmResetPasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/password/confirm/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contacts
     * @name V1AccountsPasswordContactSetupCreate
     * @summary Contact Setup password
     * @request POST:/api/v1/accounts/password/contact/setup/
     * @secure
     */
    v1AccountsPasswordContactSetupCreate: (
      data: ConfirmResetPasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/password/contact/setup/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name V1AccountsPasswordResendEmailCreate
     * @summary Resend password reset link
     * @request POST:/api/v1/accounts/password/resend-email/
     * @secure
     */
    v1AccountsPasswordResendEmailCreate: (
      data: ResendPasswordResetLinkRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/password/resend-email/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name V1AccountsPasswordResetCreate
     * @summary Reset password
     * @request POST:/api/v1/accounts/password/reset/
     * @secure
     */
    v1AccountsPasswordResetCreate: (
      data: ResetPasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/password/reset/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get user permissions based on roles and admin status
     *
     * @tags Authentication
     * @name V1AccountsPermissionsRetrieve
     * @summary Get user permissions
     * @request GET:/api/v1/accounts/permissions/
     * @secure
     */
    v1AccountsPermissionsRetrieve: (params: RequestParams = {}) =>
      this.request<UserPermissions, void>({
        path: `/api/v1/accounts/permissions/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name V1AccountsRegistrationCreate
     * @summary Registration
     * @request POST:/api/v1/accounts/registration/
     * @secure
     */
    v1AccountsRegistrationCreate: (
      data: RegistrationRequest,
      params: RequestParams = {},
    ) =>
      this.request<Registration, any>({
        path: `/api/v1/accounts/registration/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name V1AccountsResendEmailConfirmationCreate
     * @summary Resend email confirmation
     * @request POST:/api/v1/accounts/resend-email-confirmation/
     */
    v1AccountsResendEmailConfirmationCreate: (
      data: ResendEmailCodeConfirmationRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/resend-email-confirmation/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name V1AccountsRolesList
     * @request GET:/api/v1/accounts/roles/
     * @secure
     */
    v1AccountsRolesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedReadRoleList, any>({
        path: `/api/v1/accounts/roles/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name V1AccountsRolesDestroy
     * @request DELETE:/api/v1/accounts/roles/{id}/
     * @secure
     */
    v1AccountsRolesDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/accounts/roles/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name V1AccountsRolesPermissionsRetrieve
     * @request GET:/api/v1/accounts/roles/{id}/permissions/
     * @secure
     */
    v1AccountsRolesPermissionsRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ReadRole, any>({
        path: `/api/v1/accounts/roles/${id}/permissions/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name V1AccountsRolesPermissionsModulesRetrieve
     * @request GET:/api/v1/accounts/roles/{id}/permissions/modules/
     * @secure
     */
    v1AccountsRolesPermissionsModulesRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<SystemModuleRolePermission, any>({
        path: `/api/v1/accounts/roles/${id}/permissions/modules/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name V1AccountsRolesPermissionsUpdatePartialUpdate
     * @request PATCH:/api/v1/accounts/roles/{id}/permissions/update
     * @secure
     */
    v1AccountsRolesPermissionsUpdatePartialUpdate: (
      id: string,
      data: PatchedUpdateRolePermissionsRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateRolePermissions, any>({
        path: `/api/v1/accounts/roles/${id}/permissions/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name V1AccountsRolesUpdateUpdate
     * @request PUT:/api/v1/accounts/roles/{id}/update/
     * @secure
     */
    v1AccountsRolesUpdateUpdate: (
      id: string,
      data: RoleUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<RoleUpdate, any>({
        path: `/api/v1/accounts/roles/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name V1AccountsRolesUpdatePartialUpdate
     * @request PATCH:/api/v1/accounts/roles/{id}/update/
     * @secure
     */
    v1AccountsRolesUpdatePartialUpdate: (
      id: string,
      data: PatchedRoleUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<RoleUpdate, any>({
        path: `/api/v1/accounts/roles/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name V1AccountsRolesCreateCreate
     * @request POST:/api/v1/accounts/roles/create/
     * @secure
     */
    v1AccountsRolesCreateCreate: (
      data: RoleRequest,
      params: RequestParams = {},
    ) =>
      this.request<Role, any>({
        path: `/api/v1/accounts/roles/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name V1AccountsSystemModulesList
     * @request GET:/api/v1/accounts/system-modules/
     * @secure
     */
    v1AccountsSystemModulesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedSystemModuleList, any>({
        path: `/api/v1/accounts/system-modules/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     *
     * @tags v1
     * @name V1AccountsTokenCreate
     * @request POST:/api/v1/accounts/token/
     */
    v1AccountsTokenCreate: (
      data: TokenObtainPairRequest,
      params: RequestParams = {},
    ) =>
      this.request<TokenObtainPair, any>({
        path: `/api/v1/accounts/token/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     *
     * @tags v1
     * @name V1AccountsTokenRefreshCreate
     * @request POST:/api/v1/accounts/token/refresh/
     */
    v1AccountsTokenRefreshCreate: (
      data: TokenRefreshRequest,
      params: RequestParams = {},
    ) =>
      this.request<TokenRefresh, any>({
        path: `/api/v1/accounts/token/refresh/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Takes a token and indicates if it is valid.  This view provides no information about a token's fitness for a particular use.
     *
     * @tags v1
     * @name V1AccountsTokenVerifyCreate
     * @request POST:/api/v1/accounts/token/verify/
     */
    v1AccountsTokenVerifyCreate: (
      data: TokenVerifyRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/accounts/token/verify/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Analyzes vehicle images to detect damage and provide detailed inspection reports. Features: - Damage detection and analysis - Component identification - Priority assessment (1-5 scale) - Cost estimation (USD) - Repair time estimation (hours) Supported image formats: - JPEG/JPG - PNG - WebP - HEIC - BMP - GIF Size limit: 20MB Rate limit: 60 requests per hour per user
     *
     * @tags Vehicle Inspection
     * @name V1AiInspectionAnalyzeCreate
     * @summary Analyze vehicle image for damage inspection
     * @request POST:/api/v1/ai/inspection/analyze/
     * @secure
     */
    v1AiInspectionAnalyzeCreate: (
      data: InspectionRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        InspectionResponse,
        | {
            /** Error description */
            error?: string;
          }
        | {
            /** File not found error */
            error?: string;
          }
        | {
            /** Rate limit exceeded */
            error?: string;
          }
      >({
        path: `/api/v1/ai/inspection/analyze/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Enhanced vehicle inspection endpoint with streaming support. Provides real-time analysis updates during processing. New Features in V1.5: - Streaming response support - Real-time analysis updates - Enhanced error handling - Metadata control Core Features: - Damage detection and analysis - Component identification - Priority assessment (1-5 scale) - Cost estimation (USD) - Repair time estimation (hours) Supported image formats: - JPEG/JPG - PNG - WebP - HEIC - BMP - GIF Size limit: 20MB Rate limit: 60 requests per hour per user
     *
     * @tags Vehicle Inspection V1.5
     * @name V1AiInspectionAnalyzeV15Create
     * @summary [V1.5] Analyze vehicle image with streaming support
     * @request POST:/api/v1/ai/inspection/analyze-v1.5/
     * @secure
     */
    v1AiInspectionAnalyzeV15Create: (
      data: InspectionRequestRequest,
      query?: {
        /**
         * Enable streaming response for real-time updates
         * @default true
         */
        stream?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        InspectionResponse,
        | {
            /** Error description */
            error?: string;
          }
        | {
            /** File not found error */
            error?: string;
          }
        | {
            /** Rate limit exceeded */
            error?: string;
          }
      >({
        path: `/api/v1/ai/inspection/analyze-v1.5/`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Analyzes invoice documents to extract structured data in specified schema format. Features: - Automatic data extraction - Support for service and work order schemas - Cost calculation and breakdown - Detailed line item parsing Supported file format: - PDF - JPEG - PNG - WebP - HEIC - BMP - GIF Size limit: 20MB Rate limit: 60 requests per hour per user
     *
     * @tags Invoice Analysis
     * @name V1AiInvoiceAnalyzeCreate
     * @summary Analyze invoice document
     * @request POST:/api/v1/ai/invoice/analyze/
     * @secure
     */
    v1AiInvoiceAnalyzeCreate: (
      data: InvoiceRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** Extracted invoice data in specified schema */
          data?: object;
          metadata?: {
            file_name?: string;
            file_size?: number;
            model?: string;
            schema_type?: "service" | "work_order";
          };
        },
        {
          error?: string;
        }
      >({
        path: `/api/v1/ai/invoice/analyze/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Convert audio file to text and optionally translate to multiple languages. Features: - Audio transcription using OpenAI Whisper - Optional translation to multiple languages Supported audio formats: - MP3, MP4, MPEG, M4A, WAV, WebM The file must be already uploaded and associated with your account.
     *
     * @tags Speech Processing
     * @name V1AiSpeechTranscribeCreate
     * @summary Transcribe audio to text with optional translation
     * @request POST:/api/v1/ai/speech/transcribe/
     * @secure
     */
    v1AiSpeechTranscribeCreate: (
      data: TranscriptionRequestRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        TranscriptionResponse,
        {
          error?: string;
        }
      >({
        path: `/api/v1/ai/speech/transcribe/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a list of announcement of a contact
     *
     * @tags v1
     * @name V1AnnouncementsList
     * @request GET:/api/v1/announcements/
     * @secure
     */
    v1AnnouncementsList: (
      query?: {
        /** @format uuid */
        announcement_id?: string;
        /**
         * * `NEW` - New
         * * `IMPROVED` - Improved
         * * `UPDATE` - Update
         * * `MAINTENANCE` - Maintenance
         * * `DEPRECATED` - Deprecated
         */
        category?: "DEPRECATED" | "IMPROVED" | "MAINTENANCE" | "NEW" | "UPDATE";
        /** @format date */
        created_range_after?: string;
        /** @format date */
        created_range_before?: string;
        has_documents?: boolean;
        has_photos?: boolean;
        is_read?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** @format date */
        scheduled_for_range_after?: string;
        /** @format date */
        scheduled_for_range_before?: string;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAnnouncementListList, any>({
        path: `/api/v1/announcements/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1AnnouncementsRetrieve
     * @request GET:/api/v1/announcements/{id}/
     * @secure
     */
    v1AnnouncementsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<AnnouncementList, any>({
        path: `/api/v1/announcements/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Mark an announcement as read.
     *
     * @tags v1
     * @name V1AnnouncementsMarkReadCreate
     * @request POST:/api/v1/announcements/{id}/mark-read/
     * @secure
     */
    v1AnnouncementsMarkReadCreate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/announcements/${id}/mark-read/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Create a new announcement
     *
     * @tags v1
     * @name V1AnnouncementsCreateCreate
     * @request POST:/api/v1/announcements/create/
     * @secure
     */
    v1AnnouncementsCreateCreate: (
      data: AnnouncementCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<AnnouncementCreate, any>({
        path: `/api/v1/announcements/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Mark all announcements as read.
     *
     * @tags v1
     * @name V1AnnouncementsMarkAllCreate
     * @request POST:/api/v1/announcements/mark-all/
     * @secure
     */
    v1AnnouncementsMarkAllCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/announcements/mark-all/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Get a number of unread announcement of a contact
     *
     * @tags v1
     * @name V1AnnouncementsUnreadCountRetrieve
     * @request GET:/api/v1/announcements/unread-count/
     * @secure
     */
    v1AnnouncementsUnreadCountRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/announcements/unread-count/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name V1BillingCurrentInvoiceRetrieve
     * @request GET:/api/v1/billing/current-invoice/
     * @secure
     */
    v1BillingCurrentInvoiceRetrieve: (params: RequestParams = {}) =>
      this.request<Invoice, any>({
        path: `/api/v1/billing/current-invoice/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name V1BillingInfoRetrieve
     * @request GET:/api/v1/billing/info/
     * @secure
     */
    v1BillingInfoRetrieve: (params: RequestParams = {}) =>
      this.request<CompanyPackage, any>({
        path: `/api/v1/billing/info/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name V1BillingInvoicesList
     * @request GET:/api/v1/billing/invoices/
     * @secure
     */
    v1BillingInvoicesList: (
      query?: {
        active_units_max?: number;
        active_units_min?: number;
        /** @format date-time */
        created_after?: string;
        /** @format date-time */
        created_before?: string;
        /**
         * * `current_month` - Current Month
         * * `last_month` - Last Month
         * * `last_3_months` - Last 3 Months
         * * `last_6_months` - Last 6 Months
         * * `this_year` - This Year
         * * `last_year` - Last Year
         */
        date_category?:
          | "current_month"
          | "last_3_months"
          | "last_6_months"
          | "last_month"
          | "last_year"
          | "this_year";
        /** @format date */
        due_date_after?: string;
        /** @format date */
        due_date_before?: string;
        is_overdue?: boolean;
        is_paid?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        number?: string;
        number__icontains?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        /** @format date */
        period_end_after?: string;
        /** @format date */
        period_end_before?: string;
        /** @format date */
        period_start_after?: string;
        /** @format date */
        period_start_before?: string;
        search?: string;
        /**
         * * `draft` - Draft
         * * `issued` - Issued
         * * `paid` - Paid
         * * `overdue` - Overdue
         * * `cancelled` - Cancelled
         */
        status?: ("cancelled" | "draft" | "issued" | "overdue" | "paid")[];
        total_amount_max?: number;
        total_amount_min?: number;
        total_units?: number;
        total_units__gte?: number;
        total_units__lte?: number;
        unit_price?: number;
        unit_price__gte?: number;
        unit_price__lte?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInvoiceList, any>({
        path: `/api/v1/billing/invoices/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonConsultationCreate
     * @request POST:/api/v1/common/consultation/
     */
    v1CommonConsultationCreate: (
      data: ConsultationRequest,
      params: RequestParams = {},
    ) =>
      this.request<Consultation, any>({
        path: `/api/v1/common/consultation/`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Search for records across all modules
     *
     * @tags v1
     * @name V1CommonGlobalSearchRetrieve
     * @summary Global search
     * @request GET:/api/v1/common/global-search/
     * @secure
     */
    v1CommonGlobalSearchRetrieve: (
      query: {
        /** Search query */
        query: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/common/global-search/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonGroupsList
     * @request GET:/api/v1/common/groups/
     * @secure
     */
    v1CommonGroupsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedGroupList, any>({
        path: `/api/v1/common/groups/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonGroupsRetrieve
     * @request GET:/api/v1/common/groups/{id}/
     * @secure
     */
    v1CommonGroupsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<Group, any>({
        path: `/api/v1/common/groups/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonGroupsDeleteDestroy
     * @request DELETE:/api/v1/common/groups/{id}/delete/
     * @secure
     */
    v1CommonGroupsDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/common/groups/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonGroupsUpdateUpdate
     * @request PUT:/api/v1/common/groups/{id}/update/
     * @secure
     */
    v1CommonGroupsUpdateUpdate: (
      id: string,
      data: GroupRequest,
      params: RequestParams = {},
    ) =>
      this.request<Group, any>({
        path: `/api/v1/common/groups/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonGroupsUpdatePartialUpdate
     * @request PATCH:/api/v1/common/groups/{id}/update/
     * @secure
     */
    v1CommonGroupsUpdatePartialUpdate: (
      id: string,
      data: PatchedGroupRequest,
      params: RequestParams = {},
    ) =>
      this.request<Group, any>({
        path: `/api/v1/common/groups/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonGroupsCreateCreate
     * @request POST:/api/v1/common/groups/create/
     * @secure
     */
    v1CommonGroupsCreateCreate: (
      data: GroupRequest,
      params: RequestParams = {},
    ) =>
      this.request<Group, any>({
        path: `/api/v1/common/groups/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonLabelsList
     * @request GET:/api/v1/common/labels/
     * @secure
     */
    v1CommonLabelsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedLabelList, any>({
        path: `/api/v1/common/labels/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonLabelsRetrieve
     * @request GET:/api/v1/common/labels/{id}/
     * @secure
     */
    v1CommonLabelsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<Label, any>({
        path: `/api/v1/common/labels/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonLabelsDeleteDestroy
     * @request DELETE:/api/v1/common/labels/{id}/delete/
     * @secure
     */
    v1CommonLabelsDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/common/labels/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonLabelsUpdateUpdate
     * @request PUT:/api/v1/common/labels/{id}/update/
     * @secure
     */
    v1CommonLabelsUpdateUpdate: (
      id: string,
      data: LabelRequest,
      params: RequestParams = {},
    ) =>
      this.request<Label, any>({
        path: `/api/v1/common/labels/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonLabelsUpdatePartialUpdate
     * @request PATCH:/api/v1/common/labels/{id}/update/
     * @secure
     */
    v1CommonLabelsUpdatePartialUpdate: (
      id: string,
      data: PatchedLabelRequest,
      params: RequestParams = {},
    ) =>
      this.request<Label, any>({
        path: `/api/v1/common/labels/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1CommonLabelsCreateCreate
     * @request POST:/api/v1/common/labels/create/
     * @secure
     */
    v1CommonLabelsCreateCreate: (
      data: LabelRequest,
      params: RequestParams = {},
    ) =>
      this.request<Label, any>({
        path: `/api/v1/common/labels/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Debug
     * @name V1CommonMigrationsAppsRetrieve
     * @summary Get all the apps that registered migrations
     * @request GET:/api/v1/common/migrations/apps/
     * @secure
     */
    v1CommonMigrationsAppsRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/common/migrations/apps/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Debug
     * @name V1CommonMigrationsHistoryRetrieve
     * @summary Get all applied migrations
     * @request GET:/api/v1/common/migrations/history/
     * @secure
     */
    v1CommonMigrationsHistoryRetrieve: (
      query?: {
        app?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/common/migrations/history/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description API endpoint that lists all tables and their columns, filtered by app name and including field types.
     *
     * @tags Debug
     * @name V1CommonMigrationsSchemasRetrieve
     * @summary Get all applied migrations
     * @request GET:/api/v1/common/migrations/schemas/
     * @secure
     */
    v1CommonMigrationsSchemasRetrieve: (
      query?: {
        app?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/common/migrations/schemas/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieves the latest created platform metadata.
     *
     * @tags v1
     * @name V1CommonPlatformMetadataRetrieve
     * @summary Get platform metadata
     * @request GET:/api/v1/common/platform/metadata/
     */
    v1CommonPlatformMetadataRetrieve: (params: RequestParams = {}) =>
      this.request<PlatformMetadataRead, any>({
        path: `/api/v1/common/platform/metadata/`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name V1CompanyRetrieve
     * @request GET:/api/v1/company/
     * @secure
     */
    v1CompanyRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/company/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description List of all active companies
     *
     * @tags Company
     * @name V1CompanyAdminListList
     * @request GET:/api/v1/company/admin/list/
     * @secure
     */
    v1CompanyAdminListList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCompanyListMiniList, any>({
        path: `/api/v1/company/admin/list/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company-Props
     * @name V1CompanyCurrenciesList
     * @request GET:/api/v1/company/currencies/
     * @secure
     */
    v1CompanyCurrenciesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCurrencyList, any>({
        path: `/api/v1/company/currencies/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domain
     * @name V1CompanyDomainCheckCreate
     * @request POST:/api/v1/company/domain/check/
     * @secure
     */
    v1CompanyDomainCheckCreate: (
      data: SubdomainCheckRequest,
      params: RequestParams = {},
    ) =>
      this.request<SubdomainCheck, any>({
        path: `/api/v1/company/domain/check/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domain
     * @name V1CompanyDomainCreateCreate
     * @summary Create subdomain
     * @request POST:/api/v1/company/domain/create/
     * @secure
     */
    v1CompanyDomainCreateCreate: (
      data: SubdomainCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/company/domain/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Domain
     * @name V1CompanyDomainSuggestCreate
     * @request POST:/api/v1/company/domain/suggest/
     * @secure
     */
    v1CompanyDomainSuggestCreate: (
      data: SubdomainSuggestRequest,
      params: RequestParams = {},
    ) =>
      this.request<SubdomainSuggest, any>({
        path: `/api/v1/company/domain/suggest/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company-Props
     * @name V1CompanyFleetsizesList
     * @request GET:/api/v1/company/fleetsizes/
     * @secure
     */
    v1CompanyFleetsizesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFleetSizeList, any>({
        path: `/api/v1/company/fleetsizes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company-Props
     * @name V1CompanyIndustriesList
     * @request GET:/api/v1/company/industries/
     * @secure
     */
    v1CompanyIndustriesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedIndustryList, any>({
        path: `/api/v1/company/industries/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name V1CompanyOnboardingCreate
     * @request POST:/api/v1/company/onboarding/
     * @secure
     */
    v1CompanyOnboardingCreate: (
      data: CompanyOnBoardingRequest,
      params: RequestParams = {},
    ) =>
      this.request<CompanyOnBoarding, any>({
        path: `/api/v1/company/onboarding/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Company
     * @name V1CompanyUpdatePartialUpdate
     * @request PATCH:/api/v1/company/update/
     * @secure
     */
    v1CompanyUpdatePartialUpdate: (
      data: PatchedCompanyRequest,
      params: RequestParams = {},
    ) =>
      this.request<Company, any>({
        path: `/api/v1/company/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves all dashboard metrics including status distribution and downtime count
     *
     * @tags v1
     * @name V1DashboardAnalyticsCompleteRetrieve
     * @summary Get complete dashboard data
     * @request GET:/api/v1/dashboard/analytics/complete/
     * @secure
     */
    v1DashboardAnalyticsCompleteRetrieve: (params: RequestParams = {}) =>
      this.request<DashboardResponse, any>({
        path: `/api/v1/dashboard/analytics/complete/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves invoiced hours and new vehicles metrics
     *
     * @tags v1
     * @name V1DashboardAnalyticsMetricsRetrieve
     * @summary Get dashboard metrics
     * @request GET:/api/v1/dashboard/analytics/metrics/
     * @secure
     */
    v1DashboardAnalyticsMetricsRetrieve: (params: RequestParams = {}) =>
      this.request<DashboardMetrics, any>({
        path: `/api/v1/dashboard/analytics/metrics/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves vehicle status distribution data
     *
     * @tags v1
     * @name V1DashboardAnalyticsStatusDistributionRetrieve
     * @summary Get status distribution
     * @request GET:/api/v1/dashboard/analytics/status_distribution/
     * @secure
     */
    v1DashboardAnalyticsStatusDistributionRetrieve: (
      params: RequestParams = {},
    ) =>
      this.request<StatusDistribution, any>({
        path: `/api/v1/dashboard/analytics/status_distribution/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DashboardInspectionsSubmissionsWeeklyComparisonRetrieve
     * @request GET:/api/v1/dashboard/inspections/submissions/weekly-comparison/
     * @secure
     */
    v1DashboardInspectionsSubmissionsWeeklyComparisonRetrieve: (
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/dashboard/inspections/submissions/weekly-comparison/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DashboardInspectionsSubmissionsWeeklyOutcomesRetrieve
     * @request GET:/api/v1/dashboard/inspections/submissions/weekly-outcomes/
     * @secure
     */
    v1DashboardInspectionsSubmissionsWeeklyOutcomesRetrieve: (
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/dashboard/inspections/submissions/weekly-outcomes/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DashboardIssuesCalendarRetrieve
     * @request GET:/api/v1/dashboard/issues/calendar/
     * @secure
     */
    v1DashboardIssuesCalendarRetrieve: (
      query?: {
        /** Filter issues up to this date (format: YYYY-MM-DD). */
        end_date?: string;
        /** Number of results to return per page (pagination). */
        limit?: number;
        /** Filter issues for a specific month (1-12). */
        month?: number;
        /** The initial index from which to return the results (pagination). */
        offset?: number;
        /** Filter by issue priority. */
        priority?: "critical" | "high" | "low" | "medium" | "no_priority";
        /** Filter issues starting from this date (format: YYYY-MM-DD). */
        start_date?: string;
        /** Filter by issue status. */
        status?: "closed" | "done" | "open" | "resolved";
        /** Filter by vehicle ID. */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IssuesCalendarResponse, any>({
        path: `/api/v1/dashboard/issues/calendar/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DashboardIssuesStatsRetrieve
     * @request GET:/api/v1/dashboard/issues/stats/
     * @secure
     */
    v1DashboardIssuesStatsRetrieve: (
      query?: {
        /** Filter issues up to this date (format: YYYY-MM-DD). */
        end_date?: string;
        /** Filter issues starting from this date (format: YYYY-MM-DD). */
        start_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/dashboard/issues/stats/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieves comprehensive metrics about issues for the dashboard
     *
     * @tags v1
     * @name V1DashboardIssuesWidgetListRetrieve
     * @summary Get Issue Dashboard Metrics
     * @request GET:/api/v1/dashboard/issues/widget-list/
     * @secure
     */
    v1DashboardIssuesWidgetListRetrieve: (params: RequestParams = {}) =>
      this.request<IssueDashboardResponse, any>({
        path: `/api/v1/dashboard/issues/widget-list/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DashboardLocationRetrieve
     * @request GET:/api/v1/dashboard/location/
     * @secure
     */
    v1DashboardLocationRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/dashboard/location/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DashboardRecentCommentsList
     * @request GET:/api/v1/dashboard/recent-comments/
     * @secure
     */
    v1DashboardRecentCommentsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedRecentCommentDashboardList, any>({
        path: `/api/v1/dashboard/recent-comments/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DashboardRemindersList
     * @request GET:/api/v1/dashboard/reminders/
     * @secure
     */
    v1DashboardRemindersList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** Filter reminders by type(s). Comma-separated list of reminder types. Valid types: vehicle_renewal, service_reminder, contact_renewal */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedReminderDashboardList, any>({
        path: `/api/v1/dashboard/reminders/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all chart data for the dashboard
     *
     * @tags v1
     * @name V1DashboardSystemAnalyticsRetrieve
     * @summary Get system analytics dashboard data
     * @request GET:/api/v1/dashboard/system_analytics/
     * @secure
     */
    v1DashboardSystemAnalyticsRetrieve: (params: RequestParams = {}) =>
      this.request<SystemAnalyticsDashboardsAPIResponseSchema, any>({
        path: `/api/v1/dashboard/system_analytics/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DashboardVehicleAssignmentsList
     * @request GET:/api/v1/dashboard/vehicle-assignments/
     * @secure
     */
    v1DashboardVehicleAssignmentsList: (
      query?: {
        /** @format date-time */
        date_range_after?: string;
        /** @format date-time */
        date_range_before?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** @format uuid */
        operator?: string;
        /** A search term. */
        search?: string;
        /** @format uuid */
        vehicle?: string;
        year?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAssignmentListList, any>({
        path: `/api/v1/dashboard/vehicle-assignments/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DashboardVehicleAssignmentsRetrieve
     * @request GET:/api/v1/dashboard/vehicle-assignments/{id}/
     * @secure
     */
    v1DashboardVehicleAssignmentsRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<AssignmentDetail, any>({
        path: `/api/v1/dashboard/vehicle-assignments/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DashboardVehicleStatusRetrieve
     * @request GET:/api/v1/dashboard/vehicle-status/
     * @secure
     */
    v1DashboardVehicleStatusRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/dashboard/vehicle-status/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve work orders grouped by status with optional filtering and search capabilities.
     *
     * @tags v1
     * @name V1DashboardWorkOrderRetrieve
     * @summary Get Work Orders by Status
     * @request GET:/api/v1/dashboard/work-order/
     * @secure
     */
    v1DashboardWorkOrderRetrieve: (
      query?: {
        /**
         * Filter work orders up to this date
         * @format date
         */
        end_date?: string;
        /** Search in vehicle name, driver first name, and driver last name */
        search?: string;
        /**
         * Filter work orders from this date
         * @format date
         */
        start_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WorkOrdersByStatusResponse, any>({
        path: `/api/v1/dashboard/work-order/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DataMigrationExportDataCreate
     * @request POST:/api/v1/data_migration/export/data/
     * @secure
     */
    v1DataMigrationExportDataCreate: (
      data: ExportDataRequest,
      params: RequestParams = {},
    ) =>
      this.request<ExportData, any>({
        path: `/api/v1/data_migration/export/data/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DataMigrationExportDataTaskCreate
     * @request POST:/api/v1/data_migration/export/data/task/
     * @secure
     */
    v1DataMigrationExportDataTaskCreate: (
      data: ExportDataRequest,
      params: RequestParams = {},
    ) =>
      this.request<ExportData, any>({
        path: `/api/v1/data_migration/export/data/task/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DataMigrationExportDataTaskStatusRetrieve
     * @request GET:/api/v1/data_migration/export/data/task/{task_id}/status/
     * @secure
     */
    v1DataMigrationExportDataTaskStatusRetrieve: (
      taskId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/data_migration/export/data/task/${taskId}/status/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Master endpoint for importing data into different sections of the system. Supports various data sections like vehicles, maintenance records, fuel logs, etc. Data is processed according to the specified section's rules and requirements. Available sections can be queried from the schema or checked in the section dropdown. Company context is automatically determined from the authenticated user's profile.
     *
     * @tags System Data Import
     * @name V1DataMigrationImportBulkCreate
     * @summary Import bulk data into system
     * @request POST:/api/v1/data_migration/import/bulk/
     * @secure
     */
    v1DataMigrationImportBulkCreate: (
      data: BulkDataImportRequest,
      params: RequestParams = {},
    ) =>
      this.request<DataImportResult, any>({
        path: `/api/v1/data_migration/import/bulk/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DataMigrationImportDataCreate
     * @request POST:/api/v1/data_migration/import/data/
     * @secure
     */
    v1DataMigrationImportDataCreate: (
      data: ImportDataRequest,
      params: RequestParams = {},
    ) =>
      this.request<ImportData, any>({
        path: `/api/v1/data_migration/import/data/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle asynchronous data import request
     *
     * @tags v1
     * @name V1DataMigrationImportDataAsyncCreate
     * @request POST:/api/v1/data_migration/import/data/async/
     * @secure
     */
    v1DataMigrationImportDataAsyncCreate: (
      data: ImportDataAsyncRequest,
      params: RequestParams = {},
    ) =>
      this.request<ImportDataAsync, any>({
        path: `/api/v1/data_migration/import/data/async/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1DataMigrationImportStatusRetrieve
     * @request GET:/api/v1/data_migration/import/status/{job_id}/
     * @secure
     */
    v1DataMigrationImportStatusRetrieve: (
      jobId: string,
      params: RequestParams = {},
    ) =>
      this.request<ImportJob, any>({
        path: `/api/v1/data_migration/import/status/${jobId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import Sections
     * @name V1DataMigrationSectionsList
     * @request GET:/api/v1/data_migration/sections/
     * @secure
     */
    v1DataMigrationSectionsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedImportSectionWithCountList, any>({
        path: `/api/v1/data_migration/sections/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import Sections
     * @name V1DataMigrationSectionsTemplatesList
     * @request GET:/api/v1/data_migration/sections/templates/
     * @secure
     */
    v1DataMigrationSectionsTemplatesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedImportTemplateList, any>({
        path: `/api/v1/data_migration/sections/templates/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name V1DocumentsList
     * @request GET:/api/v1/documents/
     * @secure
     */
    v1DocumentsList: (
      query?: {
        file_name?: string;
        /**
         * * `photo` - Photo
         * * `document` - Document
         * * `video` - Video
         * * `audio` - Audio
         * * `text` - Text
         * * `html` - HTML
         * * `microsoft_word` - Microsoft Word
         * * `microsoft_excel` - Microsoft Excel
         * * `microsoft_powerpoint` - Microsoft PowerPoint
         * * `csv` - CSV
         */
        file_type?:
          | "audio"
          | "csv"
          | "document"
          | "html"
          | "microsoft_excel"
          | "microsoft_powerpoint"
          | "microsoft_word"
          | "photo"
          | "text"
          | "video";
        labels?: string[];
        /** Number of results to return per page. */
        limit?: number;
        /**
         * * `vehicles` - Vehicles
         * * `companies` - Companies
         * * `contacts` - Contacts
         * * `issues` - Issues
         * * `parts` - Parts
         * * `purchase_order` - Purchase Order
         * * `service_entry` - Service Entry
         * * `vendors` - Vendors
         * * `inspection` - Inspection
         * * `reminders` - Reminders
         * * `fuel` - Fuel
         * * `reports` - Reports
         * * `inventory` - Inventory
         * * `billing` - Billing
         * * `work_orders` - Work Orders
         */
        location?:
          | "billing"
          | "companies"
          | "contacts"
          | "fuel"
          | "inspection"
          | "inventory"
          | "issues"
          | "parts"
          | "purchase_order"
          | "reminders"
          | "reports"
          | "service_entry"
          | "vehicles"
          | "vendors"
          | "work_orders"
          | null;
        max_file_size?: number;
        min_file_size?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        original_file_name?: string;
        /** A search term. */
        search?: string;
        /** @format uuid */
        uploaded_by?: string;
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedListFileList, any>({
        path: `/api/v1/documents/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name V1DocumentsRetrieve
     * @request GET:/api/v1/documents/{id}/
     * @secure
     */
    v1DocumentsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<RetrieveFile, any>({
        path: `/api/v1/documents/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name V1DocumentsDeleteDestroy
     * @request DELETE:/api/v1/documents/{id}/delete/
     * @secure
     */
    v1DocumentsDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/documents/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name V1DocumentsUpdateUpdate
     * @request PUT:/api/v1/documents/{id}/update/
     * @secure
     */
    v1DocumentsUpdateUpdate: (
      id: string,
      data: UpdateFileRequest,
      params: RequestParams = {},
    ) =>
      this.request<RetrieveFile, any>({
        path: `/api/v1/documents/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name V1DocumentsUpdatePartialUpdate
     * @request PATCH:/api/v1/documents/{id}/update/
     * @secure
     */
    v1DocumentsUpdatePartialUpdate: (
      id: string,
      data: PatchedUpdateFileRequest,
      params: RequestParams = {},
    ) =>
      this.request<RetrieveFile, any>({
        path: `/api/v1/documents/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name V1DocumentsCreateCreate
     * @request POST:/api/v1/documents/create/
     * @secure
     */
    v1DocumentsCreateCreate: (
      data: CreateFileRequest,
      params: RequestParams = {},
    ) =>
      this.request<RetrieveFile, any>({
        path: `/api/v1/documents/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags files
     * @name V1DocumentsUploadDirectFinishCreate
     * @request POST:/api/v1/documents/upload/direct/finish/
     * @secure
     */
    v1DocumentsUploadDirectFinishCreate: (
      data: InputDirectFinishRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/documents/upload/direct/finish/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags files
     * @name V1DocumentsUploadDirectLocalCreate
     * @request POST:/api/v1/documents/upload/direct/local/{file_id}/
     * @secure
     */
    v1DocumentsUploadDirectLocalCreate: (
      fileId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/documents/upload/direct/local/${fileId}/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags files
     * @name V1DocumentsUploadDirectStartCreate
     * @request POST:/api/v1/documents/upload/direct/start/
     * @secure
     */
    v1DocumentsUploadDirectStartCreate: (
      data: InputRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/documents/upload/direct/start/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags files
     * @name V1DocumentsUploadStandardCreate
     * @request POST:/api/v1/documents/upload/standard/
     * @secure
     */
    v1DocumentsUploadStandardCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/documents/upload/standard/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipments
     * @name V1EquipmentsList
     * @request GET:/api/v1/equipments/
     * @secure
     */
    v1EquipmentsList: (
      query?: {
        assigned_vehicle?: string;
        is_assigned?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /**
         * * `in_service` - In Service
         * * `available` - Available
         * * `out_of_service` - Out Of service
         * * `disposed` - Disposed
         * * `missing` - Missing
         * * `rented` - Rented
         */
        status?:
          | "available"
          | "disposed"
          | "in_service"
          | "missing"
          | "out_of_service"
          | "rented";
        /** @format uuid */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedEquipmentListList, any>({
        path: `/api/v1/equipments/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipments
     * @name V1EquipmentsRetrieve
     * @request GET:/api/v1/equipments/{id}/
     * @secure
     */
    v1EquipmentsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<EquipmentRetrieve, any>({
        path: `/api/v1/equipments/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1EquipmentsAddPhotoPartialUpdate
     * @request PATCH:/api/v1/equipments/{id}/add-photo/
     * @secure
     */
    v1EquipmentsAddPhotoPartialUpdate: (
      id: string,
      data: PatchedEquipmentAddPhotoRequest,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentAddPhoto, any>({
        path: `/api/v1/equipments/${id}/add-photo/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipments
     * @name V1EquipmentsAssignCreate
     * @summary Assign equipment
     * @request POST:/api/v1/equipments/{id}/assign/
     * @secure
     */
    v1EquipmentsAssignCreate: (
      id: string,
      data: AssignEquipmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<AssignEquipment, any>({
        path: `/api/v1/equipments/${id}/assign/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipments
     * @name V1EquipmentsAssignmentDeleteCreate
     * @request POST:/api/v1/equipments/{id}/assignment/delete/
     * @secure
     */
    v1EquipmentsAssignmentDeleteCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/equipments/${id}/assignment/delete/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Histories
     * @name V1EquipmentsAssignmentsList
     * @request GET:/api/v1/equipments/{id}/assignments/
     * @secure
     */
    v1EquipmentsAssignmentsList: (
      id: string,
      query?: {
        assigned_user?: number;
        /** @format date */
        end_date?: string;
        /** @format date */
        end_date_range_after?: string;
        /** @format date */
        end_date_range_before?: string;
        ended_by?: number;
        equipment?: number;
        /** Number of results to return per page. */
        limit?: number;
        linked_vehicle?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        per_month?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        per_month_range_max?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        per_month_range_min?: number;
        /** A search term. */
        search?: string;
        /** @format date */
        start_date?: string;
        /** @format date */
        start_date_range_after?: string;
        /** @format date */
        start_date_range_before?: string;
        started_by?: number;
        total_price?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        total_price_range_max?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        total_price_range_min?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAssignmentHistoryListList, any>({
        path: `/api/v1/equipments/${id}/assignments/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment Files
     * @name V1EquipmentsBulkAddFilesCreate
     * @request POST:/api/v1/equipments/{id}/bulk_add_files/
     * @secure
     */
    v1EquipmentsBulkAddFilesCreate: (
      id: string,
      data: FilesEquipmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/equipments/${id}/bulk_add_files/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment Files
     * @name V1EquipmentsBulkRemoveFilesCreate
     * @request POST:/api/v1/equipments/{id}/bulk_remove_files/
     * @secure
     */
    v1EquipmentsBulkRemoveFilesCreate: (
      id: string,
      data: FilesEquipmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/equipments/${id}/bulk_remove_files/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipments
     * @name V1EquipmentsDeleteDestroy
     * @summary Delete equipment
     * @request DELETE:/api/v1/equipments/{id}/delete/
     * @secure
     */
    v1EquipmentsDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/equipments/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Histories
     * @name V1EquipmentsLinkedVehiclesList
     * @request GET:/api/v1/equipments/{id}/linked-vehicles/
     * @secure
     */
    v1EquipmentsLinkedVehiclesList: (
      id: string,
      query?: {
        assigned_user?: number;
        /** @format date */
        end_date?: string;
        /** @format date */
        end_date_range_after?: string;
        /** @format date */
        end_date_range_before?: string;
        ended_by?: number;
        equipment?: number;
        /** Number of results to return per page. */
        limit?: number;
        linked_vehicle?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        per_month?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        per_month_range_max?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        per_month_range_min?: number;
        /** A search term. */
        search?: string;
        /** @format date */
        start_date?: string;
        /** @format date */
        start_date_range_after?: string;
        /** @format date */
        start_date_range_before?: string;
        started_by?: number;
        total_price?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        total_price_range_max?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        total_price_range_min?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedLinkedVehicleHistoryListList, any>({
        path: `/api/v1/equipments/${id}/linked-vehicles/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1EquipmentsRemovePhotoPartialUpdate
     * @request PATCH:/api/v1/equipments/{id}/remove-photo/
     * @secure
     */
    v1EquipmentsRemovePhotoPartialUpdate: (
      id: string,
      data: PatchedEquipmentRemovePhotoRequest,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentRemovePhoto, any>({
        path: `/api/v1/equipments/${id}/remove-photo/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Rent-Histories
     * @name V1EquipmentsRentHistoryList
     * @request GET:/api/v1/equipments/{id}/rent-history/
     * @secure
     */
    v1EquipmentsRentHistoryList: (
      id: string,
      query?: {
        comment?: string;
        cost?: number;
        /**
         * Total Cost
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        cost_range_max?: number | null;
        /**
         * Total Cost
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        cost_range_min?: number | null;
        /** @format date */
        end_date?: string;
        /** @format date */
        end_date_range_after?: string;
        /** @format date */
        end_date_range_before?: string;
        equipment?: number;
        invoice_num?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * * `pending` - Pending
         * * `paid` - Paid
         * * `unpaid` - Unpaid
         */
        payment_status?: "paid" | "pending" | "unpaid";
        phone?: string;
        rent_per_month?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        rent_per_month_range_max?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        rent_per_month_range_min?: number;
        rented_by?: string;
        rented_company?: string;
        /** A search term. */
        search?: string;
        /** @format date */
        start_date?: string;
        /** @format date */
        start_date_range_after?: string;
        /** @format date */
        start_date_range_before?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedRentHistoryListList, any>({
        path: `/api/v1/equipments/${id}/rent-history/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipments
     * @name V1EquipmentsUnassignCreate
     * @summary Unassign equipment
     * @request POST:/api/v1/equipments/{id}/unassign/
     * @secure
     */
    v1EquipmentsUnassignCreate: (
      id: string,
      data: EquipmentUnAssignRequest,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentUnAssign, any>({
        path: `/api/v1/equipments/${id}/unassign/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipments
     * @name V1EquipmentsUpdateUpdate
     * @request PUT:/api/v1/equipments/{id}/update/
     * @secure
     */
    v1EquipmentsUpdateUpdate: (
      id: string,
      data: EquipmentUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentUpdate, any>({
        path: `/api/v1/equipments/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipments
     * @name V1EquipmentsUpdatePartialUpdate
     * @request PATCH:/api/v1/equipments/{id}/update/
     * @secure
     */
    v1EquipmentsUpdatePartialUpdate: (
      id: string,
      data: PatchedEquipmentUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentUpdate, any>({
        path: `/api/v1/equipments/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipments
     * @name V1EquipmentsAssignedVehiclesList
     * @request GET:/api/v1/equipments/assigned/vehicles/
     * @secure
     */
    v1EquipmentsAssignedVehiclesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedEquipmentVehiclesList, any>({
        path: `/api/v1/equipments/assigned/vehicles/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipments
     * @name V1EquipmentsCreateCreate
     * @request POST:/api/v1/equipments/create/
     * @secure
     */
    v1EquipmentsCreateCreate: (
      data: EquipmentCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentCreate, any>({
        path: `/api/v1/equipments/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle GET request for exporting Equipment data. :param format: The format for export ('csv' or 'xlsx') :return: Response with exported data
     *
     * @tags Equipment-Export
     * @name V1EquipmentsExportRetrieve
     * @request GET:/api/v1/equipments/export/
     * @secure
     */
    v1EquipmentsExportRetrieve: (
      query?: {
        /** The format for export (csv or xlsx) */
        format_type?: "csv" | "xlsx";
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/api/v1/equipments/export/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Histories
     * @name V1EquipmentsHistoriesList
     * @request GET:/api/v1/equipments/histories/
     * @secure
     */
    v1EquipmentsHistoriesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedHistoryListList, any>({
        path: `/api/v1/equipments/histories/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Histories
     * @name V1EquipmentsHistoriesDeleteDestroy
     * @request DELETE:/api/v1/equipments/histories/{id}/delete/
     * @secure
     */
    v1EquipmentsHistoriesDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/equipments/histories/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Histories
     * @name V1EquipmentsHistoriesUpdateUpdate
     * @request PUT:/api/v1/equipments/histories/{id}/update/
     * @secure
     */
    v1EquipmentsHistoriesUpdateUpdate: (
      id: string,
      data: EquipmentHistoryUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentHistoryUpdate, any>({
        path: `/api/v1/equipments/histories/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Histories
     * @name V1EquipmentsHistoriesUpdatePartialUpdate
     * @request PATCH:/api/v1/equipments/histories/{id}/update/
     * @secure
     */
    v1EquipmentsHistoriesUpdatePartialUpdate: (
      id: string,
      data: PatchedEquipmentHistoryUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentHistoryUpdate, any>({
        path: `/api/v1/equipments/histories/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Histories
     * @name V1EquipmentsHistoriesAssignmentsList
     * @request GET:/api/v1/equipments/histories/assignments/
     * @secure
     */
    v1EquipmentsHistoriesAssignmentsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAssignmentHistoryListList, any>({
        path: `/api/v1/equipments/histories/assignments/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Histories
     * @name V1EquipmentsHistoriesLinkedVehiclesList
     * @request GET:/api/v1/equipments/histories/linked-vehicles/
     * @secure
     */
    v1EquipmentsHistoriesLinkedVehiclesList: (
      query?: {
        assigned_user?: number;
        /** @format date */
        end_date?: string;
        /** @format date */
        end_date_range_after?: string;
        /** @format date */
        end_date_range_before?: string;
        ended_by?: number;
        equipment?: number;
        /** Number of results to return per page. */
        limit?: number;
        linked_vehicle?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        per_month?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        per_month_range_max?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        per_month_range_min?: number;
        /** A search term. */
        search?: string;
        /** @format date */
        start_date?: string;
        /** @format date */
        start_date_range_after?: string;
        /** @format date */
        start_date_range_before?: string;
        started_by?: number;
        total_price?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        total_price_range_max?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        total_price_range_min?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedLinkedVehicleHistoryListList, any>({
        path: `/api/v1/equipments/histories/linked-vehicles/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import Equipments
     * @name V1EquipmentsImportEquipmentsTempCreate
     * @request POST:/api/v1/equipments/import-equipments-temp/
     * @secure
     */
    v1EquipmentsImportEquipmentsTempCreate: (
      data: ImportFileRequest,
      params: RequestParams = {},
    ) =>
      this.request<ImportFile, any>({
        path: `/api/v1/equipments/import-equipments-temp/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle POST request for importing Equipment data. :return: Response with importer status
     *
     * @tags Equipment-Import
     * @name V1EquipmentsImporterCreate
     * @request POST:/api/v1/equipments/importer/
     * @secure
     */
    v1EquipmentsImporterCreate: (
      data: EquipmentImportFileRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/equipments/importer/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Rent-Histories
     * @name V1EquipmentsRentHistoriesList
     * @request GET:/api/v1/equipments/rent-histories/
     * @secure
     */
    v1EquipmentsRentHistoriesList: (
      query?: {
        comment?: string;
        cost?: number;
        /**
         * Total Cost
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        cost_range_max?: number | null;
        /**
         * Total Cost
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        cost_range_min?: number | null;
        /** @format date */
        end_date?: string;
        /** @format date */
        end_date_range_after?: string;
        /** @format date */
        end_date_range_before?: string;
        equipment?: number;
        invoice_num?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * * `pending` - Pending
         * * `paid` - Paid
         * * `unpaid` - Unpaid
         */
        payment_status?: "paid" | "pending" | "unpaid";
        phone?: string;
        rent_per_month?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        rent_per_month_range_max?: number;
        /**
         * @format double
         * @min -100000000
         * @exclusiveMin true
         * @max 100000000
         * @exclusiveMax true
         */
        rent_per_month_range_min?: number;
        rented_by?: string;
        rented_company?: string;
        /** A search term. */
        search?: string;
        /** @format date */
        start_date?: string;
        /** @format date */
        start_date_range_after?: string;
        /** @format date */
        start_date_range_before?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedRentHistoryListList, any>({
        path: `/api/v1/equipments/rent-histories/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Rent-Histories
     * @name V1EquipmentsRentHistoriesRetrieve
     * @request GET:/api/v1/equipments/rent-histories/{id}/
     * @secure
     */
    v1EquipmentsRentHistoriesRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<RentHistoryDetail, any>({
        path: `/api/v1/equipments/rent-histories/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Rent-Histories
     * @name V1EquipmentsRentHistoriesDeleteDestroy
     * @request DELETE:/api/v1/equipments/rent-histories/{id}/delete/
     * @secure
     */
    v1EquipmentsRentHistoriesDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/equipments/rent-histories/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Rent-Histories
     * @name V1EquipmentsRentHistoriesUpdateUpdate
     * @request PUT:/api/v1/equipments/rent-histories/{id}/update/
     * @secure
     */
    v1EquipmentsRentHistoriesUpdateUpdate: (
      id: string,
      data: RentHistoryUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<RentHistoryUpdate, any>({
        path: `/api/v1/equipments/rent-histories/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Rent-Histories
     * @name V1EquipmentsRentHistoriesUpdatePartialUpdate
     * @request PATCH:/api/v1/equipments/rent-histories/{id}/update/
     * @secure
     */
    v1EquipmentsRentHistoriesUpdatePartialUpdate: (
      id: string,
      data: PatchedRentHistoryUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<RentHistoryUpdate, any>({
        path: `/api/v1/equipments/rent-histories/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Rent-Histories
     * @name V1EquipmentsRentHistoriesCreateCreate
     * @request POST:/api/v1/equipments/rent-histories/create/
     * @secure
     */
    v1EquipmentsRentHistoriesCreateCreate: (
      data: RentHistoryCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<RentHistoryCreate, any>({
        path: `/api/v1/equipments/rent-histories/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Rent-Histories
     * @name V1EquipmentsRentHistoriesPaidCreate
     * @request POST:/api/v1/equipments/rent-histories/paid/
     * @secure
     */
    v1EquipmentsRentHistoriesPaidCreate: (
      data: PaidHistoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaidHistory, any>({
        path: `/api/v1/equipments/rent-histories/paid/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Rent-Histories
     * @name V1EquipmentsRentHistoriesUnpaidCreate
     * @request POST:/api/v1/equipments/rent-histories/unpaid/
     * @secure
     */
    v1EquipmentsRentHistoriesUnpaidCreate: (
      data: PaidHistoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaidHistory, any>({
        path: `/api/v1/equipments/rent-histories/unpaid/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Types
     * @name V1EquipmentsTypesList
     * @request GET:/api/v1/equipments/types/
     * @secure
     */
    v1EquipmentsTypesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedEquipmentTypeListList, any>({
        path: `/api/v1/equipments/types/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Types
     * @name V1EquipmentsTypesRetrieve
     * @request GET:/api/v1/equipments/types/{id}/
     * @secure
     */
    v1EquipmentsTypesRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<EquipmentTypeRetrieve, any>({
        path: `/api/v1/equipments/types/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Types
     * @name V1EquipmentsTypesDeleteDestroy
     * @request DELETE:/api/v1/equipments/types/{id}/delete/
     * @secure
     */
    v1EquipmentsTypesDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/equipments/types/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Types
     * @name V1EquipmentsTypesUpdateUpdate
     * @request PUT:/api/v1/equipments/types/{id}/update/
     * @secure
     */
    v1EquipmentsTypesUpdateUpdate: (
      id: string,
      data: EquipmentTypeUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentTypeUpdate, any>({
        path: `/api/v1/equipments/types/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Types
     * @name V1EquipmentsTypesUpdatePartialUpdate
     * @request PATCH:/api/v1/equipments/types/{id}/update/
     * @secure
     */
    v1EquipmentsTypesUpdatePartialUpdate: (
      id: string,
      data: PatchedEquipmentTypeUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentTypeUpdate, any>({
        path: `/api/v1/equipments/types/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment-Types
     * @name V1EquipmentsTypesCreateCreate
     * @request POST:/api/v1/equipments/types/create/
     * @secure
     */
    v1EquipmentsTypesCreateCreate: (
      data: EquipmentTypeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentTypeCreate, any>({
        path: `/api/v1/equipments/types/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipments
     * @name V1EquipmentsUsersList
     * @request GET:/api/v1/equipments/users/
     * @secure
     */
    v1EquipmentsUsersList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAssignedUserList, any>({
        path: `/api/v1/equipments/users/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipments
     * @name V1EquipmentsVehiclesList
     * @request GET:/api/v1/equipments/vehicles/
     * @secure
     */
    v1EquipmentsVehiclesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedEquipmentVehiclesList, any>({
        path: `/api/v1/equipments/vehicles/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fuel Entries
     * @name V1FuelEntriesList
     * @request GET:/api/v1/fuel-entries/
     * @secure
     */
    v1FuelEntriesList: (
      query?: {
        cost_per_meter_range_max?: number;
        cost_per_meter_range_min?: number;
        cost_range_max?: number;
        cost_range_min?: number;
        /** @format date */
        date_range_after?: string;
        /** @format date */
        date_range_before?: string;
        /**
         * * `personal_use` - Personal Use
         * * `partial_fuel_up` - Partial Fuel-Up
         * * `reset_usage` - Reset Usage
         */
        flag?: "partial_fuel_up" | "personal_use" | "reset_usage" | null;
        fuel_economy_range_max?: number;
        fuel_economy_range_min?: number;
        fuel_type?: string;
        last_known_location?: string;
        last_known_location__icontains?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        usage_range_max?: number;
        usage_range_min?: number;
        /** @format uuid */
        vehicle?: string;
        vehicle_group?: string;
        /** @format uuid */
        vendor?: string;
        volume_range_max?: number;
        volume_range_min?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFuelEntryListModList, any>({
        path: `/api/v1/fuel-entries/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fuel Entries
     * @name V1FuelEntriesRetrieve
     * @request GET:/api/v1/fuel-entries/{id}/
     * @secure
     */
    v1FuelEntriesRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<FuelEntryRetrieve, any>({
        path: `/api/v1/fuel-entries/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FuelEntry Files
     * @name V1FuelEntriesBulkAddFilesCreate
     * @request POST:/api/v1/fuel-entries/{id}/bulk_add_files/
     * @secure
     */
    v1FuelEntriesBulkAddFilesCreate: (
      id: string,
      data: FilesFuelEntryRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/fuel-entries/${id}/bulk_add_files/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FuelEntry Files
     * @name V1FuelEntriesBulkRemoveFilesCreate
     * @request POST:/api/v1/fuel-entries/{id}/bulk_remove_files/
     * @secure
     */
    v1FuelEntriesBulkRemoveFilesCreate: (
      id: string,
      data: FilesFuelEntryRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/fuel-entries/${id}/bulk_remove_files/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment Comments
     * @name V1FuelEntriesCommentsDeleteDestroy
     * @request DELETE:/api/v1/fuel-entries/{id}/comments/delete/
     * @secure
     */
    v1FuelEntriesCommentsDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/fuel-entries/${id}/comments/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fuel Entries
     * @name V1FuelEntriesDeleteDestroy
     * @request DELETE:/api/v1/fuel-entries/{id}/delete/
     * @secure
     */
    v1FuelEntriesDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/fuel-entries/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fuel Entries
     * @name V1FuelEntriesUpdateUpdate
     * @request PUT:/api/v1/fuel-entries/{id}/update/
     * @secure
     */
    v1FuelEntriesUpdateUpdate: (
      id: string,
      data: FuelEntryUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<FuelEntryUpdate, any>({
        path: `/api/v1/fuel-entries/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fuel Entries
     * @name V1FuelEntriesUpdatePartialUpdate
     * @request PATCH:/api/v1/fuel-entries/{id}/update/
     * @secure
     */
    v1FuelEntriesUpdatePartialUpdate: (
      id: string,
      data: PatchedFuelEntryUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<FuelEntryUpdate, any>({
        path: `/api/v1/fuel-entries/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Equipment Comments
     * @name V1FuelEntriesCommentsCreateCreate
     * @request POST:/api/v1/fuel-entries/comments/create/
     * @secure
     */
    v1FuelEntriesCommentsCreateCreate: (
      data: EquipmentCommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<EquipmentComment, any>({
        path: `/api/v1/fuel-entries/comments/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Fuel Entries
     * @name V1FuelEntriesCreateCreate
     * @request POST:/api/v1/fuel-entries/create/
     * @secure
     */
    v1FuelEntriesCreateCreate: (
      data: FuelEntryCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<FuelEntryCreate, any>({
        path: `/api/v1/fuel-entries/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the specified fuel entries.
     *
     * @tags Fuel Entries
     * @name V1FuelEntriesDeleteBulkCreate
     * @request POST:/api/v1/fuel-entries/delete/bulk/
     * @secure
     */
    v1FuelEntriesDeleteBulkCreate: (
      data: BulkFuelEntryRequest,
      params: RequestParams = {},
    ) =>
      this.request<BulkFuelEntry, any>({
        path: `/api/v1/fuel-entries/delete/bulk/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves fuel statistics for the user's company.
     *
     * @tags Fuel Entries, Fuel Entries Statistics
     * @name V1FuelEntriesFuelStatisticsRetrieve
     * @request GET:/api/v1/fuel-entries/fuel-statistics/
     * @secure
     */
    v1FuelEntriesFuelStatisticsRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/fuel-entries/fuel-statistics/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Healthcheck
     * @name V1HealthcheckRetrieve
     * @request GET:/api/v1/healthcheck/
     * @secure
     */
    v1HealthcheckRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/healthcheck/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1HintsList
     * @request GET:/api/v1/hints/
     * @secure
     */
    v1HintsList: (
      query?: {
        /**
         * Application section where this hint will be displayed
         *
         * * `dashboard` - Dashboard
         * * `units` - Units
         * * `users` - Users
         * * `contact` - Contact
         * * `samsara_devices` - Samsara Devices
         * * `assignment` - Assignment
         * * `meter_history` - Meter History
         * * `fuel_history` - Fuel History
         * * `report` - Report
         * * `expense` - Expense
         * * `training_videos` - Training Videos
         * * `papers` - Papers
         * * `settings` - Settings
         * * `warranty` - Warranty
         * * `inspections_history` - Inspections History
         * * `inspections_forms` - Inspections Forms
         * * `inspection_item_failures` - Inspection Item Failures
         * * `issue` - Issue
         * * `faults` - Faults
         * * `service_history` - Service History
         * * `service_tasks` - Service Tasks
         * * `contact_renewal` - Contact Renewal
         * * `vehicle_renewal` - Vehicle Renewal
         * * `service_reminders` - Service Reminders
         * * `equipment` - Equipment
         * * `vendors` - Vendors
         * * `parts` - Parts
         * * `purchase_orders` - Purchase Orders
         * * `work_orders` - Work Orders
         */
        section?:
          | "assignment"
          | "contact"
          | "contact_renewal"
          | "dashboard"
          | "equipment"
          | "expense"
          | "faults"
          | "fuel_history"
          | "inspection_item_failures"
          | "inspections_forms"
          | "inspections_history"
          | "issue"
          | "meter_history"
          | "papers"
          | "parts"
          | "purchase_orders"
          | "report"
          | "samsara_devices"
          | "service_history"
          | "service_reminders"
          | "service_tasks"
          | "settings"
          | "training_videos"
          | "units"
          | "users"
          | "vehicle_renewal"
          | "vendors"
          | "warranty"
          | "work_orders";
      },
      params: RequestParams = {},
    ) =>
      this.request<Hint[], any>({
        path: `/api/v1/hints/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1HintsSectionList
     * @request GET:/api/v1/hints/section/{section}/
     * @secure
     */
    v1HintsSectionList: (section: string, params: RequestParams = {}) =>
      this.request<Hint[], any>({
        path: `/api/v1/hints/section/${section}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API view to list all inspection submissions with basic information.
     *
     * @tags v1
     * @name V1InspectionsList
     * @request GET:/api/v1/inspections/
     * @secure
     */
    v1InspectionsList: (
      query?: {
        /** @format duration */
        duration?: string;
        /** @format uuid */
        form?: string;
        has_failed_items?: boolean;
        latitude?: string;
        /** Number of results to return per page. */
        limit?: number;
        longitude?: string;
        my_submissions?: boolean;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /**
         * * `web` - Web
         * * `mobile` - Mobile
         */
        source?: "mobile" | "web";
        /** @format date-time */
        started_at?: string;
        /** @format date-time */
        started_at__gt?: string;
        /** @format date-time */
        started_at__lt?: string;
        /** @format date-time */
        submitted_at?: string;
        /** @format date-time */
        submitted_at__gt?: string;
        /** @format date-time */
        submitted_at__lt?: string;
        /** @format uuid */
        submitted_by?: string;
        /** @format uuid */
        vehicle?: string;
        /**
         * Vehicle Group
         * @format uuid
         */
        vehicle_group?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInspectionSubmissionListList, any>({
        path: `/api/v1/inspections/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API view to retrieve a detailed inspection submission, including items and their results.
     *
     * @tags v1
     * @name V1InspectionsRetrieve
     * @request GET:/api/v1/inspections/{id}/
     * @secure
     */
    v1InspectionsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<InspectionSubmissionDetailItems, any>({
        path: `/api/v1/inspections/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API view to list all failed inspection items with basic information.
     *
     * @tags v1
     * @name V1InspectionsFailedItemsList
     * @request GET:/api/v1/inspections/failed-items/
     * @secure
     */
    v1InspectionsFailedItemsList: (
      query?: {
        chosen_option?: number;
        comment?: string;
        /** @format date-time */
        date_time_result?: string;
        /** @format date-time */
        date_time_result__gt?: string;
        /** @format date-time */
        date_time_result__lt?: string;
        failed?: boolean;
        /** @format uuid */
        form?: string;
        /** @format uuid */
        item?: string;
        /** Number of results to return per page. */
        limit?: number;
        meter_entry_value?: number;
        numeric_value?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * Ordering
         *
         * * `created` - Created
         * * `-created` - Created (descending)
         * * `submission__started_at` - Submission  started at
         * * `-submission__started_at` - Submission  started at (descending)
         * * `submission__submitted_at` - Submission  submitted at
         * * `-submission__submitted_at` - Submission  submitted at (descending)
         */
        order_by?: (
          | "-created"
          | "-submission__started_at"
          | "-submission__submitted_at"
          | "created"
          | "submission__started_at"
          | "submission__submitted_at"
        )[];
        pass_fail_na_option?: boolean;
        pass_fail_value?: boolean;
        /** @format uuid */
        photo?: string;
        /**
         * * `section` - Section
         * * `pass_fail` - Pass/Fail
         * * `meter_entry` - Meter Entry
         * * `date_time` - Date and Time
         * * `number` - Number
         * * `dropdown` - Dropdown
         * * `photo` - Photo
         * * `video` - Video
         * * `signature` - Signature
         * * `free_text` - Free Text
         */
        result_type?:
          | "date_time"
          | "dropdown"
          | "free_text"
          | "meter_entry"
          | "number"
          | "pass_fail"
          | "photo"
          | "section"
          | "signature"
          | "video";
        /** A search term. */
        search?: string;
        /**
         * * `NEEDS_ACTION` - Needs Action
         * * `OPEN_ISSUE` - Open Issue
         * * `ACKNOWLEDGED` - Acknowledged
         * * `RESOLVED` - Resolved
         */
        status?: "ACKNOWLEDGED" | "NEEDS_ACTION" | "OPEN_ISSUE" | "RESOLVED";
        /** @format uuid */
        submission?: string;
        text_value?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInspectionFailedResultListList, any>({
        path: `/api/v1/inspections/failed-items/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to acknowledge an inspection item.
     *
     * @tags Inspection Items
     * @name V1InspectionsFailedItemsAcknowledgeCreate
     * @request POST:/api/v1/inspections/failed-items/{id}/acknowledge/
     * @secure
     */
    v1InspectionsFailedItemsAcknowledgeCreate: (
      id: string,
      data: InspectionResultAcknowledgeRequest,
      params: RequestParams = {},
    ) =>
      this.request<InspectionResultAcknowledge, any>({
        path: `/api/v1/inspections/failed-items/${id}/acknowledge/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to list inspection forms
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsList
     * @request GET:/api/v1/inspections/forms/
     * @secure
     */
    v1InspectionsFormsList: (
      query?: {
        color?: string;
        description?: string;
        enable_location_exception_tracking?: boolean;
        /** Is Archived */
        is_archived?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        prevent_use_of_stored_photos?: boolean;
        /** A search term. */
        search?: string;
        title?: string;
        /** @format uuid */
        vehicle?: string;
        /** @format uuid */
        vehicle_group?: string;
        /** @format uuid */
        vehicle_type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInspectionFormReadList, any>({
        path: `/api/v1/inspections/forms/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to list inspection form items
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsItemsList
     * @request GET:/api/v1/inspections/forms/{form_id}/items/
     * @secure
     */
    v1InspectionsFormsItemsList: (
      formId: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInspectionReadItemList, any>({
        path: `/api/v1/inspections/forms/${formId}/items/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to retrieve inspection forms
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsRetrieve
     * @request GET:/api/v1/inspections/forms/{id}/
     * @secure
     */
    v1InspectionsFormsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<InspectionFormDetailsRead, any>({
        path: `/api/v1/inspections/forms/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to archive an inspection form.
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsArchiveCreate
     * @request POST:/api/v1/inspections/forms/{id}/archive/
     * @secure
     */
    v1InspectionsFormsArchiveCreate: (
      id: string,
      data: InspectionFormReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<InspectionFormRead, any>({
        path: `/api/v1/inspections/forms/${id}/archive/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to archive an inspection form.
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsArchiveUpdate
     * @request PUT:/api/v1/inspections/forms/{id}/archive/
     * @secure
     */
    v1InspectionsFormsArchiveUpdate: (
      id: string,
      data: InspectionFormReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<InspectionFormRead, any>({
        path: `/api/v1/inspections/forms/${id}/archive/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to archive an inspection form.
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsArchivePartialUpdate
     * @request PATCH:/api/v1/inspections/forms/{id}/archive/
     * @secure
     */
    v1InspectionsFormsArchivePartialUpdate: (
      id: string,
      data: PatchedInspectionFormReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<InspectionFormRead, any>({
        path: `/api/v1/inspections/forms/${id}/archive/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inspection Forms Items
     * @name V1InspectionsFormsItemsCreate
     * @request POST:/api/v1/inspections/forms/{id}/items/
     * @secure
     */
    v1InspectionsFormsItemsCreate: (
      id: string,
      data: DynamicInspectionItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/inspections/forms/${id}/items/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inspection Forms Items
     * @name V1InspectionsFormsItemsPartialUpdate
     * @request PATCH:/api/v1/inspections/forms/{id}/items/
     * @secure
     */
    v1InspectionsFormsItemsPartialUpdate: (
      id: string,
      data: PatchedDynamicInspectionItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/inspections/forms/${id}/items/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inspection Form Rules
     * @name V1InspectionsFormsLinkedVehiclesList2
     * @request GET:/api/v1/inspections/forms/{id}/linked-vehicles/
     * @secure
     */
    v1InspectionsFormsLinkedVehiclesList2: (
      id: string,
      query?: {
        /**
         * * `upcoming` - Upcoming
         * * `due_soon` - Due Soon
         * * `overdue` - Overdue
         * * `completed` - Completed
         */
        current_status?: "completed" | "due_soon" | "overdue" | "upcoming";
        /**
         * Frequency of inspections for this vehicle.
         *
         * * `daily` - Daily
         * * `weekly` - Weekly
         * * `monthly` - Monthly
         * * `yearly` - Yearly
         */
        frequency?: "daily" | "monthly" | "weekly" | "yearly" | null;
        is_enabled?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format uuid */
        vehicle?: string;
        /** @format uuid */
        vehicle__group?: string;
        /** @format uuid */
        vehicle__type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInspectionFormLinkedVehiclesListByFormList, any>({
        path: `/api/v1/inspections/forms/${id}/linked-vehicles/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inspection Form Rules
     * @name V1InspectionsFormsRulesList
     * @request GET:/api/v1/inspections/forms/{id}/rules/
     * @secure
     */
    v1InspectionsFormsRulesList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInspectionFormRuleListList, any>({
        path: `/api/v1/inspections/forms/${id}/rules/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to unarchive an inspection form.
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsUnarchiveCreate
     * @request POST:/api/v1/inspections/forms/{id}/unarchive/
     * @secure
     */
    v1InspectionsFormsUnarchiveCreate: (
      id: string,
      data: InspectionFormReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<InspectionFormRead, any>({
        path: `/api/v1/inspections/forms/${id}/unarchive/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to unarchive an inspection form.
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsUnarchiveUpdate
     * @request PUT:/api/v1/inspections/forms/{id}/unarchive/
     * @secure
     */
    v1InspectionsFormsUnarchiveUpdate: (
      id: string,
      data: InspectionFormReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<InspectionFormRead, any>({
        path: `/api/v1/inspections/forms/${id}/unarchive/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to unarchive an inspection form.
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsUnarchivePartialUpdate
     * @request PATCH:/api/v1/inspections/forms/{id}/unarchive/
     * @secure
     */
    v1InspectionsFormsUnarchivePartialUpdate: (
      id: string,
      data: PatchedInspectionFormReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<InspectionFormRead, any>({
        path: `/api/v1/inspections/forms/${id}/unarchive/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to create inspection forms
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsCreateCreate
     * @request POST:/api/v1/inspections/forms/create/
     * @secure
     */
    v1InspectionsFormsCreateCreate: (
      data: InspectionFormWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<InspectionFormWrite, any>({
        path: `/api/v1/inspections/forms/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to delete inspection forms
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsDeleteDestroy
     * @request DELETE:/api/v1/inspections/forms/delete/{id}/
     * @secure
     */
    v1InspectionsFormsDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/inspections/forms/delete/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inspection Form Rules
     * @name V1InspectionsFormsLinkedVehiclesList
     * @request GET:/api/v1/inspections/forms/linked-vehicles/
     * @secure
     */
    v1InspectionsFormsLinkedVehiclesList: (
      query?: {
        /**
         * * `upcoming` - Upcoming
         * * `due_soon` - Due Soon
         * * `overdue` - Overdue
         * * `completed` - Completed
         */
        current_status?: "completed" | "due_soon" | "overdue" | "upcoming";
        /**
         * Frequency of inspections for this vehicle.
         *
         * * `daily` - Daily
         * * `weekly` - Weekly
         * * `monthly` - Monthly
         * * `yearly` - Yearly
         */
        frequency?: "daily" | "monthly" | "weekly" | "yearly" | null;
        /** @format uuid */
        inspection_form?: string;
        is_enabled?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format uuid */
        vehicle?: string;
        /** @format uuid */
        vehicle__group?: string;
        /** @format uuid */
        vehicle__type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInspectionFormLinkedVehiclesListList, any>({
        path: `/api/v1/inspections/forms/linked-vehicles/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inspection Form Rules
     * @name V1InspectionsFormsLinkedVehiclesDeleteDestroy
     * @request DELETE:/api/v1/inspections/forms/linked-vehicles/{id}/delete/
     * @secure
     */
    v1InspectionsFormsLinkedVehiclesDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/inspections/forms/linked-vehicles/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description API View to update inspection forms
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsUpdateUpdate
     * @request PUT:/api/v1/inspections/forms/update/{id}/
     * @secure
     */
    v1InspectionsFormsUpdateUpdate: (
      id: string,
      data: InspectionFormWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<InspectionFormWrite, any>({
        path: `/api/v1/inspections/forms/update/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API View to update inspection forms
     *
     * @tags Inspection Forms
     * @name V1InspectionsFormsUpdatePartialUpdate
     * @request PATCH:/api/v1/inspections/forms/update/{id}/
     * @secure
     */
    v1InspectionsFormsUpdatePartialUpdate: (
      id: string,
      data: PatchedInspectionFormWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<InspectionFormWrite, any>({
        path: `/api/v1/inspections/forms/update/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inspection Form Rules
     * @name V1InspectionsRulesDeleteDestroy
     * @request DELETE:/api/v1/inspections/rules/{id}/delete/
     * @secure
     */
    v1InspectionsRulesDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/inspections/rules/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Inspection Form Rules
     * @name V1InspectionsRulesCreateCreate
     * @request POST:/api/v1/inspections/rules/create/
     * @secure
     */
    v1InspectionsRulesCreateCreate: (
      data: InspectionFormRuleCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<InspectionFormRuleCreate, any>({
        path: `/api/v1/inspections/rules/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API view to handle the creation of inspection submissions and their related results. Uses the `InspectionSubmissionSerializer` to validate and save data for an inspection submission along with nested results in a single transaction.
     *
     * @tags v1
     * @name V1InspectionsSubmitInspectionCreate
     * @request POST:/api/v1/inspections/submit-inspection/
     * @secure
     */
    v1InspectionsSubmitInspectionCreate: (
      data: InspectionSubmissionRequest,
      params: RequestParams = {},
    ) =>
      this.request<InspectionSubmission, any>({
        path: `/api/v1/inspections/submit-inspection/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of integration accounts
     *
     * @tags Integrations Accounts
     * @name V1IntegrationsAccountsList
     * @summary List integration accounts
     * @request GET:/api/v1/integrations/accounts/
     * @secure
     */
    v1IntegrationsAccountsList: (
      query?: {
        external_id?: string;
        /** Number of results to return per page. */
        limit?: number;
        name?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        provider_code?: string;
        /** @format uuid */
        provider_id?: string;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedReadIntegrationAccountList, any>({
        path: `/api/v1/integrations/accounts/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a paginated list of drivers from telematics provider.
     *
     * @tags Integrations Accounts [Telematics]
     * @name V1IntegrationsAccountsDriversRetrieve
     * @summary List Telematics Provider Drivers
     * @request GET:/api/v1/integrations/accounts/{account_id}/drivers/
     * @secure
     */
    v1IntegrationsAccountsDriversRetrieve: (
      accountId: string,
      query?: {
        /** Default is 10 */
        limit?: number;
        /** Default is 0 */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, Record<string, any>>({
        path: `/api/v1/integrations/accounts/${accountId}/drivers/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Synchronize fault codes from telematics provider for all vehicles in the integration account
     *
     * @tags Integrations Accounts [Telematics]
     * @name V1IntegrationsAccountsFaultsSyncCreate
     * @summary Sync Fault Codes
     * @request POST:/api/v1/integrations/accounts/{account_id}/faults/sync/
     * @secure
     */
    v1IntegrationsAccountsFaultsSyncCreate: (
      accountId: string,
      data: FaultSyncRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, Record<string, any>>({
        path: `/api/v1/integrations/accounts/${accountId}/faults/sync/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Import odometer statistics from telematics provider for all vehicles in the integration account
     *
     * @tags Integrations Accounts [Telematics]
     * @name V1IntegrationsAccountsOdometerImportCreate
     * @summary Import Odometer Statistics
     * @request POST:/api/v1/integrations/accounts/{account_id}/odometer/import/
     * @secure
     */
    v1IntegrationsAccountsOdometerImportCreate: (
      accountId: string,
      data: OdometerImportRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, Record<string, any>>({
        path: `/api/v1/integrations/accounts/${accountId}/odometer/import/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get a paginated list of vehicles from telematics provider.
     *
     * @tags Integrations Accounts [Telematics]
     * @name V1IntegrationsAccountsVehiclesRetrieve
     * @summary List Telematics Provider Vehicles
     * @request GET:/api/v1/integrations/accounts/{account_id}/vehicles/
     * @secure
     */
    v1IntegrationsAccountsVehiclesRetrieve: (
      accountId: string,
      query?: {
        /** Default is 10 */
        limit?: number;
        /** Default is 0 */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, Record<string, any>>({
        path: `/api/v1/integrations/accounts/${accountId}/vehicles/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns an integration account with the specified ID
     *
     * @tags Integrations Accounts
     * @name V1IntegrationsAccountsRetrieve
     * @summary Retrieve an integration account
     * @request GET:/api/v1/integrations/accounts/{id}/
     * @secure
     */
    v1IntegrationsAccountsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<ReadDetailedIntegrationAccount, any>({
        path: `/api/v1/integrations/accounts/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new integration account with the specified provider and credentials
     *
     * @tags Integrations Accounts
     * @name V1IntegrationsAccountsCreateCreate
     * @summary Create a new integration account
     * @request POST:/api/v1/integrations/accounts/create/
     * @secure
     */
    v1IntegrationsAccountsCreateCreate: (
      data: CreateIntegrationAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReadIntegrationAccount, any>({
        path: `/api/v1/integrations/accounts/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an integration account and its associated data based on provided flags. Different providers support different deletion flags. The deletion process is atomic - either all specified data is deleted or none is.
     *
     * @tags Integrations Accounts
     * @name V1IntegrationsAccountsDeleteCreate
     * @summary Delete an integration account
     * @request POST:/api/v1/integrations/accounts/delete/
     * @secure
     */
    v1IntegrationsAccountsDeleteCreate: (
      data: DeletionAccountRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, Record<string, any>>({
        path: `/api/v1/integrations/accounts/delete/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of integration accounts grouped by provider
     *
     * @tags Integrations Accounts
     * @name V1IntegrationsAccountsGroupedByProviderList
     * @summary List integration accounts grouped by provider
     * @request GET:/api/v1/integrations/accounts/grouped-by-provider/
     * @secure
     */
    v1IntegrationsAccountsGroupedByProviderList: (
      query?: {
        account_name?: string;
        active_accounts_count_max?: number;
        active_accounts_count_min?: number;
        code?: string;
        /**
         * Business domain this integration operates in
         *
         * * `telematics` - Telematics
         * * `fuel` - Fuel
         * * `maintenance` - Maintenance
         * * `accounting` - Accounting
         */
        domain?: "accounting" | "fuel" | "maintenance" | "telematics";
        /** Number of results to return per page. */
        limit?: number;
        name__icontains?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedReadAccountsGroupedByProviderList, any>({
        path: `/api/v1/integrations/accounts/grouped-by-provider/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns data directly from the provider's system using the specified credentials, without requiring an account in our system
     *
     * @tags Integrations Accounts
     * @name V1IntegrationsAccountsPreviewCreate
     * @summary Preview provider data directly
     * @request POST:/api/v1/integrations/accounts/preview/
     * @secure
     */
    v1IntegrationsAccountsPreviewCreate: (
      data: PreviewProviderDataRequest,
      params: RequestParams = {},
    ) =>
      this.request<UnifiedOrganizationData, any>({
        path: `/api/v1/integrations/accounts/preview/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle POST request for saving drivers.
     *
     * @tags Integrations Accounts [Telematics]
     * @name V1IntegrationsAccountsSaveDriversCreate
     * @summary Save Telematics Provider Vehicles
     * @request POST:/api/v1/integrations/accounts/save-drivers/
     * @secure
     */
    v1IntegrationsAccountsSaveDriversCreate: (
      data: SaveIntegrationAccountDriversRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/integrations/accounts/save-drivers/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Handle POST request for saving vehicles.
     *
     * @tags Integrations Accounts [Telematics]
     * @name V1IntegrationsAccountsSaveVehiclesCreate
     * @summary Save Telematics Provider Vehicles
     * @request POST:/api/v1/integrations/accounts/save-vehicles/
     * @secure
     */
    v1IntegrationsAccountsSaveVehiclesCreate: (
      data: SaveIntegrationAccountVehiclesRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/integrations/accounts/save-vehicles/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Check the status of an asynchronous fault sync task
     *
     * @tags Integrations Accounts [Telematics]
     * @name V1IntegrationsFaultsSyncStatusRetrieve
     * @summary Check Fault Sync Task Status
     * @request GET:/api/v1/integrations/faults/sync/status/{task_id}/
     * @secure
     */
    v1IntegrationsFaultsSyncStatusRetrieve: (
      taskId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, Record<string, any>>({
        path: `/api/v1/integrations/faults/sync/status/${taskId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Check the status of an asynchronous odometer import task
     *
     * @tags Integrations Accounts [Telematics]
     * @name V1IntegrationsOdometerImportStatusRetrieve
     * @summary Check Odometer Import Task Status
     * @request GET:/api/v1/integrations/odometer/import/status/{task_id}/
     * @secure
     */
    v1IntegrationsOdometerImportStatusRetrieve: (
      taskId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, Record<string, any>>({
        path: `/api/v1/integrations/odometer/import/status/${taskId}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of all available integration providers
     *
     * @tags Integrations Providers
     * @name V1IntegrationsProvidersList
     * @summary Get all available integration providers
     * @request GET:/api/v1/integrations/providers/
     * @secure
     */
    v1IntegrationsProvidersList: (
      query?: {
        /**
         * Authentication method required by the provider
         *
         * * `token` - Token
         * * `oauth2` - OAuth2
         * * `basic_auth` - Basic Auth
         * * `api_key` - API Key
         */
        auth_type?: "api_key" | "basic_auth" | "oauth2" | "token";
        code?: string;
        connected?: boolean;
        /**
         * Business domain this integration operates in
         *
         * * `telematics` - Telematics
         * * `fuel` - Fuel
         * * `maintenance` - Maintenance
         * * `accounting` - Accounting
         */
        domain?: "accounting" | "fuel" | "maintenance" | "telematics";
        /** Number of results to return per page. */
        limit?: number;
        name?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedReadIntegrationProviderList, any>({
        path: `/api/v1/integrations/providers/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts Locations
     * @name V1InventoryLocationList
     * @request GET:/api/v1/inventory/location/
     * @secure
     */
    v1InventoryLocationList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedLocationRetrieveList, any>({
        path: `/api/v1/inventory/location/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts Locations
     * @name V1InventoryLocationDeleteDestroy
     * @request DELETE:/api/v1/inventory/location/{id}/delete/
     * @secure
     */
    v1InventoryLocationDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<LocationRetrieve, any>({
        path: `/api/v1/inventory/location/${id}/delete/`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts Locations
     * @name V1InventoryLocationUpdateUpdate
     * @request PUT:/api/v1/inventory/location/{id}/update/
     * @secure
     */
    v1InventoryLocationUpdateUpdate: (
      id: string,
      data: LocationRetrieveRequest,
      params: RequestParams = {},
    ) =>
      this.request<LocationRetrieve, any>({
        path: `/api/v1/inventory/location/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts Locations
     * @name V1InventoryLocationUpdatePartialUpdate
     * @request PATCH:/api/v1/inventory/location/{id}/update/
     * @secure
     */
    v1InventoryLocationUpdatePartialUpdate: (
      id: string,
      data: PatchedLocationRetrieveRequest,
      params: RequestParams = {},
    ) =>
      this.request<LocationRetrieve, any>({
        path: `/api/v1/inventory/location/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts Locations
     * @name V1InventoryLocationCreateCreate
     * @request POST:/api/v1/inventory/location/create/
     * @secure
     */
    v1InventoryLocationCreateCreate: (
      data: LocationRetrieveRequest,
      params: RequestParams = {},
    ) =>
      this.request<LocationRetrieve, any>({
        path: `/api/v1/inventory/location/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsList
     * @request GET:/api/v1/inventory/parts/
     * @secure
     */
    v1InventoryPartsList: (
      query?: {
        /** @format uuid */
        category?: string;
        description__icontains?: string;
        in_stock?: boolean;
        is_archived?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        low_in_stock?: boolean;
        /** @format uuid */
        manufacturer?: string;
        manufacturer_part_number?: string;
        manufacturer_part_number__icontains?: string;
        /** @format uuid */
        measurement_unit?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        out_of_stock?: boolean;
        part_number?: string;
        part_number__icontains?: string;
        /** A search term. */
        search?: string;
        unit_cost?: number;
        unit_cost__gte?: number;
        unit_cost__lte?: number;
        upc?: string;
        upc__icontains?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPartListList, any>({
        path: `/api/v1/inventory/parts/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsMetaDataRetrieve2
     * @request GET:/api/v1/inventory/parts/{location_id}/meta_data/
     * @secure
     */
    v1InventoryPartsMetaDataRetrieve2: (
      locationId: string,
      params: RequestParams = {},
    ) =>
      this.request<PartsMetaData, any>({
        path: `/api/v1/inventory/parts/${locationId}/meta_data/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsPartsLocationList
     * @request GET:/api/v1/inventory/parts/{location_id}/parts_location/
     * @secure
     */
    v1InventoryPartsPartsLocationList: (
      locationId: string,
      query?: {
        /** @format uuid */
        category?: string;
        description__icontains?: string;
        in_stock?: boolean;
        is_archived?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        low_in_stock?: boolean;
        /** @format uuid */
        manufacturer?: string;
        manufacturer_part_number?: string;
        manufacturer_part_number__icontains?: string;
        /** @format uuid */
        measurement_unit?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        out_of_stock?: boolean;
        part_number?: string;
        part_number__icontains?: string;
        /** A search term. */
        search?: string;
        unit_cost?: number;
        unit_cost__gte?: number;
        unit_cost__lte?: number;
        upc?: string;
        upc__icontains?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPartListList, any>({
        path: `/api/v1/inventory/parts/${locationId}/parts_location/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsAdjustPartLocationCreate
     * @request POST:/api/v1/inventory/parts/{part_id}/adjust_part_location/{id}/
     * @secure
     */
    v1InventoryPartsAdjustPartLocationCreate: (
      id: string,
      partId: string,
      data: PartLocationAdjustRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartLocationAdjust, any>({
        path: `/api/v1/inventory/parts/${partId}/adjust_part_location/${id}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsEditPartLocationUpdate
     * @request PUT:/api/v1/inventory/parts/{part_id}/edit_part_location/{id}/
     * @secure
     */
    v1InventoryPartsEditPartLocationUpdate: (
      id: string,
      partId: string,
      data: PartLocationInventoryEditRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartLocationRetrieve, any>({
        path: `/api/v1/inventory/parts/${partId}/edit_part_location/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsEditPartLocationPartialUpdate
     * @request PATCH:/api/v1/inventory/parts/{part_id}/edit_part_location/{id}/
     * @secure
     */
    v1InventoryPartsEditPartLocationPartialUpdate: (
      id: string,
      partId: string,
      data: PatchedPartLocationInventoryEditRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartLocationRetrieve, any>({
        path: `/api/v1/inventory/parts/${partId}/edit_part_location/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsRetrieve
     * @request GET:/api/v1/inventory/parts/{id}/
     * @secure
     */
    v1InventoryPartsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<PartRetrieve, any>({
        path: `/api/v1/inventory/parts/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsAdjustmentsList
     * @request GET:/api/v1/inventory/parts/{id}/adjustments/
     * @secure
     */
    v1InventoryPartsAdjustmentsList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAdjustmentListList, any>({
        path: `/api/v1/inventory/parts/${id}/adjustments/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsAdjustmentsCreateCreate
     * @request POST:/api/v1/inventory/parts/{id}/adjustments/create/
     * @secure
     */
    v1InventoryPartsAdjustmentsCreateCreate: (
      id: string,
      data: AdjustmentCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<AdjustmentCreate, any>({
        path: `/api/v1/inventory/parts/${id}/adjustments/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsArchiveCreate
     * @request POST:/api/v1/inventory/parts/{id}/archive/
     * @secure
     */
    v1InventoryPartsArchiveCreate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/inventory/parts/${id}/archive/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1InventoryPartsBulkAddDocumentsCreate
     * @request POST:/api/v1/inventory/parts/{id}/bulk-add-documents/
     * @secure
     */
    v1InventoryPartsBulkAddDocumentsCreate: (
      id: string,
      data: UploadFilesPartRequest,
      params: RequestParams = {},
    ) =>
      this.request<UploadFilesPart, any>({
        path: `/api/v1/inventory/parts/${id}/bulk-add-documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1InventoryPartsBulkRemoveDocumentsCreate
     * @request POST:/api/v1/inventory/parts/{id}/bulk-remove-documents/
     * @secure
     */
    v1InventoryPartsBulkRemoveDocumentsCreate: (
      id: string,
      data: UploadFilesPartRequest,
      params: RequestParams = {},
    ) =>
      this.request<UploadFilesPart, any>({
        path: `/api/v1/inventory/parts/${id}/bulk-remove-documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1InventoryPartsCommentsDeleteDestroy
     * @request DELETE:/api/v1/inventory/parts/{id}/comments/delete/
     * @secure
     */
    v1InventoryPartsCommentsDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/inventory/parts/${id}/comments/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsDeleteDestroy
     * @request DELETE:/api/v1/inventory/parts/{id}/delete/
     * @secure
     */
    v1InventoryPartsDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/inventory/parts/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsLocationsList
     * @request GET:/api/v1/inventory/parts/{id}/locations/{part_location_id}/
     * @secure
     */
    v1InventoryPartsLocationsList: (
      id: string,
      partLocationId: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedLocationRetrieveList, any>({
        path: `/api/v1/inventory/parts/${id}/locations/${partLocationId}/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsPurchaseHistoryList
     * @request GET:/api/v1/inventory/parts/{id}/purchase-history/
     * @secure
     */
    v1InventoryPartsPurchaseHistoryList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPartPurchaseHistoryList, any>({
        path: `/api/v1/inventory/parts/${id}/purchase-history/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1InventoryPartsPurchaseVendorCreate
     * @request POST:/api/v1/inventory/parts/{id}/purchase_vendor/
     * @secure
     */
    v1InventoryPartsPurchaseVendorCreate: (
      id: string,
      data: PartAddPurchaseHistoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartAddPurchaseHistory, any>({
        path: `/api/v1/inventory/parts/${id}/purchase_vendor/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsTransferCreate
     * @request POST:/api/v1/inventory/parts/{id}/transfer/{part_location_id}/
     * @secure
     */
    v1InventoryPartsTransferCreate: (
      id: string,
      partLocationId: string,
      data: TransferPartQuantityRequest,
      params: RequestParams = {},
    ) =>
      this.request<TransferPartQuantity, any>({
        path: `/api/v1/inventory/parts/${id}/transfer/${partLocationId}/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsUnarchiveCreate
     * @request POST:/api/v1/inventory/parts/{id}/unarchive/
     * @secure
     */
    v1InventoryPartsUnarchiveCreate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/inventory/parts/${id}/unarchive/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsUpdateUpdate
     * @request PUT:/api/v1/inventory/parts/{id}/update/
     * @secure
     */
    v1InventoryPartsUpdateUpdate: (
      id: string,
      data: PartUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartRetrieve, any>({
        path: `/api/v1/inventory/parts/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsUpdatePartialUpdate
     * @request PATCH:/api/v1/inventory/parts/{id}/update/
     * @secure
     */
    v1InventoryPartsUpdatePartialUpdate: (
      id: string,
      data: PatchedPartUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartRetrieve, any>({
        path: `/api/v1/inventory/parts/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsWorkOrderActivityList
     * @request GET:/api/v1/inventory/parts/{id}/work-order-activity/
     * @secure
     */
    v1InventoryPartsWorkOrderActivityList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedWorkOrderActivityByPartList, any>({
        path: `/api/v1/inventory/parts/${id}/work-order-activity/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsAdjustmentReasonsList
     * @request GET:/api/v1/inventory/parts/adjustment_reasons/
     * @secure
     */
    v1InventoryPartsAdjustmentReasonsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAdjustmentReasonListList, any>({
        path: `/api/v1/inventory/parts/adjustment_reasons/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsArchivedList
     * @request GET:/api/v1/inventory/parts/archived/
     * @secure
     */
    v1InventoryPartsArchivedList: (
      query?: {
        /** @format uuid */
        category?: string;
        description__icontains?: string;
        in_stock?: boolean;
        is_archived?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        low_in_stock?: boolean;
        /** @format uuid */
        manufacturer?: string;
        manufacturer_part_number?: string;
        manufacturer_part_number__icontains?: string;
        /** @format uuid */
        measurement_unit?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        out_of_stock?: boolean;
        part_number?: string;
        part_number__icontains?: string;
        /** A search term. */
        search?: string;
        unit_cost?: number;
        unit_cost__gte?: number;
        unit_cost__lte?: number;
        upc?: string;
        upc__icontains?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPartListList, any>({
        path: `/api/v1/inventory/parts/archived/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsCategoriesList
     * @request GET:/api/v1/inventory/parts/categories/
     * @secure
     */
    v1InventoryPartsCategoriesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPartCategoryList, any>({
        path: `/api/v1/inventory/parts/categories/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsCategoriesRetrieve
     * @request GET:/api/v1/inventory/parts/categories/{id}/
     * @secure
     */
    v1InventoryPartsCategoriesRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PartCategory, any>({
        path: `/api/v1/inventory/parts/categories/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsCategoriesDeleteDestroy
     * @request DELETE:/api/v1/inventory/parts/categories/{id}/delete/
     * @secure
     */
    v1InventoryPartsCategoriesDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/inventory/parts/categories/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsCategoriesUpdateUpdate
     * @request PUT:/api/v1/inventory/parts/categories/{id}/update/
     * @secure
     */
    v1InventoryPartsCategoriesUpdateUpdate: (
      id: string,
      data: PartCategoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartCategory, any>({
        path: `/api/v1/inventory/parts/categories/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsCategoriesUpdatePartialUpdate
     * @request PATCH:/api/v1/inventory/parts/categories/{id}/update/
     * @secure
     */
    v1InventoryPartsCategoriesUpdatePartialUpdate: (
      id: string,
      data: PatchedPartCategoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartCategory, any>({
        path: `/api/v1/inventory/parts/categories/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsCategoriesCreateCreate
     * @request POST:/api/v1/inventory/parts/categories/create/
     * @secure
     */
    v1InventoryPartsCategoriesCreateCreate: (
      data: PartCategoryRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartCategory, any>({
        path: `/api/v1/inventory/parts/categories/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1InventoryPartsCommentsCreateCreate
     * @request POST:/api/v1/inventory/parts/comments/create/
     * @secure
     */
    v1InventoryPartsCommentsCreateCreate: (
      data: CommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<Comment, any>({
        path: `/api/v1/inventory/parts/comments/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsCreateCreate
     * @request POST:/api/v1/inventory/parts/create/
     * @secure
     */
    v1InventoryPartsCreateCreate: (
      data: PartCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartRetrieve, any>({
        path: `/api/v1/inventory/parts/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsManufacturersList
     * @request GET:/api/v1/inventory/parts/manufacturers/
     * @secure
     */
    v1InventoryPartsManufacturersList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPartManufacturerList, any>({
        path: `/api/v1/inventory/parts/manufacturers/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsManufacturersDeleteDestroy
     * @request DELETE:/api/v1/inventory/parts/manufacturers/{id}/delete/
     * @secure
     */
    v1InventoryPartsManufacturersDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/inventory/parts/manufacturers/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsManufacturersUpdateUpdate
     * @request PUT:/api/v1/inventory/parts/manufacturers/{id}/update/
     * @secure
     */
    v1InventoryPartsManufacturersUpdateUpdate: (
      id: string,
      data: PartManufacturerRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartManufacturer, any>({
        path: `/api/v1/inventory/parts/manufacturers/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsManufacturersUpdatePartialUpdate
     * @request PATCH:/api/v1/inventory/parts/manufacturers/{id}/update/
     * @secure
     */
    v1InventoryPartsManufacturersUpdatePartialUpdate: (
      id: string,
      data: PatchedPartManufacturerRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartManufacturer, any>({
        path: `/api/v1/inventory/parts/manufacturers/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsManufacturersCreateCreate
     * @request POST:/api/v1/inventory/parts/manufacturers/create/
     * @secure
     */
    v1InventoryPartsManufacturersCreateCreate: (
      data: PartManufacturerRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartManufacturer, any>({
        path: `/api/v1/inventory/parts/manufacturers/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsMeasurementUnitsList
     * @request GET:/api/v1/inventory/parts/measurement-units/
     * @secure
     */
    v1InventoryPartsMeasurementUnitsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedMeasurementUnitList, any>({
        path: `/api/v1/inventory/parts/measurement-units/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsMeasurementUnitsRetrieve
     * @request GET:/api/v1/inventory/parts/measurement-units/{id}/
     * @secure
     */
    v1InventoryPartsMeasurementUnitsRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<MeasurementUnit, any>({
        path: `/api/v1/inventory/parts/measurement-units/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsMeasurementUnitsDeleteDestroy
     * @request DELETE:/api/v1/inventory/parts/measurement-units/{id}/delete/
     * @secure
     */
    v1InventoryPartsMeasurementUnitsDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/inventory/parts/measurement-units/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsMeasurementUnitsUpdateUpdate
     * @request PUT:/api/v1/inventory/parts/measurement-units/{id}/update/
     * @secure
     */
    v1InventoryPartsMeasurementUnitsUpdateUpdate: (
      id: string,
      data: MeasurementUnitRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeasurementUnit, any>({
        path: `/api/v1/inventory/parts/measurement-units/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsMeasurementUnitsUpdatePartialUpdate
     * @request PATCH:/api/v1/inventory/parts/measurement-units/{id}/update/
     * @secure
     */
    v1InventoryPartsMeasurementUnitsUpdatePartialUpdate: (
      id: string,
      data: PatchedMeasurementUnitRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeasurementUnit, any>({
        path: `/api/v1/inventory/parts/measurement-units/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts-Depends
     * @name V1InventoryPartsMeasurementUnitsCreateCreate
     * @request POST:/api/v1/inventory/parts/measurement-units/create/
     * @secure
     */
    v1InventoryPartsMeasurementUnitsCreateCreate: (
      data: MeasurementUnitRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeasurementUnit, any>({
        path: `/api/v1/inventory/parts/measurement-units/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Parts
     * @name V1InventoryPartsMetaDataRetrieve
     * @request GET:/api/v1/inventory/parts/meta_data/
     * @secure
     */
    v1InventoryPartsMetaDataRetrieve: (params: RequestParams = {}) =>
      this.request<PartsMetaData, any>({
        path: `/api/v1/inventory/parts/meta_data/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order
     * @name V1InventoryPurchaseOrdersList
     * @request GET:/api/v1/inventory/purchase-orders/
     * @secure
     */
    v1InventoryPurchaseOrdersList: (
      query?: {
        /** @format date */
        approved_on__date?: string;
        /** @format date */
        closed_on__date?: string;
        /** @format uuid */
        created_by?: string;
        description__icontains?: string;
        discount?: number;
        discount__gte?: number;
        discount__lte?: number;
        /** Number of results to return per page. */
        limit?: number;
        /** @format uuid */
        location?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        /** @format uuid */
        part?: string;
        /** @format uuid */
        partially_received_by?: string;
        /** @format date */
        partially_received_on__date?: string;
        po_number?: number;
        /** @format date */
        purchased_on__date?: string;
        /** @format uuid */
        received_in_full_by?: string;
        /** @format date */
        received_in_full_on__date?: string;
        /** @format date */
        rejected_on__date?: string;
        /** A search term. */
        search?: string;
        shipping?: number;
        shipping__gte?: number;
        shipping__lte?: number;
        /**
         * * `draft` - Draft
         * * `pending_approval` - Pending Approval
         * * `rejected` - Rejected
         * * `approved` - Approved
         * * `purchased` - Purchased
         * * `partially_received` - Partially Received
         * * `received_in_full` - Received in Full
         * * `closed` - Closed
         */
        status?:
          | "approved"
          | "closed"
          | "draft"
          | "partially_received"
          | "pending_approval"
          | "purchased"
          | "received_in_full"
          | "rejected";
        sub_total?: number;
        sub_total__gte?: number;
        sub_total__lte?: number;
        tax?: number;
        tax__gte?: number;
        tax__lte?: number;
        total?: number;
        total__gte?: number;
        total__lte?: number;
        /** @format uuid */
        vendor?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPurchaseOrderListList, any>({
        path: `/api/v1/inventory/purchase-orders/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order
     * @name V1InventoryPurchaseOrdersRetrieve
     * @request GET:/api/v1/inventory/purchase-orders/{id}/
     * @secure
     */
    v1InventoryPurchaseOrdersRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PurchaseOrderRetrieve, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order Status
     * @name V1InventoryPurchaseOrdersApprovedCreate
     * @request POST:/api/v1/inventory/purchase-orders/{id}/approved/
     * @secure
     */
    v1InventoryPurchaseOrdersApprovedCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PurchaseOrderRetrieve, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/approved/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order Status
     * @name V1InventoryPurchaseOrdersClosedCreate
     * @request POST:/api/v1/inventory/purchase-orders/{id}/closed/
     * @secure
     */
    v1InventoryPurchaseOrdersClosedCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PurchaseOrderRetrieve, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/closed/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order
     * @name V1InventoryPurchaseOrdersDeleteDestroy
     * @request DELETE:/api/v1/inventory/purchase-orders/{id}/delete/
     * @secure
     */
    v1InventoryPurchaseOrdersDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order Files
     * @name V1InventoryPurchaseOrdersDocumentsList
     * @request GET:/api/v1/inventory/purchase-orders/{id}/documents/
     * @secure
     */
    v1InventoryPurchaseOrdersDocumentsList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFileList, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/documents/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order Status
     * @name V1InventoryPurchaseOrdersDraftCreate
     * @request POST:/api/v1/inventory/purchase-orders/{id}/draft/
     * @secure
     */
    v1InventoryPurchaseOrdersDraftCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PurchaseOrderRetrieve, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/draft/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order
     * @name V1InventoryPurchaseOrdersHistoryList
     * @request GET:/api/v1/inventory/purchase-orders/{id}/history/
     * @secure
     */
    v1InventoryPurchaseOrdersHistoryList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPurchaseOrderTimeLineList, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/history/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order Status
     * @name V1InventoryPurchaseOrdersPendingApprovalCreate
     * @request POST:/api/v1/inventory/purchase-orders/{id}/pending-approval/
     * @secure
     */
    v1InventoryPurchaseOrdersPendingApprovalCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PurchaseOrderRetrieve, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/pending-approval/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order Status
     * @name V1InventoryPurchaseOrdersPurchasedCreate
     * @request POST:/api/v1/inventory/purchase-orders/{id}/purchased/
     * @secure
     */
    v1InventoryPurchaseOrdersPurchasedCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PurchaseOrderRetrieve, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/purchased/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order Status
     * @name V1InventoryPurchaseOrdersReceiveCreate
     * @request POST:/api/v1/inventory/purchase-orders/{id}/receive/
     * @secure
     */
    v1InventoryPurchaseOrdersReceiveCreate: (
      id: string,
      data: ReceivePurchaseOrderRequest,
      params: RequestParams = {},
    ) =>
      this.request<PurchaseOrderRetrieve, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/receive/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order Status
     * @name V1InventoryPurchaseOrdersRejectedCreate
     * @request POST:/api/v1/inventory/purchase-orders/{id}/rejected/
     * @secure
     */
    v1InventoryPurchaseOrdersRejectedCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PurchaseOrderRetrieve, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/rejected/`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order Files
     * @name V1InventoryPurchaseOrdersRemoveDocumentsCreate
     * @request POST:/api/v1/inventory/purchase-orders/{id}/remove-documents/
     * @secure
     */
    v1InventoryPurchaseOrdersRemoveDocumentsCreate: (
      id: string,
      data: IdsRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/remove-documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order
     * @name V1InventoryPurchaseOrdersUpdateUpdate
     * @request PUT:/api/v1/inventory/purchase-orders/{id}/update/
     * @secure
     */
    v1InventoryPurchaseOrdersUpdateUpdate: (
      id: string,
      data: PurchaseOrderUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<PurchaseOrderUpdate, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order
     * @name V1InventoryPurchaseOrdersUpdatePartialUpdate
     * @request PATCH:/api/v1/inventory/purchase-orders/{id}/update/
     * @secure
     */
    v1InventoryPurchaseOrdersUpdatePartialUpdate: (
      id: string,
      data: PatchedPurchaseOrderUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<PurchaseOrderUpdate, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order Files
     * @name V1InventoryPurchaseOrdersUploadDocumentsCreate
     * @request POST:/api/v1/inventory/purchase-orders/{id}/upload-documents/
     * @secure
     */
    v1InventoryPurchaseOrdersUploadDocumentsCreate: (
      id: string,
      data: AppUploadDocumentsRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/inventory/purchase-orders/${id}/upload-documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Purchase Order
     * @name V1InventoryPurchaseOrdersCreateCreate
     * @request POST:/api/v1/inventory/purchase-orders/create/
     * @secure
     */
    v1InventoryPurchaseOrdersCreateCreate: (
      data: PurchaseOrderCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<PurchaseOrderCreate, any>({
        path: `/api/v1/inventory/purchase-orders/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues
     * @name V1IssuesList
     * @request GET:/api/v1/issues/
     * @secure
     */
    v1IssuesList: (
      query?: {
        assigned_to?: string[];
        /** @format date-time */
        due_date?: string;
        due_odometer?: number;
        /** @format uuid */
        fault?: string;
        labels?: string;
        /** Number of results to return per page. */
        limit?: number;
        major_functionality_impaired?: boolean;
        odometer?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        over_due?: boolean;
        /**
         * * `critical` - Critical
         * * `high` - High
         * * `medium` - Medium
         * * `low` - Low
         * * `no_priority` - No Priority
         */
        priority?: "critical" | "high" | "low" | "medium" | "no_priority";
        reference_code?: number;
        /** @format uuid */
        reported_by?: string;
        /** @format date-time */
        reported_date?: string;
        /** @format uuid */
        resolved_by?: string;
        /** @format date-time */
        resolved_date?: string;
        /** A search term. */
        search?: string;
        source?: string;
        /**
         * * `open` - Open
         * * `resolved` - Resolved
         * * `closed` - Closed
         * * `done` - Done
         * * `overdue` - Overdue
         */
        status?: "closed" | "done" | "open" | "overdue" | "resolved";
        /** @format time */
        time?: string;
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedIssueReadList, any>({
        path: `/api/v1/issues/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues
     * @name V1IssuesRetrieve
     * @request GET:/api/v1/issues/{id}/
     * @secure
     */
    v1IssuesRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<IssueRead, any>({
        path: `/api/v1/issues/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Files
     * @name V1IssuesBulkAddFilesCreate
     * @request POST:/api/v1/issues/{id}/bulk_add_files/
     * @secure
     */
    v1IssuesBulkAddFilesCreate: (
      id: string,
      data: FilesIssueRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/issues/${id}/bulk_add_files/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Files
     * @name V1IssuesBulkRemoveFilesCreate
     * @request POST:/api/v1/issues/{id}/bulk_remove_files/
     * @secure
     */
    v1IssuesBulkRemoveFilesCreate: (
      id: string,
      data: FilesIssueRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/issues/${id}/bulk_remove_files/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1IssuesCommentsDeleteDestroy
     * @request DELETE:/api/v1/issues/{id}/comments/delete/
     * @secure
     */
    v1IssuesCommentsDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/issues/${id}/comments/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues
     * @name V1IssuesDeleteDestroy
     * @request DELETE:/api/v1/issues/{id}/delete/
     * @secure
     */
    v1IssuesDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/issues/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Faults
     * @name V1IssuesFaultsRetrieve
     * @request GET:/api/v1/issues/{id}/faults/
     * @secure
     */
    v1IssuesFaultsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<FaultCodeList, any>({
        path: `/api/v1/issues/${id}/faults/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Files
     * @name V1IssuesFilesList
     * @request GET:/api/v1/issues/{id}/files/
     * @secure
     */
    v1IssuesFilesList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFileList, any>({
        path: `/api/v1/issues/${id}/files/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues
     * @name V1IssuesIssuesTimelineRetrieve
     * @request GET:/api/v1/issues/{id}/issues-timeline/
     * @secure
     */
    v1IssuesIssuesTimelineRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<IssueTimeline, any>({
        path: `/api/v1/issues/${id}/issues-timeline/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues
     * @name V1IssuesReopenCreate
     * @request POST:/api/v1/issues/{id}/reopen/
     * @secure
     */
    v1IssuesReopenCreate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/issues/${id}/reopen/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues
     * @name V1IssuesResolveWithNotesCreate
     * @request POST:/api/v1/issues/{id}/resolve_with_notes/
     * @secure
     */
    v1IssuesResolveWithNotesCreate: (
      id: string,
      data: IssueNoteRequest,
      params: RequestParams = {},
    ) =>
      this.request<IssueNote, any>({
        path: `/api/v1/issues/${id}/resolve_with_notes/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues
     * @name V1IssuesUpdateUpdate
     * @request PUT:/api/v1/issues/{id}/update/
     * @secure
     */
    v1IssuesUpdateUpdate: (
      id: string,
      data: IssueUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<IssueUpdate, any>({
        path: `/api/v1/issues/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues
     * @name V1IssuesUpdatePartialUpdate
     * @request PATCH:/api/v1/issues/{id}/update/
     * @secure
     */
    v1IssuesUpdatePartialUpdate: (
      id: string,
      data: PatchedIssueUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<IssueUpdate, any>({
        path: `/api/v1/issues/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1IssuesCommentsCreateCreate
     * @request POST:/api/v1/issues/comments/create/
     * @secure
     */
    v1IssuesCommentsCreateCreate: (
      data: IssueCommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<IssueComment, any>({
        path: `/api/v1/issues/comments/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues
     * @name V1IssuesCreateCreate
     * @request POST:/api/v1/issues/create/
     * @secure
     */
    v1IssuesCreateCreate: (data: IssueRequest, params: RequestParams = {}) =>
      this.request<Issue, any>({
        path: `/api/v1/issues/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Faults
     * @name V1IssuesFaultsList
     * @request GET:/api/v1/issues/faults/
     * @secure
     */
    v1IssuesFaultsList: (
      query?: {
        code?: number;
        description?: string;
        device?: number;
        fmi_id?: number;
        /** Number of results to return per page. */
        limit?: number;
        mil_status?: number;
        name?: string;
        occurrence_count?: number;
        occurrence_count_max?: number;
        occurrence_count_min?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * * `off` - Off
         * * `ignore` - Ignore
         * * `critical` - Critical
         */
        priority?: "critical" | "ignore" | "off";
        /** A search term. */
        search?: string;
        source_address_name?: string;
        /**
         * * `open` - Open
         * * `resolved` - Resolved
         * * `pending` - Pending
         * * `ignored` - Ignored
         */
        status?: "ignored" | "open" | "pending" | "resolved";
        tx_id?: number;
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFaultCodeListList, any>({
        path: `/api/v1/issues/faults/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Faults
     * @name V1IssuesFaultsIgnoreUpdate
     * @request PUT:/api/v1/issues/faults/{id}/ignore/
     * @secure
     */
    v1IssuesFaultsIgnoreUpdate: (
      id: string,
      data: FaultCodeListRequest,
      params: RequestParams = {},
    ) =>
      this.request<FaultCodeList, any>({
        path: `/api/v1/issues/faults/${id}/ignore/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Faults
     * @name V1IssuesFaultsIgnorePartialUpdate
     * @request PATCH:/api/v1/issues/faults/{id}/ignore/
     * @secure
     */
    v1IssuesFaultsIgnorePartialUpdate: (
      id: string,
      data: PatchedFaultCodeListRequest,
      params: RequestParams = {},
    ) =>
      this.request<FaultCodeList, any>({
        path: `/api/v1/issues/faults/${id}/ignore/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Faults
     * @name V1IssuesFaultsCodesList
     * @request GET:/api/v1/issues/faults_codes/
     * @secure
     */
    v1IssuesFaultsCodesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedIntFaultCodeList, any>({
        path: `/api/v1/issues/faults_codes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Faults
     * @name V1IssuesFaultsRulesList
     * @request GET:/api/v1/issues/faults_rules/
     * @secure
     */
    v1IssuesFaultsRulesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFaultRuleListList, any>({
        path: `/api/v1/issues/faults_rules/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Faults
     * @name V1IssuesFaultsRulesRetrieve
     * @request GET:/api/v1/issues/faults_rules/{id}/
     * @secure
     */
    v1IssuesFaultsRulesRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<FaultRuleRetrieve, any>({
        path: `/api/v1/issues/faults_rules/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Faults
     * @name V1IssuesFaultsRulesDeleteDestroy
     * @request DELETE:/api/v1/issues/faults_rules/{id}/delete/
     * @secure
     */
    v1IssuesFaultsRulesDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/issues/faults_rules/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Faults
     * @name V1IssuesFaultsRulesUpdateUpdate
     * @request PUT:/api/v1/issues/faults_rules/{id}/update/
     * @secure
     */
    v1IssuesFaultsRulesUpdateUpdate: (
      id: string,
      data: FaultRuleUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<FaultRuleUpdate, any>({
        path: `/api/v1/issues/faults_rules/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Faults
     * @name V1IssuesFaultsRulesUpdatePartialUpdate
     * @request PATCH:/api/v1/issues/faults_rules/{id}/update/
     * @secure
     */
    v1IssuesFaultsRulesUpdatePartialUpdate: (
      id: string,
      data: PatchedFaultRuleUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<FaultRuleUpdate, any>({
        path: `/api/v1/issues/faults_rules/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Issues-Faults
     * @name V1IssuesFaultsRulesCreateCreate
     * @request POST:/api/v1/issues/faults_rules/create/
     * @secure
     */
    v1IssuesFaultsRulesCreateCreate: (
      data: FaultRuleCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<FaultRuleCreate, any>({
        path: `/api/v1/issues/faults_rules/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description ListAPIView for listing TrainingVideo instances with filtering, searching, and pagination.
     *
     * @tags v1
     * @name V1MediaCenterTrainingVideosList
     * @request GET:/api/v1/media-center/training-videos/
     * @secure
     */
    v1MediaCenterTrainingVideosList: (
      query?: {
        is_published?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format uuid */
        section?: string;
        title?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTrainingVideoList, any>({
        path: `/api/v1/media-center/training-videos/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ListAPIView for listing TrainingVideo instances by section with filtering, searching, and pagination.
     *
     * @tags v1
     * @name V1MediaCenterTrainingVideosSectionsList
     * @request GET:/api/v1/media-center/training-videos/sections/
     * @secure
     */
    v1MediaCenterTrainingVideosSectionsList: (
      query?: {
        /** @format uuid */
        category?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVideoSectionList, any>({
        path: `/api/v1/media-center/training-videos/sections/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ListAPIView for listing SectionCategory instances with filtering, searching, and pagination.
     *
     * @tags v1
     * @name V1MediaCenterTrainingVideosSectionsCategoriesList
     * @request GET:/api/v1/media-center/training-videos/sections/categories/
     * @secure
     */
    v1MediaCenterTrainingVideosSectionsCategoriesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedSectionCategoryList, any>({
        path: `/api/v1/media-center/training-videos/sections/categories/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name V1NotificationsList
     * @request GET:/api/v1/notifications/
     * @secure
     */
    v1NotificationsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedNotificationList, any>({
        path: `/api/v1/notifications/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Hide a specific notification (soft delete)
     *
     * @tags Notifications
     * @name V1NotificationsHideCreate
     * @request POST:/api/v1/notifications/{notification_id}/hide/
     * @secure
     */
    v1NotificationsHideCreate: (
      notificationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/notifications/${notificationId}/hide/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name V1NotificationsMarkReadCreate
     * @request POST:/api/v1/notifications/{notification_id}/mark-read/
     * @secure
     */
    v1NotificationsMarkReadCreate: (
      notificationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/notifications/${notificationId}/mark-read/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Hide multiple notifications in bulk (soft delete)
     *
     * @tags Notifications
     * @name V1NotificationsBulkHideCreate
     * @request POST:/api/v1/notifications/bulk-hide/
     * @secure
     */
    v1NotificationsBulkHideCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/notifications/bulk-hide/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name V1NotificationsBulkMarkReadCreate
     * @request POST:/api/v1/notifications/bulk-mark-read/
     * @secure
     */
    v1NotificationsBulkMarkReadCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/notifications/bulk-mark-read/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name V1NotificationsChannelsTelegramChannelsList
     * @request GET:/api/v1/notifications/channels/telegram-channels/
     * @secure
     */
    v1NotificationsChannelsTelegramChannelsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTelegramChannelList, any>({
        path: `/api/v1/notifications/channels/telegram-channels/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Hide all notifications for the current user (soft delete)
     *
     * @tags Notifications
     * @name V1NotificationsHideAllCreate
     * @request POST:/api/v1/notifications/hide-all/
     * @secure
     */
    v1NotificationsHideAllCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/notifications/hide-all/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name V1NotificationsMarkAllReadCreate
     * @request POST:/api/v1/notifications/mark-all-read/
     * @secure
     */
    v1NotificationsMarkAllReadCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/notifications/mark-all-read/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Endpoint to update a user's device token. Expects JSON payload with 'device_id' and 'token'.
     *
     * @tags v1
     * @name V1NotificationsUpdateTokenCreate
     * @request POST:/api/v1/notifications/update-token/
     * @secure
     */
    v1NotificationsUpdateTokenCreate: (
      data: DeviceTokenRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeviceToken, any>({
        path: `/api/v1/notifications/update-token/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Contact-Renewal
     * @name V1RemindersContactRenewalList
     * @request GET:/api/v1/reminders/contact_renewal/
     * @secure
     */
    v1RemindersContactRenewalList: (
      query?: {
        /** @format uuid */
        contact?: string;
        /** @format date */
        due_date_after?: string;
        /** @format date */
        due_date_before?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * * `days` - Days
         * * `weeks` - Weeks
         * * `months` - Months
         * * `years` - Years
         */
        primary_meter_due_soon_threshold?:
          | "days"
          | "months"
          | "weeks"
          | "years";
        /** @format uuid */
        renewal_type?: string;
        /** A search term. */
        search?: string;
        /**
         * * `upcoming` - Upcoming
         * * `due_soon` - Due Soon
         * * `overdue` - Overdue
         */
        status?: "due_soon" | "overdue" | "upcoming";
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedContactRenewalListList, any>({
        path: `/api/v1/reminders/contact_renewal/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Contact-Renewal
     * @name V1RemindersContactRenewalRetrieve
     * @request GET:/api/v1/reminders/contact_renewal/{id}/
     * @secure
     */
    v1RemindersContactRenewalRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ContactRenewalRetrieve, any>({
        path: `/api/v1/reminders/contact_renewal/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Contact-Renewal
     * @name V1RemindersContactRenewalDeleteDestroy
     * @request DELETE:/api/v1/reminders/contact_renewal/{id}/delete/
     * @secure
     */
    v1RemindersContactRenewalDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/reminders/contact_renewal/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Contact-Renewal
     * @name V1RemindersContactRenewalUpdateUpdate
     * @request PUT:/api/v1/reminders/contact_renewal/{id}/update/
     * @secure
     */
    v1RemindersContactRenewalUpdateUpdate: (
      id: string,
      data: ContactRenewalUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContactRenewalUpdate, any>({
        path: `/api/v1/reminders/contact_renewal/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Contact-Renewal
     * @name V1RemindersContactRenewalUpdatePartialUpdate
     * @request PATCH:/api/v1/reminders/contact_renewal/{id}/update/
     * @secure
     */
    v1RemindersContactRenewalUpdatePartialUpdate: (
      id: string,
      data: PatchedContactRenewalUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContactRenewalUpdate, any>({
        path: `/api/v1/reminders/contact_renewal/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Contact-Renewal
     * @name V1RemindersContactRenewalCreateCreate
     * @request POST:/api/v1/reminders/contact_renewal/create/
     * @secure
     */
    v1RemindersContactRenewalCreateCreate: (
      data: ContactRenewalCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContactRenewalCreate, any>({
        path: `/api/v1/reminders/contact_renewal/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Contact-Renewal
     * @name V1RemindersContactRenewalDeleteMultipleCreate
     * @request POST:/api/v1/reminders/contact_renewal/delete-multiple/
     * @secure
     */
    v1RemindersContactRenewalDeleteMultipleCreate: (
      data: DeleteMultipleObjectsRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteMultipleObjects, any>({
        path: `/api/v1/reminders/contact_renewal/delete-multiple/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Contact-Renewal
     * @name V1RemindersContactRenewalTypeList
     * @request GET:/api/v1/reminders/contact_renewal_type/
     * @secure
     */
    v1RemindersContactRenewalTypeList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedContactRenewalTypeListList, any>({
        path: `/api/v1/reminders/contact_renewal_type/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Contact-Renewal
     * @name V1RemindersContactRenewalTypeCreateCreate
     * @request POST:/api/v1/reminders/contact_renewal_type/create/
     * @secure
     */
    v1RemindersContactRenewalTypeCreateCreate: (
      data: ContactRenewalTypeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContactRenewalTypeCreate, any>({
        path: `/api/v1/reminders/contact_renewal_type/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a platform-specific list of service reminders and statistics
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersList
     * @summary Get reminder list and statistics
     * @request GET:/api/v1/reminders/service_reminders/
     * @secure
     */
    v1RemindersServiceRemindersList: (
      query?: {
        /** @format date-time */
        archived_at_after?: string;
        /** @format date-time */
        archived_at_before?: string;
        /**
         * * `on_time` - On time
         * * `up_coming` - Upcoming
         * * `late` - Late
         */
        compliance_status?: ("late" | "on_time" | "up_coming")[];
        /** @format date-time */
        created_after?: string;
        /** @format date-time */
        created_before?: string;
        due_within_days?: number;
        has_history?: boolean;
        is_archived?: boolean;
        is_due_soon?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        manual_next_due?: boolean;
        /**
         * @format int64
         * @min 0
         * @max 9223372036854776000
         */
        meter_due_soon_threshold_max?: number | null;
        /**
         * @format int64
         * @min 0
         * @max 9223372036854776000
         */
        meter_due_soon_threshold_min?: number | null;
        /**
         * @min -2147483648
         * @max 2147483647
         */
        meter_interval_max?: number | null;
        /**
         * @min -2147483648
         * @max 2147483647
         */
        meter_interval_min?: number | null;
        /** @format date */
        next_due_date_after?: string;
        /** @format date */
        next_due_date_before?: string;
        /**
         * @min -2147483648
         * @max 2147483647
         */
        next_due_meter_max?: number | null;
        /**
         * @min -2147483648
         * @max 2147483647
         */
        next_due_meter_min?: number | null;
        notification_active?: boolean;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * Platform type (web/mobile)
         * @default "web"
         */
        platform?: string;
        /** @format uuid */
        recipient_group?: string;
        recipient_name?: string;
        /** A search term. */
        search?: string;
        /** @format uuid */
        service_task?: string;
        /** @format date-time */
        snoozed_until_after?: string;
        /** @format date-time */
        snoozed_until_before?: string;
        /**
         * * `Upcoming` - Upcoming
         * * `DueSoon` - Due Soon
         * * `Overdue` - Overdue
         * * `Snoozed` - Snoozed
         * * `Completed` - Completed
         */
        status?: (
          | "Completed"
          | "DueSoon"
          | "Overdue"
          | "Snoozed"
          | "Upcoming"
        )[];
        /**
         * @min -2147483648
         * @max 2147483647
         */
        time_due_soon_threshold_max?: number | null;
        /**
         * @min -2147483648
         * @max 2147483647
         */
        time_due_soon_threshold_min?: number | null;
        /**
         * @min -2147483648
         * @max 2147483647
         */
        time_interval_max?: number | null;
        /**
         * @min -2147483648
         * @max 2147483647
         */
        time_interval_min?: number | null;
        /**
         * * `Days` - Days
         * * `Weeks` - Weeks
         * * `Months` - Months
         * * `Years` - Years
         */
        time_interval_unit?: ("Days" | "Months" | "Weeks" | "Years")[];
        /** @format date-time */
        updated_after?: string;
        /** @format date-time */
        updated_before?: string;
        /** @format uuid */
        vehicle?: string;
        /** @format uuid */
        work_order?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedServiceReminderReadList, any>({
        path: `/api/v1/reminders/service_reminders/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API view to retrieve a specific service reminder.
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersRetrieve
     * @request GET:/api/v1/reminders/service_reminders/{id}/
     * @secure
     */
    v1RemindersServiceRemindersRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderDetail, any>({
        path: `/api/v1/reminders/service_reminders/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersArchiveUpdate
     * @request PUT:/api/v1/reminders/service_reminders/{id}/archive/
     * @secure
     */
    v1RemindersServiceRemindersArchiveUpdate: (
      id: string,
      data: ServiceReminderReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderRead, any>({
        path: `/api/v1/reminders/service_reminders/${id}/archive/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersArchivePartialUpdate
     * @request PATCH:/api/v1/reminders/service_reminders/{id}/archive/
     * @secure
     */
    v1RemindersServiceRemindersArchivePartialUpdate: (
      id: string,
      data: PatchedServiceReminderReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderRead, any>({
        path: `/api/v1/reminders/service_reminders/${id}/archive/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders Documents
     * @name V1RemindersServiceRemindersBulkAddDocumentsCreate
     * @request POST:/api/v1/reminders/service_reminders/{id}/bulk-add-documents/
     * @secure
     */
    v1RemindersServiceRemindersBulkAddDocumentsCreate: (
      id: string,
      data: ServiceReminderDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderDocument, any>({
        path: `/api/v1/reminders/service_reminders/${id}/bulk-add-documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders Documents
     * @name V1RemindersServiceRemindersBulkRemoveDocumentsCreate
     * @request POST:/api/v1/reminders/service_reminders/{id}/bulk-remove-documents/
     * @secure
     */
    v1RemindersServiceRemindersBulkRemoveDocumentsCreate: (
      id: string,
      data: ServiceReminderDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderDocument, any>({
        path: `/api/v1/reminders/service_reminders/${id}/bulk-remove-documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersDeleteDestroy
     * @request DELETE:/api/v1/reminders/service_reminders/{id}/delete/
     * @secure
     */
    v1RemindersServiceRemindersDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/reminders/service_reminders/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersResolveCreate
     * @request POST:/api/v1/reminders/service_reminders/{id}/resolve/
     * @secure
     */
    v1RemindersServiceRemindersResolveCreate: (
      id: string,
      data: ResolveServiceReminderRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderRead, any>({
        path: `/api/v1/reminders/service_reminders/${id}/resolve/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersRestartUpdate
     * @request PUT:/api/v1/reminders/service_reminders/{id}/restart/
     * @secure
     */
    v1RemindersServiceRemindersRestartUpdate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/reminders/service_reminders/${id}/restart/`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersRestartPartialUpdate
     * @request PATCH:/api/v1/reminders/service_reminders/{id}/restart/
     * @secure
     */
    v1RemindersServiceRemindersRestartPartialUpdate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/reminders/service_reminders/${id}/restart/`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders Statuses
     * @name V1RemindersServiceRemindersResumeCreate
     * @request POST:/api/v1/reminders/service_reminders/{id}/resume/
     * @secure
     */
    v1RemindersServiceRemindersResumeCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/reminders/service_reminders/${id}/resume/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders Statuses
     * @name V1RemindersServiceRemindersSnoozeCreate
     * @request POST:/api/v1/reminders/service_reminders/{id}/snooze/
     * @secure
     */
    v1RemindersServiceRemindersSnoozeCreate: (
      id: string,
      data: ServiceReminderSnoozeRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderSnooze, any>({
        path: `/api/v1/reminders/service_reminders/${id}/snooze/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersUnarchiveUpdate
     * @request PUT:/api/v1/reminders/service_reminders/{id}/unarchive/
     * @secure
     */
    v1RemindersServiceRemindersUnarchiveUpdate: (
      id: string,
      data: ServiceReminderReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderRead, any>({
        path: `/api/v1/reminders/service_reminders/${id}/unarchive/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersUnarchivePartialUpdate
     * @request PATCH:/api/v1/reminders/service_reminders/{id}/unarchive/
     * @secure
     */
    v1RemindersServiceRemindersUnarchivePartialUpdate: (
      id: string,
      data: PatchedServiceReminderReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderRead, any>({
        path: `/api/v1/reminders/service_reminders/${id}/unarchive/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersUpdateUpdate
     * @request PUT:/api/v1/reminders/service_reminders/{id}/update/
     * @secure
     */
    v1RemindersServiceRemindersUpdateUpdate: (
      id: string,
      data: UpdateServiceReminderRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateServiceReminder, any>({
        path: `/api/v1/reminders/service_reminders/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersUpdatePartialUpdate
     * @request PATCH:/api/v1/reminders/service_reminders/{id}/update/
     * @secure
     */
    v1RemindersServiceRemindersUpdatePartialUpdate: (
      id: string,
      data: PatchedUpdateServiceReminderRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateServiceReminder, any>({
        path: `/api/v1/reminders/service_reminders/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Archive the specified service reminders.
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersBulkArchiveCreate
     * @request POST:/api/v1/reminders/service_reminders/bulk-archive/
     * @secure
     */
    v1RemindersServiceRemindersBulkArchiveCreate: (
      data: BulkServiceReminderRequest,
      params: RequestParams = {},
    ) =>
      this.request<BulkServiceReminder, any>({
        path: `/api/v1/reminders/service_reminders/bulk-archive/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create multiple service reminders for the specified vehicles
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersBulkCreateCreate
     * @request POST:/api/v1/reminders/service_reminders/bulk-create/
     * @secure
     */
    v1RemindersServiceRemindersBulkCreateCreate: (
      data: ServiceReminderBulkCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderBulkCreateResponse, void>({
        path: `/api/v1/reminders/service_reminders/bulk-create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete the specified service reminders.
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersBulkDeleteCreate
     * @request POST:/api/v1/reminders/service_reminders/bulk-delete/
     * @secure
     */
    v1RemindersServiceRemindersBulkDeleteCreate: (
      data: BulkServiceReminderRequest,
      params: RequestParams = {},
    ) =>
      this.request<BulkServiceReminder, any>({
        path: `/api/v1/reminders/service_reminders/bulk-delete/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Unarchive the specified service reminders.
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersBulkUnarchiveCreate
     * @request POST:/api/v1/reminders/service_reminders/bulk-unarchive/
     * @secure
     */
    v1RemindersServiceRemindersBulkUnarchiveCreate: (
      data: BulkServiceReminderRequest,
      params: RequestParams = {},
    ) =>
      this.request<BulkServiceReminder, any>({
        path: `/api/v1/reminders/service_reminders/bulk-unarchive/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders Comments
     * @name V1RemindersServiceRemindersCommentsDeleteDestroy
     * @request DELETE:/api/v1/reminders/service_reminders/comments/{id}/delete/
     * @secure
     */
    v1RemindersServiceRemindersCommentsDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/reminders/service_reminders/comments/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders Comments
     * @name V1RemindersServiceRemindersCommentsUpdateUpdate
     * @request PUT:/api/v1/reminders/service_reminders/comments/{id}/update/
     * @secure
     */
    v1RemindersServiceRemindersCommentsUpdateUpdate: (
      id: string,
      data: ServiceReminderCommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderComment, any>({
        path: `/api/v1/reminders/service_reminders/comments/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders Comments
     * @name V1RemindersServiceRemindersCommentsUpdatePartialUpdate
     * @request PATCH:/api/v1/reminders/service_reminders/comments/{id}/update/
     * @secure
     */
    v1RemindersServiceRemindersCommentsUpdatePartialUpdate: (
      id: string,
      data: PatchedServiceReminderCommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderComment, any>({
        path: `/api/v1/reminders/service_reminders/comments/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders Comments
     * @name V1RemindersServiceRemindersCommentsCreateCreate
     * @request POST:/api/v1/reminders/service_reminders/comments/create/
     * @secure
     */
    v1RemindersServiceRemindersCommentsCreateCreate: (
      data: ServiceReminderCommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminderComment, any>({
        path: `/api/v1/reminders/service_reminders/comments/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Service-Reminders
     * @name V1RemindersServiceRemindersCreateCreate
     * @request POST:/api/v1/reminders/service_reminders/create/
     * @secure
     */
    v1RemindersServiceRemindersCreateCreate: (
      data: ServiceReminderRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceReminder, any>({
        path: `/api/v1/reminders/service_reminders/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Vehicle-Renewal
     * @name V1RemindersVehicleRenewalList
     * @request GET:/api/v1/reminders/vehicle_renewal/
     * @secure
     */
    v1RemindersVehicleRenewalList: (
      query?: {
        /** @format date */
        due_date?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** @format uuid */
        renewal_type?: string;
        /** A search term. */
        search?: string;
        /**
         * * `upcoming` - Upcoming
         * * `due_soon` - Due Soon
         * * `overdue` - Overdue
         */
        status?: "due_soon" | "overdue" | "upcoming";
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleRenewalListList, any>({
        path: `/api/v1/reminders/vehicle_renewal/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Vehicle-Renewal
     * @name V1RemindersVehicleRenewalRetrieve
     * @request GET:/api/v1/reminders/vehicle_renewal/{id}/
     * @secure
     */
    v1RemindersVehicleRenewalRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<VehicleRenewalRetrieve, any>({
        path: `/api/v1/reminders/vehicle_renewal/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Vehicle-Renewal
     * @name V1RemindersVehicleRenewalDeleteDestroy
     * @request DELETE:/api/v1/reminders/vehicle_renewal/{id}/delete/
     * @secure
     */
    v1RemindersVehicleRenewalDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/reminders/vehicle_renewal/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Vehicle-Renewal
     * @name V1RemindersVehicleRenewalUpdateUpdate
     * @request PUT:/api/v1/reminders/vehicle_renewal/{id}/update/
     * @secure
     */
    v1RemindersVehicleRenewalUpdateUpdate: (
      id: string,
      data: VehicleRenewalUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleRenewalUpdate, any>({
        path: `/api/v1/reminders/vehicle_renewal/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Vehicle-Renewal
     * @name V1RemindersVehicleRenewalUpdatePartialUpdate
     * @request PATCH:/api/v1/reminders/vehicle_renewal/{id}/update/
     * @secure
     */
    v1RemindersVehicleRenewalUpdatePartialUpdate: (
      id: string,
      data: PatchedVehicleRenewalUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleRenewalUpdate, any>({
        path: `/api/v1/reminders/vehicle_renewal/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Vehicle-Renewal
     * @name V1RemindersVehicleRenewalCreateCreate
     * @request POST:/api/v1/reminders/vehicle_renewal/create/
     * @secure
     */
    v1RemindersVehicleRenewalCreateCreate: (
      data: VehicleRenewalCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleRenewalCreate, any>({
        path: `/api/v1/reminders/vehicle_renewal/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Vehicle-Renewal
     * @name V1RemindersVehicleRenewalDeleteMultipleCreate
     * @request POST:/api/v1/reminders/vehicle_renewal/delete-multiple/
     * @secure
     */
    v1RemindersVehicleRenewalDeleteMultipleCreate: (
      data: DeleteMultipleObjectsRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeleteMultipleObjects, any>({
        path: `/api/v1/reminders/vehicle_renewal/delete-multiple/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Vehicle-Renewal
     * @name V1RemindersVehicleRenewalTypeList
     * @request GET:/api/v1/reminders/vehicle_renewal_type/
     * @secure
     */
    v1RemindersVehicleRenewalTypeList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleRenewalTypeListList, any>({
        path: `/api/v1/reminders/vehicle_renewal_type/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reminders-Vehicle-Renewal
     * @name V1RemindersVehicleRenewalTypeCreateCreate
     * @request POST:/api/v1/reminders/vehicle_renewal_type/create/
     * @secure
     */
    v1RemindersVehicleRenewalTypeCreateCreate: (
      data: VehicleRenewalTypeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleRenewalTypeCreate, any>({
        path: `/api/v1/reminders/vehicle_renewal_type/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports [Catalogues]
     * @name V1ReportsCataloguesList
     * @request GET:/api/v1/reports/catalogues/
     * @secure
     */
    v1ReportsCataloguesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCatalogueWithCountReadList, any>({
        path: `/api/v1/reports/catalogues/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports [Catalogues]
     * @name V1ReportsCataloguesCreateCreate
     * @request POST:/api/v1/reports/catalogues/create/
     * @secure
     */
    v1ReportsCataloguesCreateCreate: (
      data: CatalogueCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CatalogueCreate, any>({
        path: `/api/v1/reports/catalogues/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports [Catalogues]
     * @name V1ReportsCataloguesReportsList
     * @request GET:/api/v1/reports/catalogues/reports/
     * @secure
     */
    v1ReportsCataloguesReportsList: (
      query?: {
        /** @format uuid */
        catalogue?: string;
        catalogue_code_name?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCatalogueReportReadList, any>({
        path: `/api/v1/reports/catalogues/reports/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Fuel]
     * @name V1ReportsFuelFuelEntriesByVehicleList
     * @request GET:/api/v1/reports/fuel/fuel-entries-by-vehicle/
     * @secure
     */
    v1ReportsFuelFuelEntriesByVehicleList: (
      query?: {
        /** @format date-time */
        date?: string;
        /** Multiple values may be separated by commas. */
        date__range?: string[];
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        fuel_efficiency?: number;
        fuel_price?: number;
        fuel_price__gte?: number;
        fuel_price__lte?: number;
        /** Multiple values may be separated by commas. */
        fuel_price__range?: number[];
        fuel_type__icontains?: string;
        is_void?: boolean;
        last_known_location?: string;
        last_known_location__icontains?: string;
        /** Number of results to return per page. */
        limit?: number;
        odometer?: number;
        odometer__gte?: number;
        odometer__lte?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A search term. */
        search?: string;
        total_price?: number;
        /** @format uuid */
        vehicle?: string;
        /** @format uuid */
        vendor?: string;
        volume?: number;
        volume__gte?: number;
        volume__lte?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFuelEntriesByVehicleList, any>({
        path: `/api/v1/reports/fuel/fuel-entries-by-vehicle/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Fuel]
     * @name V1ReportsFuelFuelSummaryList
     * @request GET:/api/v1/reports/fuel/fuel-summary/
     * @secure
     */
    v1ReportsFuelFuelSummaryList: (
      query?: {
        /**
         * Filter entries from this date (format: YYYY-MM-DD)
         * @format date-time
         */
        date_from?: string;
        /**
         * Filter entries until this date (format: YYYY-MM-DD)
         * @format date-time
         */
        date_to?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Filter by fuel type */
        fuel_type?: string;
        /** Filter entries with documents */
        has_documents?: boolean;
        /** Filter by void status */
        is_void?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** Filter by maximum fuel volume */
        max_volume?: number;
        /** Filter by minimum fuel volume */
        min_volume?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        search?: string;
        /**
         * Filter by vehicle UUID
         * @format uuid
         */
        vehicle?: string;
        /** Filter by multiple vehicle UUIDs (comma-separated) */
        vehicles?: string[];
        /**
         * Filter by vendor UUID
         * @format uuid
         */
        vendor?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFuelSummaryList, any>({
        path: `/api/v1/reports/fuel/fuel-summary/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Fuel]
     * @name V1ReportsFuelFuelSummaryByLocationList
     * @request GET:/api/v1/reports/fuel/fuel-summary-by-location/
     * @secure
     */
    v1ReportsFuelFuelSummaryByLocationList: (
      query?: {
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFuelSummaryByLocationList, any>({
        path: `/api/v1/reports/fuel/fuel-summary-by-location/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Inspections]
     * @name V1ReportsInspectionsFailedInspectionsList
     * @request GET:/api/v1/reports/inspections/failed-inspections/
     * @secure
     */
    v1ReportsInspectionsFailedInspectionsList: (
      query?: {
        /** @format date-time */
        date_range_after?: string;
        /** @format date-time */
        date_range_before?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        failed?: boolean;
        /** @format uuid */
        form?: string;
        /** @format uuid */
        inspector?: string;
        /** @format uuid */
        item?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format uuid */
        submission?: string;
        submission_code?: number;
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInspectionFailedListList, any>({
        path: `/api/v1/reports/inspections/failed-inspections/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Inspections]
     * @name V1ReportsInspectionsInspectionsListList
     * @request GET:/api/v1/reports/inspections/inspections-list/
     * @secure
     */
    v1ReportsInspectionsInspectionsListList: (
      query?: {
        /** @format date-time */
        date_range_after?: string;
        /** @format date-time */
        date_range_before?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** @format uuid */
        form?: string;
        has_failed_items?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format uuid */
        submitted_by?: string;
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInspectionSubmissionListList, any>({
        path: `/api/v1/reports/inspections/inspections-list/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Inspections]
     * @name V1ReportsInspectionsSubmissionSummaryList
     * @request GET:/api/v1/reports/inspections/submission-summary/
     * @secure
     */
    v1ReportsInspectionsSubmissionSummaryList: (
      query?: {
        /** @format date-time */
        date_range_after?: string;
        /** @format date-time */
        date_range_before?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** @format uuid */
        form?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInspectionSubmissionSummaryList, any>({
        path: `/api/v1/reports/inspections/submission-summary/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Handles GET requests, extends schema with status filters.
     *
     * @tags Reports [Issues]
     * @name V1ReportsIssuesFaultsSummaryList
     * @request GET:/api/v1/reports/issues/faults-summary/
     * @secure
     */
    v1ReportsIssuesFaultsSummaryList: (
      query?: {
        code?: string;
        common_faults_status?: "ignored" | "open" | "pending" | "resolved";
        common_vehicles_with_faults_status?:
          | "ignored"
          | "open"
          | "pending"
          | "resolved";
        critical?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * * `off` - Off
         * * `ignore` - Ignore
         * * `critical` - Critical
         */
        priority?: "critical" | "ignore" | "off";
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFaultsSummaryReportList, any>({
        path: `/api/v1/reports/issues/faults-summary/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Issues]
     * @name V1ReportsIssuesIssuesListList
     * @request GET:/api/v1/reports/issues/issues-list/
     * @secure
     */
    v1ReportsIssuesIssuesListList: (
      query?: {
        assigned_to?: string[];
        /** @format date-time */
        due_date?: string;
        due_odometer?: number;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** @format uuid */
        fault?: string;
        labels?: string;
        /** Number of results to return per page. */
        limit?: number;
        major_functionality_impaired?: boolean;
        odometer?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        over_due?: boolean;
        /**
         * * `critical` - Critical
         * * `high` - High
         * * `medium` - Medium
         * * `low` - Low
         * * `no_priority` - No Priority
         */
        priority?: "critical" | "high" | "low" | "medium" | "no_priority";
        reference_code?: number;
        /** @format uuid */
        reported_by?: string;
        /** @format date-time */
        reported_date?: string;
        /** @format uuid */
        resolved_by?: string;
        /** @format date-time */
        resolved_date?: string;
        /** A search term. */
        search?: string;
        source?: string;
        /**
         * * `open` - Open
         * * `resolved` - Resolved
         * * `closed` - Closed
         * * `done` - Done
         * * `overdue` - Overdue
         */
        status?: "closed" | "done" | "open" | "overdue" | "resolved";
        /** @format time */
        time?: string;
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedIssueList, any>({
        path: `/api/v1/reports/issues/issues-list/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Parts]
     * @name V1ReportsPartsPartsActivityList
     * @request GET:/api/v1/reports/parts/parts-activity/
     * @secure
     */
    v1ReportsPartsPartsActivityList: (
      query?: {
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPartsActivityReportList, any>({
        path: `/api/v1/reports/parts/parts-activity/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Parts]
     * @name V1ReportsPartsPartsByLocationList
     * @request GET:/api/v1/reports/parts/parts-by-location/
     * @secure
     */
    v1ReportsPartsPartsByLocationList: (
      query?: {
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPartsByLocationReportList, any>({
        path: `/api/v1/reports/parts/parts-by-location/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Parts]
     * @name V1ReportsPartsPartsByVehicleList
     * @request GET:/api/v1/reports/parts/parts-by-vehicle/
     * @secure
     */
    v1ReportsPartsPartsByVehicleList: (
      query?: {
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPartsByVehicleReportList, any>({
        path: `/api/v1/reports/parts/parts-by-vehicle/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Parts]
     * @name V1ReportsPartsPurchaseOrdersListList
     * @request GET:/api/v1/reports/parts/purchase-orders-list/
     * @secure
     */
    v1ReportsPartsPurchaseOrdersListList: (
      query?: {
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPurchaseOrderListList, any>({
        path: `/api/v1/reports/parts/purchase-orders-list/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Services]
     * @name V1ReportsServicesServiceEntriesSummaryList
     * @request GET:/api/v1/reports/services/service-entries-summary/
     * @secure
     */
    v1ReportsServicesServiceEntriesSummaryList: (
      query?: {
        /** @format date */
        created_after?: string;
        /** @format date */
        created_before?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedServiceHistorySummaryReportList, any>({
        path: `/api/v1/reports/services/service-entries-summary/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Services]
     * @name V1ReportsServicesServiceHistoryByVehicleList
     * @request GET:/api/v1/reports/services/service-history-by-vehicle/
     * @secure
     */
    v1ReportsServicesServiceHistoryByVehicleList: (
      query?: {
        /** @format date */
        created_after?: string;
        /** @format date */
        created_before?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedServiceHistoryByVehicleReportList, any>({
        path: `/api/v1/reports/services/service-history-by-vehicle/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Services]
     * @name V1ReportsServicesServiceReminderList
     * @request GET:/api/v1/reports/services/service-reminder/
     * @secure
     */
    v1ReportsServicesServiceReminderList: (
      query?: {
        /** @format date */
        date_range_after?: string;
        /** @format date */
        date_range_before?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** @format date */
        next_due_date?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format uuid */
        service_task?: string;
        /**
         * * `Upcoming` - Upcoming
         * * `DueSoon` - Due Soon
         * * `Overdue` - Overdue
         * * `Snoozed` - Snoozed
         * * `Completed` - Completed
         */
        status?: "Completed" | "DueSoon" | "Overdue" | "Snoozed" | "Upcoming";
        /** @format uuid */
        vehicle__group?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedServiceReminderReportList, any>({
        path: `/api/v1/reports/services/service-reminder/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve service reminder compliance reports with optional date filtering. Allows filtering by date range to analyze service history and compliance status.
     *
     * @tags Reports [Services]
     * @name V1ReportsServicesServiceReminderComplianceList
     * @summary Service Reminder Compliance Report
     * @request GET:/api/v1/reports/services/service-reminder-compliance/
     * @secure
     */
    v1ReportsServicesServiceReminderComplianceList: (
      query?: {
        /**
         * Filter data up to this date (format: YYYY-MM-DD)
         * @format date
         */
        end_date?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /**
         * Filter data starting from this date (format: YYYY-MM-DD)
         * @format date
         */
        start_date?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedServiceReminderComplianceReportList, void>({
        path: `/api/v1/reports/services/service-reminder-compliance/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Services]
     * @name V1ReportsServicesVehiclesWithoutServiceList
     * @request GET:/api/v1/reports/services/vehicles-without-service/
     * @secure
     */
    v1ReportsServicesVehiclesWithoutServiceList: (
      query?: {
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * Service Date From
         * @format date
         */
        service_date_from?: string;
        /**
         * Service Date To
         * @format date
         */
        service_date_to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehiclesWithoutServiceReportList, any>({
        path: `/api/v1/reports/services/vehicles-without-service/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Users]
     * @name V1ReportsUsersUserListList
     * @request GET:/api/v1/reports/users/user-list/
     * @secure
     */
    v1ReportsUsersUserListList: (
      query?: {
        email?: string;
        employee_number?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Full Name */
        full_name?: string;
        /** @format uuid */
        group?: string;
        job_title?: string;
        /** @format date */
        leave_date?: string;
        /** @format date */
        leave_date__gte?: string;
        /** @format date */
        leave_date__lte?: string;
        license_class?: string;
        license_number?: string;
        license_state?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** @format uuid */
        role?: string;
        /** A search term. */
        search?: string;
        /** @format date */
        start_date?: string;
        /** @format date */
        start_date__gte?: string;
        /** @format date */
        start_date__lte?: string;
        /**
         * Type
         *
         * * `contact` - Contact
         * * `user` - User
         */
        type?: "contact" | "user";
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedListUsersReportList, any>({
        path: `/api/v1/reports/users/user-list/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports [Users]
     * @name V1ReportsUsersUserRenewalRemindersList
     * @request GET:/api/v1/reports/users/user-renewal-reminders/
     * @secure
     */
    v1ReportsUsersUserRenewalRemindersList: (
      query?: {
        /** @format uuid */
        contact?: string;
        /** @format date */
        due_date?: string;
        /**
         * Date on which the contact will be renewed
         *
         * * `today` - Today
         * * `yesterday` - Yesterday
         * * `week` - Past 7 days
         * * `month` - This month
         * * `year` - This year
         * @format date
         */
        due_date_named_range?:
          | "month"
          | "today"
          | "week"
          | "year"
          | "yesterday";
        /** @format date */
        due_date_range_after?: string;
        /** @format date */
        due_date_range_before?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** @format uuid */
        group?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        reference_code?: number;
        /** @format uuid */
        renewal_type?: string;
        /** A search term. */
        search?: string;
        /**
         * * `upcoming` - Upcoming
         * * `due_soon` - Due Soon
         * * `overdue` - Overdue
         */
        status?: "due_soon" | "overdue" | "upcoming";
        /**
         * User Type
         *
         * * `contact` - Contact
         * * `user` - User
         */
        user_type?: "contact" | "user";
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedUserRenewalRemindersList, any>({
        path: `/api/v1/reports/users/user-renewal-reminders/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Vehicle Assignments]
     * @name V1ReportsVehicleAssignmentsAssignmentsLogList
     * @request GET:/api/v1/reports/vehicle-assignments/assignments-log/
     * @secure
     */
    v1ReportsVehicleAssignmentsAssignmentsLogList: (
      query?: {
        /** Max duration in seconds  */
        duration_max?: string;
        /** Min duration in seconds  */
        duration_min?: string;
        /**
         * End Datetime
         * @format date
         */
        end_datetime?: string;
        end_odometer?: number;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** @format uuid */
        operator?: string;
        /** A search term. */
        search?: string;
        /**
         * Start Datetime
         * @format date
         */
        start_datetime?: string;
        start_odometer?: number;
        /**
         * Time Status Frame
         *
         * * `current` - Current
         * * `past` - Past
         * * `future` - Future
         */
        status?: ("current" | "future" | "past")[];
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleAssignmentLogList, any>({
        path: `/api/v1/reports/vehicle-assignments/assignments-log/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Vehicle Assignments]
     * @name V1ReportsVehicleAssignmentsAssignmentsSummaryList
     * @request GET:/api/v1/reports/vehicle-assignments/assignments-summary/
     * @secure
     */
    v1ReportsVehicleAssignmentsAssignmentsSummaryList: (
      query: {
        /**
         * The end date for filtering the assignments (YYYY-MM-DD format)
         * @format date
         */
        end_date: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * The start date for filtering the assignments (YYYY-MM-DD format)
         * @format date
         */
        start_date: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleAssignmentsSummaryList, any>({
        path: `/api/v1/reports/vehicle-assignments/assignments-summary/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Vehicles]
     * @name V1ReportsVehiclesCostComparisonInServiceList
     * @request GET:/api/v1/reports/vehicles/cost-comparison-in-service/
     * @secure
     */
    v1ReportsVehiclesCostComparisonInServiceList: (
      query?: {
        /** Filter by expense type (maintenance, fuel, rental, all) */
        expense_type?: "all" | "fuel" | "maintenance" | "rental";
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** @format uuid */
        group?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleCostComparisonReportList, any>({
        path: `/api/v1/reports/vehicles/cost-comparison-in-service/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Vehicles]
     * @name V1ReportsVehiclesListOfUnitsList
     * @request GET:/api/v1/reports/vehicles/list-of-units/
     * @secure
     */
    v1ReportsVehiclesListOfUnitsList: (
      query?: {
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** @format uuid */
        group?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /**
         * * `active` - Active
         * * `inactive` - Inactive
         * * `in_shop` - In Shop
         * * `out_of_service` - Out of Service
         * * `sold` - Sold
         * * `yes` - Yes
         * * `downtime` - Downtime
         */
        status?:
          | "active"
          | "downtime"
          | "in_shop"
          | "inactive"
          | "out_of_service"
          | "sold"
          | "yes";
        /** @format uuid */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleReportListList, any>({
        path: `/api/v1/reports/vehicles/list-of-units/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Vehicles]
     * @name V1ReportsVehiclesOperatingCostsSummaryList
     * @request GET:/api/v1/reports/vehicles/operating-costs-summary/
     * @secure
     */
    v1ReportsVehiclesOperatingCostsSummaryList: (
      query?: {
        /**
         * The datetime after which the cost needs to be considered
         * @format date-time
         */
        date_range_after?: string;
        /**
         * The datetime before which the cost needs to be considered
         * @format date-time
         */
        date_range_before?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** @format uuid */
        group?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleOperatingCostsSummaryReportList, any>({
        path: `/api/v1/reports/vehicles/operating-costs-summary/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Vehicles]
     * @name V1ReportsVehiclesRenewalRemindersList
     * @request GET:/api/v1/reports/vehicles/renewal-reminders/
     * @secure
     */
    v1ReportsVehiclesRenewalRemindersList: (
      query?: {
        /** @format date */
        due_date_after?: string;
        /** @format date */
        due_date_before?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** @format uuid */
        renewal_type?: string;
        /** A search term. */
        search?: string;
        /**
         * * `upcoming` - Upcoming
         * * `due_soon` - Due Soon
         * * `overdue` - Overdue
         */
        status?: "due_soon" | "overdue" | "upcoming";
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleRenewalRemindersList, any>({
        path: `/api/v1/reports/vehicles/renewal-reminders/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Vehicles]
     * @name V1ReportsVehiclesStatusChangesList
     * @request GET:/api/v1/reports/vehicles/status-changes/
     * @secure
     */
    v1ReportsVehiclesStatusChangesList: (
      query?: {
        /** @format date-time */
        created_after?: string;
        /** @format date-time */
        created_before?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /**
         * From Status
         * * `active` - Active
         * * `inactive` - Inactive
         * * `in_shop` - In Shop
         * * `out_of_service` - Out of Service
         * * `sold` - Sold
         * * `yes` - Yes
         * * `downtime` - Downtime
         */
        status_from?:
          | "active"
          | "downtime"
          | "in_shop"
          | "inactive"
          | "out_of_service"
          | "sold"
          | "yes"
          | null;
        /**
         * To Status
         * * `active` - Active
         * * `inactive` - Inactive
         * * `in_shop` - In Shop
         * * `out_of_service` - Out of Service
         * * `sold` - Sold
         * * `yes` - Yes
         * * `downtime` - Downtime
         */
        status_to?:
          | "active"
          | "downtime"
          | "in_shop"
          | "inactive"
          | "out_of_service"
          | "sold"
          | "yes";
        /** @format uuid */
        updated_by?: string;
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleStatusChangesList, any>({
        path: `/api/v1/reports/vehicles/status-changes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Vehicles]
     * @name V1ReportsVehiclesStatusSummaryList
     * @request GET:/api/v1/reports/vehicles/status-summary/
     * @secure
     */
    v1ReportsVehiclesStatusSummaryList: (
      query?: {
        changes_count?: number;
        /** @format date */
        date_range_after?: string;
        /** @format date */
        date_range_before?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A search term. */
        search?: string;
        /** @format uuid */
        vehicle_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleStatusSummaryList, any>({
        path: `/api/v1/reports/vehicles/status-summary/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Vehicles]
     * @name V1ReportsVehiclesVehiclesDetailList
     * @request GET:/api/v1/reports/vehicles/vehicles-detail/
     * @secure
     */
    v1ReportsVehiclesVehiclesDetailList: (
      query?: {
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** @format uuid */
        group?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** @format uuid */
        make?: string;
        /** @format uuid */
        model?: string;
        name?: string;
        name__icontains?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        /** @format uuid */
        operator?: string;
        /** A search term. */
        search?: string;
        /**
         * * `active` - Active
         * * `inactive` - Inactive
         * * `in_shop` - In Shop
         * * `out_of_service` - Out of Service
         * * `sold` - Sold
         * * `yes` - Yes
         * * `downtime` - Downtime
         */
        status?:
          | "active"
          | "downtime"
          | "in_shop"
          | "inactive"
          | "out_of_service"
          | "sold"
          | "yes";
        /** Multiple values may be separated by commas. */
        status__in?: string[];
        /** @format uuid */
        type?: string;
        vin_sn?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleListList, any>({
        path: `/api/v1/reports/vehicles/vehicles-detail/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Vehicles]
     * @name V1ReportsVehiclesVehiclesDetailRetrieve
     * @request GET:/api/v1/reports/vehicles/vehicles-detail/{id}/
     * @secure
     */
    v1ReportsVehiclesVehiclesDetailRetrieve: (
      id: string,
      query?: {
        /** Format of export file */
        export_format?: "csv" | "xlsx";
      },
      params: RequestParams = {},
    ) =>
      this.request<VehicleDetailRetrieve, any>({
        path: `/api/v1/reports/vehicles/vehicles-detail/${id}/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Work Orders]
     * @name V1ReportsWorkOrdersLaborTimeEntriesListList
     * @request GET:/api/v1/reports/work-orders/labor-time-entries-list/
     * @secure
     */
    v1ReportsWorkOrdersLaborTimeEntriesListList: (
      query?: {
        /** @format date-time */
        date_range_after?: string;
        /** @format date-time */
        date_range_before?: string;
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format uuid */
        technician?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedLaborTimeEntriesListReportList, any>({
        path: `/api/v1/reports/work-orders/labor-time-entries-list/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Work Orders]
     * @name V1ReportsWorkOrdersWorkOrdersByVehicleList
     * @request GET:/api/v1/reports/work-orders/work-orders-by-vehicle/
     * @secure
     */
    v1ReportsWorkOrdersWorkOrdersByVehicleList: (
      query?: {
        /** Format of export file */
        export_format?: "csv" | "xlsx";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format uuid */
        service_task?: string;
        /**
         * * `open` - Open
         * * `pending` - Pending
         * * `under_review` - Under review
         * * `completed` - Completed
         */
        status?: "completed" | "open" | "pending" | "under_review";
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedWorkOrderByVehicleReportList, any>({
        path: `/api/v1/reports/work-orders/work-orders-by-vehicle/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Base class for an endpoint that integrates charts data and export features.
     *
     * @tags Reports [Work Orders]
     * @name V1ReportsWorkOrdersWorkOrdersListList
     * @request GET:/api/v1/reports/work-orders/work-orders-list/
     * @secure
     */
    v1ReportsWorkOrdersWorkOrdersListList: (
      query?: {
        /**
         * The end date for filtering the chart `created work orders` (YYYY-MM-DD format)
         * @format date
         */
        created_work_orders_end_date?: string;
        /**
         * The start date for filtering the chart `created work orders` (YYYY-MM-DD format)
         * @format date
         */
        created_work_orders_start_date?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format uuid */
        service_task?: string;
        /**
         * * `open` - Open
         * * `pending` - Pending
         * * `under_review` - Under review
         * * `completed` - Completed
         */
        status?: "completed" | "open" | "pending" | "under_review";
        /**
         * The end date for filtering the chart `status distribution` (YYYY-MM-DD format)
         * @format date
         */
        status_distribution_end_date?: string;
        /**
         * The start date for filtering the chart `status distribution` (YYYY-MM-DD format)
         * @format date
         */
        status_distribution_start_date?: string;
        /** @format uuid */
        vehicle?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedWorkOrderListReportList, any>({
        path: `/api/v1/reports/work-orders/work-orders-list/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description OpenApi3 schema for this API. Format can be selected via content negotiation. - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     *
     * @tags v1
     * @name V1SchemaRetrieve
     * @request GET:/api/v1/schema/
     * @secure
     */
    v1SchemaRetrieve: (
      query?: {
        format?: "json" | "yaml";
        lang?:
          | "af"
          | "ar"
          | "ar-dz"
          | "ast"
          | "az"
          | "be"
          | "bg"
          | "bn"
          | "br"
          | "bs"
          | "ca"
          | "ckb"
          | "cs"
          | "cy"
          | "da"
          | "de"
          | "dsb"
          | "el"
          | "en"
          | "en-au"
          | "en-gb"
          | "eo"
          | "es"
          | "es-ar"
          | "es-co"
          | "es-mx"
          | "es-ni"
          | "es-ve"
          | "et"
          | "eu"
          | "fa"
          | "fi"
          | "fr"
          | "fy"
          | "ga"
          | "gd"
          | "gl"
          | "he"
          | "hi"
          | "hr"
          | "hsb"
          | "hu"
          | "hy"
          | "ia"
          | "id"
          | "ig"
          | "io"
          | "is"
          | "it"
          | "ja"
          | "ka"
          | "kab"
          | "kk"
          | "km"
          | "kn"
          | "ko"
          | "ky"
          | "lb"
          | "lt"
          | "lv"
          | "mk"
          | "ml"
          | "mn"
          | "mr"
          | "ms"
          | "my"
          | "nb"
          | "ne"
          | "nl"
          | "nn"
          | "os"
          | "pa"
          | "pl"
          | "pt"
          | "pt-br"
          | "ro"
          | "ru"
          | "sk"
          | "sl"
          | "sq"
          | "sr"
          | "sr-latn"
          | "sv"
          | "sw"
          | "ta"
          | "te"
          | "tg"
          | "th"
          | "tk"
          | "tr"
          | "tt"
          | "udm"
          | "uk"
          | "ur"
          | "uz"
          | "vi"
          | "zh-hans"
          | "zh-hant";
      },
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, any>({
        path: `/api/v1/schema/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services
     * @name V1ServicesList
     * @request GET:/api/v1/services/
     * @secure
     */
    v1ServicesList: (
      query?: {
        /** @format date */
        completion_date?: string;
        cost_labor?: number;
        cost_parts?: number;
        /** @format uuid */
        created_by?: string;
        discount?: number;
        general_notes?: string;
        /** Archived Service Entries */
        is_archived?: boolean;
        /** Issues */
        issues?: string[];
        /** Number of results to return per page. */
        limit?: number;
        odometer?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * Ordering
         *
         * * `Vehicle Name` - Vehicle name
         * * `-Vehicle Name` - Vehicle name (descending)
         * * `Repair Priority Class` - Repair priority class
         * * `-Repair Priority Class` - Repair priority class (descending)
         * * `Odometer` - Odometer
         * * `-Odometer` - Odometer (descending)
         * * `Completion Date` - Completion date
         * * `-Completion Date` - Completion date (descending)
         * * `Vendor Name` - Vendor name
         * * `-Vendor Name` - Vendor name (descending)
         */
        ordering?: (
          | "-Completion Date"
          | "-Odometer"
          | "-Repair Priority Class"
          | "-Vehicle Name"
          | "-Vendor Name"
          | "Completion Date"
          | "Odometer"
          | "Repair Priority Class"
          | "Vehicle Name"
          | "Vendor Name"
        )[];
        /**
         * * `scheduled` - Scheduled
         * * `non_scheduled` - Non scheduled
         * * `emergency` - Emergency
         */
        repair_priority_class?: "emergency" | "non_scheduled" | "scheduled";
        /** A search term. */
        search?: string;
        /** Service Task Items */
        service_task_items?: string[];
        /** Service Tasks */
        service_tasks?: string[];
        /** @format date */
        start_date?: string;
        sub_total?: number;
        tax?: number;
        total_cost?: number;
        /** @format uuid */
        vehicle?: string;
        /**
         * * `active` - Active
         * * `inactive` - Inactive
         * * `in_shop` - In Shop
         * * `out_of_service` - Out of Service
         * * `sold` - Sold
         * * `yes` - Yes
         * * `downtime` - Downtime
         */
        vehicle_status?:
          | "active"
          | "downtime"
          | "in_shop"
          | "inactive"
          | "out_of_service"
          | "sold"
          | "yes";
        /** @format uuid */
        vehicle_type?: string;
        /** @format uuid */
        vendor?: string;
        void?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedRetrieveServiceList, any>({
        path: `/api/v1/services/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services
     * @name V1ServicesRetrieve
     * @request GET:/api/v1/services/{id}/
     * @secure
     */
    v1ServicesRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<RetrieveService, any>({
        path: `/api/v1/services/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesArchiveCreate
     * @request POST:/api/v1/services/{id}/archive/
     * @secure
     */
    v1ServicesArchiveCreate: (
      id: string,
      data: RetrieveServiceRequest,
      params: RequestParams = {},
    ) =>
      this.request<RetrieveService, any>({
        path: `/api/v1/services/${id}/archive/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesBulkAddDocumentsCreate
     * @request POST:/api/v1/services/{id}/bulk-add-documents/
     * @secure
     */
    v1ServicesBulkAddDocumentsCreate: (
      id: string,
      data: UploadFilesServiceRequest,
      params: RequestParams = {},
    ) =>
      this.request<UploadFilesService, any>({
        path: `/api/v1/services/${id}/bulk-add-documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesBulkRemoveDocumentsCreate
     * @request POST:/api/v1/services/{id}/bulk-remove-documents/
     * @secure
     */
    v1ServicesBulkRemoveDocumentsCreate: (
      id: string,
      data: UploadFilesServiceRequest,
      params: RequestParams = {},
    ) =>
      this.request<UploadFilesService, any>({
        path: `/api/v1/services/${id}/bulk-remove-documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesCommentsDeleteDestroy
     * @request DELETE:/api/v1/services/{id}/comments/delete/
     * @secure
     */
    v1ServicesCommentsDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/services/${id}/comments/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services
     * @name V1ServicesDeleteDestroy
     * @request DELETE:/api/v1/services/{id}/delete/
     * @secure
     */
    v1ServicesDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/services/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services-Files
     * @name V1ServicesDocumentsRetrieve
     * @request GET:/api/v1/services/{id}/documents/
     * @secure
     */
    v1ServicesDocumentsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<RetrieveFilesService, any>({
        path: `/api/v1/services/${id}/documents/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesUnarchiveCreate
     * @request POST:/api/v1/services/{id}/unarchive/
     * @secure
     */
    v1ServicesUnarchiveCreate: (
      id: string,
      data: RetrieveServiceRequest,
      params: RequestParams = {},
    ) =>
      this.request<RetrieveService, any>({
        path: `/api/v1/services/${id}/unarchive/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services
     * @name V1ServicesUpdateUpdate
     * @request PUT:/api/v1/services/{id}/update/
     * @secure
     */
    v1ServicesUpdateUpdate: (
      id: string,
      data: UpdateServiceRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateService, any>({
        path: `/api/v1/services/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services
     * @name V1ServicesUpdatePartialUpdate
     * @request PATCH:/api/v1/services/{id}/update/
     * @secure
     */
    v1ServicesUpdatePartialUpdate: (
      id: string,
      data: PatchedUpdateServiceRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateService, any>({
        path: `/api/v1/services/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesCommentsCreateCreate
     * @request POST:/api/v1/services/comments/create/
     * @secure
     */
    v1ServicesCommentsCreateCreate: (
      data: ServiceEntryCommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceEntryComment, any>({
        path: `/api/v1/services/comments/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services
     * @name V1ServicesCreateCreate
     * @request POST:/api/v1/services/create/
     * @secure
     */
    v1ServicesCreateCreate: (
      data: CreateServiceRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateService, any>({
        path: `/api/v1/services/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesPaymentTypeList
     * @request GET:/api/v1/services/payment-type/
     * @secure
     */
    v1ServicesPaymentTypeList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedPaymentTypeList, any>({
        path: `/api/v1/services/payment-type/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesPaymentTypeRetrieve
     * @request GET:/api/v1/services/payment-type/{id}/
     * @secure
     */
    v1ServicesPaymentTypeRetrieve: (id: number, params: RequestParams = {}) =>
      this.request<PaymentType, any>({
        path: `/api/v1/services/payment-type/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesPaymentTypeDeleteDestroy
     * @request DELETE:/api/v1/services/payment-type/{id}/delete/
     * @secure
     */
    v1ServicesPaymentTypeDeleteDestroy: (
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/services/payment-type/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesPaymentTypeUpdatePartialUpdate
     * @request PATCH:/api/v1/services/payment-type/{id}/update/
     * @secure
     */
    v1ServicesPaymentTypeUpdatePartialUpdate: (
      id: number,
      data: PatchedPaymentTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentType, any>({
        path: `/api/v1/services/payment-type/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesPaymentTypeCreateCreate
     * @request POST:/api/v1/services/payment-type/create/
     * @secure
     */
    v1ServicesPaymentTypeCreateCreate: (
      data: PaymentTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentType, any>({
        path: `/api/v1/services/payment-type/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskList
     * @request GET:/api/v1/services/service-task/
     * @secure
     */
    v1ServicesServiceTaskList: (
      query?: {
        /** @format uuid */
        assembly_code?: string;
        description?: string;
        /** Is Archived */
        is_archived?: boolean;
        is_general?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** @format uuid */
        maintenance_category?: string;
        name?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * Ordering
         *
         * * `Name` - Name
         * * `-Name` - Name (descending)
         * * `Description` - Description
         * * `-Description` - Description (descending)
         * * `Maintenance Category` - Maintenance category
         * * `-Maintenance Category` - Maintenance category (descending)
         * * `System Code` - System code
         * * `-System Code` - System code (descending)
         * * `Assembly Code` - Assembly code
         * * `-Assembly Code` - Assembly code (descending)
         * * `Reason For Repair Code` - Reason for repair code
         * * `-Reason For Repair Code` - Reason for repair code (descending)
         */
        ordering?: (
          | "-Assembly Code"
          | "-Description"
          | "-Maintenance Category"
          | "-Name"
          | "-Reason For Repair Code"
          | "-System Code"
          | "Assembly Code"
          | "Description"
          | "Maintenance Category"
          | "Name"
          | "Reason For Repair Code"
          | "System Code"
        )[];
        /** @format uuid */
        reason_for_repair_code?: string;
        /** A search term. */
        search?: string;
        /** @format uuid */
        system_code?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedListServiceTaskList, any>({
        path: `/api/v1/services/service-task/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskRetrieve
     * @request GET:/api/v1/services/service-task/{id}/
     * @secure
     */
    v1ServicesServiceTaskRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<ListServiceTask, any>({
        path: `/api/v1/services/service-task/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskArchiveCreate
     * @request POST:/api/v1/services/service-task/{id}/archive/
     * @secure
     */
    v1ServicesServiceTaskArchiveCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/services/service-task/${id}/archive/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskDeleteDestroy
     * @request DELETE:/api/v1/services/service-task/{id}/delete/
     * @secure
     */
    v1ServicesServiceTaskDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/services/service-task/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskUnarchiveCreate
     * @request POST:/api/v1/services/service-task/{id}/unarchive/
     * @secure
     */
    v1ServicesServiceTaskUnarchiveCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/services/service-task/${id}/unarchive/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskUpdateUpdate
     * @request PUT:/api/v1/services/service-task/{id}/update/
     * @secure
     */
    v1ServicesServiceTaskUpdateUpdate: (
      id: string,
      data: UpdateServiceTaskRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateServiceTask, any>({
        path: `/api/v1/services/service-task/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskUpdatePartialUpdate
     * @request PATCH:/api/v1/services/service-task/{id}/update/
     * @secure
     */
    v1ServicesServiceTaskUpdatePartialUpdate: (
      id: string,
      data: PatchedUpdateServiceTaskRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateServiceTask, any>({
        path: `/api/v1/services/service-task/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskAssemblyCodesList
     * @request GET:/api/v1/services/service-task/assembly-codes/
     * @secure
     */
    v1ServicesServiceTaskAssemblyCodesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAssemblyCodeReadOnlyList, any>({
        path: `/api/v1/services/service-task/assembly-codes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskAssemblyCodesCreateCreate
     * @request POST:/api/v1/services/service-task/assembly-codes/create/
     * @secure
     */
    v1ServicesServiceTaskAssemblyCodesCreateCreate: (
      data: AssemblyCodeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<AssemblyCodeCreate, any>({
        path: `/api/v1/services/service-task/assembly-codes/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskCreateCreate
     * @request POST:/api/v1/services/service-task/create/
     * @secure
     */
    v1ServicesServiceTaskCreateCreate: (
      data: CreateServiceTaskRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateServiceTask, any>({
        path: `/api/v1/services/service-task/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskMaintenanceCategoriesList
     * @request GET:/api/v1/services/service-task/maintenance-categories/
     * @secure
     */
    v1ServicesServiceTaskMaintenanceCategoriesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedMaintenanceCategoryReadOnlyList, any>({
        path: `/api/v1/services/service-task/maintenance-categories/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskMaintenanceCategoriesCreateCreate
     * @request POST:/api/v1/services/service-task/maintenance-categories/create/
     * @secure
     */
    v1ServicesServiceTaskMaintenanceCategoriesCreateCreate: (
      data: MaintenanceCategoryCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<MaintenanceCategoryCreate, any>({
        path: `/api/v1/services/service-task/maintenance-categories/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskReasonForRepairCodesList
     * @request GET:/api/v1/services/service-task/reason-for-repair-codes/
     * @secure
     */
    v1ServicesServiceTaskReasonForRepairCodesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedReasonForRepairCodeReadOnlyList, any>({
        path: `/api/v1/services/service-task/reason-for-repair-codes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskReasonForRepairCodesCreateCreate
     * @request POST:/api/v1/services/service-task/reason-for-repair-codes/create/
     * @secure
     */
    v1ServicesServiceTaskReasonForRepairCodesCreateCreate: (
      data: ReasonForRepairCodeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ReasonForRepairCodeCreate, any>({
        path: `/api/v1/services/service-task/reason-for-repair-codes/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskSystemCodesList
     * @request GET:/api/v1/services/service-task/system-codes/
     * @secure
     */
    v1ServicesServiceTaskSystemCodesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedSystemCodeReadOnlyList, any>({
        path: `/api/v1/services/service-task/system-codes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Services Task
     * @name V1ServicesServiceTaskSystemCodesCreateCreate
     * @request POST:/api/v1/services/service-task/system-codes/create/
     * @secure
     */
    v1ServicesServiceTaskSystemCodesCreateCreate: (
      data: SystemCodeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<SystemCodeCreate, any>({
        path: `/api/v1/services/service-task/system-codes/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderList
     * @request GET:/api/v1/services/work-order/
     * @secure
     */
    v1ServicesWorkOrderList: (
      query?: {
        /** @format uuid */
        assigned_to?: string;
        /** @format date-time */
        completion_date?: string;
        invoice_number?: string;
        /** @format date-time */
        issue_date?: string;
        /** @format uuid */
        issued_by?: string;
        /** @format uuid */
        labels?: string;
        labor_subtotal?: number;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        parts_subtotal?: number;
        po_number?: string;
        /**
         * * `scheduled` - Scheduled
         * * `non_scheduled` - Non scheduled
         * * `emergency` - Emergency
         */
        repair_priority_class?: "emergency" | "non_scheduled" | "scheduled";
        /** A search term. */
        search?: string;
        /** @format uuid */
        service_task?: string;
        /** @format date-time */
        start_date?: string;
        /**
         * * `open` - Open
         * * `pending` - Pending
         * * `under_review` - Under review
         * * `completed` - Completed
         */
        status?: "completed" | "open" | "pending" | "under_review";
        total_cost?: number;
        /** @format uuid */
        vehicle?: string;
        /** @format uuid */
        vehicle_group?: string;
        /** @format uuid */
        vehicle_type?: string;
        /** @format uuid */
        vendor?: string;
        void?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedWorkOrderRetrieveList, any>({
        path: `/api/v1/services/work-order/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderRetrieve
     * @request GET:/api/v1/services/work-order/{id}/
     * @secure
     */
    v1ServicesWorkOrderRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<WorkOrderRetrieve, any>({
        path: `/api/v1/services/work-order/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesWorkOrderBulkAddDocumentsCreate
     * @request POST:/api/v1/services/work-order/{id}/bulk-add-documents/
     * @secure
     */
    v1ServicesWorkOrderBulkAddDocumentsCreate: (
      id: string,
      data: UploadFilesWorkOrderRequest,
      params: RequestParams = {},
    ) =>
      this.request<UploadFilesWorkOrder, any>({
        path: `/api/v1/services/work-order/${id}/bulk-add-documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesWorkOrderBulkRemoveDocumentsCreate
     * @request POST:/api/v1/services/work-order/{id}/bulk-remove-documents/
     * @secure
     */
    v1ServicesWorkOrderBulkRemoveDocumentsCreate: (
      id: string,
      data: UploadFilesWorkOrderRequest,
      params: RequestParams = {},
    ) =>
      this.request<UploadFilesWorkOrder, any>({
        path: `/api/v1/services/work-order/${id}/bulk-remove-documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesWorkOrderCommentsDeleteDestroy
     * @request DELETE:/api/v1/services/work-order/{id}/comments/delete/
     * @secure
     */
    v1ServicesWorkOrderCommentsDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/services/work-order/${id}/comments/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderDeleteDestroy
     * @request DELETE:/api/v1/services/work-order/{id}/delete/
     * @secure
     */
    v1ServicesWorkOrderDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/services/work-order/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderMoveToCompleteCreate
     * @request POST:/api/v1/services/work-order/{id}/move-to-complete/
     * @secure
     */
    v1ServicesWorkOrderMoveToCompleteCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/services/work-order/${id}/move-to-complete/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderMoveToOpenCreate
     * @request POST:/api/v1/services/work-order/{id}/move-to-open/
     * @secure
     */
    v1ServicesWorkOrderMoveToOpenCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/services/work-order/${id}/move-to-open/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderMoveToPendingCreate
     * @request POST:/api/v1/services/work-order/{id}/move-to-pending/
     * @secure
     */
    v1ServicesWorkOrderMoveToPendingCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/services/work-order/${id}/move-to-pending/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderRelatedServiceTasksList
     * @request GET:/api/v1/services/work-order/{id}/related_service_tasks/
     * @secure
     */
    v1ServicesWorkOrderRelatedServiceTasksList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedWorkOrderServiceTaskList, any>({
        path: `/api/v1/services/work-order/${id}/related_service_tasks/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderStartLaborCreate
     * @request POST:/api/v1/services/work-order/{id}/start-labor/
     * @secure
     */
    v1ServicesWorkOrderStartLaborCreate: (
      id: string,
      data: WorkOrderLaborCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<WorkOrderLaborCreate, any>({
        path: `/api/v1/services/work-order/${id}/start-labor/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderUpdateUpdate
     * @request PUT:/api/v1/services/work-order/{id}/update/
     * @secure
     */
    v1ServicesWorkOrderUpdateUpdate: (
      id: string,
      data: WorkOrderUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<WorkOrderUpdate, any>({
        path: `/api/v1/services/work-order/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderUpdatePartialUpdate
     * @request PATCH:/api/v1/services/work-order/{id}/update/
     * @secure
     */
    v1ServicesWorkOrderUpdatePartialUpdate: (
      id: string,
      data: PatchedWorkOrderUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<WorkOrderUpdate, any>({
        path: `/api/v1/services/work-order/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderDeleteLaborDestroy
     * @request DELETE:/api/v1/services/work-order/{wo_id}/delete-labor/{id}/
     * @secure
     */
    v1ServicesWorkOrderDeleteLaborDestroy: (
      id: string,
      woId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/services/work-order/${woId}/delete-labor/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderStopLaborUpdate
     * @request PUT:/api/v1/services/work-order/{wo_id}/stop-labor/{id}/
     * @secure
     */
    v1ServicesWorkOrderStopLaborUpdate: (
      id: string,
      woId: string,
      data: WorkOrderLaborCompleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<WorkOrderLaborComplete, any>({
        path: `/api/v1/services/work-order/${woId}/stop-labor/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderStopLaborPartialUpdate
     * @request PATCH:/api/v1/services/work-order/{wo_id}/stop-labor/{id}/
     * @secure
     */
    v1ServicesWorkOrderStopLaborPartialUpdate: (
      id: string,
      woId: string,
      data: PatchedWorkOrderLaborCompleteRequest,
      params: RequestParams = {},
    ) =>
      this.request<WorkOrderLaborComplete, any>({
        path: `/api/v1/services/work-order/${woId}/stop-labor/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ServicesWorkOrderCommentsCreateCreate
     * @request POST:/api/v1/services/work-order/comments/create/
     * @secure
     */
    v1ServicesWorkOrderCommentsCreateCreate: (
      data: WorkOrderCommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<WorkOrderComment, any>({
        path: `/api/v1/services/work-order/comments/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderCostLimitList
     * @request GET:/api/v1/services/work-order/cost-limit/
     * @secure
     */
    v1ServicesWorkOrderCostLimitList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedWorkOrderCostLimitList, any>({
        path: `/api/v1/services/work-order/cost-limit/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderCostLimitCreate
     * @request POST:/api/v1/services/work-order/cost-limit/
     * @secure
     */
    v1ServicesWorkOrderCostLimitCreate: (
      data: WorkOrderCostLimitRequest,
      params: RequestParams = {},
    ) =>
      this.request<WorkOrderCostLimit, any>({
        path: `/api/v1/services/work-order/cost-limit/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderCostLimitRetrieve
     * @request GET:/api/v1/services/work-order/cost-limit/{id}/
     * @secure
     */
    v1ServicesWorkOrderCostLimitRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<WorkOrderCostLimit, any>({
        path: `/api/v1/services/work-order/cost-limit/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderCostLimitUpdate
     * @request PUT:/api/v1/services/work-order/cost-limit/{id}/
     * @secure
     */
    v1ServicesWorkOrderCostLimitUpdate: (
      id: string,
      data: WorkOrderCostLimitRequest,
      params: RequestParams = {},
    ) =>
      this.request<WorkOrderCostLimit, any>({
        path: `/api/v1/services/work-order/cost-limit/${id}/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderCostLimitPartialUpdate
     * @request PATCH:/api/v1/services/work-order/cost-limit/{id}/
     * @secure
     */
    v1ServicesWorkOrderCostLimitPartialUpdate: (
      id: string,
      data: PatchedWorkOrderCostLimitRequest,
      params: RequestParams = {},
    ) =>
      this.request<WorkOrderCostLimit, any>({
        path: `/api/v1/services/work-order/cost-limit/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderCostLimitDestroy
     * @request DELETE:/api/v1/services/work-order/cost-limit/{id}/
     * @secure
     */
    v1ServicesWorkOrderCostLimitDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/services/work-order/cost-limit/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Work Order
     * @name V1ServicesWorkOrderCreateCreate
     * @request POST:/api/v1/services/work-order/create/
     * @secure
     */
    v1ServicesWorkOrderCreateCreate: (
      data: WorkOrderCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<WorkOrderCreate, any>({
        path: `/api/v1/services/work-order/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesList
     * @request GET:/api/v1/vehicles/
     * @secure
     */
    v1VehiclesList: (
      query?: {
        /** @format uuid */
        body_subtype?: string;
        /** @format uuid */
        body_type?: string;
        /** @format uuid */
        fuel_type?: string;
        /** @format uuid */
        group?: string;
        has_telematics_device?: boolean;
        /** Archived Vehicles */
        is_archived?: boolean;
        /** Assigned Vehicles */
        is_assigned?: boolean;
        /** Unassigned Vehicles */
        is_unassigned?: boolean;
        /** Comma-separated list of label UUIDs */
        labels?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** @format uuid */
        make?: string;
        /** @format uuid */
        model?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        /** @format uuid */
        operator?: string;
        /**
         * * `owned` - Owned
         * * `leased` - Leased
         * * `rented` - Rented
         * * `customer` - Customer
         * * `vehicle` - Vehicle
         */
        ownership?:
          | ""
          | "customer"
          | "leased"
          | "owned"
          | "rented"
          | "vehicle"
          | null;
        /** A search term. */
        search?: string;
        /**
         * * `active` - Active
         * * `inactive` - Inactive
         * * `in_shop` - In Shop
         * * `out_of_service` - Out of Service
         * * `sold` - Sold
         * * `yes` - Yes
         * * `downtime` - Downtime
         */
        status?:
          | "active"
          | "downtime"
          | "in_shop"
          | "inactive"
          | "out_of_service"
          | "sold"
          | "yes";
        /** @format uuid */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleListMiniList, any>({
        path: `/api/v1/vehicles/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesRetrieve
     * @request GET:/api/v1/vehicles/{id}/
     * @secure
     */
    v1VehiclesRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<VehicleListDetails, any>({
        path: `/api/v1/vehicles/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesArchiveCreate
     * @request POST:/api/v1/vehicles/{id}/archive/
     * @secure
     */
    v1VehiclesArchiveCreate: (
      id: string,
      data: VehicleReadRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleRead, any>({
        path: `/api/v1/vehicles/${id}/archive/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Telematics Devices
     * @name V1VehiclesArchiveTelematicsDeviceCreate
     * @request POST:/api/v1/vehicles/{id}/archive-telematics-device/
     * @secure
     */
    v1VehiclesArchiveTelematicsDeviceCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/${id}/archive-telematics-device/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Telematics Devices
     * @name V1VehiclesAssignVehicleCreate
     * @summary Assign a telematics device to a vehicle
     * @request POST:/api/v1/vehicles/{id}/assign-vehicle/
     * @secure
     */
    v1VehiclesAssignVehicleCreate: (
      id: string,
      data: AssignTelematicsDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/${id}/assign-vehicle/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesBulkAddDocumentsCreate
     * @request POST:/api/v1/vehicles/{id}/bulk-add-documents/
     * @secure
     */
    v1VehiclesBulkAddDocumentsCreate: (
      id: string,
      data: FileVehicleListRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/${id}/bulk-add-documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesBulkRemoveDocumentsCreate
     * @request POST:/api/v1/vehicles/{id}/bulk-remove-documents/
     * @secure
     */
    v1VehiclesBulkRemoveDocumentsCreate: (
      id: string,
      data: FileVehicleListRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/${id}/bulk-remove-documents/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesCommentsDeleteDestroy
     * @request DELETE:/api/v1/vehicles/{id}/comments/delete/
     * @secure
     */
    v1VehiclesCommentsDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/${id}/comments/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesDeleteDestroy
     * @request DELETE:/api/v1/vehicles/{id}/delete/
     * @secure
     */
    v1VehiclesDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesDocumentsList
     * @request GET:/api/v1/vehicles/{id}/documents/
     * @secure
     */
    v1VehiclesDocumentsList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedListFileList, any>({
        path: `/api/v1/vehicles/${id}/documents/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description API view to list fault codes for a vehicle
     *
     * @tags Vehicles
     * @name V1VehiclesFaultsList
     * @request GET:/api/v1/vehicles/{id}/faults/
     * @secure
     */
    v1VehiclesFaultsList: (
      id: string,
      query?: {
        /** Filter by whether issue is null (true) or not null (false) */
        is_issue_null?: boolean;
        /** Filter by fault code issue */
        issue?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** Filter by fault code status */
        status?: "ignored" | "open" | "pending" | "resolved";
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleFaultList, any>({
        path: `/api/v1/vehicles/${id}/faults/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesIssuesList
     * @request GET:/api/v1/vehicles/{id}/issues/
     * @secure
     */
    v1VehiclesIssuesList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleIssueList, any>({
        path: `/api/v1/vehicles/${id}/issues/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesLatestOdometerRetrieve
     * @request GET:/api/v1/vehicles/{id}/latest-odometer/
     * @secure
     */
    v1VehiclesLatestOdometerRetrieve: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<MeterEntry, any>({
        path: `/api/v1/vehicles/${id}/latest-odometer/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesLinkPartialUpdate
     * @request PATCH:/api/v1/vehicles/{id}/link/
     * @secure
     */
    v1VehiclesLinkPartialUpdate: (
      id: string,
      data: PatchedVehicleLinkRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/${id}/link/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesLinkedRetrieve
     * @request GET:/api/v1/vehicles/{id}/linked/
     * @secure
     */
    v1VehiclesLinkedRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<VehicleWithLinked, any>({
        path: `/api/v1/vehicles/${id}/linked/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesMeterEntriesList
     * @request GET:/api/v1/vehicles/{id}/meter-entries/
     * @secure
     */
    v1VehiclesMeterEntriesList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleMeterEntryList, any>({
        path: `/api/v1/vehicles/${id}/meter-entries/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesRestoreArchivedCreate
     * @request POST:/api/v1/vehicles/{id}/restore_archived/
     * @secure
     */
    v1VehiclesRestoreArchivedCreate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/${id}/restore_archived/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesRestoreDeletedCreate
     * @request POST:/api/v1/vehicles/{id}/restore_deleted/
     * @secure
     */
    v1VehiclesRestoreDeletedCreate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/${id}/restore_deleted/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesServicesList
     * @request GET:/api/v1/vehicles/{id}/services/
     * @secure
     */
    v1VehiclesServicesList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleServiceList, any>({
        path: `/api/v1/vehicles/${id}/services/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesSpecsRetrieve
     * @request GET:/api/v1/vehicles/{id}/specs/
     * @secure
     */
    v1VehiclesSpecsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<VehicleListMini, any>({
        path: `/api/v1/vehicles/${id}/specs/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Telematics Devices
     * @name V1VehiclesUnassignVehicleCreate
     * @summary Unassign a telematics device from a vehicle
     * @request POST:/api/v1/vehicles/{id}/unassign-vehicle/
     * @secure
     */
    v1VehiclesUnassignVehicleCreate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/${id}/unassign-vehicle/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesUnlinkPartialUpdate
     * @request PATCH:/api/v1/vehicles/{id}/unlink/
     * @secure
     */
    v1VehiclesUnlinkPartialUpdate: (
      id: string,
      data: PatchedVehicleUnlinkRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/${id}/unlink/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesUpdateUpdate
     * @request PUT:/api/v1/vehicles/{id}/update/
     * @secure
     */
    v1VehiclesUpdateUpdate: (
      id: string,
      data: VehicleWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleWrite, any>({
        path: `/api/v1/vehicles/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesUpdatePartialUpdate
     * @request PATCH:/api/v1/vehicles/{id}/update/
     * @secure
     */
    v1VehiclesUpdatePartialUpdate: (
      id: string,
      data: PatchedVehicleWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleWrite, any>({
        path: `/api/v1/vehicles/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List all warranties related to a specific vehicle
     *
     * @tags Warranty
     * @name V1VehiclesWarrantyList
     * @request GET:/api/v1/vehicles/{id}/warranty/
     * @secure
     */
    v1VehiclesWarrantyList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedWarrantyListList, any>({
        path: `/api/v1/vehicles/${id}/warranty/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List all equipment related to a specific vehicle
     *
     * @tags Equipment
     * @name V1VehiclesEquipmentsList
     * @request GET:/api/v1/vehicles/{vehicle_id}/equipments/
     * @secure
     */
    v1VehiclesEquipmentsList: (
      vehicleId: string,
      query: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** Which field to use when ordering the results. */
        ordering?: string;
        /** A search term. */
        search?: string;
        /**
         * ID of the vehicle
         * @format uuid
         */
        vehicle_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedEquipmentListList, any>({
        path: `/api/v1/vehicles/${vehicleId}/equipments/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesAssignmentsList
     * @request GET:/api/v1/vehicles/assignments/
     * @secure
     */
    v1VehiclesAssignmentsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedReadAssignmentList, any>({
        path: `/api/v1/vehicles/assignments/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesAssignmentsRetrieve
     * @request GET:/api/v1/vehicles/assignments/{id}/
     * @secure
     */
    v1VehiclesAssignmentsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<ReadAssignment, any>({
        path: `/api/v1/vehicles/assignments/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesAssignmentsDeleteDestroy
     * @request DELETE:/api/v1/vehicles/assignments/{id}/delete/
     * @secure
     */
    v1VehiclesAssignmentsDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/assignments/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesAssignmentsUpdateUpdate
     * @request PUT:/api/v1/vehicles/assignments/{id}/update/
     * @secure
     */
    v1VehiclesAssignmentsUpdateUpdate: (
      id: string,
      data: CreateAssignmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateAssignment, any>({
        path: `/api/v1/vehicles/assignments/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesAssignmentsUpdatePartialUpdate
     * @request PATCH:/api/v1/vehicles/assignments/{id}/update/
     * @secure
     */
    v1VehiclesAssignmentsUpdatePartialUpdate: (
      id: string,
      data: PatchedCreateAssignmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateAssignment, any>({
        path: `/api/v1/vehicles/assignments/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesAssignmentsCreateCreate
     * @request POST:/api/v1/vehicles/assignments/create/
     * @secure
     */
    v1VehiclesAssignmentsCreateCreate: (
      data: CreateAssignmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateAssignment, any>({
        path: `/api/v1/vehicles/assignments/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesCommentsCreateCreate
     * @request POST:/api/v1/vehicles/comments/create/
     * @secure
     */
    v1VehiclesCommentsCreateCreate: (
      data: CommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<Comment, any>({
        path: `/api/v1/vehicles/comments/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesCreateCreate
     * @request POST:/api/v1/vehicles/create/
     * @secure
     */
    v1VehiclesCreateCreate: (
      data: VehicleWriteRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleList, any>({
        path: `/api/v1/vehicles/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesDeletedList
     * @request GET:/api/v1/vehicles/deleted/
     * @secure
     */
    v1VehiclesDeletedList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleReadList, any>({
        path: `/api/v1/vehicles/deleted/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesEngineAspirationsList
     * @request GET:/api/v1/vehicles/engine-aspirations/
     * @secure
     */
    v1VehiclesEngineAspirationsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedEngineAspirationListList, any>({
        path: `/api/v1/vehicles/engine-aspirations/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesEngineAspirationsCreateCreate
     * @request POST:/api/v1/vehicles/engine-aspirations/create/
     * @secure
     */
    v1VehiclesEngineAspirationsCreateCreate: (
      data: EngineAspirationCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EngineAspirationList, any>({
        path: `/api/v1/vehicles/engine-aspirations/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesEngineBlockTypesList
     * @request GET:/api/v1/vehicles/engine-block-types/
     * @secure
     */
    v1VehiclesEngineBlockTypesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedEngineBlockTypeListList, any>({
        path: `/api/v1/vehicles/engine-block-types/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesEngineBlockTypesCreateCreate
     * @request POST:/api/v1/vehicles/engine-block-types/create/
     * @secure
     */
    v1VehiclesEngineBlockTypesCreateCreate: (
      data: EngineBlockTypeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EngineBlockTypeList, any>({
        path: `/api/v1/vehicles/engine-block-types/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesEngineCamTypesList
     * @request GET:/api/v1/vehicles/engine-cam-types/
     * @secure
     */
    v1VehiclesEngineCamTypesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedEngineCamTypeListList, any>({
        path: `/api/v1/vehicles/engine-cam-types/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesEngineCamTypesCreateCreate
     * @request POST:/api/v1/vehicles/engine-cam-types/create/
     * @secure
     */
    v1VehiclesEngineCamTypesCreateCreate: (
      data: EngineCamTypeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EngineCamTypeList, any>({
        path: `/api/v1/vehicles/engine-cam-types/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesEngineFuelInductionsList
     * @request GET:/api/v1/vehicles/engine-fuel-inductions/
     * @secure
     */
    v1VehiclesEngineFuelInductionsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedEngineFuelInductionListList, any>({
        path: `/api/v1/vehicles/engine-fuel-inductions/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesEngineFuelInductionsCreateCreate
     * @request POST:/api/v1/vehicles/engine-fuel-inductions/create/
     * @secure
     */
    v1VehiclesEngineFuelInductionsCreateCreate: (
      data: EngineFuelInductionCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EngineFuelInductionList, any>({
        path: `/api/v1/vehicles/engine-fuel-inductions/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesList
     * @request GET:/api/v1/vehicles/expenses/
     * @secure
     */
    v1VehiclesExpensesList: (
      query?: {
        /**
         * Date From
         * @format date
         */
        date_from?: string;
        /**
         * Date To
         * @format date
         */
        date_to?: string;
        /**
         * Expense Type
         * @format uuid
         */
        expense_type?: string;
        /**
         * Frequency
         *
         * * `ONE_TIME` - One-time
         * * `MONTHLY` - Monthly
         * * `YEARLY` - Yearly
         */
        frequency?: "MONTHLY" | "ONE_TIME" | "YEARLY";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /**
         * Time Period
         *
         * * `past` - PAST
         * * `future` - FUTURE
         */
        time_period?: "future" | "past";
        /** Vehicles */
        vehicles?: string;
        /** Vendors */
        vendors?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedExpenseListList, any>({
        path: `/api/v1/vehicles/expenses/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesRetrieve
     * @request GET:/api/v1/vehicles/expenses/{id}/
     * @secure
     */
    v1VehiclesExpensesRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<ExpenseList, any>({
        path: `/api/v1/vehicles/expenses/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesAttachmentsAddCreate
     * @request POST:/api/v1/vehicles/expenses/{id}/attachments/add/
     * @secure
     */
    v1VehiclesExpensesAttachmentsAddCreate: (
      id: string,
      data: BulkAddAttachmentExpenseRequest,
      params: RequestParams = {},
    ) =>
      this.request<BulkAddAttachmentExpense, any>({
        path: `/api/v1/vehicles/expenses/${id}/attachments/add/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesAttachmentsRemoveCreate
     * @request POST:/api/v1/vehicles/expenses/{id}/attachments/remove/
     * @secure
     */
    v1VehiclesExpensesAttachmentsRemoveCreate: (
      id: string,
      data: BulkRemoveAttachmentExpenseRequest,
      params: RequestParams = {},
    ) =>
      this.request<BulkRemoveAttachmentExpense, any>({
        path: `/api/v1/vehicles/expenses/${id}/attachments/remove/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesCommentDeleteDestroy
     * @request DELETE:/api/v1/vehicles/expenses/{id}/comment/delete/
     * @secure
     */
    v1VehiclesExpensesCommentDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/expenses/${id}/comment/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesDeleteDestroy
     * @request DELETE:/api/v1/vehicles/expenses/{id}/delete/
     * @secure
     */
    v1VehiclesExpensesDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/expenses/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesUpdateUpdate
     * @request PUT:/api/v1/vehicles/expenses/{id}/update/
     * @secure
     */
    v1VehiclesExpensesUpdateUpdate: (
      id: string,
      data: ExpenseUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ExpenseUpdate, any>({
        path: `/api/v1/vehicles/expenses/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesUpdatePartialUpdate
     * @request PATCH:/api/v1/vehicles/expenses/{id}/update/
     * @secure
     */
    v1VehiclesExpensesUpdatePartialUpdate: (
      id: string,
      data: PatchedExpenseUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ExpenseUpdate, any>({
        path: `/api/v1/vehicles/expenses/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesCommentCreateCreate
     * @request POST:/api/v1/vehicles/expenses/comment/create/
     * @secure
     */
    v1VehiclesExpensesCommentCreateCreate: (
      data: ExpenseCommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<ExpenseComment, any>({
        path: `/api/v1/vehicles/expenses/comment/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesCreateCreate
     * @request POST:/api/v1/vehicles/expenses/create/
     * @secure
     */
    v1VehiclesExpensesCreateCreate: (
      data: ExpenseCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ExpenseCreate, any>({
        path: `/api/v1/vehicles/expenses/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesTypesList
     * @request GET:/api/v1/vehicles/expenses/types/
     * @secure
     */
    v1VehiclesExpensesTypesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedExpenseTypeList, any>({
        path: `/api/v1/vehicles/expenses/types/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesTypesCreate
     * @request POST:/api/v1/vehicles/expenses/types/
     * @secure
     */
    v1VehiclesExpensesTypesCreate: (
      data: ExpenseTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<ExpenseType, any>({
        path: `/api/v1/vehicles/expenses/types/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesTypesRetrieve
     * @request GET:/api/v1/vehicles/expenses/types/{id}/
     * @secure
     */
    v1VehiclesExpensesTypesRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<ExpenseType, any>({
        path: `/api/v1/vehicles/expenses/types/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesTypesPartialUpdate
     * @request PATCH:/api/v1/vehicles/expenses/types/{id}/
     * @secure
     */
    v1VehiclesExpensesTypesPartialUpdate: (
      id: string,
      data: PatchedExpenseTypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<ExpenseType, any>({
        path: `/api/v1/vehicles/expenses/types/${id}/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesExpensesTypesDestroy
     * @request DELETE:/api/v1/vehicles/expenses/types/{id}/
     * @secure
     */
    v1VehiclesExpensesTypesDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/expenses/types/${id}/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import Vehicles
     * @name V1VehiclesImporterUnitsCreate
     * @request POST:/api/v1/vehicles/importer-units/
     * @secure
     */
    v1VehiclesImporterUnitsCreate: (
      data: ImportFileRequest,
      params: RequestParams = {},
    ) =>
      this.request<ImportFile, any>({
        path: `/api/v1/vehicles/importer-units/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import Examples Sheets
     * @name V1VehiclesImporterUnitsExampleRetrieve
     * @request GET:/api/v1/vehicles/importer-units/example/
     * @secure
     */
    v1VehiclesImporterUnitsExampleRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/importer-units/example/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter Entries
     * @name V1VehiclesMeterEntityList
     * @summary List Meter Entries
     * @request GET:/api/v1/vehicles/meter-entity/
     * @secure
     */
    v1VehiclesMeterEntityList: (
      query?: {
        /** @format date */
        date_range_after?: string;
        /** @format date */
        date_range_before?: string;
        /** Number of results to return per page. */
        limit?: number;
        /** @format date */
        meter_date?: string;
        /**
         * * `miles` - Miles
         * * `gallons` - Gallons
         * * `liters` - Liters
         * * `kilometers` - Kilometers
         */
        meter_unit?: "gallons" | "kilometers" | "liters" | "miles";
        meter_value?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /**
         * * `manual` - Manual
         * * `samsara` - Samsara
         * * `vehicle` - Vehicle
         * * `verizon` - Verizon
         */
        source_name?: "manual" | "samsara" | "vehicle" | "verizon" | null;
        /** @format uuid */
        vehicle?: string;
        void?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedMeterEntryList, any>({
        path: `/api/v1/vehicles/meter-entity/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter Entries
     * @name V1VehiclesMeterEntityRetrieve
     * @summary Retrieve Meter Entry
     * @request GET:/api/v1/vehicles/meter-entity/{id}/
     * @secure
     */
    v1VehiclesMeterEntityRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<MeterEntry, any>({
        path: `/api/v1/vehicles/meter-entity/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesMeterEntityDeleteDestroy
     * @request DELETE:/api/v1/vehicles/meter-entity/{id}/delete/
     * @secure
     */
    v1VehiclesMeterEntityDeleteDestroy: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/meter-entity/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter Entries
     * @name V1VehiclesMeterEntityUpdateUpdate
     * @summary Update Meter Entry
     * @request PUT:/api/v1/vehicles/meter-entity/{id}/update/
     * @secure
     */
    v1VehiclesMeterEntityUpdateUpdate: (
      id: string,
      data: UpdateMeterEntryRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeterEntry, any>({
        path: `/api/v1/vehicles/meter-entity/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter Entries
     * @name V1VehiclesMeterEntityUpdatePartialUpdate
     * @summary Update Meter Entry
     * @request PATCH:/api/v1/vehicles/meter-entity/{id}/update/
     * @secure
     */
    v1VehiclesMeterEntityUpdatePartialUpdate: (
      id: string,
      data: PatchedUpdateMeterEntryRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeterEntry, any>({
        path: `/api/v1/vehicles/meter-entity/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter Entries
     * @name V1VehiclesMeterEntityCreateCreate
     * @summary Create Meter Entry
     * @request POST:/api/v1/vehicles/meter-entity/create/
     * @secure
     */
    v1VehiclesMeterEntityCreateCreate: (
      data: CreateMeterEntryRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeterEntry, any>({
        path: `/api/v1/vehicles/meter-entity/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Coordinating method to determine the provider and call the appropriate handler.
     *
     * @tags Samsara
     * @name V1VehiclesSamsaraGeoPositionCreate
     * @summary Get vehicle geo position
     * @request POST:/api/v1/vehicles/samsara/{vehicle_id}/geo-position/
     * @secure
     */
    v1VehiclesSamsaraGeoPositionCreate: (
      vehicleId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/samsara/${vehicleId}/geo-position/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Samsara
     * @name V1VehiclesSamsaraDriversRetrieve
     * @summary Get Samsara drivers
     * @request GET:/api/v1/vehicles/samsara/drivers/
     * @secure
     */
    v1VehiclesSamsaraDriversRetrieve: (
      query: {
        integration_id: number;
        /** Default is 10 */
        limit?: number;
        /** Default is 0 */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/samsara/drivers/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Samsara
     * @name V1VehiclesSamsaraIntegrationsList
     * @summary Get all integrations for a user
     * @request GET:/api/v1/vehicles/samsara/integrations/
     * @secure
     */
    v1VehiclesSamsaraIntegrationsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedIntegrationsList, any>({
        path: `/api/v1/vehicles/samsara/integrations/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Import specific drivers or all available active drivers from Samsara
     *
     * @tags Samsara
     * @name V1VehiclesSamsaraSaveDriversCreate
     * @summary Select Samsara drivers and save them to the database
     * @request POST:/api/v1/vehicles/samsara/save-drivers/
     * @secure
     */
    v1VehiclesSamsaraSaveDriversCreate: (
      data: SamsaraSelectDriversRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/samsara/save-drivers/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Import specific vehicles or all available vehicles from Samsara
     *
     * @tags Samsara
     * @name V1VehiclesSamsaraSaveVehiclesCreate
     * @summary Select Samsara vehicles and save them to the database
     * @request POST:/api/v1/vehicles/samsara/save-vehicles/
     * @secure
     */
    v1VehiclesSamsaraSaveVehiclesCreate: (
      data: SamsaraSelectVehiclesRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/samsara/save-vehicles/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Synchronizes vehicle data from Samsara with the local database.
     *
     * @tags Samsara
     * @name V1VehiclesSamsaraSyncVehiclesCreate
     * @summary Sync Samsara vehicles for a company
     * @request POST:/api/v1/vehicles/samsara/sync-vehicles/
     * @secure
     */
    v1VehiclesSamsaraSyncVehiclesCreate: (
      data: InputRequest,
      params: RequestParams = {},
    ) =>
      this.request<Output, any>({
        path: `/api/v1/vehicles/samsara/sync-vehicles/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Samsara
     * @name V1VehiclesSamsaraTokenRegistrationCreate
     * @summary Verify and store Samsara API token
     * @request POST:/api/v1/vehicles/samsara/token-registration/
     * @secure
     */
    v1VehiclesSamsaraTokenRegistrationCreate: (
      data: SamsaraTokenRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/samsara/token-registration/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Samsara
     * @name V1VehiclesSamsaraTokenRemovalCreate
     * @summary Remove Samsara integration from the user
     * @request POST:/api/v1/vehicles/samsara/token-removal/
     * @secure
     */
    v1VehiclesSamsaraTokenRemovalCreate: (
      data: RemoveSamsaraIntegrationRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/samsara/token-removal/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Samsara
     * @name V1VehiclesSamsaraUpdateFaultsCreate
     * @summary Update vehicle faults
     * @request POST:/api/v1/vehicles/samsara/update_faults/
     * @secure
     */
    v1VehiclesSamsaraUpdateFaultsCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/samsara/update_faults/`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Samsara
     * @name V1VehiclesSamsaraVehicleDiagnosticsCreate
     * @summary Get Samsara vehicles diagnostics and save them to the database
     * @request POST:/api/v1/vehicles/samsara/vehicle-diagnostics/
     * @secure
     */
    v1VehiclesSamsaraVehicleDiagnosticsCreate: (
      data: SamsaraSelectVehiclesRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/samsara/vehicle-diagnostics/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Samsara
     * @name V1VehiclesSamsaraVehiclesRetrieve
     * @summary Get Samsara vehicles
     * @request GET:/api/v1/vehicles/samsara/vehicles/
     * @secure
     */
    v1VehiclesSamsaraVehiclesRetrieve: (
      query: {
        integration_id: number;
        /** Default is 10 */
        limit?: number;
        /** Default is 0 */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/samsara/vehicles/`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles
     * @name V1VehiclesSelectOptionsList
     * @request GET:/api/v1/vehicles/select-options/
     * @secure
     */
    v1VehiclesSelectOptionsList: (
      query?: {
        /** @format uuid */
        id?: string;
        /** Archived Vehicles */
        is_archived?: boolean;
        license_plate?: string;
        /** Number of results to return per page. */
        limit?: number;
        name?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        vin_sn?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleListForSelectOptionsList, any>({
        path: `/api/v1/vehicles/select-options/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Telematics Devices
     * @name V1VehiclesTelematicsDevicesList
     * @request GET:/api/v1/vehicles/telematics-devices/
     * @secure
     */
    v1VehiclesTelematicsDevicesList: (
      query?: {
        archived?: boolean;
        assigned?: boolean;
        device_errors?: string;
        device_name?: string;
        /**
         * * `SV` - Samsara Vehicle
         * * `ST` - Samsara Tracker
         * * `TR` - Trailer
         */
        device_type?: "ST" | "SV" | "TR" | null;
        integration?: number;
        is_active?: boolean;
        is_deleted?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        provider?: string;
        samsara_asset_id?: number;
        /** A search term. */
        search?: string;
        serial_number?: string;
        unassigned?: boolean;
        /** @format uuid */
        vehicle?: string;
        /** @format uuid */
        vehicle_group?: string;
        /**
         * * `active` - Active
         * * `inactive` - Inactive
         * * `in_shop` - In Shop
         * * `out_of_service` - Out of Service
         * * `sold` - Sold
         * * `yes` - Yes
         * * `downtime` - Downtime
         */
        vehicle_status?:
          | "active"
          | "downtime"
          | "in_shop"
          | "inactive"
          | "out_of_service"
          | "sold"
          | "yes";
        vin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTelematicsDeviceListList, any>({
        path: `/api/v1/vehicles/telematics-devices/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Handles GET requests to initiate the meter history processing service.
     *
     * @tags v1
     * @name V1VehiclesTestTriggerMeterHistoryRetrieve
     * @request GET:/api/v1/vehicles/test/trigger-meter-history/
     * @secure
     */
    v1VehiclesTestTriggerMeterHistoryRetrieve: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/vehicles/test/trigger-meter-history/`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesTransmissionTypesList
     * @request GET:/api/v1/vehicles/transmission-types/
     * @secure
     */
    v1VehiclesTransmissionTypesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTransmissionTypeListList, any>({
        path: `/api/v1/vehicles/transmission-types/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesTransmissionTypesCreateCreate
     * @request POST:/api/v1/vehicles/transmission-types/create/
     * @secure
     */
    v1VehiclesTransmissionTypesCreateCreate: (
      data: TransmissionTypeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<TransmissionTypeList, any>({
        path: `/api/v1/vehicles/transmission-types/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesVehicleBodySubtypesList
     * @request GET:/api/v1/vehicles/vehicle-body-subtypes/
     * @secure
     */
    v1VehiclesVehicleBodySubtypesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleBodySubTypeListList, any>({
        path: `/api/v1/vehicles/vehicle-body-subtypes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesVehicleBodySubtypesCreateCreate
     * @request POST:/api/v1/vehicles/vehicle-body-subtypes/create/
     * @secure
     */
    v1VehiclesVehicleBodySubtypesCreateCreate: (
      data: VehicleBodySubTypeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleBodySubTypeList, any>({
        path: `/api/v1/vehicles/vehicle-body-subtypes/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesVehicleBodyTypesList
     * @request GET:/api/v1/vehicles/vehicle-body-types/
     * @secure
     */
    v1VehiclesVehicleBodyTypesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleBodyTypeListList, any>({
        path: `/api/v1/vehicles/vehicle-body-types/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesVehicleBodyTypesCreateCreate
     * @request POST:/api/v1/vehicles/vehicle-body-types/create/
     * @secure
     */
    v1VehiclesVehicleBodyTypesCreateCreate: (
      data: VehicleBodyTypeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleBodyTypeList, any>({
        path: `/api/v1/vehicles/vehicle-body-types/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesVehicleFuelTypesList
     * @request GET:/api/v1/vehicles/vehicle-fuel-types/
     * @secure
     */
    v1VehiclesVehicleFuelTypesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleFuelTypeListList, any>({
        path: `/api/v1/vehicles/vehicle-fuel-types/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesVehicleFuelTypesCreateCreate
     * @request POST:/api/v1/vehicles/vehicle-fuel-types/create/
     * @secure
     */
    v1VehiclesVehicleFuelTypesCreateCreate: (
      data: VehicleFuelTypeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleFuelTypeList, any>({
        path: `/api/v1/vehicles/vehicle-fuel-types/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesVehicleMakesList
     * @request GET:/api/v1/vehicles/vehicle-makes/
     * @secure
     */
    v1VehiclesVehicleMakesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleMakeListList, any>({
        path: `/api/v1/vehicles/vehicle-makes/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesVehicleMakesCreateCreate
     * @request POST:/api/v1/vehicles/vehicle-makes/create/
     * @secure
     */
    v1VehiclesVehicleMakesCreateCreate: (
      data: VehicleMakeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleMakeList, any>({
        path: `/api/v1/vehicles/vehicle-makes/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesVehicleModelsList
     * @request GET:/api/v1/vehicles/vehicle-models/
     * @secure
     */
    v1VehiclesVehicleModelsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleModelListList, any>({
        path: `/api/v1/vehicles/vehicle-models/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesVehicleModelsCreateCreate
     * @request POST:/api/v1/vehicles/vehicle-models/create/
     * @secure
     */
    v1VehiclesVehicleModelsCreateCreate: (
      data: VehicleModelCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleModelList, any>({
        path: `/api/v1/vehicles/vehicle-models/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesVehicleTypesList
     * @request GET:/api/v1/vehicles/vehicle-types/
     * @secure
     */
    v1VehiclesVehicleTypesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedVehicleTypeListList, any>({
        path: `/api/v1/vehicles/vehicle-types/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesVehicleTypesCreateCreate
     * @request POST:/api/v1/vehicles/vehicle-types/create/
     * @secure
     */
    v1VehiclesVehicleTypesCreateCreate: (
      data: VehicleTypeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleBodySubTypeList, any>({
        path: `/api/v1/vehicles/vehicle-types/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vin Decoding
     * @name V1VehiclesVinDecodingRetrieve
     * @request GET:/api/v1/vehicles/vin_decoding/
     * @secure
     */
    v1VehiclesVinDecodingRetrieve: (
      query?: {
        /** VIN of the vehicle */
        vin?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ReadAssignment, any>({
        path: `/api/v1/vehicles/vin_decoding/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesWheelsTiresBrakeSystemsList
     * @request GET:/api/v1/vehicles/wheels-tires-brake-systems/
     * @secure
     */
    v1VehiclesWheelsTiresBrakeSystemsList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedWheelsTiresBrakeSystemListList, any>({
        path: `/api/v1/vehicles/wheels-tires-brake-systems/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesWheelsTiresBrakeSystemsCreateCreate
     * @request POST:/api/v1/vehicles/wheels-tires-brake-systems/create/
     * @secure
     */
    v1VehiclesWheelsTiresBrakeSystemsCreateCreate: (
      data: WheelsTiresBrakeSystemCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<WheelsTiresBrakeSystemList, any>({
        path: `/api/v1/vehicles/wheels-tires-brake-systems/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesWheelsTiresDriveTypesList
     * @request GET:/api/v1/vehicles/wheels-tires-drive-types/
     * @secure
     */
    v1VehiclesWheelsTiresDriveTypesList: (
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedWheelsTiresDriveTypeListList, any>({
        path: `/api/v1/vehicles/wheels-tires-drive-types/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vehicles Fields
     * @name V1VehiclesWheelsTiresDriveTypesCreateCreate
     * @request POST:/api/v1/vehicles/wheels-tires-drive-types/create/
     * @secure
     */
    v1VehiclesWheelsTiresDriveTypesCreateCreate: (
      data: WheelsTiresDriveTypeCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<WheelsTiresDriveTypeList, any>({
        path: `/api/v1/vehicles/wheels-tires-drive-types/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VehiclesWithExpensesList
     * @request GET:/api/v1/vehicles/with-expenses/
     * @secure
     */
    v1VehiclesWithExpensesList: (
      query?: {
        /**
         * Date From
         * @format date
         */
        date_from?: string;
        /**
         * Date To
         * @format date
         */
        date_to?: string;
        /**
         * Expense Type
         * @format uuid
         */
        expense_type?: string;
        /**
         * Frequency
         *
         * * `ONE_TIME` - One-time
         * * `MONTHLY` - Monthly
         * * `YEARLY` - Yearly
         */
        frequency?: "MONTHLY" | "ONE_TIME" | "YEARLY";
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /**
         * Time Period
         *
         * * `past` - PAST
         * * `future` - FUTURE
         */
        time_period?: "future" | "past";
        /** Vehicles */
        vehicles?: string;
        /** Vendors */
        vendors?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedExpenseVehicleList, any>({
        path: `/api/v1/vehicles/with-expenses/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name V1VendorsList
     * @request GET:/api/v1/vendors/
     * @secure
     */
    v1VendorsList: (
      query?: {
        address?: string;
        /**
         * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
         *
         * * `fuel` - Fuel
         * * `parts` - Parts
         * * `services_app` - Service
         * * `vehicle` - Vehicle
         */
        classification?: "fuel" | "parts" | "services_app" | "vehicle" | null;
        contact_email?: string;
        contact_name?: string;
        contact_phone?: string;
        /** Archived Vendors */
        is_archived?: boolean;
        is_featured?: boolean;
        labels?: string[];
        /** @format float */
        latitude?: number;
        /** Number of results to return per page. */
        limit?: number;
        /** @format float */
        longitude?: number;
        name?: string;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * Ordering
         *
         * * `Name` - Name
         * * `-Name` - Name (descending)
         * * `Address` - Address
         * * `-Address` - Address (descending)
         * * `Phone` - Phone
         * * `-Phone` - Phone (descending)
         * * `Website` - Website
         * * `-Website` - Website (descending)
         * * `Contact Name` - Contact name
         * * `-Contact Name` - Contact name (descending)
         * * `Contact Phone` - Contact phone
         * * `-Contact Phone` - Contact phone (descending)
         * * `Contact Email` - Contact email
         * * `-Contact Email` - Contact email (descending)
         */
        ordering?: (
          | "-Address"
          | "-Contact Email"
          | "-Contact Name"
          | "-Contact Phone"
          | "-Name"
          | "-Phone"
          | "-Website"
          | "Address"
          | "Contact Email"
          | "Contact Name"
          | "Contact Phone"
          | "Name"
          | "Phone"
          | "Website"
        )[];
        phone?: string;
        /** Radius (km) - Default: 5 km */
        radius?: number;
        /** A search term. */
        search?: string;
        website?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedListVendorList, any>({
        path: `/api/v1/vendors/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name V1VendorsRetrieve
     * @request GET:/api/v1/vendors/{id}/
     * @secure
     */
    v1VendorsRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<DetailVendor, any>({
        path: `/api/v1/vendors/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name V1VendorsArchiveUpdate
     * @request PUT:/api/v1/vendors/{id}/archive/
     * @secure
     */
    v1VendorsArchiveUpdate: (
      id: string,
      data: DetailVendorRequest,
      params: RequestParams = {},
    ) =>
      this.request<DetailVendor, any>({
        path: `/api/v1/vendors/${id}/archive/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name V1VendorsArchivePartialUpdate
     * @request PATCH:/api/v1/vendors/{id}/archive/
     * @secure
     */
    v1VendorsArchivePartialUpdate: (
      id: string,
      data: PatchedDetailVendorRequest,
      params: RequestParams = {},
    ) =>
      this.request<DetailVendor, any>({
        path: `/api/v1/vendors/${id}/archive/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors-Files
     * @name V1VendorsBulkAddFilesCreate
     * @request POST:/api/v1/vendors/{id}/bulk_add_files/
     * @secure
     */
    v1VendorsBulkAddFilesCreate: (
      id: string,
      data: FilesVendorRequest,
      params: RequestParams = {},
    ) =>
      this.request<FilesVendor, any>({
        path: `/api/v1/vendors/${id}/bulk_add_files/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors-Files
     * @name V1VendorsBulkRemoveFilesCreate
     * @request POST:/api/v1/vendors/{id}/bulk_remove_files/
     * @secure
     */
    v1VendorsBulkRemoveFilesCreate: (
      id: string,
      data: FilesVendorRequest,
      params: RequestParams = {},
    ) =>
      this.request<FilesVendor, any>({
        path: `/api/v1/vendors/${id}/bulk_remove_files/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VendorsCommentsDeleteDestroy
     * @request DELETE:/api/v1/vendors/{id}/comments/delete/
     * @secure
     */
    v1VendorsCommentsDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/vendors/${id}/comments/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name V1VendorsDeleteDestroy
     * @request DELETE:/api/v1/vendors/{id}/delete/
     * @secure
     */
    v1VendorsDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/vendors/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors-Files
     * @name V1VendorsFilesList
     * @request GET:/api/v1/vendors/{id}/files/
     * @secure
     */
    v1VendorsFilesList: (
      id: string,
      query?: {
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFileVendorReadList, any>({
        path: `/api/v1/vendors/${id}/files/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name V1VendorsUnarchiveUpdate
     * @request PUT:/api/v1/vendors/{id}/unarchive/
     * @secure
     */
    v1VendorsUnarchiveUpdate: (
      id: string,
      data: DetailVendorRequest,
      params: RequestParams = {},
    ) =>
      this.request<DetailVendor, any>({
        path: `/api/v1/vendors/${id}/unarchive/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name V1VendorsUnarchivePartialUpdate
     * @request PATCH:/api/v1/vendors/{id}/unarchive/
     * @secure
     */
    v1VendorsUnarchivePartialUpdate: (
      id: string,
      data: PatchedDetailVendorRequest,
      params: RequestParams = {},
    ) =>
      this.request<DetailVendor, any>({
        path: `/api/v1/vendors/${id}/unarchive/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name V1VendorsUpdateUpdate
     * @request PUT:/api/v1/vendors/{id}/update/
     * @secure
     */
    v1VendorsUpdateUpdate: (
      id: string,
      data: UpdateVendorRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateVendor, any>({
        path: `/api/v1/vendors/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name V1VendorsUpdatePartialUpdate
     * @request PATCH:/api/v1/vendors/{id}/update/
     * @secure
     */
    v1VendorsUpdatePartialUpdate: (
      id: string,
      data: PatchedUpdateVendorRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateVendor, any>({
        path: `/api/v1/vendors/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoint to retrieve nearest vendors for a given vehicle.
     *
     * @tags Vendors
     * @name V1VendorsNearestVendorsList
     * @request GET:/api/v1/vendors/{vehicle_id}/nearest-vendors/
     * @secure
     */
    v1VendorsNearestVendorsList: (
      vehicleId: string,
      query?: {
        classification?: string;
        is_open?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** @format uuid */
        service_task?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedNearestVendorList, any>({
        path: `/api/v1/vendors/${vehicleId}/nearest-vendors/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VendorsCommentsCreateCreate
     * @request POST:/api/v1/vendors/comments/create/
     * @secure
     */
    v1VendorsCommentsCreateCreate: (
      data: VendorCommentRequest,
      params: RequestParams = {},
    ) =>
      this.request<VendorComment, any>({
        path: `/api/v1/vendors/comments/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name V1VendorsCreateCreate
     * @request POST:/api/v1/vendors/create/
     * @secure
     */
    v1VendorsCreateCreate: (
      data: CreateVendorRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateVendor, any>({
        path: `/api/v1/vendors/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description API endpoint to retrieve featured vendors.
     *
     * @tags Vendors
     * @name V1VendorsFeaturedList
     * @request GET:/api/v1/vendors/featured/
     * @secure
     */
    v1VendorsFeaturedList: (
      query?: {
        classification?: string;
        /** @format float */
        latitude?: number;
        /** Number of results to return per page. */
        limit?: number;
        /** @format float */
        longitude?: number;
        minumum_discount?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        partner_tier?: string;
        promo_code_tag?: string;
        radius?: number;
        /** @format uuid */
        service_task?: string;
        state_province_region?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedFeaturedVendorList, any>({
        path: `/api/v1/vendors/featured/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1VendorsNearbyList
     * @request GET:/api/v1/vendors/nearby/
     * @secure
     */
    v1VendorsNearbyList: (
      query?: {
        /**
         * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
         *
         * * `fuel` - Fuel
         * * `parts` - Parts
         * * `services_app` - Service
         * * `vehicle` - Vehicle
         */
        classification?: (
          | "fuel"
          | "parts"
          | "services_app"
          | "vehicle"
          | null
        )[];
        has_active_promos?: boolean;
        is_featured?: boolean;
        is_global?: boolean;
        lat?: number;
        /** Number of results to return per page. */
        limit?: number;
        lng?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * * `basic` - Basic
         * * `standard` - Standard
         * * `premium` - Premium
         */
        partner_tier?: ("basic" | "premium" | "standard" | null)[];
        radius_km?: number;
        radius_mi?: number;
        /** @format uuid */
        service_task_id?: string;
        /** @format uuid */
        vehicle_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedNearbyVendorList, any>({
        path: `/api/v1/vendors/nearby/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name V1VendorsSearchList
     * @request GET:/api/v1/vendors/search/
     * @secure
     */
    v1VendorsSearchList: (
      query?: {
        city__icontains?: string;
        /**
         * Primary type of service or product the vendor provides (fuel, parts, service, or vehicle)
         *
         * * `fuel` - Fuel
         * * `parts` - Parts
         * * `services_app` - Service
         * * `vehicle` - Vehicle
         */
        classification?: (
          | "fuel"
          | "parts"
          | "services_app"
          | "vehicle"
          | null
        )[];
        country__icontains?: string;
        has_active_promos?: boolean;
        is_featured?: boolean;
        is_global?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /**
         * * `name` - Name
         * * `created` - Newest First
         * * `tier` - Partnership Tier
         * * `services_count` - Number of Services
         */
        order_by?: "created" | "name" | "services_count" | "tier";
        /** @format uuid */
        partner?: string;
        /**
         * * `basic` - Basic
         * * `standard` - Standard
         * * `premium` - Premium
         */
        partnership_tier?: ("basic" | "premium" | "standard" | null)[];
        search?: string;
        service_cost_max?: number;
        service_cost_min?: number;
        /** @format uuid */
        service_task_id?: string;
        state_province_region__icontains?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedSearchVendorList, any>({
        path: `/api/v1/vendors/search/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Warranties
     * @name V1WarrantiesList
     * @request GET:/api/v1/warranties/
     * @secure
     */
    v1WarrantiesList: (
      query?: {
        /**
         * Type of warranty coverage.Standard Warranty or Extended Warranty
         *
         * * `Standard` - Standard Warranty
         * * `Extended` - Extended Warranty
         */
        coverage_type?: "Extended" | "Standard";
        /** @format date */
        end_date?: string;
        is_unlimited?: boolean;
        /** Number of results to return per page. */
        limit?: number;
        /** The initial index from which to return the results. */
        offset?: number;
        /** A search term. */
        search?: string;
        /** @format date */
        start_date?: string;
        /**
         * The status of the warranty.
         *
         * * `Active` - Active
         * * `Expired` - Expired
         */
        status?: "Active" | "Expired";
        /** @format uuid */
        vehicle?: string;
        /** @format uuid */
        vehicle_group?: string;
        /** @format uuid */
        vehicle_type?: string;
        /** @format uuid */
        vendor?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedWarrantyListList, any>({
        path: `/api/v1/warranties/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Warranties
     * @name V1WarrantiesRetrieve
     * @request GET:/api/v1/warranties/{id}/
     * @secure
     */
    v1WarrantiesRetrieve: (id: string, params: RequestParams = {}) =>
      this.request<WarrantyList, any>({
        path: `/api/v1/warranties/${id}/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Warranties
     * @name V1WarrantiesDeleteDestroy
     * @request DELETE:/api/v1/warranties/{id}/delete/
     * @secure
     */
    v1WarrantiesDeleteDestroy: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/warranties/${id}/delete/`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Warranties
     * @name V1WarrantiesUpdateUpdate
     * @request PUT:/api/v1/warranties/{id}/update/
     * @secure
     */
    v1WarrantiesUpdateUpdate: (
      id: string,
      data: WarrantyCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<WarrantyCreate, any>({
        path: `/api/v1/warranties/${id}/update/`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Warranties
     * @name V1WarrantiesUpdatePartialUpdate
     * @request PATCH:/api/v1/warranties/{id}/update/
     * @secure
     */
    v1WarrantiesUpdatePartialUpdate: (
      id: string,
      data: PatchedWarrantyCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<WarrantyCreate, any>({
        path: `/api/v1/warranties/${id}/update/`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Warranties
     * @name V1WarrantiesCreateCreate
     * @request POST:/api/v1/warranties/create/
     * @secure
     */
    v1WarrantiesCreateCreate: (
      data: WarrantyCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<WarrantyCreate, any>({
        path: `/api/v1/warranties/create/`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
